// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jTTlG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _app = require("./App");
// Aplica el zoom al cargar la aplicación
const applyZoom = (zoomLevel)=>{
    document.body.style.transform = `scale(${zoomLevel})`;
    document.body.style.transformOrigin = "top center";
};
const app = document.getElementById("app");
const root = (0, _clientDefault.default).createRoot(app);
// Aplica el zoom al cuerpo del documento antes de renderizar la aplicación
applyZoom(0.75);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}));

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom/client":"5eZdG","./App":"lVpWa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"84Frb"}],"84Frb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"bmhQu"}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7cX1V"}],"7cX1V":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"82aNB"}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"cfGqX"}],"cfGqX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"bmhQu","ece50e903283a22f":"dHubo"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"cUjz3"}],"cUjz3":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"lVpWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _notFound = require("./screens/NotFound");
var _onboardingRegisterVisaMobile = require("./screens/VXLab/Simple/Mobile/OnboardingRegisterVisaMobile");
var _disclosuresVisaMobile = require("./screens/VXLab/Simple/Mobile/DisclosuresVisaMobile");
var _cardDetailsVisaMobile = require("./screens/VXLab/Simple/Mobile/CardDetailsVisaMobile");
var _phoneStep1VisaMobile = require("./screens/VXLab/Simple/Mobile/PhoneStep1VisaMobile");
var _phoneStep2VisaMobile = require("./screens/VXLab/Simple/Mobile/PhoneStep2VisaMobile");
var _skanId1VisaMobile = require("./screens/VXLab/Simple/Mobile/SkanId1VisaMobile");
var _skanId2VisaMobile = require("./screens/VXLab/Simple/Mobile/SkanId2VisaMobile");
var _onboardingSuccessVisaMobile = require("./screens/VXLab/Simple/Mobile/OnboardingSuccessVisaMobile");
var _onboardingLandingVisaMobile = require("./screens/VXLab/Simple/Mobile/OnboardingLandingVisaMobile");
var _corporativo = require("./screens/VXLab/Corporativo/Mobile/Corporativo");
var _corporativoLanding = require("./screens/VXLab/Corporativo/Mobile/CorporativoLanding");
var _corporativoCard = require("./screens/VXLab/Corporativo/Mobile/CorporativoCard");
var _corporativoOnboardingTutorialEasy = require("./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingTutorialEasy");
var _corporativoOnboardingWelcome = require("./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingWelcome");
var _corporativoOnboardingStepper = require("./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingStepper");
var _corporativoOnboardingCardId = require("./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingCardId");
var _corporativoOnboardingPhone = require("./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingPhone");
var _corporativoBusinessBankingLoginWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingLoginWeb");
var _corporativoBusinessBankingProductSelectionCodeWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingProductSelectionCodeWeb");
var _corporativoBusinessBankingDocumentsWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentsWeb");
var _corporativoBusinessBankingMailWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailWeb");
var _corporativoBusinessBankingMailCodeWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailCodeWeb");
var _corporativoBusinessBankingSignupWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingSignupWeb");
var _corporativoBusinessBankingStepperWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingStepperWeb");
var _corporativoBusinessBankingCredentialsWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCredentialsWeb");
var _corporativoBusinessBankingDocumentIdWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentIdWeb");
var _corporativoBusinessBankingCheckoutWeb = require("./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCheckoutWeb");
var _pixieOnboarding = require("./screens/VXLab/Pixie/Mobile/PixieOnboarding");
var _pixieLanding = require("./screens/VXLab/Pixie/Mobile/PixieLanding");
var _pixieCardDetails = require("./screens/VXLab/Pixie/Mobile/PixieCardDetails");
var _pixieOnboardingTutorialEasy = require("./screens/VXLab/Pixie/Mobile/PixieOnboardingTutorialEasy");
var _pixieOnboardingWelcome = require("./screens/VXLab/Pixie/Mobile/PixieOnboardingWelcome");
var _pixieOnboardingStepper = require("./screens/VXLab/Pixie/Mobile/PixieOnboardingStepper");
var _pixieOnboardingCardId = require("./screens/VXLab/Pixie/Mobile/PixieOnboardingCardId");
var _pixieOnboardingPhone = require("./screens/VXLab/Pixie/Mobile/PixieOnboardingPhone");
var _adultosOnboarding = require("./screens/VXLab/Adults/Mobile/AdultosOnboarding");
var _adultosLanding = require("./screens/VXLab/Adults/Mobile/AdultosLanding");
var _adultosCardDetails = require("./screens/VXLab/Adults/Mobile/AdultosCardDetails");
var _adultosOnboardingTutorialEasy = require("./screens/VXLab/Adults/Mobile/AdultosOnboardingTutorialEasy");
var _adultosOnboardingWelcome = require("./screens/VXLab/Adults/Mobile/AdultosOnboardingWelcome");
var _adultosOnboardingStepper = require("./screens/VXLab/Adults/Mobile/AdultosOnboardingStepper");
var _adultosOnboardingCardId = require("./screens/VXLab/Adults/Mobile/AdultosOnboardingCardId");
var _adultosOnboardingPhone = require("./screens/VXLab/Adults/Mobile/AdultosOnboardingPhone");
var _youngOnboarding = require("./screens/VXLab/Young/Mobile/YoungOnboarding");
var _corporativoTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoTelco");
var _corporativoLandingTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoLandingTelco");
var _corporativoOnboardingTutorialEasyTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoOnboardingTutorialEasyTelco");
var _corporativoOnboardingWelcomeTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoOnboardingWelcomeTelco");
var _corporativoOnboardingStepperTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoOnboardingStepperTelco");
var _corporativoOnboardingCardIdTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoOnboardingCardIdTelco");
var _corporativoOnboardingPhoneTelco = require("./screens/Telco/Corporativo/Mobile/CorporativoOnboardingPhoneTelco");
var _corporativoRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoRegional");
var _corporativoLandingRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoLandingRegional");
var _corporativoCardRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoCardRegional");
var _corporativoOnboardingTutorialEasyRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingTutorialEasyRegional");
var _corporativoOnboardingWelcomeRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingWelcomeRegional");
var _corporativoOnboardingStepperRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingStepperRegional");
var _corporativoOnboardingCardIdRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingCardIdRegional");
var _corporativoOnboardingPhoneRegional = require("./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingPhoneRegional");
var _corporativoLoginDashboard = require("./screens/VXLab/Corporativo/Mobile/CorporativoLoginDashboard");
var _userDashboard = require("./screens/UserDashboard");
var _userDetailsDashboard = require("./screens/UserDetailsDashboard");
var _youngLanding = require("./screens/VXLab/Young/Mobile/YoungLanding");
var _youngCardDetails = require("./screens/VXLab/Young/Mobile/YoungCardDetails");
var _youngOnboardingTutorialEasy = require("./screens/VXLab/Young/Mobile/YoungOnboardingTutorialEasy");
var _youngOnboardingWelcome = require("./screens/VXLab/Young/Mobile/YoungOnboardingWelcome");
var _youngOnboardingStepper = require("./screens/VXLab/Young/Mobile/YoungOnboardingStepper");
var _youngOnboardingCardId = require("./screens/VXLab/Young/Mobile/YoungOnboardingCardId");
var _youngOnboardingPhone = require("./screens/VXLab/Young/Mobile/YoungOnboardingPhone");
const visaMobileBasePaths = [
    "vxlab",
    "wallet",
    "wallet_visa",
    "retail_banking"
];
const visaMobileSuffixes = [
    {
        suffix: "onboarding_register-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingRegisterVisaMobile.OnboardingRegisterVisaMobile), {})
    },
    {
        suffix: "onboarding_register-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingRegisterVisaMobile.OnboardingRegisterVisaMobile), {})
    },
    {
        suffix: "landing-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingLandingVisaMobile.OnboardingLandingVisaMobile), {})
    },
    {
        suffix: "landing-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingLandingVisaMobile.OnboardingLandingVisaMobile), {})
    },
    {
        suffix: "card_details-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDetailsVisaMobile.CardDetailsVisaMobile), {})
    },
    {
        suffix: "card_details-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDetailsVisaMobile.CardDetailsVisaMobile), {})
    },
    {
        suffix: "onboarding_disclosures-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosuresVisaMobile.DisclosuresVisaMobile), {})
    },
    {
        suffix: "onboarding_disclosures-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosuresVisaMobile.DisclosuresVisaMobile), {})
    },
    {
        suffix: "onboarding_phone_step_01-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneStep1VisaMobile.PhoneStep1VisaMobile), {})
    },
    {
        suffix: "onboarding_phone_step_01-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneStep1VisaMobile.PhoneStep1VisaMobile), {})
    },
    {
        suffix: "onboarding_phone_step_02-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneStep2VisaMobile.PhoneStep2VisaMobile), {})
    },
    {
        suffix: "onboarding_phone_step_02-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _phoneStep2VisaMobile.PhoneStep2VisaMobile), {})
    },
    {
        suffix: "onboarding_skan_id_01-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skanId1VisaMobile.SkanId1VisaMobile), {})
    },
    {
        suffix: "onboarding_skan_id_01-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skanId1VisaMobile.SkanId1VisaMobile), {})
    },
    {
        suffix: "onboarding_skan_id_02-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skanId2VisaMobile.SkanId2VisaMobile), {})
    },
    {
        suffix: "onboarding_skan_id_02-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skanId2VisaMobile.SkanId2VisaMobile), {})
    },
    {
        suffix: "onboarding_success-visa-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingSuccessVisaMobile.OnboardingSuccessVisaMobile), {})
    },
    {
        suffix: "onboarding_success-wallet-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingSuccessVisaMobile.OnboardingSuccessVisaMobile), {})
    }
];
const visaMobileRoutes = visaMobileBasePaths.flatMap((prefix)=>visaMobileSuffixes.map(({ suffix, element })=>({
            path: `/${prefix}-${suffix}`,
            element
        })));
const router = (0, _reactRouterDom.createBrowserRouter)([
    // 🧩 NOT FOUND
    {
        path: "/*",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
    },
    // =========================
    // CORPORATIVO
    // =========================
    /* BORRAR LUEGO DEL 01/10/2025
  { path: "/corporativo-landing", element: <CorporativoLanding /> },
  { path: "/corporativo-card-details", element: <CorporativoCard /> },
  { path: "/corporativo-onboarding", element: <Corporativo /> },
  { path: "/corporativo", element: <CorporativoScreen /> },
  { path: "/corporativo-onboarding-tutorial-easy", element: <CorporativoOnboardingTutorialEasy /> },
  { path: "/corporativo-onboarding-welcome", element: <CorporativoOnboardingWelcome /> },
  { path: "/corporativo-onboarding-steppper", element: <CorporativoOnboardingStepper /> },
  { path: "/corporativo-onboarding-card-id", element: <CorporativoOnboardingCardId /> },
  { path: "/corporativo-onboarding-phone", element: <CorporativoOnboardingPhone /> },
  { path: "/corporativo-login-dashboard", element: <CorporativoLoginDashboard /> },
  { path: "/corporativo-user-dashboard", element: <UserDashboard /> },
  { path: "/corporativo-user-details-dashboard", element: <UserDetailsDashboard /> },
*/ // NUEVAS rutas corporativo (vxlab)
    {
        path: "/vxlab-login-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativo.Corporativo), {})
    },
    {
        path: "/vxlab-landing-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLanding.CorporativoLanding), {})
    },
    {
        path: "/vxlab-onboarding_register-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativo.Corporativo), {})
    },
    {
        path: "/vxlab-card_details-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoCard.CorporativoCard), {})
    },
    {
        path: "/vxlab-onboarding_tutorial_easy-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingTutorialEasy.CorporativoOnboardingTutorialEasy), {})
    },
    {
        path: "/vxlab-onboarding_welcome-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingWelcome.CorporativoOnboardingWelcome), {})
    },
    {
        path: "/vxlab-onboarding_steppper-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingStepper.CorporativoOnboardingStepper), {})
    },
    {
        path: "/vxlab-onboarding_card_id-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingCardId.CorporativoOnboardingCardId), {})
    },
    {
        path: "/vxlab-onboarding_phone-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingPhone.CorporativoOnboardingPhone), {})
    },
    // CORPORATIVO WEB - BUSINESS BANKING
    {
        path: "/business_banking-login-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingLoginWeb.CorporativoBusinessBankingLoginWeb), {})
    },
    {
        path: "/business_banking-product_selection-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingProductSelectionCodeWeb.CorporativoBusinessBankingProductSelectionCodeWeb), {})
    },
    {
        path: "/business_banking-document-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingDocumentsWeb.CorporativoBusinessBankingDocumentsWeb), {})
    },
    {
        path: "/business_banking-mail-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingMailWeb.CorporativoBusinessBankingMailWeb), {})
    },
    {
        path: "/business_banking-mail_code-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingMailCodeWeb.CorporativoBusinessBankingMailCodeWeb), {})
    },
    {
        path: "/business_banking-signup-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingSignupWeb.CorporativoBusinessBankingSignupWeb), {})
    },
    {
        path: "/business_banking-stepper-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingStepperWeb.CorporativoBusinessBankingStepperWeb), {})
    },
    {
        path: "/business_banking-credentials-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingCredentialsWeb.CorporativoBusinessBankingCredentialsWeb), {})
    },
    {
        path: "/business_banking-document_id-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingDocumentIdWeb.CorporativoBusinessBankingDocumentIdWeb), {})
    },
    {
        path: "/business_banking-checkout-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoBusinessBankingCheckoutWeb.CorporativoBusinessBankingCheckoutWeb), {})
    },
    // =========================
    // PIXIE
    // =========================
    /* BORRAR LUEGO DEL 01/10/2025
  { path: "/pixie-landing", element: <PixieLanding /> },
  { path: "/pixie-card-details", element: <PixieCardDetails /> },
  { path: "/pixie-onboarding", element: <PixieOnboarding /> },
  { path: "/pixie-onboarding-tutorial-easy", element: <PixieOnboardingTutorialEasy /> },
  { path: "/pixie-onboarding-welcome", element: <PixieOnboardingWelcome /> },
  { path: "/pixie-onboarding-steppper", element: <PixieOnboardingStepper /> },
  { path: "/pixie-onboarding-card-id", element: <PixieOnboardingCardId /> },
  { path: "/pixie-onboarding-phone", element: <PixieOnboardingPhone /> },
  { path: "/pixie-user-dashboard", element: <UserDashboard /> },
  { path: "/pixie-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/pixie-login-dashboard", element: <CorporativoLoginDashboard /> },
  */ // NUEVAS rutas pixie (vxlab)
    {
        path: "/vxlab-login-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboarding.PixieOnboarding), {})
    },
    {
        path: "/vxlab-landing-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieLanding.PixieLanding), {})
    },
    {
        path: "/vxlab-onboarding_register-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboarding.PixieOnboarding), {})
    },
    {
        path: "/vxlab-card_details-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieCardDetails.PixieCardDetails), {})
    },
    {
        path: "/vxlab-onboarding_tutorial_easy-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboardingTutorialEasy.PixieOnboardingTutorialEasy), {})
    },
    {
        path: "/vxlab-onboarding_welcome-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboardingWelcome.PixieOnboardingWelcome), {})
    },
    {
        path: "/vxlab-onboarding_steppper-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboardingStepper.PixieOnboardingStepper), {})
    },
    {
        path: "/vxlab-onboarding_card_id-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboardingCardId.PixieOnboardingCardId), {})
    },
    {
        path: "/vxlab-onboarding_phone-pixie-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pixieOnboardingPhone.PixieOnboardingPhone), {})
    },
    // =========================
    // ADULTOS
    // =========================
    /* BORRAR LUEGO DEL 01/10/2025
  { path: "/adultos-landing", element: <AdultosLanding /> },
  { path: "/adultos-card-details", element: <AdultosCardDetails /> },
  { path: "/adultos-onboarding", element: <AdultosOnboarding /> },
  { path: "/adultos-onboarding-tutorial-easy", element: <AdultosOnboardingTutorialEasy /> },
  { path: "/adultos-onboarding-welcome", element: <AdultosOnboardingWelcome /> },
  { path: "/adultos-onboarding-steppper", element: <AdultosOnboardingStepper /> },
  { path: "/adultos-onboarding-card-id", element: <AdultosOnboardingCardId /> },
  { path: "/adultos-onboarding-phone", element: <AdultosOnboardingPhone /> },
  { path: "/adultos-user-dashboard", element: <UserDashboard /> },
  { path: "/adultos-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/adultos-login-dashboard", element: <CorporativoLoginDashboard /> },
   */ // NUEVAS rutas adultos (vxlab)
    {
        path: "/vxlab-login-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboarding.AdultosOnboarding), {})
    },
    {
        path: "/vxlab-landing-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosLanding.AdultosLanding), {})
    },
    {
        path: "/vxlab-onboarding_register-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboarding.AdultosOnboarding), {})
    },
    {
        path: "/vxlab-card_details-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosCardDetails.AdultosCardDetails), {})
    },
    {
        path: "/vxlab-onboarding_tutorial_easy-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboardingTutorialEasy.AdultosOnboardingTutorialEasy), {})
    },
    {
        path: "/vxlab-onboarding_welcome-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboardingWelcome.AdultosOnboardingWelcome), {})
    },
    {
        path: "/vxlab-onboarding_steppper-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboardingStepper.AdultosOnboardingStepper), {})
    },
    {
        path: "/vxlab-onboarding_card_id-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboardingCardId.AdultosOnboardingCardId), {})
    },
    {
        path: "/vxlab-onboarding_phone-adultos-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adultosOnboardingPhone.AdultosOnboardingPhone), {})
    },
    // =========================
    // YOUNG
    // =========================
    /* BORRAR LUEGO DEL 01/10/2025
  { path: "/young-landing", element: <YoungLanding /> },
  { path: "/young-card-details", element: <YoungCardDetails /> },
  { path: "/young-onboarding", element: <YoungOnboarding /> },
  { path: "/young-onboarding-tutorial-easy", element: <YoungOnboardingTutorialEasy /> },
  { path: "/young-onboarding-welcome", element: <YoungOnboardingWelcome /> },
  { path: "/young-onboarding-steppper", element: <YoungOnboardingStepper /> },
  { path: "/young-onboarding-card-id", element: <YoungOnboardingCardId /> },
  { path: "/young-onboarding-phone", element: <YoungOnboardingPhone /> },
  { path: "/young-user-dashboard", element: <UserDashboard /> },
  { path: "/young-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/young-login-dashboard", element: <CorporativoLoginDashboard /> },
  */ // NUEVAS rutas young (vxlab)
    {
        path: "/vxlab-login-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboarding.YoungOnboarding), {})
    },
    {
        path: "/vxlab-landing-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngLanding.YoungLanding), {})
    },
    {
        path: "/vxlab-onboarding_register-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboarding.YoungOnboarding), {})
    },
    {
        path: "/vxlab-card_details-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngCardDetails.YoungCardDetails), {})
    },
    {
        path: "/vxlab-onboarding_tutorial_easy-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboardingTutorialEasy.YoungOnboardingTutorialEasy), {})
    },
    {
        path: "/vxlab-onboarding_welcome-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboardingWelcome.YoungOnboardingWelcome), {})
    },
    {
        path: "/vxlab-onboarding_steppper-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboardingStepper.YoungOnboardingStepper), {})
    },
    {
        path: "/vxlab-onboarding_card_id-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboardingCardId.YoungOnboardingCardId), {})
    },
    {
        path: "/vxlab-onboarding_phone-young-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youngOnboardingPhone.YoungOnboardingPhone), {})
    },
    // Rutas corporativo Telco
    {
        path: "/telco-login-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoTelco.CorporativoTelco), {})
    },
    {
        path: "/telco-landing-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLandingTelco.CorporativoLandingTelco), {})
    },
    {
        path: "/telco-onboarding_register-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoTelco.CorporativoTelco), {})
    },
    {
        path: "/telco-onboarding_tutorial_easy-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingTutorialEasyTelco.CorporativoOnboardingTutorialEasyTelco), {})
    },
    {
        path: "/telco-onboarding_welcome-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingWelcomeTelco.CorporativoOnboardingWelcomeTelco), {})
    },
    {
        path: "/telco-onboarding_steppper-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingStepperTelco.CorporativoOnboardingStepperTelco), {})
    },
    {
        path: "/telco-onboarding_card_id-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingCardIdTelco.CorporativoOnboardingCardIdTelco), {})
    },
    {
        path: "/telco-onboarding_phone-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingPhoneTelco.CorporativoOnboardingPhoneTelco), {})
    },
    // Rutas corporativo Regional
    {
        path: "/regional_retail-login-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoRegional.CorporativoRegional), {})
    },
    {
        path: "/regional_retail-landing-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLandingRegional.CorporativoLandingRegional), {})
    },
    {
        path: "/regional_retail-card-details-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoCardRegional.CorporativoCardRegional), {})
    },
    {
        path: "/regional_retail-onboarding_register-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoRegional.CorporativoRegional), {})
    },
    {
        path: "/regional_retail-onboarding_tutorial_easy-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingTutorialEasyRegional.CorporativoOnboardingTutorialEasyRegional), {})
    },
    {
        path: "/regional_retail-onboarding_welcome-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingWelcomeRegional.CorporativoOnboardingWelcomeRegional), {})
    },
    {
        path: "/regional_retail-onboarding_steppper-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingStepperRegional.CorporativoOnboardingStepperRegional), {})
    },
    {
        path: "/regional_retail-onboarding_card_id-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingCardIdRegional.CorporativoOnboardingCardIdRegional), {})
    },
    {
        path: "/regional_retail-onboarding_phone-corporativo-mobile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoOnboardingPhoneRegional.CorporativoOnboardingPhoneRegional), {})
    },
    // =========================
    // VISA MOBILE
    // =========================
    ...visaMobileRoutes,
    // =========================
    // BACKOFFICE WEB
    // =========================
    {
        path: "/backoffice-login-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-login-pixie-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-login-adultos-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-login-young-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-login-visa-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-login-wallet-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _corporativoLoginDashboard.CorporativoLoginDashboard), {})
    },
    {
        path: "/backoffice-users-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-users-pixie-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-users-adultos-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-users-young-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-users-visa-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-users-wallet-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDashboard.UserDashboard), {})
    },
    {
        path: "/backoffice-user_details-corporativo-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    },
    {
        path: "/backoffice-user_details-pixie-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    },
    {
        path: "/backoffice-user_details-adultos-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    },
    {
        path: "/backoffice-user_details-young-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    },
    {
        path: "/backoffice-user_details-visa-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    },
    {
        path: "/backoffice-user_details-wallet-web",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDetailsDashboard.UserDetailsDashboard), {})
    }
]);
const App = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
        router: router
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./screens/UserDashboard":"bJmFh","./screens/UserDetailsDashboard":"hTEfG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","./screens/Telco/Corporativo/Mobile/CorporativoLandingTelco":"9GtlQ","./screens/VXLab/Simple/Mobile/OnboardingRegisterVisaMobile":"ilag0","./screens/VXLab/Simple/Mobile/OnboardingLandingVisaMobile":"1Cxlp","./screens/VXLab/Simple/Mobile/CardDetailsVisaMobile":"kD8NH","./screens/VXLab/Simple/Mobile/DisclosuresVisaMobile":"2l7l6","./screens/VXLab/Simple/Mobile/PhoneStep1VisaMobile":"bBvww","./screens/VXLab/Simple/Mobile/PhoneStep2VisaMobile":"jdi9l","./screens/VXLab/Simple/Mobile/OnboardingSuccessVisaMobile":"6Xfiv","./screens/Telco/Corporativo/Mobile/CorporativoTelco":"jkonB","./screens/RegionalRetail/Corporativo/Mobile/CorporativoRegional":"2hnjE","./screens/VXLab/Corporativo/Mobile/Corporativo":"fdDqo","./screens/VXLab/Corporativo/Mobile/CorporativoLanding":"5S7pv","./screens/VXLab/Corporativo/Mobile/CorporativoCard":"aFj7S","./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingTutorialEasy":"3GLaK","./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingWelcome":"jTin8","./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingStepper":"71qD6","./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingCardId":"jQTyD","./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingPhone":"9BQzj","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingLoginWeb":"49Gaw","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingProductSelectionCodeWeb":"1tKSh","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentsWeb":"ar8LY","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailWeb":"9gVqk","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailCodeWeb":"dRXlT","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingSignupWeb":"LvJ0j","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingStepperWeb":"an1mT","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCredentialsWeb":"hgljw","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentIdWeb":"2SC88","./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCheckoutWeb":"7BMlU","./screens/VXLab/Pixie/Mobile/PixieOnboarding":"gbhH1","./screens/VXLab/Pixie/Mobile/PixieLanding":"4WDBZ","./screens/VXLab/Pixie/Mobile/PixieCardDetails":"koQK1","./screens/VXLab/Pixie/Mobile/PixieOnboardingTutorialEasy":"39byp","./screens/VXLab/Pixie/Mobile/PixieOnboardingWelcome":"jTycc","./screens/VXLab/Pixie/Mobile/PixieOnboardingStepper":"XmR4d","./screens/VXLab/Pixie/Mobile/PixieOnboardingCardId":"a2vcV","./screens/VXLab/Pixie/Mobile/PixieOnboardingPhone":"f1DVo","./screens/VXLab/Adults/Mobile/AdultosOnboarding":"2oBV1","./screens/VXLab/Adults/Mobile/AdultosLanding":"kF3OL","./screens/VXLab/Adults/Mobile/AdultosCardDetails":"jAFX0","./screens/VXLab/Adults/Mobile/AdultosOnboardingTutorialEasy":"3px1w","./screens/VXLab/Adults/Mobile/AdultosOnboardingWelcome":"8tHLe","./screens/VXLab/Adults/Mobile/AdultosOnboardingStepper":"cLe84","./screens/VXLab/Adults/Mobile/AdultosOnboardingCardId":"dfkf6","./screens/VXLab/Adults/Mobile/AdultosOnboardingPhone":"60gqD","./screens/VXLab/Young/Mobile/YoungOnboarding":"bgMjd","./screens/Telco/Corporativo/Mobile/CorporativoOnboardingTutorialEasyTelco":"9YXCR","./screens/Telco/Corporativo/Mobile/CorporativoOnboardingWelcomeTelco":"gcyDs","./screens/Telco/Corporativo/Mobile/CorporativoOnboardingStepperTelco":"6ACwN","./screens/Telco/Corporativo/Mobile/CorporativoOnboardingCardIdTelco":"9cdlb","./screens/Telco/Corporativo/Mobile/CorporativoOnboardingPhoneTelco":"f7o6c","./screens/RegionalRetail/Corporativo/Mobile/CorporativoLandingRegional":"4l8UB","./screens/RegionalRetail/Corporativo/Mobile/CorporativoCardRegional":"6yyDQ","./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingTutorialEasyRegional":"jkHvY","./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingWelcomeRegional":"6Ddn9","./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingStepperRegional":"9QovJ","./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingCardIdRegional":"khQcb","./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingPhoneRegional":"N32jz","./screens/VXLab/Corporativo/Mobile/CorporativoLoginDashboard":"iXtDk","./screens/VXLab/Simple/Mobile/SkanId1VisaMobile":"j4NfX","./screens/VXLab/Simple/Mobile/SkanId2VisaMobile":"1Jump","./screens/NotFound":"84Bgq","./screens/VXLab/Young/Mobile/YoungLanding":"f0KVh","./screens/VXLab/Young/Mobile/YoungCardDetails":"6FYQ7","./screens/VXLab/Young/Mobile/YoungOnboardingTutorialEasy":"e96qW","./screens/VXLab/Young/Mobile/YoungOnboardingWelcome":"lKPyd","./screens/VXLab/Young/Mobile/YoungOnboardingStepper":"S1Fva","./screens/VXLab/Young/Mobile/YoungOnboardingCardId":"kypKv","./screens/VXLab/Young/Mobile/YoungOnboardingPhone":"289aS"}],"f3cgC":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"bmhQu","react-dom":"82aNB","react-router":"9oT3O","@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9oT3O":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator, static: isStatic } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"bmhQu","@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jit4b":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"bJmFh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserDashboard", ()=>UserDashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactChartjs2 = require("react-chartjs-2");
var _chartJs = require("chart.js");
var _useDynamicColors = require("../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
(0, _chartJs.Chart).register((0, _chartJs.CategoryScale), (0, _chartJs.LinearScale), (0, _chartJs.PointElement), (0, _chartJs.LineElement), (0, _chartJs.Title), (0, _chartJs.Tooltip), (0, _chartJs.Legend), (0, _chartJs.ArcElement));
const optionsDoughnut = {
    plugins: {
        legend: {
            labels: {
                usePointStyle: true,
                pointStyle: "circle"
            }
        }
    }
};
const options = {
    scales: {
        x: {
            grid: {
                display: false
            }
        },
        y: {
            grid: {
                display: false
            }
        }
    }
};
const UserDashboard = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    // Styles
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "10px",
        width: "960px",
        height: "500px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "500px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1100px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    const navLinkStyle = {
        display: "flex",
        alignItems: "center",
        padding: "10px",
        color: colors.primario,
        textDecoration: "none",
        borderRadius: "5px",
        fontSize: "0.8em",
        fontWeight: "200",
        gap: "10px"
    };
    const inputStyle = {
        padding: "10px",
        border: `1px solid ${colors.primario}`,
        borderRadius: "5px",
        width: "150px"
    };
    const headerCellStyle = {
        padding: "10px",
        fontWeight: "bold",
        color: "#333333"
    };
    const cellStyle = {
        padding: "10px"
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/backoffice-user_details-corporativo-web${currentParams}`);
    };
    const lineData = {
        labels: [
            "<18",
            "19-29",
            "30-39",
            "40-49",
            "50-59",
            ">60"
        ],
        datasets: [
            {
                label: "",
                data: [
                    5,
                    20,
                    30,
                    15,
                    10,
                    2
                ],
                borderColor: `${colors.primario}`,
                backgroundColor: "rgba(0, 102, 255, 0.3)",
                fill: false
            }
        ]
    };
    const doughnutData = {
        labels: [
            "Male",
            "Female"
        ],
        datasets: [
            {
                data: [
                    35,
                    65
                ],
                backgroundColor: [
                    `${colors.secundario}`,
                    `${colors.primario}`
                ],
                hoverBackgroundColor: [
                    colors.secundario,
                    colors.primario
                ]
            }
        ]
    };
    const doughnutDataSystem = {
        labels: [
            "Ios",
            "Android"
        ],
        datasets: [
            {
                data: [
                    88,
                    12
                ],
                backgroundColor: [
                    `${colors.secundario}`,
                    `${colors.primario}`
                ],
                hoverBackgroundColor: [
                    colors.secundario,
                    colors.primario
                ]
            }
        ]
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            display: "flex",
                            fontFamily: "Inter"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    width: "150px",
                                    backgroundColor: "#E0E0E0",
                                    padding: "20px",
                                    height: "100vh",
                                    boxSizing: "border-box"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            textAlign: "center",
                                            marginBottom: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: colors.url_logo ?? "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png",
                                                alt: "Logo",
                                                style: {
                                                    width: "60px",
                                                    marginBottom: "10px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                style: {
                                                    color: `${colors.primario}`,
                                                    fontSize: "0.8em",
                                                    fontWeight: "300",
                                                    marginTop: 10
                                                },
                                                children: "It's nice to see u!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "15px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Users"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Merchants"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Banners"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 640 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Campaigns"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Audits"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    flexGrow: 1,
                                    padding: "20px",
                                    backgroundColor: "#F3F4F6"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: `${colors.primario}`,
                                            color: "white",
                                            padding: "15px",
                                            marginLeft: -20,
                                            marginRight: -20,
                                            marginTop: -20
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                style: {
                                                    fontSize: "1em",
                                                    fontWeight: "bold"
                                                },
                                                children: "Dashboard Administrator"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: {
                                                                    marginRight: "20px"
                                                                },
                                                                children: "User"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: {
                                                                    marginRight: "20px"
                                                                },
                                                                children: "Admin"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: "#FFFFFF",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 512 512",
                                                            width: 20,
                                                            height: 20,
                                                            fill: "#FFFFFF"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            marginLeft: 15
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z",
                                                                fill: "#FFFFFF"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 512 512",
                                                                width: 20,
                                                                height: 20,
                                                                fill: "#FFFFFF",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z",
                                                                    fill: "#FFFFFF"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            marginTop: "20px",
                                            gap: "15px",
                                            minHeight: 185
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "#FFFFFF",
                                                    padding: "20px",
                                                    borderRadius: "8px",
                                                    width: "65%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            textAlign: "center",
                                                            marginRight: "20px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: "img/QR.png",
                                                                alt: "QR Code",
                                                                style: {
                                                                    width: "100px",
                                                                    marginBottom: "10px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                style: {
                                                                    color: `${colors.primario}`,
                                                                    fontWeight: "bold",
                                                                    fontSize: "0.7em"
                                                                },
                                                                children: "Download VXApp and Try Me!"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            textAlign: "center",
                                                            flex: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                                style: {
                                                                    color: `${colors.primario}`,
                                                                    fontSize: "1.5em",
                                                                    fontWeight: "600"
                                                                },
                                                                children: "VXApp Experience"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: {
                                                                    fontSize: "1em",
                                                                    marginTop: 10,
                                                                    color: `${colors.primario}`,
                                                                    fontWeight: "bold"
                                                                },
                                                                children: "62 Active Users"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                                                style: {
                                                                    margin: "10px 0",
                                                                    borderColor: "#f7f7f7"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "space-around",
                                                                    fontWeight: "bold"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        style: {
                                                                            color: "green"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                children: "Actives"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: "1.2em"
                                                                                },
                                                                                children: "55"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        style: {
                                                                            color: "blue"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                children: "Review"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: "1.2em"
                                                                                },
                                                                                children: "4"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                children: "Rejected"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: "1.2em"
                                                                                },
                                                                                children: "3"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    backgroundColor: "white",
                                                    padding: "20px",
                                                    borderRadius: "8px",
                                                    width: "35%",
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Line), {
                                                        data: lineData,
                                                        options: options
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        style: {
                                                            color: `${colors.primario}`,
                                                            fontSize: "1em",
                                                            fontWeight: "600",
                                                            marginBottom: 10,
                                                            marginTop: 10
                                                        },
                                                        children: "Last 30 Days Evolution"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            marginTop: "20px",
                                            gap: "15px",
                                            minHeight: 185
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "top",
                                                    justifyContent: "center",
                                                    backgroundColor: "#FFFFFF",
                                                    padding: "5px",
                                                    borderRadius: "8px",
                                                    width: "65%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            backgroundColor: "white",
                                                            padding: "10px",
                                                            borderRadius: "8px",
                                                            width: "50%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    textAlign: "center"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Doughnut), {
                                                                data: doughnutData,
                                                                options: optionsDoughnut
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            backgroundColor: "white",
                                                            padding: "10px",
                                                            borderRadius: "8px",
                                                            width: "50%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    textAlign: "center"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Doughnut), {
                                                                data: doughnutDataSystem,
                                                                options: optionsDoughnut
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    backgroundColor: "white",
                                                    padding: "20px",
                                                    borderRadius: "8px",
                                                    width: "35%",
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Line), {
                                                        data: lineData,
                                                        options: options
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        style: {
                                                            color: `${colors.primario}`,
                                                            fontSize: "1em",
                                                            fontWeight: "600",
                                                            marginBottom: 10,
                                                            marginTop: 10
                                                        },
                                                        children: "Age Segmentation"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            backgroundColor: "white",
                                            padding: "20px",
                                            marginTop: "20px",
                                            borderRadius: "8px",
                                            display: "flex",
                                            gap: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                placeholder: "Name",
                                                style: inputStyle
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                style: inputStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        children: "User Status"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        children: "Active"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        children: "Inactive"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "date",
                                                style: inputStyle
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "date",
                                                style: inputStyle
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                style: {
                                                    backgroundColor: `${colors.primario}`,
                                                    color: "white",
                                                    padding: "10px 15px",
                                                    borderRadius: "5px",
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                children: "Search"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            backgroundColor: "white",
                                            padding: "20px",
                                            marginTop: "20px",
                                            borderRadius: "8px"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                            style: {
                                                width: "100%",
                                                borderCollapse: "collapse"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                        style: {
                                                            textAlign: "left"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: headerCellStyle,
                                                                children: "Id"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: headerCellStyle,
                                                                children: "User Details"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: headerCellStyle,
                                                                children: "Contact Info"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: headerCellStyle,
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: headerCellStyle,
                                                                children: "Action"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                        style: {
                                                            borderBottom: "1px solid #E0E0E0"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: cellStyle,
                                                                children: "1"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: cellStyle,
                                                                children: "John Doe"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: cellStyle,
                                                                children: "johndoe@example.com"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: cellStyle,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    style: {
                                                                        backgroundColor: "#00c228",
                                                                        color: "#ffffff",
                                                                        padding: "5px 10px",
                                                                        borderRadius: "5px"
                                                                    },
                                                                    children: "Approved"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: cellStyle,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        gap: 12
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            onClick: handleButtonClick,
                                                                            className: "highlighted-button",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                viewBox: "0 0 512 512",
                                                                                width: 20,
                                                                                height: 20,
                                                                                fill: colors.primario,
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                    d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z",
                                                                                    fill: colors.primario
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                viewBox: "0 0 448 512",
                                                                                width: 20,
                                                                                height: 20,
                                                                                fill: "#F44336",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                    d: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z",
                                                                                    fill: "#F44336"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","react-chartjs-2":"by1A5","chart.js":"epfF8","../../hooks/useDynamicColors":"b2GRH","./style.css":"3C11K","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"by1A5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
parcelHelpers.export(exports, "Bubble", ()=>Bubble);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Doughnut", ()=>Doughnut);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Pie", ()=>Pie);
parcelHelpers.export(exports, "PolarArea", ()=>PolarArea);
parcelHelpers.export(exports, "Radar", ()=>Radar);
parcelHelpers.export(exports, "Scatter", ()=>Scatter);
parcelHelpers.export(exports, "getDatasetAtEvent", ()=>getDatasetAtEvent);
parcelHelpers.export(exports, "getElementAtEvent", ()=>getElementAtEvent);
parcelHelpers.export(exports, "getElementsAtEvent", ()=>getElementsAtEvent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _chartJs = require("chart.js");
const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function ChartComponent(props, ref) {
    const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
    const canvasRef = (0, _react.useRef)(null);
    const chartRef = (0, _react.useRef)(null);
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, _chartJs.Chart)(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && options) setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current) setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, _react.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("canvas", {
        ref: canvasRef,
        role: "img",
        height: height,
        width: width,
        ...canvasProps
    }, fallbackContent);
}
const Chart = /*#__PURE__*/ (0, _react.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
    (0, _chartJs.Chart).register(registerables);
    return /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Chart, {
            ...props,
            ref: ref,
            type: type
        }));
}
const Line = /* #__PURE__ */ createTypedChart('line', (0, _chartJs.LineController));
const Bar = /* #__PURE__ */ createTypedChart('bar', (0, _chartJs.BarController));
const Radar = /* #__PURE__ */ createTypedChart('radar', (0, _chartJs.RadarController));
const Doughnut = /* #__PURE__ */ createTypedChart('doughnut', (0, _chartJs.DoughnutController));
const PolarArea = /* #__PURE__ */ createTypedChart('polarArea', (0, _chartJs.PolarAreaController));
const Bubble = /* #__PURE__ */ createTypedChart('bubble', (0, _chartJs.BubbleController));
const Pie = /* #__PURE__ */ createTypedChart('pie', (0, _chartJs.PieController));
const Scatter = /* #__PURE__ */ createTypedChart('scatter', (0, _chartJs.ScatterController));

},{"react":"bmhQu","chart.js":"epfF8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"epfF8":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersDatasetJs.aM));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersDatasetJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _helpersDatasetJs = require("./chunks/helpers.dataset.js");
var _color = require("@kurkle/color");
class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersDatasetJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();
const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, _helpersDatasetJs.c)(from || transparent);
        const c1 = c0.valid && (0, _helpersDatasetJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, _helpersDatasetJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, _helpersDatasetJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersDatasetJs.e)[cfg.easing] || (0, _helpersDatasetJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersDatasetJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersDatasetJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, _helpersDatasetJs.i)(config)) return;
        const animationOptions = Object.keys((0, _helpersDatasetJs.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, _helpersDatasetJs.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, _helpersDatasetJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if ((0, _helpersDatasetJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersDatasetJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersDatasetJs.s)(value) === (0, _helpersDatasetJs.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function convertObjectDataToArray(data, meta) {
    const { iScale, vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min, max, minDefined, maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale, vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, _helpersDatasetJs.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, _helpersDatasetJs.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, _helpersDatasetJs.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, _helpersDatasetJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, _helpersDatasetJs.i)(data)) {
            const meta = this._cachedMeta;
            this._data = convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, _helpersDatasetJs.u)(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersDatasetJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            updateStacks(this, meta._parsed);
            meta._stacked = isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale, _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersDatasetJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersDatasetJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersDatasetJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersDatasetJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, _helpersDatasetJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersDatasetJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip((0, _helpersDatasetJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, _helpersDatasetJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, _helpersDatasetJs.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersDatasetJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersDatasetJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, _helpersDatasetJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersDatasetJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersDatasetJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start, end, reverse, top, bottom } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersDatasetJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersDatasetJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale, vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index, _cachedMeta: { vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, _helpersDatasetJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersDatasetJs.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersDatasetJs.s)(value) !== (0, _helpersDatasetJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, _helpersDatasetJs.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, _helpersDatasetJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, _helpersDatasetJs.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class BubbleController extends DatasetController {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, _helpersDatasetJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, _helpersDatasetJs.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, _helpersDatasetJs.H), startY, endY);
        const minX = calcMin((0, _helpersDatasetJs.P), startX, endX);
        const minY = calcMin((0, _helpersDatasetJs.P) + (0, _helpersDatasetJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, _helpersDatasetJs.i)(data[start])) {
                const { key = 'value' } = this._parsing;
                getter = (i)=>+(0, _helpersDatasetJs.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersDatasetJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersDatasetJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, _helpersDatasetJs.T);
        let max = -(0, _helpersDatasetJs.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, _helpersDatasetJs.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference, rotation } = this._getRotationExtents();
        const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, _helpersDatasetJs.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersDatasetJs.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersDatasetJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersDatasetJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class LineController extends DatasetController {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class PolarAreaController extends DatasetController {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersDatasetJs.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersDatasetJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class PieController extends DoughnutController {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class RadarController extends DatasetController {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class ScatterController extends DatasetController {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    const { controller, data, _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, _helpersDatasetJs.A) : (0, _helpersDatasetJs.B);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale } = controller._cachedMeta;
                const { _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index, data } = metasets[i];
        const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersDatasetJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle, endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle } = (0, _helpersDatasetJs.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, _helpersDatasetJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack, stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack, pos, stackWeight } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth, hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos, box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, _helpersDatasetJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same, other } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x, y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, _helpersDatasetJs.h)(stack.start)) y = stack.start;
            if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, _helpersDatasetJs.h)(stack.start)) x = stack.start;
            if (box.fullSize) setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, _helpersDatasetJs.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, _helpersDatasetJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersDatasetJs.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersDatasetJs.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, _helpersDatasetJs.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, _helpersDatasetJs.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const eventListenerOptions = (0, _helpersDatasetJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x, y } = (0, _helpersDatasetJs.z)(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, _helpersDatasetJs.I)(canvas);
    if (!container) return;
    const resize = (0, _helpersDatasetJs.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, _helpersDatasetJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, _helpersDatasetJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersDatasetJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, _helpersDatasetJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersDatasetJs.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersDatasetJs.x)(this.x) && (0, _helpersDatasetJs.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, _helpersDatasetJs.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, _helpersDatasetJs.v)(majorStart, 0);
    const end = Math.min((0, _helpersDatasetJs.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersDatasetJs.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, _helpersDatasetJs.a0)(options.font, fallback);
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    const lines = (0, _helpersDatasetJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersDatasetJs.j)(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersDatasetJs.j)(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    let ret = (0, _helpersDatasetJs.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top, left, bottom, right, chart } = scale;
    const { chartArea, scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersDatasetJs.a2)(align, left, right);
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, _helpersDatasetJs.H) : (0, _helpersDatasetJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
        _userMin = (0, _helpersDatasetJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersDatasetJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersDatasetJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersDatasetJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersDatasetJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersDatasetJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersDatasetJs.g)(_userMin),
            maxDefined: (0, _helpersDatasetJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersDatasetJs.O)(min, (0, _helpersDatasetJs.O)(max, min)),
            max: (0, _helpersDatasetJs.O)(max, (0, _helpersDatasetJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero, grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersDatasetJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersDatasetJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersDatasetJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, _helpersDatasetJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersDatasetJs.U)(Math.min(Math.asin((0, _helpersDatasetJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersDatasetJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersDatasetJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersDatasetJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first, last, widest, highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, _helpersDatasetJs.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align, padding }, position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersDatasetJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis, position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersDatasetJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersDatasetJs.k)(label) && !(0, _helpersDatasetJs.b)(label)) {
                width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersDatasetJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersDatasetJs.k)(nestedLabel) && !(0, _helpersDatasetJs.b)(nestedLabel)) {
                    width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, _helpersDatasetJs.W)(this._alignToPixels ? (0, _helpersDatasetJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min, max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, _helpersDatasetJs.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid, position, border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, _helpersDatasetJs.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, _helpersDatasetJs.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersDatasetJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align, crossAlign, padding, mirror } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersDatasetJs.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position, ticks } = this.options;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position, ticks: { crossAlign, mirror, padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx, options: { backgroundColor }, left, top, width, height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart, ctx, options: { border, grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersDatasetJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersDatasetJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersDatasetJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersDatasetJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, _helpersDatasetJs.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, _helpersDatasetJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, _helpersDatasetJs.$)(ctx);
    }
    drawTitle() {
        const { ctx, options: { position, title, reverse } } = this;
        if (!title.display) return;
        const font = (0, _helpersDatasetJs.a0)(title.font);
        const padding = (0, _helpersDatasetJs.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, _helpersDatasetJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersDatasetJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
        (0, _helpersDatasetJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, _helpersDatasetJs.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, _helpersDatasetJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersDatasetJs.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersDatasetJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersDatasetJs.d)[scope]) {
            delete (0, _helpersDatasetJs.d)[scope][id];
            if (this.override) delete (0, _helpersDatasetJs.a3)[id];
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, _helpersDatasetJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersDatasetJs.d).get(parentScope) : {},
        (0, _helpersDatasetJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersDatasetJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersDatasetJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, _helpersDatasetJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersDatasetJs.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, _helpersDatasetJs.a5)(method);
        (0, _helpersDatasetJs.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, _helpersDatasetJs.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, _helpersDatasetJs.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersDatasetJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, _helpersDatasetJs.v)(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    const datasetDefaults = (0, _helpersDatasetJs.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = (0, _helpersDatasetJs.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, _helpersDatasetJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersDatasetJs.d).scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersDatasetJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = (0, _helpersDatasetJs.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersDatasetJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, _helpersDatasetJs.ab)(scale, [
            (0, _helpersDatasetJs.d).scales[scale.type],
            (0, _helpersDatasetJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, _helpersDatasetJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = (0, _helpersDatasetJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options, type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options, type } = this;
        return [
            options,
            (0, _helpersDatasetJs.a3)[type] || {},
            (0, _helpersDatasetJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersDatasetJs.d),
            (0, _helpersDatasetJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersDatasetJs.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersDatasetJs.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
        return (0, _helpersDatasetJs.i)(context) ? (0, _helpersDatasetJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, _helpersDatasetJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>(0, _helpersDatasetJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersDatasetJs.a7)(value[key]));
function needContext(proxy, names) {
    const { isScriptable, isIndexable } = (0, _helpersDatasetJs.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, _helpersDatasetJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersDatasetJs.b)(value)) return true;
    }
    return false;
}
var version = "4.4.9";
const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersDatasetJs.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class Chart {
    static defaults = (0, _helpersDatasetJs.d);
    static instances = instances;
    static overrides = (0, _helpersDatasetJs.a3);
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, _helpersDatasetJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersDatasetJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
        if (!(0, _helpersDatasetJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, _helpersDatasetJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, _helpersDatasetJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersDatasetJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, _helpersDatasetJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, _helpersDatasetJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, _helpersDatasetJs.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = (0, _helpersDatasetJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersDatasetJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersDatasetJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType, dataElementType } = (0, _helpersDatasetJs.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersDatasetJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersDatasetJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active, _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersDatasetJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, _helpersDatasetJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method, start, count } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, _helpersDatasetJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersDatasetJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, _helpersDatasetJs.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width, height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, _helpersDatasetJs.ah)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, _helpersDatasetJs.Y)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, _helpersDatasetJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, _helpersDatasetJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersDatasetJs.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersDatasetJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas, ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersDatasetJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersDatasetJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersDatasetJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersDatasetJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, _helpersDatasetJs.aj)(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersDatasetJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersDatasetJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return (0, _helpersDatasetJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
    const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersDatasetJs.H), startAngle - (0, _helpersDatasetJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersDatasetJs.al)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersDatasetJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersDatasetJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersDatasetJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x, y, startAngle: start, pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersDatasetJs.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersDatasetJs.H));
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, _helpersDatasetJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersDatasetJs.H));
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, _helpersDatasetJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference, options } = element;
    const { borderWidth, borderJoinStyle, borderDash, borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle, distance } = (0, _helpersDatasetJs.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, _helpersDatasetJs.v)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, _helpersDatasetJs.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, _helpersDatasetJs.T) || nonZeroBetween;
        const withinRadius = (0, _helpersDatasetJs.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset, spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options, circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersDatasetJs.T) ? Math.floor(circumference / (0, _helpersDatasetJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, _helpersDatasetJs.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, _helpersDatasetJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersDatasetJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersDatasetJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersDatasetJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersDatasetJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersDatasetJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.as;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.at;
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    const { points, options } = line;
    const { count, start, loop, ilen } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move = true, reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count, start, ilen } = pathVars(points, segment, params);
    const { move = true, reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.ap;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.aq;
    return 0, _helpersDatasetJs.ar;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments, options } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersDatasetJs.am)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersDatasetJs.an)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, _helpersDatasetJs.ao)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start, end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersDatasetJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersDatasetJs.au)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function getBarBounds(bar, useFinalPosition) {
    const { x, y, base, width, height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersDatasetJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, _helpersDatasetJs.aw)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, _helpersDatasetJs.ax)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, _helpersDatasetJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersDatasetJs.ak)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersDatasetJs.ak)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount, options: { borderColor, backgroundColor } } = this;
        const { inner, outer } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? (0, _helpersDatasetJs.av) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, base, horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
const BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function containsDefaultColorsDefenitions() {
    return (0, _helpersDatasetJs.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, _helpersDatasetJs.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets }, options: chartOptions } = chart.config;
        const { elements } = chartOptions;
        const containsColorDefenition = containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements) || containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, _helpersDatasetJs.k)(minIndex) && !(0, _helpersDatasetJs.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale } = meta;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data, indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, _helpersDatasetJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersDatasetJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start, end } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, _helpersDatasetJs.ao)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, _helpersDatasetJs.ay)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, _helpersDatasetJs.az)(start);
        end = (0, _helpersDatasetJs.az)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x = null, y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start, end })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, _helpersDatasetJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersDatasetJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    const fill = parseFillOption(line);
    if ((0, _helpersDatasetJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, _helpersDatasetJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, _helpersDatasetJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersDatasetJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, _helpersDatasetJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    const { scale, index, line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first, last, point } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, _helpersDatasetJs.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x, y, radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersDatasetJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x, y, radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}
function _getTarget(source) {
    const { chart, fill, line } = source;
    if ((0, _helpersDatasetJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale = {}, fill } = source;
    const pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersDatasetJs.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale, fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { chart, index, line, scale, axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above = color, below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, _helpersDatasetJs.ah)(chart, meta);
    if (target && line.points.length) {
        (0, _helpersDatasetJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis,
            clip
        });
        (0, _helpersDatasetJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line, target, above, below, area, scale, clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property,
            clip
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property,
        clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line, target, property, color, scale, clip } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src, target: tgt, start, end } of segments){
        const { style: { backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property, start, end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, _helpersDatasetJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options, ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx, maxWidth, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx, maxHeight, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
        const rtlHelper = (0, _helpersDatasetJs.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, _helpersDatasetJs.Y)(ctx, this);
            this._draw();
            (0, _helpersDatasetJs.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes, lineWidths, ctx } = this;
        const { align, labels: labelOpts } = opts;
        const defaultColor = (0, _helpersDatasetJs.d).color;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const { padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, _helpersDatasetJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersDatasetJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersDatasetJs.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, _helpersDatasetJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersDatasetJs.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersDatasetJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersDatasetJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, _helpersDatasetJs.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, _helpersDatasetJs.ax)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersDatasetJs.av)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, _helpersDatasetJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersDatasetJs.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersDatasetJs.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersDatasetJs.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersDatasetJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersDatasetJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, _helpersDatasetJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersDatasetJs.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersDatasetJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, _helpersDatasetJs.ak)(x, this.left, this.right) && (0, _helpersDatasetJs.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersDatasetJs.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersDatasetJs.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersDatasetJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersDatasetJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersDatasetJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle, pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, _helpersDatasetJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class Title extends Element {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, _helpersDatasetJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersDatasetJs.E)(opts.padding);
        const textSize = lineCount * (0, _helpersDatasetJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top, left, bottom, right, options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersDatasetJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
                rotation = (0, _helpersDatasetJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersDatasetJs.a2)(align, top, bottom);
                rotation = (0, _helpersDatasetJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, _helpersDatasetJs.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
        (0, _helpersDatasetJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersDatasetJs.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, _helpersDatasetJs.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersDatasetJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    const { element, datasetIndex, index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label, value } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body, footer, title } = tooltip;
    const { boxWidth, boxHeight } = options;
    const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
    const titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
    const footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersDatasetJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersDatasetJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersDatasetJs.F)(body, (bodyItem)=>{
        (0, _helpersDatasetJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersDatasetJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y, height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x, width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    const { x, width } = size;
    const { width: chartWidth, chartArea: { left, right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x, width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y, height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize, caretPadding, cornerRadius } = options;
    const { xAlign, yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersDatasetJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersDatasetJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersDatasetJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: (0, _helpersDatasetJs.aG),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, _helpersDatasetJs.aG),
    beforeBody: (0, _helpersDatasetJs.aG),
    beforeLabel: (0, _helpersDatasetJs.aG),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, _helpersDatasetJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersDatasetJs.aG),
    afterBody: (0, _helpersDatasetJs.aG),
    beforeFooter: (0, _helpersDatasetJs.aG),
    footer: (0, _helpersDatasetJs.aG),
    afterFooter: (0, _helpersDatasetJs.aG)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks } = options;
        const bodyItems = [];
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign, yAlign } = this;
        const { caretSize, cornerRadius } = options;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width, height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight, boxWidth } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersDatasetJs.au)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersDatasetJs.au)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersDatasetJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, _helpersDatasetJs.ax)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersDatasetJs.av)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersDatasetJs.av)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body } = this;
        const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersDatasetJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersDatasetJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersDatasetJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersDatasetJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign, yAlign } = this;
        const { x, y } = pt;
        const { width, height } = tooltipSize;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ax)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, _helpersDatasetJs.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersDatasetJs.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersDatasetJs.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, _helpersDatasetJs.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX, caretY, options } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : (0, _helpersDatasetJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index, label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersDatasetJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, _helpersDatasetJs.k)(min);
    const maxDefined = !(0, _helpersDatasetJs.k)(max);
    const countDefined = !(0, _helpersDatasetJs.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, _helpersDatasetJs.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersDatasetJs.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersDatasetJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersDatasetJs.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersDatasetJs.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, _helpersDatasetJs.aL)(spacing), (0, _helpersDatasetJs.aL)(niceMin));
    factor = Math.pow(10, (0, _helpersDatasetJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersDatasetJs.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersDatasetJs.aK)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
    const rad = (0, _helpersDatasetJs.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero } = this.options;
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, _helpersDatasetJs.s)(min);
            const maxSign = (0, _helpersDatasetJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit, stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class LinearScale extends LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, _helpersDatasetJs.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const log10Floor = (v)=>Math.floor((0, _helpersDatasetJs.aN)(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
    min = (0, _helpersDatasetJs.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, _helpersDatasetJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, _helpersDatasetJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersDatasetJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersDatasetJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersDatasetJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, _helpersDatasetJs.aN)(start);
        this._valueRange = (0, _helpersDatasetJs.aN)(this.max) - (0, _helpersDatasetJs.aN)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersDatasetJs.aN)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, _helpersDatasetJs.E)(tickOpts.backdropPadding);
        return (0, _helpersDatasetJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersDatasetJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersDatasetJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersDatasetJs.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, _helpersDatasetJs.a0)(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, _helpersDatasetJs.az)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, _helpersDatasetJs.U)(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra, additionalAngle, padding, size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, _helpersDatasetJs.U)((0, _helpersDatasetJs.az)(pointLabelPosition.angle + (0, _helpersDatasetJs.H))));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    const { left, top, right, bottom } = item;
    const apexesInArea = (0, _helpersDatasetJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels, display } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left, top, right, bottom } = item;
    const { backdropColor } = opts;
    if (!(0, _helpersDatasetJs.k)(backdropColor)) {
        const borderRadius = (0, _helpersDatasetJs.ax)(opts.borderRadius);
        const padding = (0, _helpersDatasetJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersDatasetJs.av)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx, options: { pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
        const { x, y, textAlign } = item;
        (0, _helpersDatasetJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersDatasetJs.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color, lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersDatasetJs.j)(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, _helpersDatasetJs.E)(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(false);
        this.min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, _helpersDatasetJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, _helpersDatasetJs.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, _helpersDatasetJs.az)(index * angleMultiplier + (0, _helpersDatasetJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersDatasetJs.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersDatasetJs.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, _helpersDatasetJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left, top, right, bottom } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        const { backgroundColor, grid: { circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines, grid, border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color, lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersDatasetJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersDatasetJs.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser, round, isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, _helpersDatasetJs.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, _helpersDatasetJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo, hi } = (0, _helpersDatasetJs.aQ)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersDatasetJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, _helpersDatasetJs.aP)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersDatasetJs.S)(start, 0, limit);
        end = (0, _helpersDatasetJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, _helpersDatasetJs.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, _helpersDatasetJs.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, _helpersDatasetJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, _helpersDatasetJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersDatasetJs._)(values.sort(sorter));
    }
}
function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
    static defaults = TimeScale.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min, max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
const registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"./chunks/helpers.dataset.js":"c6tkY","@kurkle/color":"haii5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c6tkY":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>getStyle);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>getRtlAdapter);
parcelHelpers.export(exports, "aB", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aC", ()=>_textX);
parcelHelpers.export(exports, "aD", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aE", ()=>drawPointLegend);
parcelHelpers.export(exports, "aF", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aG", ()=>noop);
parcelHelpers.export(exports, "aH", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aI", ()=>niceNum);
parcelHelpers.export(exports, "aJ", ()=>almostWhole);
parcelHelpers.export(exports, "aK", ()=>almostEquals);
parcelHelpers.export(exports, "aL", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aM", ()=>Ticks);
parcelHelpers.export(exports, "aN", ()=>log10);
parcelHelpers.export(exports, "aO", ()=>_longestText);
parcelHelpers.export(exports, "aP", ()=>_filterBetween);
parcelHelpers.export(exports, "aQ", ()=>_lookup);
parcelHelpers.export(exports, "aR", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aS", ()=>getHoverColor);
parcelHelpers.export(exports, "aT", ()=>clone);
parcelHelpers.export(exports, "aU", ()=>_merger);
parcelHelpers.export(exports, "aV", ()=>_mergerIf);
parcelHelpers.export(exports, "aW", ()=>_deprecated);
parcelHelpers.export(exports, "aX", ()=>_splitKey);
parcelHelpers.export(exports, "aY", ()=>toFontString);
parcelHelpers.export(exports, "aZ", ()=>splineCurve);
parcelHelpers.export(exports, "a_", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>getDatasetClipArea);
parcelHelpers.export(exports, "ai", ()=>_elementsEqual);
parcelHelpers.export(exports, "aj", ()=>_isClickEvent);
parcelHelpers.export(exports, "ak", ()=>_isBetween);
parcelHelpers.export(exports, "al", ()=>_readValueToProps);
parcelHelpers.export(exports, "am", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "an", ()=>_computeSegments);
parcelHelpers.export(exports, "ao", ()=>_boundSegments);
parcelHelpers.export(exports, "ap", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "aq", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "ar", ()=>_pointInLine);
parcelHelpers.export(exports, "as", ()=>_steppedLineTo);
parcelHelpers.export(exports, "at", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "au", ()=>drawPoint);
parcelHelpers.export(exports, "av", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "aw", ()=>toTRBL);
parcelHelpers.export(exports, "ax", ()=>toTRBLCorners);
parcelHelpers.export(exports, "ay", ()=>_boundSegment);
parcelHelpers.export(exports, "az", ()=>_normalizeAngle);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>fontString);
parcelHelpers.export(exports, "b1", ()=>toLineHeight);
parcelHelpers.export(exports, "b2", ()=>PITAU);
parcelHelpers.export(exports, "b3", ()=>INFINITY);
parcelHelpers.export(exports, "b4", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b5", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b6", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b7", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function isNumber(n) {
    return !isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale, vScale, _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = _limitValue(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = _limitValue(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale, yScale, _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
const formatters = {
    values (value) {
        return isArray(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ''), scope);
}
class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x, y, w, h, radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min, max } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = _resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy, _context, _subProxy, _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale } = meta;
    const { key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX, offsetY } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) return event;
    const { canvas, currentDevicePixelRatio } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x, y, box } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width, height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width, height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === 'angle') return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start, end, count, loop, style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property, start: startBound, end: endBound } = bounds;
    const { between, normalize } = propertyFn(property);
    const count = points.length;
    let { start, end, loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare, between, normalize } = propertyFn(property);
    const { start, end, loop, style } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale, yScale } = meta;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, 'left'),
        right: getSizeForArea(xScale, chartArea, 'right'),
        top: getSizeForArea(yScale, chartArea, 'top'),
        bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function getDatasetClipArea(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

},{"@kurkle/color":"haii5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"haii5":[function(require,module,exports,__globalThis) {
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
const lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
const map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const hex = [
    ...'0123456789ABCDEF'
];
const h1 = (b)=>hex[b & 0xF];
const h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
const alpha = (a, f)=>a < 255 ? f(a) : '';
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    const rgb = hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    const m = HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    const h = hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    const a = rgb2hsl(v);
    const h = a[0];
    const s = n2p(a[1]);
    const l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function unpack() {
    const unpacked = {};
    const keys = Object.keys(names$1);
    const tkeys = Object.keys(map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    const m = RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    const r = from(b2n(rgb1.r));
    const g = from(b2n(rgb1.g));
    const b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        let tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === 'r') return rgbParse(str);
    return hueParse(str);
}
class Color {
    constructor(input){
        if (input instanceof Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = fromObject(input);
        else if (type === 'string') v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b2GRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
const defaultColors = {
    primario: "#0066FF",
    secundario: "#01087A",
    terciario: "#2222E3",
    cuaternario: "#D6E4F9",
    quinto: "#02087A",
    sexto: "#E4F3FF",
    septimo: "#9F0DFF"
};
const useDynamicColors = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const queryParams = new URLSearchParams(location.search);
    const colors = {
        primario: `#${queryParams.get("primario")}` || defaultColors.primario,
        secundario: `#${queryParams.get("secundario")}` || defaultColors.secundario,
        terciario: `#${queryParams.get("terciario")}` || defaultColors.terciario,
        cuaternario: `#${queryParams.get("cuaternario")}` || defaultColors.cuaternario,
        quinto: `#${queryParams.get("quinto")}` || defaultColors.quinto,
        sexto: `#${queryParams.get("sexto")}` || defaultColors.sexto,
        septimo: `#${queryParams.get("septimo")}` || defaultColors.septimo,
        url_logo: `${queryParams.get("url_logo") || ""}`,
        url_card: `${queryParams.get("url_card") || ""}`
    };
    (0, _react.useEffect)(()=>{
        document.documentElement.style.setProperty("--primario", colors.primario);
        document.documentElement.style.setProperty("--secundario", colors.secundario);
        document.documentElement.style.setProperty("--terciario", colors.terciario);
        document.documentElement.style.setProperty("--cuaternario", colors.cuaternario);
        document.documentElement.style.setProperty("--quinto", colors.quinto);
        document.documentElement.style.setProperty("--sexto", colors.sexto);
        document.documentElement.style.setProperty("--septimo", colors.septimo);
    }, [
        colors
    ]);
    return colors;
};
exports.default = useDynamicColors;

},{"react":"bmhQu","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3C11K":[function() {},{}],"hTEfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserDetailsDashboard", ()=>UserDetailsDashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTabs = require("react-tabs");
var _reactTabsCss = require("react-tabs/style/react-tabs.css");
var _useDynamicColors = require("../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const TimelineStep = ({ title, date })=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const styles = {
        container: {
            fontFamily: "Inter",
            fontSize: "14px",
            display: "flex",
            height: "100vh",
            backgroundColor: "#f7f9fc"
        },
        screen: {
            backgroundColor: "white",
            borderRadius: "5px",
            overflowY: "scroll",
            overflowX: "hidden",
            width: "100%",
            height: "500px"
        },
        base: {
            position: "absolute",
            width: "1100px",
            height: "20px",
            backgroundColor: "rgb(170, 170, 170)",
            borderRadius: "0px 0px 10px 10px",
            bottom: 0
        },
        laptop: {
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#333",
            borderRadius: "15px 15px 5px 5px",
            padding: "10px",
            width: "960px",
            height: "500px",
            position: "relative",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
        },
        header: {
            display: "flex",
            padding: "20px",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
        },
        title: {
            fontSize: "1.5em",
            color: "rgb(1, 8, 122)",
            fontWeight: 700
        },
        navLinkStyle: {
            display: "flex",
            alignItems: "center",
            padding: "10px",
            color: colors.primario,
            textDecoration: "none",
            borderRadius: "5px",
            fontSize: "0.8em",
            fontWeight: "200",
            gap: "10px"
        },
        disableButton: {
            backgroundColor: "red",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "4px",
            cursor: "pointer"
        },
        tabList: {
            display: "flex",
            borderBottom: "2px solid blue",
            justifyContent: "space-around",
            backgroundColor: "#f5f5f5",
            padding: "10px 0"
        },
        tab: {
            fontWeight: "bold",
            color: colors.primario,
            cursor: "pointer"
        },
        tabSelected: {
            color: colors.secundario,
            borderBottom: "3px solid #0000ff"
        },
        infoGrid: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
        },
        card: {
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "30px"
        },
        personalInfo: {
            display: "flex",
            alignItems: "center",
            gridColumn: "span 2"
        },
        profileImg: {
            width: "60px",
            height: "60px",
            borderRadius: "50%"
        },
        info: {
            margin: 0,
            fontSize: "1.4em"
        },
        approvedStatus: {
            marginTop: 20,
            backgroundColor: "rgb(0, 194, 40)",
            padding: "4px 6px",
            color: "#ffffff",
            borderColor: "rgb(0, 194, 40)",
            borderWidth: "0px",
            borderStyle: "solid",
            borderRadius: "8px",
            textAlign: "center",
            fontSize: "12px"
        },
        icon: {
            width: "60px",
            height: "60px"
        },
        timeline: {
            listStyle: "none",
            padding: 0,
            margin: 0
        },
        timelineItem: {
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 0",
            borderBottom: "1px solid #e0e0e0"
        },
        boldText: {
            fontWeight: "bold"
        },
        onboardingTimeline: {
            padding: "20px",
            borderRadius: "8px",
            backgroundColor: "#fff",
            width: "400px",
            maxWidth: "400px"
        },
        timelineTable: {
            width: "100%",
            marginTop: "5px"
        },
        timelineRow: {
            width: "100%"
        },
        timelineCell: {
            position: "relative",
            width: "100%"
        },
        timelineContainer: {
            display: "flex",
            alignItems: "center",
            marginBottom: "10px"
        },
        timelineIconContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "10px"
        },
        timelineIcon: {
            width: "30px",
            height: "30px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        timelineConnector: {
            width: "2px",
            height: "100%",
            backgroundColor: colors.secundario,
            marginTop: "4px"
        },
        timelineContent: {
            display: "flex",
            flexDirection: "column"
        },
        timelineTitle: {
            fontSize: "12px",
            fontWeight: 300,
            color: colors.secundario
        },
        timelineDate: {
            fontSize: "10px",
            marginTop: 10,
            color: "#555"
        }
    };
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
        style: styles.timelineRow,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
            style: styles.timelineCell,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: styles.timelineContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: styles.timelineIconContainer,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: styles.timelineIcon,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512",
                                    width: "20",
                                    height: "20",
                                    fill: colors.secundario,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: styles.timelineConnector
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: styles.timelineContent,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: styles.timelineTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: styles.timelineDate,
                                children: date
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const UserDetailsDashboard = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const styles = {
        container: {
            fontFamily: "Inter",
            fontSize: "14px",
            display: "flex",
            height: "100vh",
            backgroundColor: "#f7f9fc"
        },
        screen: {
            backgroundColor: "white",
            borderRadius: "5px",
            overflowY: "scroll",
            overflowX: "hidden",
            width: "100%",
            height: "500px"
        },
        base: {
            position: "absolute",
            width: "1100px",
            height: "20px",
            backgroundColor: "rgb(170, 170, 170)",
            borderRadius: "0px 0px 10px 10px",
            bottom: 0
        },
        laptop: {
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#333",
            borderRadius: "15px 15px 5px 5px",
            padding: "10px",
            width: "960px",
            height: "500px",
            position: "relative",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
        },
        header: {
            display: "flex",
            padding: "20px",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
        },
        title: {
            fontSize: "1.5em",
            color: colors.primario,
            fontWeight: 700
        },
        navLinkStyle: {
            display: "flex",
            alignItems: "center",
            padding: "10px",
            color: colors.primario,
            textDecoration: "none",
            borderRadius: "5px",
            fontSize: "0.8em",
            fontWeight: "200",
            gap: "10px"
        },
        disableButton: {
            backgroundColor: "red",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "4px",
            cursor: "pointer"
        },
        tabList: {
            display: "flex",
            borderBottom: "2px solid blue",
            justifyContent: "space-around",
            backgroundColor: "#f5f5f5",
            padding: "10px 0"
        },
        tab: {
            fontWeight: "bold",
            color: colors.primario,
            cursor: "pointer"
        },
        tabSelected: {
            color: colors.primario,
            borderBottom: "3px solid #0000ff"
        },
        infoGrid: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
        },
        card: {
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "30px"
        },
        personalInfo: {
            display: "flex",
            alignItems: "center",
            gridColumn: "span 2"
        },
        profileImg: {
            width: "60px",
            height: "60px",
            borderRadius: "50%"
        },
        info: {
            margin: 0,
            fontSize: "1.4em"
        },
        approvedStatus: {
            marginTop: 20,
            backgroundColor: "rgb(0, 194, 40)",
            padding: "4px 6px",
            color: "#ffffff",
            borderColor: "rgb(0, 194, 40)",
            borderWidth: "0px",
            borderStyle: "solid",
            borderRadius: "8px",
            textAlign: "center",
            fontSize: "12px"
        },
        icon: {
            width: "60px",
            height: "60px"
        },
        timeline: {
            listStyle: "none",
            padding: 0,
            margin: 0
        },
        timelineItem: {
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 0",
            borderBottom: "1px solid #e0e0e0"
        },
        boldText: {
            fontWeight: "bold"
        },
        onboardingTimeline: {
            padding: "20px",
            borderRadius: "8px",
            backgroundColor: "#fff",
            width: "400px",
            maxWidth: "400px"
        },
        timelineTable: {
            width: "100%",
            marginTop: "5px"
        },
        timelineRow: {
            width: "100%"
        },
        timelineCell: {
            position: "relative",
            width: "100%"
        },
        timelineContainer: {
            display: "flex",
            alignItems: "center",
            marginBottom: "10px"
        },
        timelineIconContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "10px"
        },
        timelineIcon: {
            width: "30px",
            height: "30px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        timelineConnector: {
            width: "2px",
            height: "100%",
            backgroundColor: colors.secundario,
            marginTop: "4px"
        },
        timelineContent: {
            display: "flex",
            flexDirection: "column"
        },
        timelineTitle: {
            fontSize: "12px",
            fontWeight: 300,
            color: colors.secundario
        },
        timelineDate: {
            fontSize: "10px",
            marginTop: 10,
            color: "#555"
        }
    };
    const steps = [
        {
            title: "Terms & Conditions Acceptance",
            date: "2024-11-06 18:16:54"
        },
        {
            title: "Email Record",
            date: "2024-11-06 18:17:29"
        },
        {
            title: "ID Record",
            date: "2024-11-06 18:19:14"
        },
        {
            title: "Self Alive",
            date: "2024-11-06 18:19:49"
        },
        {
            title: "SMS Record",
            date: "2024-11-06 18:22:10"
        },
        {
            title: "Credentials generation",
            date: "2024-11-06 18:22:44"
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: styles.laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: styles.screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.container,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                fontFamily: "Inter"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    width: "150px",
                                    backgroundColor: "#E0E0E0",
                                    padding: "20px",
                                    height: "100vh",
                                    boxSizing: "border-box"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            textAlign: "center",
                                            marginBottom: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: colors.url_logo ?? "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png",
                                                alt: "Logo",
                                                style: {
                                                    width: "60px",
                                                    marginBottom: "10px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                style: {
                                                    color: colors.primario,
                                                    fontSize: "0.8em",
                                                    fontWeight: "300",
                                                    marginTop: 10
                                                },
                                                children: "It's nice to see u!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "15px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: `/backoffice-users-corporativo-web${location.search}`,
                                                style: styles.navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Users"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: styles.navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Merchants"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: styles.navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Banners"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: styles.navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 640 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Campaigns"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: "#",
                                                style: styles.navLinkStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: colors.secundario,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z",
                                                            fill: colors.secundario
                                                        })
                                                    }),
                                                    "Audits"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        backgroundColor: colors.primario,
                                        color: "white",
                                        padding: "15px",
                                        // marginLeft: -20,
                                        marginRight: -20
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            style: {
                                                fontSize: "1em",
                                                fontWeight: "bold"
                                            },
                                            children: "Dashboard Administrator"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            style: {
                                                                marginRight: "20px"
                                                            },
                                                            children: "User"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            style: {
                                                                marginRight: "20px"
                                                            },
                                                            children: "Admin"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 512 512",
                                                    width: 20,
                                                    height: 20,
                                                    fill: "#FFFFFF",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 512 512",
                                                        width: 20,
                                                        height: 20,
                                                        fill: "#FFFFFF"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    style: {
                                                        marginLeft: 15
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z",
                                                            fill: "#FFFFFF"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 512 512",
                                                            width: 20,
                                                            height: 20,
                                                            fill: "#FFFFFF",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z",
                                                                fill: "#FFFFFF"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactTabs.Tabs), {
                                    style: {
                                        fontWeight: 300
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                fontWeight: 700,
                                                fontSize: 12,
                                                paddingTop: 40,
                                                paddingLeft: 20,
                                                marginBottom: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    style: {
                                                        color: colors.secundario
                                                    },
                                                    children: "Users / "
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    style: {
                                                        color: colors.primario
                                                    },
                                                    children: "Jhon Doe"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactTabs.TabList), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Onboarding"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Accounts"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Scores"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Transactions"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Trades"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.Tab), {
                                                    children: "Digital Folder"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            ...styles.header,
                                                            width: "100%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: styles.title,
                                                                children: "Customer Detail"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                style: styles.disableButton,
                                                                children: "Disable Account"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 12,
                                                            padding: 20
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    width: "50%"
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                                                    style: styles.infoGrid,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            style: {
                                                                                ...styles.card,
                                                                                ...styles.personalInfo
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                            src: "/img/frame-480954771-5.png",
                                                                                            alt: "Customer Profile",
                                                                                            style: styles.profileImg
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            style: styles.approvedStatus,
                                                                                            children: "Approved"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    style: {
                                                                                        marginLeft: 20
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                                            style: {
                                                                                                fontWeight: 700,
                                                                                                marginBottom: 5
                                                                                            },
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                                                children: "Ana Juliana Fer Hurtado"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Id: 4556789"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Email: test@gmail.com"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Phone: 456890907"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Address: Av buenos Aires."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Gender: Female"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: 12,
                                                                                                marginBottom: 3
                                                                                            },
                                                                                            children: "Birth Date: 03/06/1987"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            style: {
                                                                                                display: "flex",
                                                                                                gap: 8
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    viewBox: "0 0 576 512",
                                                                                                    width: 20,
                                                                                                    height: 20,
                                                                                                    fill: colors.primario,
                                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                        d: "M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z",
                                                                                                        fill: colors.primario
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    viewBox: "0 0 576 512",
                                                                                                    width: 20,
                                                                                                    height: 20,
                                                                                                    fill: colors.primario,
                                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                        d: "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z",
                                                                                                        fill: colors.primario
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            style: styles.card,
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                style: {
                                                                                    display: "flex"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        style: {
                                                                                            width: "30%"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                                            width: 50,
                                                                                            height: 50,
                                                                                            viewBox: "0 0 151 150",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                                    cx: 104.5,
                                                                                                    cy: 103,
                                                                                                    r: 26,
                                                                                                    fill: "#5ECAFA"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z",
                                                                                                    fill: colors.primario
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M100.109 109.207C100.327 109.425 100.586 109.598 100.87 109.716C101.155 109.834 101.46 109.894 101.768 109.894C102.076 109.894 102.381 109.834 102.665 109.716C102.95 109.598 103.208 109.425 103.426 109.207L112.262 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.953 99.3114 113.026 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.869 97.7535C112.752 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.86 96.5636 111.565 96.4452C111.271 96.3268 110.955 96.2695 110.638 96.2767C110.32 96.284 110.008 96.3556 109.719 96.4874C109.43 96.6191 109.171 96.8081 108.957 97.043L101.774 104.227L98.2579 100.711C98.0443 100.476 97.7852 100.287 97.4963 100.155C97.2075 100.024 96.8948 99.952 96.5774 99.9447C96.26 99.9375 95.9445 99.9948 95.6499 100.113C95.3553 100.232 95.0878 100.409 94.8637 100.633C94.6396 100.858 94.4635 101.126 94.3462 101.421C94.2288 101.716 94.1726 102.032 94.181 102.35C94.1894 102.667 94.2621 102.979 94.3949 103.268C94.5276 103.556 94.7176 103.815 94.9532 104.027L100.109 109.207Z",
                                                                                                    fill: colors.primario
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                                                                                    fill: "#9F0DFF"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z",
                                                                                                    fill: "#9F0DFF"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M42.0898 37.8866L50.8905 28.0194C51.0952 27.7886 51.2524 27.5197 51.3532 27.2281C51.4539 26.9365 51.4963 26.6279 51.4778 26.32C51.4593 26.012 51.3803 25.7107 51.2454 25.4333C51.1104 25.1559 50.9222 24.9077 50.6913 24.703C50.4605 24.4984 50.1916 24.3412 49.9 24.2404C49.6084 24.1396 49.2998 24.0973 48.9919 24.1158C48.6839 24.1343 48.3826 24.2133 48.1052 24.3482C47.8277 24.4832 47.5796 24.6714 47.3749 24.9023L38.5859 34.7694C38.1725 35.2356 37.9613 35.847 37.9986 36.4689C38.036 37.0909 38.3189 37.6725 38.7851 38.0859C39.2513 38.4992 39.8626 38.7105 40.4845 38.6731C41.1065 38.6357 41.6881 38.3528 42.1015 37.8866H42.0898Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M25.496 38.0741C25.9583 37.6603 26.2377 37.08 26.2729 36.4606C26.308 35.8411 26.0961 35.2329 25.6835 34.7695L16.9062 24.9023C16.4928 24.4361 15.9112 24.1532 15.2892 24.1158C14.6673 24.0784 14.056 24.2897 13.5898 24.703C13.1236 25.1164 12.8407 25.698 12.8033 26.32C12.7659 26.9419 12.9772 27.5532 13.3905 28.0194L22.1796 37.8866C22.3847 38.1173 22.6333 38.3052 22.9112 38.4395C23.189 38.5738 23.4907 38.6519 23.7989 38.6693C24.107 38.6868 24.4156 38.6431 24.7068 38.541C24.998 38.4389 25.2662 38.2802 25.496 38.0741Z",
                                                                                                    fill: "#2222E3"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        style: {
                                                                                            fontSize: 12
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                                                style: {
                                                                                                    fontWeight: 700
                                                                                                },
                                                                                                children: "Gamification"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "Level: 1"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "Points: 0 points"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "Progress: 0%"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                src: "https://vxapp.wfsystems.com.ar/storage/logos/20231114001227.png",
                                                                                                alt: "Gamification Icon",
                                                                                                style: styles.icon
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            style: styles.card,
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                style: {
                                                                                    display: "flex"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        style: {
                                                                                            width: "30%"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                                            width: 50,
                                                                                            height: 50,
                                                                                            viewBox: "0 0 139 143",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                                    cx: 63.5,
                                                                                                    cy: 52,
                                                                                                    r: 31,
                                                                                                    fill: "#7BC7F5"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M44.375 10.0625H49.0625V14.75H44.375V10.0625Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M53.75 10.0625H72.5V14.75H53.75V10.0625Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M67.8125 94.4375H58.4375C56.5727 94.4375 54.7843 95.1783 53.4657 96.4969C52.147 97.8155 51.4063 99.6039 51.4062 101.469C51.4063 103.334 52.147 105.122 53.4657 106.441C54.7843 107.759 56.5727 108.5 58.4375 108.5H67.8125C69.6773 108.5 71.4657 107.759 72.7843 106.441C74.103 105.122 74.8438 103.334 74.8438 101.469C74.8438 99.6039 74.103 97.8155 72.7843 96.4969C71.4657 95.1783 69.6773 94.4375 67.8125 94.4375ZM67.8125 103.812H58.4375C57.8159 103.812 57.2198 103.566 56.7802 103.126C56.3407 102.686 56.0938 102.09 56.0938 101.469C56.0938 100.847 56.3407 100.251 56.7802 99.8115C57.2198 99.3719 57.8159 99.125 58.4375 99.125H67.8125C68.4341 99.125 69.0302 99.3719 69.4698 99.8115C69.9093 100.251 70.1562 100.847 70.1562 101.469C70.1562 102.09 69.9093 102.686 69.4698 103.126C69.0302 103.566 68.4341 103.812 67.8125 103.812Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M6.87505 61.625H11.5625V34.4703L14.593 37.5008L17.9071 34.1867L10.8758 27.1555C10.4363 26.7161 9.84028 26.4692 9.2188 26.4692C8.59732 26.4692 8.00129 26.7161 7.56177 27.1555L0.530518 34.1867L3.84458 37.5008L6.87505 34.4703V61.625Z",
                                                                                                    fill: "#9F0DFF"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M114.688 34.4703V61.625H119.375V34.4703L122.406 37.5008L125.72 34.1867L118.688 27.1555C118.249 26.7161 117.653 26.4692 117.031 26.4692C116.41 26.4692 115.814 26.7161 115.374 27.1555L108.343 34.1867L111.657 37.5008L114.688 34.4703Z",
                                                                                                    fill: "#9F0DFF"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M128.75 103.812C126.543 103.804 124.407 104.585 122.727 106.016C121.891 104.63 120.712 103.484 119.304 102.687C117.895 101.891 116.305 101.471 114.688 101.469C112.481 101.46 110.344 102.241 108.664 103.672C107.398 101.563 105.352 100.039 102.969 99.4297V17.0938C102.964 12.7441 101.234 8.57395 98.158 5.49826C95.0823 2.42257 90.9122 0.692463 86.5625 0.6875H39.6875C35.3378 0.692463 31.1677 2.42257 28.092 5.49826C25.0163 8.57395 23.2862 12.7441 23.2812 17.0938V59.9844C21.7913 60.6813 20.59 61.8743 19.8828 63.3594L9.24219 86.4453C7.69 89.828 6.88272 93.5047 6.875 97.2266V141.312H11.5625V97.2266C11.5704 94.1834 12.2339 91.1777 13.5078 88.4141L23.2812 67.2031V101.469C23.2845 103.381 23.6257 105.277 24.2891 107.07L21.9687 111.078L26.0234 113.422L40.0859 89.0703C40.3906 88.5347 40.7979 88.0644 41.2846 87.6864C41.7712 87.3084 42.3276 87.03 42.9219 86.8672C44.1255 86.5593 45.4014 86.7272 46.4844 87.3359C47.561 87.9624 48.3455 88.9899 48.6662 90.1935C48.9868 91.3971 48.8175 92.6788 48.1953 93.7578L37.6484 112.016C37.4447 112.382 37.3397 112.795 37.3438 113.214C37.3479 113.633 37.461 114.044 37.6719 114.406L42.6875 122.75C43.7868 124.567 44.3702 126.65 44.375 128.773V141.289H49.0625V128.773C49.0571 125.801 48.2472 122.885 46.7188 120.336L45.2422 117.875H59.7031C59.0654 120.281 59.4023 122.841 60.6406 125L70.7422 142.484L74.7969 140.141L64.6953 122.656C64.2255 121.853 64.0054 120.928 64.063 119.999C64.1207 119.07 64.4535 118.18 65.019 117.441C65.5846 116.702 66.3573 116.148 67.2388 115.85C68.1203 115.551 69.0706 115.522 69.9688 115.766C70.5662 115.921 71.1256 116.197 71.6132 116.576C72.1007 116.954 72.5061 117.428 72.8047 117.969L77.4922 126.078C77.7556 126.523 78.1559 126.871 78.6333 127.069C79.1106 127.268 79.6394 127.306 80.1406 127.18C80.64 127.045 81.081 126.749 81.3947 126.338C81.7084 125.927 81.8773 125.423 81.875 124.906V80.375C81.875 79.1318 82.3689 77.9395 83.2479 77.0604C84.127 76.1814 85.3193 75.6875 86.5625 75.6875C87.8057 75.6875 88.998 76.1814 89.8771 77.0604C90.7561 77.9395 91.25 79.1318 91.25 80.375V117.875C91.25 118.497 91.4969 119.093 91.9365 119.532C92.376 119.972 92.9721 120.219 93.5938 120.219C94.2154 120.219 94.8115 119.972 95.251 119.532C95.6906 119.093 95.9375 118.497 95.9375 117.875V108.5C95.9375 107.257 96.4314 106.065 97.3104 105.185C98.1895 104.306 99.3818 103.812 100.625 103.812C101.868 103.812 103.06 104.306 103.94 105.185C104.819 106.065 105.312 107.257 105.312 108.5V117.875C105.312 118.497 105.559 119.093 105.999 119.532C106.439 119.972 107.035 120.219 107.656 120.219C108.278 120.219 108.874 119.972 109.314 119.532C109.753 119.093 110 118.497 110 117.875V110.844C110 109.601 110.494 108.408 111.373 107.529C112.252 106.65 113.444 106.156 114.688 106.156C115.931 106.156 117.123 106.65 118.002 107.529C118.881 108.408 119.375 109.601 119.375 110.844V117.875C119.375 118.497 119.622 119.093 120.061 119.532C120.501 119.972 121.097 120.219 121.719 120.219C122.34 120.219 122.936 119.972 123.376 119.532C123.816 119.093 124.062 118.497 124.062 117.875V113.188C124.062 111.944 124.556 110.752 125.435 109.873C126.315 108.994 127.507 108.5 128.75 108.5C129.993 108.5 131.185 108.994 132.065 109.873C132.944 110.752 133.438 111.944 133.438 113.188V141.312H138.125V113.188C138.125 110.701 137.137 108.317 135.379 106.558C133.621 104.8 131.236 103.812 128.75 103.812ZM98.2812 99.4297C97.4599 99.6418 96.6713 99.9651 95.9375 100.391V80.375C95.9375 77.8886 94.9498 75.504 93.1916 73.7459C91.4335 71.9877 89.0489 71 86.5625 71C84.0761 71 81.6915 71.9877 79.9334 73.7459C78.1752 75.504 77.1875 77.8886 77.1875 80.375V113.188H74.8203C73.765 112.283 72.5253 111.619 71.1875 111.242C68.7816 110.606 66.2219 110.943 64.0625 112.18C63.5735 112.475 63.1108 112.812 62.6797 113.188H42.4297L42.4062 113.164L52.2734 96.1016C53.5166 93.9477 53.8533 91.3882 53.2094 88.9861C52.5655 86.5841 50.9937 84.5362 48.8398 83.293C46.686 82.0498 44.1265 81.7131 41.7244 82.357C39.3223 83.0009 37.2745 84.5727 36.0313 86.7266L27.9688 100.672V17.0938C27.9688 13.9857 29.2034 11.005 31.4011 8.80734C33.5988 6.60965 36.5795 5.375 39.6875 5.375H86.5625C89.6705 5.375 92.6512 6.60965 94.8489 8.80734C97.0466 11.005 98.2812 13.9857 98.2812 17.0938V99.4297Z",
                                                                                                    fill: "#2222E3"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M60.7812 45.2188H65.4688C66.0904 45.2188 66.6865 45.4657 67.126 45.9052C67.5656 46.3448 67.8125 46.9409 67.8125 47.5625H72.5C72.5 45.6977 71.7592 43.9093 70.4406 42.5907C69.122 41.272 67.3336 40.5312 65.4688 40.5312V38.1875H60.7812V40.5312C58.9164 40.5312 57.128 41.272 55.8094 42.5907C54.4908 43.9093 53.75 45.6977 53.75 47.5625C53.75 49.4273 54.4908 51.2157 55.8094 52.5343C57.128 53.853 58.9164 54.5938 60.7812 54.5938H65.4688C66.0904 54.5938 66.6865 54.8407 67.126 55.2802C67.5656 55.7198 67.8125 56.3159 67.8125 56.9375C67.8125 57.5591 67.5656 58.1552 67.126 58.5948C66.6865 59.0343 66.0904 59.2812 65.4688 59.2812H60.7812C60.1596 59.2812 59.5635 59.0343 59.124 58.5948C58.6844 58.1552 58.4375 57.5591 58.4375 56.9375H53.75C53.75 58.8023 54.4908 60.5907 55.8094 61.9093C57.128 63.228 58.9164 63.9688 60.7812 63.9688V66.3125H65.4688V63.9688C67.3336 63.9688 69.122 63.228 70.4406 61.9093C71.7592 60.5907 72.5 58.8023 72.5 56.9375C72.5 55.0727 71.7592 53.2843 70.4406 51.9657C69.122 50.647 67.3336 49.9062 65.4688 49.9062H60.7812C60.1596 49.9062 59.5635 49.6593 59.124 49.2198C58.6844 48.7802 58.4375 48.1841 58.4375 47.5625C58.4375 46.9409 58.6844 46.3448 59.124 45.9052C59.5635 45.4657 60.1596 45.2188 60.7812 45.2188Z",
                                                                                                    fill: colors.primario
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                                    d: "M63.125 28.8125C58.4895 28.8125 53.9581 30.1871 50.1038 32.7624C46.2496 35.3378 43.2455 38.9982 41.4716 43.2809C39.6977 47.5635 39.2335 52.276 40.1379 56.8224C41.0422 61.3689 43.2744 65.545 46.5522 68.8228C49.83 72.1006 54.0062 74.3328 58.5526 75.2372C63.099 76.1415 67.8115 75.6774 72.0942 73.9034C76.3768 72.1295 80.0372 69.1255 82.6126 65.2712C85.1879 61.4169 86.5625 56.8855 86.5625 52.25C86.5557 46.0361 84.0842 40.0786 79.6903 35.6847C75.2964 31.2908 69.3389 28.8193 63.125 28.8125ZM63.125 71C59.4166 71 55.7915 69.9003 52.7081 67.8401C49.6247 65.7798 47.2214 62.8514 45.8023 59.4253C44.3831 55.9992 44.0118 52.2292 44.7353 48.5921C45.4588 44.9549 47.2445 41.614 49.8668 38.9917C52.489 36.3695 55.8299 34.5837 59.4671 33.8603C63.1042 33.1368 66.8742 33.5081 70.3003 34.9273C73.7264 36.3464 76.6548 38.7496 78.7151 41.8331C80.7753 44.9165 81.875 48.5416 81.875 52.25C81.8694 57.2211 79.8922 61.987 76.3771 65.5021C72.862 69.0172 68.0961 70.9944 63.125 71Z",
                                                                                                    fill: colors.primario
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        style: {
                                                                                            fontSize: 12
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                                                style: {
                                                                                                    fontWeight: 700
                                                                                                },
                                                                                                children: "Device Information"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "OS: ANDROID"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "Last Login: 2024-11-06 22:22:57"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "IP: 152.70.206.189"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                                children: "UUID: ...41d4-7f16-446655440000"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                style: {
                                                                    ...styles.card,
                                                                    width: "50%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        style: {
                                                                            fontWeight: 700,
                                                                            marginBottom: 5
                                                                        },
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "Onboarding Timeline"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "row"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                style: {
                                                                                    width: "30%"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                                    width: 70,
                                                                                    height: 159,
                                                                                    viewBox: "0 0 151 159",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M76 59L50.3191 33.7743C47.8936 31.3919 47.8936 27.573 50.3191 25.2257L76 0L101.681 25.2257C104.106 27.6081 104.106 31.427 101.681 33.7743L76 59Z",
                                                                                            fill: "#9F0DFF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                            cx: 75.5,
                                                                                            cy: 85,
                                                                                            r: 34,
                                                                                            fill: "#5ECAFA"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M133.886 35.9092C133.682 34.9092 132.795 34.1819 131.773 34.1819C95.9545 34.1819 77.3181 13.3865 77.1363 13.1592C76.7045 12.6819 76.1136 12.4092 75.4999 12.4092C74.8636 12.4092 74.2727 12.6819 73.8636 13.1592C73.6818 13.3637 55.1818 34.1819 19.2499 34.1819C18.2272 34.1819 17.3408 34.9092 17.1363 35.9092C16.9545 36.7728 0.204482 122.705 74.6363 155.409C74.909 155.523 75.2045 155.591 75.4999 155.591C75.7954 155.591 76.0909 155.523 76.3636 155.409C150.818 122.682 134.068 36.7728 133.886 35.9092ZM75.4999 151.046C10.9545 122.023 19.1818 50.5001 21.0681 38.5001C52.0908 37.9092 70.1818 22.8637 75.4999 17.7046C80.8181 22.8865 98.9318 37.9092 129.954 38.5001C131.818 50.4774 140.091 122 75.4999 151.046Z",
                                                                                            fill: "#2222E3"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M122.477 44.5909C100.886 42.6136 85.7271 34.0909 76.818 27.3182C76.0453 26.7273 74.9771 26.7273 74.1816 27.3182C65.2725 34.1136 50.0907 42.6136 28.5226 44.5909C27.4771 44.6818 26.6589 45.5 26.568 46.5455C24.568 67.4773 25.2271 118.795 74.5225 143.386C74.818 143.545 75.1589 143.614 75.4998 143.614C75.8407 143.614 76.1589 143.545 76.4771 143.386C125.795 118.795 126.454 67.4773 124.454 46.5455C124.341 45.5 123.523 44.6818 122.477 44.5909ZM75.4998 139.023C30.8635 116.114 29.0453 69.6136 30.7271 48.7273C51.3635 46.4545 66.2498 38.5 75.4998 31.75C84.7498 38.5 99.6362 46.4773 120.273 48.7273C121.954 69.6136 120.136 116.114 75.4998 139.023Z",
                                                                                            fill: "#2222E3"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M75.5 59C61.1599 59 49.5 70.8841 49.5 85.5C49.5 100.116 61.1599 112 75.5 112C89.8401 112 101.5 100.116 101.5 85.5C101.5 70.8841 89.8401 59 75.5 59ZM75.5 108.191C63.2336 108.191 53.2366 98.0222 53.2366 85.5C53.2366 72.9778 63.2336 62.8085 75.5 62.8085C87.7664 62.8085 97.7634 72.9778 97.7634 85.5C97.7634 98.0222 87.7664 108.191 75.5 108.191Z",
                                                                                            fill: colors.primario
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M84.4227 75.5557L70.3442 90.3742L66.5963 86.4293C65.8924 85.6884 64.7319 85.6884 64.0279 86.4293C63.324 87.1702 63.324 88.3917 64.0279 89.1327L69.0505 94.4393C69.393 94.7997 69.8496 95 70.3252 95C70.8008 95 71.2765 94.7997 71.5999 94.4393L86.9721 78.2591C87.676 77.5181 87.676 76.2966 86.9721 75.5557C86.2681 74.8148 85.1266 74.8148 84.4227 75.5557Z",
                                                                                            fill: colors.primario
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                                                                    style: styles.timelineTable,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {}),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                                                                            children: steps.map((step, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TimelineStep, {
                                                                                                    title: step.title,
                                                                                                    date: step.date
                                                                                                }, index))
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "300px",
                                                    justifySelf: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        children: "Accounts Content"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "En construccion ..."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "300px",
                                                    justifySelf: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        children: "Scores Content"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "En construccion ..."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "300px",
                                                    justifySelf: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        children: "Transactions Content"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "En construccion ..."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "300px",
                                                    justifySelf: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        children: "Trades Content"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "En construccion ..."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTabs.TabPanel), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "300px",
                                                    justifySelf: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                        children: "Digital Folder Content"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "Contenido de Digital Folder..."
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: styles.base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-tabs":"1w83m","react-tabs/style/react-tabs.css":"l4iuc","../../hooks/useDynamicColors":"b2GRH","./style.css":"nJOpd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1w83m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "TabList", ()=>(0, _tabListDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabPanel", ()=>(0, _tabPanelDefault.default));
var _tabs = require("./components/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tabList = require("./components/TabList");
var _tabListDefault = parcelHelpers.interopDefault(_tabList);
var _tab = require("./components/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabPanel = require("./components/TabPanel");
var _tabPanelDefault = parcelHelpers.interopDefault(_tabPanel);

},{"./components/Tabs":"1sQ5N","./components/TabList":"OvkCM","./components/Tab":"b6EEp","./components/TabPanel":"bJVvI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1sQ5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes1 = require("../helpers/propTypes");
var _uncontrolledTabs = require("./UncontrolledTabs");
var _uncontrolledTabsDefault = parcelHelpers.interopDefault(_uncontrolledTabs);
var _count = require("../helpers/count");
const _excluded = [
    "children",
    "defaultFocus",
    "defaultIndex",
    "focusTabOnClick",
    "onSelect"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const MODE_CONTROLLED = 0;
const MODE_UNCONTROLLED = 1;
const propTypes = {
    children: (0, _propTypes1.childrenPropType),
    onSelect: (0, _propTypes1.onSelectPropType),
    selectedIndex: (0, _propTypes1.selectedIndexPropType)
};
const defaultProps = {
    defaultFocus: false,
    focusTabOnClick: true,
    forceRenderTabPanel: false,
    selectedIndex: null,
    defaultIndex: null,
    environment: null,
    disableUpDownKeys: false,
    disableLeftRightKeys: false
};
const getModeFromProps = (props)=>{
    return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
};
const checkForIllegalModeChange = (props, mode)=>{};
const Tabs = (props)=>{
    (0, _propTypes.checkPropTypes)(propTypes, props, "prop", "Tabs");
    const _defaultProps$props = Object.assign({}, defaultProps, props), { children, defaultFocus, defaultIndex, focusTabOnClick, onSelect } = _defaultProps$props, attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
    const [focus, setFocus] = (0, _react.useState)(defaultFocus);
    const [mode] = (0, _react.useState)(getModeFromProps(attributes));
    const [selectedIndex, setSelectedIndex] = (0, _react.useState)(mode === MODE_UNCONTROLLED ? defaultIndex || 0 : null);
    (0, _react.useEffect)(()=>{
        setFocus(false);
    }, []);
    if (mode === MODE_UNCONTROLLED) {
        const tabsCount = (0, _count.getTabsCount)(children);
        (0, _react.useEffect)(()=>{
            if (selectedIndex != null) {
                const maxTabIndex = Math.max(0, tabsCount - 1);
                setSelectedIndex(Math.min(selectedIndex, maxTabIndex));
            }
        }, [
            tabsCount
        ]);
    }
    checkForIllegalModeChange(attributes, mode);
    const handleSelected = (index, last, event)=>{
        if (typeof onSelect === "function") {
            if (onSelect(index, last, event) === false) return;
        }
        if (focusTabOnClick) setFocus(true);
        if (mode === MODE_UNCONTROLLED) setSelectedIndex(index);
    };
    let subProps = Object.assign({}, props, attributes);
    subProps.focus = focus;
    subProps.onSelect = handleSelected;
    if (selectedIndex != null) subProps.selectedIndex = selectedIndex;
    delete subProps.defaultFocus;
    delete subProps.defaultIndex;
    delete subProps.focusTabOnClick;
    return (0, _reactDefault.default).createElement((0, _uncontrolledTabsDefault.default), subProps, children);
};
Tabs.tabsRole = "Tabs";
exports.default = Tabs;

},{"prop-types":"gLXGb","react":"bmhQu","../helpers/propTypes":"1eGP6","./UncontrolledTabs":"60rax","../helpers/count":"lBkS5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLXGb":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"cW0bY"}],"cW0bY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6JNoQ"}],"6JNoQ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"1eGP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "childrenPropType", ()=>childrenPropType);
parcelHelpers.export(exports, "onSelectPropType", ()=>onSelectPropType);
parcelHelpers.export(exports, "selectedIndexPropType", ()=>selectedIndexPropType);
var _childrenDeepMap = require("./childrenDeepMap");
var _elementTypes = require("./elementTypes");
function childrenPropType(props, propName, componentName) {
    let error;
    let tabsCount = 0;
    let panelsCount = 0;
    let tabListFound = false;
    const listTabs = [];
    const children = props[propName];
    (0, _childrenDeepMap.deepForEach)(children, (child)=>{
        if ((0, _elementTypes.isTabList)(child)) {
            if (child.props && child.props.children && typeof child.props.children === "object") (0, _childrenDeepMap.deepForEach)(child.props.children, (listChild)=>listTabs.push(listChild));
            if (tabListFound) error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
            tabListFound = true;
        }
        if ((0, _elementTypes.isTab)(child)) {
            if (!tabListFound || listTabs.indexOf(child) === -1) error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components have to be inside the 'TabList' component.");
            tabsCount++;
        } else if ((0, _elementTypes.isTabPanel)(child)) panelsCount++;
    });
    if (!error && tabsCount !== panelsCount) error = new Error(`There should be an equal number of 'Tab' and 'TabPanel' in \`${componentName}\`. ` + `Received ${tabsCount} 'Tab' and ${panelsCount} 'TabPanel'.`);
    return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop && typeof prop !== "function") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied ` + `to \`${componentName}\`, expected \`function\`.`);
    else if (props.selectedIndex != null && prop == null) error = new Error(`The ${location} \`${name}\` is marked as required in \`${componentName}\`, but ` + `its value is \`undefined\` or \`null\`.\n` + `\`onSelect\` is required when \`selectedIndex\` is also set. Not doing so will ` + `make the tabs not do anything, as \`selectedIndex\` indicates that you want to ` + `handle the selected tab yourself.\n` + `If you only want to set the inital tab replace \`selectedIndex\` with \`defaultIndex\`.`);
    return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop != null && typeof prop !== "number") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied to ` + `\`${componentName}\`, expected \`number\`.`);
    else if (props.defaultIndex != null && prop != null) return new Error(`The ${location} \`${name}\` cannot be used together with \`defaultIndex\` ` + `in \`${componentName}\`.\n` + `Either remove \`${name}\` to let \`${componentName}\` handle the selected ` + `tab internally or remove \`defaultIndex\` to handle it yourself.`);
    return error;
}

},{"./childrenDeepMap":"fm9Fk","./elementTypes":"gHpNU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fm9Fk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepMap", ()=>deepMap);
parcelHelpers.export(exports, "deepForEach", ()=>deepForEach);
var _react = require("react");
var _elementTypes = require("./elementTypes");
function isTabChild(child) {
    return (0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabList)(child) || (0, _elementTypes.isTabPanel)(child);
}
function deepMap(children, callback) {
    return (0, _react.Children).map(children, (child)=>{
        if (child === null) return null;
        if (isTabChild(child)) return callback(child);
        if (child.props && child.props.children && typeof child.props.children === "object") return (0, _react.cloneElement)(child, Object.assign({}, child.props, {
            children: deepMap(child.props.children, callback)
        }));
        return child;
    });
}
function deepForEach(children, callback) {
    return (0, _react.Children).forEach(children, (child)=>{
        if (child === null) return;
        if ((0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabPanel)(child)) callback(child);
        else if (child.props && child.props.children && typeof child.props.children === "object") {
            if ((0, _elementTypes.isTabList)(child)) callback(child);
            deepForEach(child.props.children, callback);
        }
    });
}

},{"react":"bmhQu","./elementTypes":"gHpNU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHpNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTab", ()=>isTab);
parcelHelpers.export(exports, "isTabList", ()=>isTabList);
parcelHelpers.export(exports, "isTabPanel", ()=>isTabPanel);
function makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const isTab = makeTypeChecker("Tab");
const isTabList = makeTypeChecker("TabList");
const isTabPanel = makeTypeChecker("TabPanel");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60rax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes1 = require("../helpers/propTypes");
var _count = require("../helpers/count");
var _childrenDeepMap = require("../helpers/childrenDeepMap");
var _elementTypes = require("../helpers/elementTypes");
const _excluded = [
    "children",
    "className",
    "disabledTabClassName",
    "domRef",
    "focus",
    "forceRenderTabPanel",
    "onSelect",
    "selectedIndex",
    "selectedTabClassName",
    "selectedTabPanelClassName",
    "environment",
    "disableUpDownKeys",
    "disableLeftRightKeys"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function isNode(node) {
    return node && "getAttribute" in node;
}
function isTabNode(node) {
    return isNode(node) && node.getAttribute("data-rttab");
}
function isTabDisabled(node) {
    return isNode(node) && node.getAttribute("aria-disabled") === "true";
}
let canUseActiveElement;
function determineCanUseActiveElement(environment) {
    const env = environment || (typeof window !== "undefined" ? window : undefined);
    try {
        canUseActiveElement = !!(typeof env !== "undefined" && env.document && env.document.activeElement);
    } catch (e) {
        canUseActiveElement = false;
    }
}
const defaultProps = {
    className: "react-tabs",
    focus: false
};
const propTypes = {
    children: (0, _propTypes1.childrenPropType)
};
const UncontrolledTabs = (props)=>{
    (0, _propTypes.checkPropTypes)(propTypes, props, "prop", "UncontrolledTabs");
    let tabNodes = (0, _react.useRef)([]);
    let tabIds = (0, _react.useRef)([]);
    const ref = (0, _react.useRef)();
    function setSelected(index, event) {
        if (index < 0 || index >= getTabsCount()) return;
        const { onSelect, selectedIndex } = props;
        onSelect(index, selectedIndex, event);
    }
    function getNextTab(index) {
        const count = getTabsCount();
        for(let i = index + 1; i < count; i++){
            if (!isTabDisabled(getTab(i))) return i;
        }
        for(let i = 0; i < index; i++){
            if (!isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getPrevTab(index) {
        let i = index;
        while(i--){
            if (!isTabDisabled(getTab(i))) return i;
        }
        i = getTabsCount();
        while(i-- > index){
            if (!isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getFirstTab() {
        const count = getTabsCount();
        for(let i = 0; i < count; i++){
            if (!isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getLastTab() {
        let i = getTabsCount();
        while(i--){
            if (!isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getTabsCount() {
        const { children } = props;
        return (0, _count.getTabsCount)(children);
    }
    function getTab(index) {
        return tabNodes.current[`tabs-${index}`];
    }
    function getChildren() {
        let index = 0;
        const { children, disabledTabClassName, focus, forceRenderTabPanel, selectedIndex, selectedTabClassName, selectedTabPanelClassName, environment } = props;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        const id = (0, _react.useId)();
        while(diff++ < 0)tabIds.current.push(`${id}${tabIds.current.length}`);
        return (0, _childrenDeepMap.deepMap)(children, (child)=>{
            let result = child;
            if ((0, _elementTypes.isTabList)(child)) {
                let listIndex = 0;
                let wasTabFocused = false;
                if (canUseActiveElement == null) determineCanUseActiveElement(environment);
                const env = environment || (typeof window !== "undefined" ? window : undefined);
                if (canUseActiveElement && env) wasTabFocused = (0, _reactDefault.default).Children.toArray(child.props.children).filter((0, _elementTypes.isTab)).some((tab, i)=>env.document.activeElement === getTab(i));
                result = (0, _react.cloneElement)(child, {
                    children: (0, _childrenDeepMap.deepMap)(child.props.children, (tab)=>{
                        const key = `tabs-${listIndex}`;
                        const selected = selectedIndex === listIndex;
                        const props = {
                            tabRef: (node)=>{
                                tabNodes.current[key] = node;
                            },
                            id: tabIds.current[listIndex],
                            selected,
                            focus: selected && (focus || wasTabFocused)
                        };
                        if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
                        if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
                        listIndex++;
                        return (0, _react.cloneElement)(tab, props);
                    })
                });
            } else if ((0, _elementTypes.isTabPanel)(child)) {
                const props = {
                    id: tabIds.current[index],
                    selected: selectedIndex === index
                };
                if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
                if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
                index++;
                result = (0, _react.cloneElement)(child, props);
            }
            return result;
        });
    }
    function handleKeyDown(e) {
        const { direction, disableUpDownKeys, disableLeftRightKeys } = props;
        if (isTabFromContainer(e.target)) {
            let { selectedIndex: index } = props;
            let preventDefault = false;
            let useSelectedIndex = false;
            if (e.code === "Space" || e.keyCode === 32 || e.code === "Enter" || e.keyCode === 13) {
                preventDefault = true;
                useSelectedIndex = false;
                handleClick(e);
            }
            if (!disableLeftRightKeys && (e.keyCode === 37 || e.code === "ArrowLeft") || !disableUpDownKeys && (e.keyCode === 38 || e.code === "ArrowUp")) {
                if (direction === "rtl") index = getNextTab(index);
                else index = getPrevTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (!disableLeftRightKeys && (e.keyCode === 39 || e.code === "ArrowRight") || !disableUpDownKeys && (e.keyCode === 40 || e.code === "ArrowDown")) {
                if (direction === "rtl") index = getPrevTab(index);
                else index = getNextTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 35 || e.code === "End") {
                index = getLastTab();
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 36 || e.code === "Home") {
                index = getFirstTab();
                preventDefault = true;
                useSelectedIndex = true;
            }
            if (preventDefault) e.preventDefault();
            if (useSelectedIndex) setSelected(index, e);
        }
    }
    function handleClick(e) {
        let node = e.target;
        do if (isTabFromContainer(node)) {
            if (isTabDisabled(node)) return;
            const index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);
            setSelected(index, e);
            return;
        }
        while ((node = node.parentNode) != null);
    }
    function isTabFromContainer(node) {
        if (!isTabNode(node)) return false;
        let nodeAncestor = node.parentElement;
        do {
            if (nodeAncestor === ref.current) return true;
            if (nodeAncestor.getAttribute("data-rttabs")) break;
            nodeAncestor = nodeAncestor.parentElement;
        }while (nodeAncestor);
        return false;
    }
    const _defaultProps$props = Object.assign({}, defaultProps, props), { className, domRef } = _defaultProps$props, attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
    return (0, _reactDefault.default).createElement("div", Object.assign({}, attributes, {
        className: (0, _clsxDefault.default)(className),
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: (node)=>{
            ref.current = node;
            if (domRef) domRef(node);
        },
        "data-rttabs": true
    }), getChildren());
};
exports.default = UncontrolledTabs;

},{"prop-types":"gLXGb","react":"bmhQu","clsx":"431Ou","../helpers/propTypes":"1eGP6","../helpers/count":"lBkS5","../helpers/childrenDeepMap":"fm9Fk","../helpers/elementTypes":"gHpNU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"431Ou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lBkS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabsCount", ()=>getTabsCount);
var _childrenDeepMap = require("./childrenDeepMap");
var _elementTypes = require("./elementTypes");
function getTabsCount(children) {
    let tabCount = 0;
    (0, _childrenDeepMap.deepForEach)(children, (child)=>{
        if ((0, _elementTypes.isTab)(child)) tabCount++;
    });
    return tabCount;
}

},{"./childrenDeepMap":"fm9Fk","./elementTypes":"gHpNU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"OvkCM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
const _excluded = [
    "children",
    "className"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const defaultProps = {
    className: "react-tabs__tab-list"
};
const TabList = (props)=>{
    const _defaultProps$props = Object.assign({}, defaultProps, props), { children, className } = _defaultProps$props, attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
    return (0, _reactDefault.default).createElement("ul", Object.assign({}, attributes, {
        className: (0, _clsxDefault.default)(className),
        role: "tablist"
    }), children);
};
TabList.tabsRole = "TabList";
exports.default = TabList;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b6EEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
const _excluded = [
    "children",
    "className",
    "disabled",
    "disabledClassName",
    "focus",
    "id",
    "selected",
    "selectedClassName",
    "tabIndex",
    "tabRef"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const DEFAULT_CLASS = "react-tabs__tab";
const defaultProps = {
    className: DEFAULT_CLASS,
    disabledClassName: `${DEFAULT_CLASS}--disabled`,
    focus: false,
    id: null,
    selected: false,
    selectedClassName: `${DEFAULT_CLASS}--selected`
};
const Tab = (props)=>{
    let nodeRef = (0, _react.useRef)();
    const _defaultProps$props = Object.assign({}, defaultProps, props), { children, className, disabled, disabledClassName, focus, id, selected, selectedClassName, tabIndex, tabRef } = _defaultProps$props, attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
    (0, _react.useEffect)(()=>{
        if (selected && focus) nodeRef.current.focus();
    }, [
        selected,
        focus
    ]);
    return (0, _reactDefault.default).createElement("li", Object.assign({}, attributes, {
        className: (0, _clsxDefault.default)(className, {
            [selectedClassName]: selected,
            [disabledClassName]: disabled
        }),
        ref: (node)=>{
            nodeRef.current = node;
            if (tabRef) tabRef(node);
        },
        role: "tab",
        id: `tab${id}`,
        "aria-selected": selected ? "true" : "false",
        "aria-disabled": disabled ? "true" : "false",
        "aria-controls": `panel${id}`,
        tabIndex: tabIndex || (selected ? "0" : null),
        "data-rttab": true
    }), children);
};
Tab.tabsRole = "Tab";
exports.default = Tab;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJVvI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
const _excluded = [
    "children",
    "className",
    "forceRender",
    "id",
    "selected",
    "selectedClassName"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const DEFAULT_CLASS = "react-tabs__tab-panel";
const defaultProps = {
    className: DEFAULT_CLASS,
    forceRender: false,
    selectedClassName: `${DEFAULT_CLASS}--selected`
};
const TabPanel = (props)=>{
    const _defaultProps$props = Object.assign({}, defaultProps, props), { children, className, forceRender, id, selected, selectedClassName } = _defaultProps$props, attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
    return (0, _reactDefault.default).createElement("div", Object.assign({}, attributes, {
        className: (0, _clsxDefault.default)(className, {
            [selectedClassName]: selected
        }),
        role: "tabpanel",
        id: `panel${id}`,
        "aria-labelledby": `tab${id}`
    }), forceRender || selected ? children : null);
};
TabPanel.tabsRole = "TabPanel";
exports.default = TabPanel;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l4iuc":[function() {},{}],"nJOpd":[function() {},{}],"9GtlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLandingTelco", ()=>(0, _corporativoLandingTelco.CorporativoLandingTelco));
var _corporativoLandingTelco = require("./CorporativoLandingTelco");

},{"./CorporativoLandingTelco":"ZoS15","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ZoS15":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLandingTelco", ()=>CorporativoLandingTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("../../../../../components/Button");
var _chevronsDown1 = require("../../../../../icons/ChevronsDown1");
var _chevronsDown2 = require("../../../../../icons/ChevronsDown2");
var _icons1 = require("../../../../../icons/Icons1");
var _icons19 = require("../../../../../icons/Icons19");
var _nameMenuDarkTrue = require("../../../../../icons/NameMenuDarkTrue");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _frameCorp = require("../../../../../components/FrameCorp");
var _styleCss = require("./style.css");
const CorporativoLandingTelco = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const scrollRef = (0, _react.useRef)(null);
    // const handleButtonClick = () => {
    //   const currentParams = location.search;
    //   navigate(`/corporativo-card-details${currentParams}`);
    // };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "contenedor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "corporativo-landing-telco",
            ref: scrollRef,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                                className: "header",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frameCorp.FrameCorp), {
                                                color: "#FFFFFF"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-7",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-11",
                                                    children: "Good morning, Mary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons1.Icons1), {
                                                            className: "icon-instance-node-2",
                                                            color: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameMenuDarkTrue.NameMenuDarkTrue), {
                                                            className: "icon-instance-node-2",
                                                            color: "white"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "vector-2",
                                alt: "Vector",
                                src: "/img/vector-101.svg"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-9",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "accounts",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "tarjtetas",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "title",
                                                        children: "Accounts"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-10",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                                className: "icon-instance-node-2",
                                                                color: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "menu-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-2"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-3"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "account",
                                                // onClick={handleButtonClick}
                                                style: {
                                                    background: "#FFFFFF"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-12",
                                                                style: {
                                                                    fontSize: 16,
                                                                    marginTop: 20,
                                                                    marginBottom: 20
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "My linked account"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "element-USD",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "span",
                                                                        children: "$13,000"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-13",
                                                                        children: ".23"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-14",
                                                                        children: "\xa0"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-15",
                                                                        children: "USD"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-12",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "main-account",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-16",
                                                                    children: "**** **** **** 2357"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                className: "button-instance",
                                                                divClassName: "button-4",
                                                                leadingIcon: false,
                                                                size: "small",
                                                                text: "Transactions",
                                                                trailingIcon: true,
                                                                trailingIcon14StyleOverrideClassName: "button-5",
                                                                trailingIcon14Color: colors.secundario,
                                                                type: "text"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "cards",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "div-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "title-2",
                                                    children: "Plans"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-16",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "menu-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-4"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-5"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-6"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "balances",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        width: 101,
                                                        height: 101,
                                                        style: {
                                                            marginTop: 60,
                                                            marginLeft: 30
                                                        },
                                                        viewBox: "0 0 101 101",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                cx: 50.7441,
                                                                cy: 50.5261,
                                                                r: 44,
                                                                stroke: "#f0f0f0",
                                                                strokeWidth: 12
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                                                                id: "path-2-inside-1_2608_2064",
                                                                fill: "white",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M94.747 50.5261C98.0591 50.5261 100.781 53.2206 100.385 56.509C99.6835 62.3287 97.9621 67.9958 95.2845 73.2453C91.6957 80.2809 86.4914 86.3662 80.0977 91.0029C73.704 95.6396 66.3029 98.6957 58.5005 99.9208C50.6982 101.146 42.7165 100.505 35.2094 98.0516C27.7023 95.5978 20.8833 91.4004 15.3109 85.8034C9.73854 80.2064 5.57132 73.3689 3.1506 65.8511C0.729873 58.3332 0.124514 50.3489 1.38411 42.552C2.32393 36.7344 4.28207 31.1448 7.15341 26.0343C8.77582 23.1467 12.5639 22.5802 15.2366 24.5365C17.9093 26.4927 18.4414 30.2299 16.9295 33.1769C15.1161 36.7111 13.8624 40.519 13.2249 44.4649C12.2675 50.3914 12.7276 56.4604 14.5677 62.1748C16.4077 67.8892 19.5752 73.0865 23.8109 77.3409C28.0465 81.5952 33.2298 84.7857 38.936 86.6509C44.6422 88.5161 50.7092 89.003 56.6399 88.0717C62.5705 87.1404 68.1963 84.8174 73.0562 81.293C77.9161 77.7686 81.872 73.1431 84.5998 67.7953C86.416 64.2347 87.6534 60.4214 88.2776 56.4985C88.7981 53.2275 91.4348 50.5261 94.747 50.5261Z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M94.747 50.5261C98.0591 50.5261 100.781 53.2206 100.385 56.509C99.6835 62.3287 97.9621 67.9958 95.2845 73.2453C91.6957 80.2809 86.4914 86.3662 80.0977 91.0029C73.704 95.6396 66.3029 98.6957 58.5005 99.9208C50.6982 101.146 42.7165 100.505 35.2094 98.0516C27.7023 95.5978 20.8833 91.4004 15.3109 85.8034C9.73854 80.2064 5.57132 73.3689 3.1506 65.8511C0.729873 58.3332 0.124514 50.3489 1.38411 42.552C2.32393 36.7344 4.28207 31.1448 7.15341 26.0343C8.77582 23.1467 12.5639 22.5802 15.2366 24.5365C17.9093 26.4927 18.4414 30.2299 16.9295 33.1769C15.1161 36.7111 13.8624 40.519 13.2249 44.4649C12.2675 50.3914 12.7276 56.4604 14.5677 62.1748C16.4077 67.8892 19.5752 73.0865 23.8109 77.3409C28.0465 81.5952 33.2298 84.7857 38.936 86.6509C44.6422 88.5161 50.7092 89.003 56.6399 88.0717C62.5705 87.1404 68.1963 84.8174 73.0562 81.293C77.9161 77.7686 81.872 73.1431 84.5998 67.7953C86.416 64.2347 87.6534 60.4214 88.2776 56.4985C88.7981 53.2275 91.4348 50.5261 94.747 50.5261Z",
                                                                stroke: colors.septimo,
                                                                strokeWidth: 22,
                                                                mask: "url(#path-2-inside-1_2608_2064)"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M35.8777 58.7648C39.764 58.7648 42.4061 56.2335 42.3976 52.7051C42.4061 49.3642 40.0708 46.9608 36.926 46.9608C35.3919 46.9608 34.0708 47.6 33.4572 48.4608H33.3549L33.8066 44.0886H41.4345V41.0716H30.764L29.9373 50.2761L33.2186 50.8642C33.7555 50.1398 34.7953 49.6881 35.8265 49.6881C37.5822 49.6966 38.8436 50.9665 38.8436 52.7989C38.8436 54.6142 37.6078 55.867 35.8777 55.867C34.4118 55.867 33.2271 54.9466 33.1419 53.5915H29.5623C29.6305 56.6085 32.264 58.7648 35.8777 58.7648ZM51.2868 40.8329C47.3833 40.8159 44.7498 43.3727 44.7669 46.8841C44.7754 50.1398 47.0339 52.5006 50.1277 52.5006C52.0453 52.5006 53.7498 51.5716 54.5254 50.0375H54.6447C54.6362 53.4977 53.4345 55.6028 51.1589 55.6028C49.8208 55.6028 48.8578 54.8699 48.5765 53.6H44.9373C45.2782 56.5403 47.6646 58.7648 51.1589 58.7648C55.4799 58.7648 58.2669 55.2704 58.2583 49.3471C58.2498 43.0233 54.8748 40.85 51.2868 40.8329ZM51.3123 43.7307C53.0083 43.7307 54.2612 45.1114 54.2782 46.7733C54.2868 48.4437 52.9657 49.8244 51.2782 49.8244C49.5737 49.8244 48.3549 48.4949 48.3464 46.7818C48.3294 45.0773 49.5993 43.7307 51.3123 43.7307Z",
                                                                fill: "#333"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M68.0382 53.617C68.0431 54.7655 68.764 55.7349 70.1113 55.7349C71.4437 55.7349 72.1745 54.7655 72.1745 53.617V53.0801C72.1745 51.9267 71.4636 50.9622 70.1113 50.9622C68.7839 50.9622 68.0431 51.9317 68.0382 53.0801V53.617ZM62.9174 47.7903C62.9174 48.9388 63.6433 49.9082 64.9906 49.9082C66.318 49.9082 67.0538 48.9437 67.0488 47.7903V47.2534C67.0538 46.1 66.3379 45.1355 64.9906 45.1355C63.6681 45.1355 62.9174 46.1 62.9174 47.2534V47.7903ZM63.335 55.5261H64.5233L71.5233 45.3443H70.335L63.335 55.5261ZM69.1966 53.0801C69.2015 52.5084 69.4501 51.9565 70.1113 51.9565C70.7974 51.9565 71.0112 52.5084 71.0112 53.0801V53.617C71.0112 54.1888 70.7775 54.7406 70.1113 54.7406C69.4352 54.7406 69.2015 54.1838 69.1966 53.617V53.0801ZM64.0808 47.2534C64.0808 46.6866 64.3294 46.1298 64.9906 46.1298C65.6767 46.1298 65.8904 46.6817 65.8904 47.2534V47.7903C65.8904 48.3621 65.6568 48.9139 64.9906 48.9139C64.3145 48.9139 64.0808 48.3621 64.0808 47.7903V47.2534Z",
                                                                fill: "#333"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-18",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-19",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        className: "div-6",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "span",
                                                                            children: [
                                                                                "81% ",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                " consumed"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-19",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        className: "div-6",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "span",
                                                                            children: [
                                                                                "2GB ",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                " available"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-20",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-23",
                                                                children: "11 GB plan"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                className: "trailing-icon",
                                                                style: {
                                                                    color: colors.primario
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-22",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-23",
                                                                    children: "GB Internet"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                    className: "trailing-icon",
                                                                    style: {
                                                                        color: colors.primario
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                width: "90%",
                                                                borderRadius: "10px",
                                                                fontFamily: "Arial, sans-serif"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "24px",
                                                                        marginBottom: "8px"
                                                                    },
                                                                    children: "$"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "14px",
                                                                        color: "#555"
                                                                    },
                                                                    children: "Total Internet balance"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "16px",
                                                                        marginTop: "10px",
                                                                        color: "#333",
                                                                        marginBottom: "20px"
                                                                    },
                                                                    children: "6.51GB"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "20px",
                                                                        marginBottom: "8px"
                                                                    },
                                                                    children: "\uD83D\uDD52"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "13px",
                                                                        color: "#555",
                                                                        textAlign: "center"
                                                                    },
                                                                    children: "Missing until the deadline:"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    style: {
                                                                        fontSize: "14px",
                                                                        color: "#888",
                                                                        marginTop: "5px"
                                                                    },
                                                                    children: "7 Days"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "banners",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "image-4",
                                            alt: "Image",
                                            width: "200px",
                                            style: {
                                                borderRadius: 12
                                            },
                                            src: "/img/promo-telco.png"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "menu",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronsDown1.ChevronsDown1), {
                                            className: "icon-instance-node-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Send"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronsDown2.ChevronsDown2), {
                                            className: "icon-instance-node-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Receive"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 42.000000 40.000000",
                                            preserveAspectRatio: "xMidYMid meet",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
                                                fill: colors.primario,
                                                stroke: colors.primario,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 330 c0 -37 4 -50 13 -47 7 2 12 21 12 47 0 26 -5 45 -12 48 -9 2 -13 -11 -13 -48z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M82 298 l3 -83 53 -3 c42 -2 52 0 52 12 0 12 -11 16 -40 16 -33 0 -40 3 -40 19 0 16 8 20 38 23 37 3 37 3 40 51 l3 47 -56 0 -56 0 3 -82z m78 32 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M232 298 l3 -83 88 -3 87 -3 0 86 0 85 -90 0 -91 0 3 -82z m148 -3 l0 -55 -60 0 -60 0 0 55 0 55 60 0 60 0 0 -55z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M310 294 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 225 c0 -9 5 -15 11 -13 14 5 14 21 0 26 -6 2 -11 -4 -11 -13z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 85 l0 -85 90 0 91 0 -3 83 -3 82 -87 3 -88 3 0 -86z m148 -2 l3 -53 -60 0 -61 0 0 55 0 56 58 -3 57 -3 3 -52z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M87 93 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M230 121 l0 -51 90 0 90 0 0 51 c0 57 -23 66 -28 11 -2 -24 -8 -32 -22 -32 -14 0 -20 9 -22 33 -3 31 -4 32 -55 35 l-53 3 0 -50z m80 -1 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M230 15 c0 -12 13 -15 55 -15 42 0 55 3 55 15 0 12 -13 15 -55 15 -42 0 -55 -3 -55 -15z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M387 24 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "QR"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M12.25 4C7.563 4 3.75 7.813 3.75 12.5C3.75 17.187 7.563 21 12.25 21C16.937 21 20.75 17.187 20.75 12.5C20.75 7.813 16.937 4 12.25 4ZM12.25 22.5C6.736 22.5 2.25 18.014 2.25 12.5C2.25 6.986 6.736 2.5 12.25 2.5C17.764 2.5 22.25 6.986 22.25 12.5C22.25 18.014 17.764 22.5 12.25 22.5Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M12.25 3.5C7.28686 3.5 3.25 7.53686 3.25 12.5H4.25C4.25 8.08914 7.83914 4.5 12.25 4.5V3.5ZM3.25 12.5C3.25 17.4631 7.28686 21.5 12.25 21.5V20.5C7.83914 20.5 4.25 16.9109 4.25 12.5H3.25ZM12.25 21.5C17.2131 21.5 21.25 17.4631 21.25 12.5H20.25C20.25 16.9109 16.6609 20.5 12.25 20.5V21.5ZM21.25 12.5C21.25 7.53686 17.2131 3.5 12.25 3.5V4.5C16.6609 4.5 20.25 8.08914 20.25 12.5H21.25ZM12.25 22C7.01214 22 2.75 17.7379 2.75 12.5H1.75C1.75 18.2901 6.45986 23 12.25 23V22ZM2.75 12.5C2.75 7.26214 7.01214 3 12.25 3V2C6.45986 2 1.75 6.70986 1.75 12.5H2.75ZM12.25 3C17.4879 3 21.75 7.26214 21.75 12.5H22.75C22.75 6.70986 18.0401 2 12.25 2V3ZM21.75 12.5C21.75 17.7379 17.4879 22 12.25 22V23C18.0401 23 22.75 18.2901 22.75 12.5H21.75Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925",
                                                    stroke: colors.primario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Transactions"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../components/Button":"jfuTO","../../../../../icons/ChevronsDown1":"45OBA","../../../../../icons/ChevronsDown2":"aABvQ","../../../../../icons/Icons1":"gEDpR","../../../../../icons/Icons19":"2OHy7","../../../../../icons/NameMenuDarkTrue":"8A1Jb","../../../../../icons/TrailingIcon14":"1nwir","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/FrameCorp":"aBd21","./style.css":"gB3MM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jfuTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
var _button = require("./Button");

},{"./Button":"c1pEO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c1pEO":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _leadingIcon4 = require("../../icons/LeadingIcon4");
var _trailingIcon14 = require("../../icons/TrailingIcon14");
var _styleCss = require("./style.css");
const Button = ({ type, size, leadingIcon, trailingIcon, className, divClassName, text = "Small", trailingIcon14StyleOverrideClassName, trailingIcon14Color = "#074EE8" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `button ${type} ${size} ${className}`,
        children: [
            leadingIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadingIcon4.LeadingIcon4), {
                className: `${size === "large" ? "class" : "class-2"}`,
                color: type === "solid" ? "white" : "#074EE8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `div ${divClassName}`,
                children: [
                    size === "small" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: text
                    }),
                    size === "medium" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "Medium"
                    }),
                    size === "large" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "Large"
                    })
                ]
            }),
            trailingIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                className: trailingIcon14StyleOverrideClassName,
                color: trailingIcon14Color
            })
        ]
    });
};
Button.propTypes = {
    type: (0, _propTypesDefault.default).oneOf([
        "text",
        "outlined",
        "solid"
    ]),
    size: (0, _propTypesDefault.default).oneOf([
        "large",
        "medium",
        "small"
    ]),
    leadingIcon: (0, _propTypesDefault.default).bool,
    trailingIcon: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).string,
    trailingIcon14Color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/LeadingIcon4":"6e7bk","../../icons/TrailingIcon14":"1nwir","./style.css":"b6ulx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6e7bk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LeadingIcon4", ()=>(0, _leadingIcon4.LeadingIcon4));
var _leadingIcon4 = require("./LeadingIcon4");

},{"./LeadingIcon4":"1wAbF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1wAbF":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LeadingIcon4", ()=>LeadingIcon4);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const LeadingIcon4 = ({ color = "#074EE8", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `leading-icon-4 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M20.84 4.60999C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.60999L12 5.66999L10.94 4.60999C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.60999C2.1283 5.64169 1.54871 7.04096 1.54871 8.49999C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.49999C22.4518 7.77751 22.3095 7.0621 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.60999V4.60999Z",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
LeadingIcon4.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1nwir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrailingIcon14", ()=>(0, _trailingIcon14.TrailingIcon14));
var _trailingIcon14 = require("./TrailingIcon14");

},{"./TrailingIcon14":"jxdUb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jxdUb":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrailingIcon14", ()=>TrailingIcon14);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TrailingIcon14 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `trailing-icon-14 ${className}`,
        fill: "none",
        height: "19",
        viewBox: "0 0 18 19",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M6.75 14.1602L11.25 9.66016L6.75 5.16016",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
TrailingIcon14.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b6ulx":[function() {},{}],"45OBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronsDown1", ()=>(0, _chevronsDown1.ChevronsDown1));
var _chevronsDown1 = require("./ChevronsDown1");

},{"./ChevronsDown1":"6UTUv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6UTUv":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronsDown1", ()=>ChevronsDown1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ChevronsDown1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `chevrons-down-1 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 24 25",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M17 11.5L12 6.5L7 11.5",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M17 18.5L12 13.5L7 18.5",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aABvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronsDown2", ()=>(0, _chevronsDown2.ChevronsDown2));
var _chevronsDown2 = require("./ChevronsDown2");

},{"./ChevronsDown2":"6hf1x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6hf1x":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChevronsDown2", ()=>ChevronsDown2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ChevronsDown2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `chevrons-down-2 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 25 25",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M7.75 13.5L12.75 18.5L17.75 13.5",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M7.75 6.5L12.75 11.5L17.75 6.5",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gEDpR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons1", ()=>(0, _icons1.Icons1));
var _icons1 = require("./Icons1");

},{"./Icons1":"h3It6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h3It6":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons1", ()=>Icons1);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Icons1 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M18.0002 7.99999C18.0002 6.40869 17.368 4.88257 16.2428 3.75735C15.1176 2.63213 13.5915 1.99999 12.0002 1.99999C10.4089 1.99999 8.88275 2.63213 7.75753 3.75735C6.63231 4.88257 6.00017 6.40869 6.00017 7.99999C6.00017 15 3.00017 17 3.00017 17H21.0002C21.0002 17 18.0002 15 18.0002 7.99999Z",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.99832"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M13.7302 21C13.5544 21.3028 13.302 21.5542 12.9984 21.7289C12.6948 21.9036 12.3506 21.9956 12.0002 21.9956C11.6498 21.9956 11.3056 21.9036 11.002 21.7289C10.6983 21.5542 10.446 21.3028 10.2702 21",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.99832"
            })
        ]
    });
};
Icons1.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2OHy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons19", ()=>(0, _icons19.Icons19));
var _icons19 = require("./Icons19");

},{"./Icons19":"idxvZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"idxvZ":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons19", ()=>Icons19);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Icons19 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-19 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 24 25",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2608_2019)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M9.89902 4.90018C10.5874 4.73906 11.2921 4.65852 11.999 4.66018C18.999 4.66018 22.999 12.6602 22.999 12.6602C22.392 13.7958 21.6681 14.8649 20.839 15.8502M14.119 14.7802C13.8444 15.0749 13.5132 15.3113 13.1452 15.4753C12.7772 15.6393 12.3799 15.7274 11.9771 15.7345C11.5743 15.7417 11.1742 15.6676 10.8006 15.5167C10.4271 15.3658 10.0877 15.1412 9.80287 14.8563C9.51799 14.5715 9.29342 14.2321 9.14253 13.8586C8.99165 13.485 8.91755 13.0849 8.92466 12.6821C8.93176 12.2793 9.01993 11.882 9.1839 11.514C9.34787 11.146 9.58428 10.8148 9.87902 10.5402M17.939 18.6002C16.2296 19.9032 14.1481 20.625 11.999 20.6602C4.99902 20.6602 0.999023 12.6602 0.999023 12.6602C2.24291 10.3421 3.96816 8.31679 6.05902 6.72018L17.939 18.6002Z",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.99832"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M1 1.66016L23 23.6602",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.99832"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2608_2019",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(0 0.660156)",
                        width: "24"
                    })
                })
            })
        ]
    });
};
Icons19.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8A1Jb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NameMenuDarkTrue", ()=>(0, _nameMenuDarkTrue.NameMenuDarkTrue));
var _nameMenuDarkTrue = require("./NameMenuDarkTrue");

},{"./NameMenuDarkTrue":"5jOPL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5jOPL":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NameMenuDarkTrue", ()=>NameMenuDarkTrue);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const NameMenuDarkTrue = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `name-menu-dark-true ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M3 12H21",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.99832"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M3 6H21",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.99832"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M3 18H21",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.99832"
            })
        ]
    });
};
NameMenuDarkTrue.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aBd21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FrameCorp", ()=>FrameCorp);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const FrameCorp = ({ color })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 256,
        height: 217,
        viewBox: "0 0 206 197",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                fill: color,
                fillOpacity: 0.05
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                fill: color,
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                fill: color,
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                fill: color,
                fillOpacity: 0.05
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                fill: color,
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                fill: color,
                fillOpacity: 0.15
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                fill: color,
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                fill: color,
                fillOpacity: 0.15
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                fill: color,
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                fill: color,
                fillOpacity: 0.05
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                fill: color,
                fillOpacity: 0.05
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                fill: color,
                fillOpacity: 0.15
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                fill: color,
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                fill: color,
                fillOpacity: 0.25
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                fill: color,
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                fill: color,
                fillOpacity: 0.15
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                fill: color,
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                fill: color,
                fillOpacity: 0.05
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                fill: color,
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                fill: color,
                fillOpacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                fill: color,
                fillOpacity: 0.45
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                fill: color,
                fillOpacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                fill: color,
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                fill: color,
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                fill: color,
                fillOpacity: 0.15
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                fill: color,
                fillOpacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                fill: color,
                fillOpacity: 0.65
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                fill: color,
                fillOpacity: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                fill: color,
                fillOpacity: 0.55
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                fill: color,
                fillOpacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                fill: color,
                fillOpacity: 0.25
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                fill: color,
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                fill: color,
                fillOpacity: 0.55
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                fill: color,
                fillOpacity: 0.75
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                fill: color,
                fillOpacity: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                fill: color,
                fillOpacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                fill: color,
                fillOpacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                fill: color,
                fillOpacity: 0.65
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                fill: color,
                fillOpacity: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                fill: color,
                fillOpacity: 0.45
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                fill: color,
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                fill: color,
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                fill: color,
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                fill: color,
                fillOpacity: 0.9
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                fill: color,
                fillOpacity: 0.9
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gB3MM":[function() {},{}],"ilag0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnboardingRegisterVisaMobile", ()=>OnboardingRegisterVisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _svgFondo = require("./SvgFondo");
var _svgFondoDefault = parcelHelpers.interopDefault(_svgFondo);
const OnboardingRegisterVisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLanding = ()=>{
        const currentParams = location.search;
        navigate(`/wallet_visa-landing-visa-mobile${currentParams}`);
    };
    const handleButtonClickOnboarding = ()=>{
        const currentParams = location.search;
        navigate(`/wallet_visa-onboarding_disclosures-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#ffffff",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        page: {
            minHeight: "100vh",
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            overflow: "hidden"
        },
        svgFondo: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "300px",
            zIndex: 0
        },
        card: {
            width: "375px",
            height: "812px",
            background: colors.primario,
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            padding: "24px",
            paddingBottom: "64px",
            position: "relative",
            color: "white",
            boxSizing: "border-box",
            zIndex: 1
        },
        content: {
            position: "relative",
            zIndex: 2
        },
        welcomeText: {
            fontFamily: "Open Sans, sans-serif",
            fontSize: "20px",
            marginBottom: "16px",
            fontWeight: "normal"
        },
        name: {
            fontWeight: "bold"
        },
        menuIcon: {
            marginLeft: "12px",
            fontWeight: "bold"
        },
        faceIdButton: {
            width: "100%",
            backgroundColor: colors.secundario,
            color: '#FFFFFF',
            padding: "20px 16px",
            borderRadius: "2px",
            fontWeight: "500",
            fontSize: "15px",
            marginBottom: "16px",
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        passwordButton: {
            width: "100%",
            backgroundColor: "transparent",
            color: "white",
            padding: "20px 16px",
            border: "1px solid white",
            borderRadius: "2px",
            fontSize: "15px",
            fontWeight: "400",
            marginBottom: "16px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        supportText: {
            fontSize: "12px",
            color: "white"
        },
        clickHere: {
            color: colors.secundario,
            cursor: "pointer",
            textDecoration: "underline"
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: styles.page,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: styles.card,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 375,
                            height: 547,
                            viewBox: "0 0 375 547",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    clipPath: "url(#clip0_629_375)",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        clipPath: "url(#clip1_629_375)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M63.2116 224.054C80.7628 221.697 86.8886 199.728 76.2448 186.742C74.717 184.88 66.6668 178.242 67.1227 176.507L105.227 138.16L106.438 137.582C115.43 145.224 119.436 152.747 133.02 151.16C141.082 150.216 150.494 140.703 155.592 134.651C162.642 126.281 168.783 109.976 164.874 99.303C163.35 95.1343 152.241 83.6467 148.507 80.1412C145.251 77.0827 133.138 70.273 132.324 66.7231C130.696 59.6262 136.069 57.6307 141.976 57.0859C150.701 56.2806 157.381 58.1725 164.167 63.5906L167.764 16.5535C170.384 5.96882 184.622 6.33595 187.118 16.666C189.037 24.6126 188.954 35.2683 190.313 43.6708C190.52 44.9558 190.893 48.5175 191.562 49.234C199.921 53.61 212.415 53.8854 218.635 61.5359C228.515 73.6808 218.854 87.241 215.085 99.9988C212.021 110.373 210.159 119.238 210.926 130.237C212.258 149.381 232.874 158.589 248.207 147.332L308.36 86.6873H347.738V95.8656C347.738 96.8427 346.074 100.2 345.367 101.192C340.017 108.694 331.2 105.376 323.422 106.486C321.835 112.339 320.662 118.326 318.418 123.984C317.938 125.192 314.362 133.118 313.921 133.396C312.668 134.189 307.588 130.681 307.549 130.225C307.517 129.831 310.631 124.419 311.129 123.208C312.002 121.085 312.861 118.939 313.551 116.748C314.477 113.808 316.719 100.404 317.219 99.6909C318.232 98.249 334.018 99.7175 337.248 98.9951C339.632 98.4622 340.766 95.3978 340.632 93.201H311.913L255.082 150.654C236.175 168.297 205.78 156.901 203.823 130.823C202.846 117.808 206.011 105.313 209.937 93.0736C211.778 87.3298 217.075 77.3758 216.006 71.8541C212.909 55.8394 186.733 63.3242 183.785 47.8277C181.922 38.0306 182.061 27.2151 179.876 17.3736C176.744 13.3174 174.642 16.8791 174.245 20.6718C172.913 33.3941 173.108 46.4125 171.862 59.1466C171.299 64.8904 171.4 72.4551 163.323 71.256C160.392 70.8208 159.116 68.4196 156.883 67.031C152.108 64.0555 145.144 62.285 139.904 65.074C143.462 68.1502 147.927 70.6135 151.453 73.6453C156.019 77.5742 168.865 90.557 170.973 95.5755C182.867 123.889 142.595 174.725 113.645 153.496C112.025 152.309 107.602 147.066 106.438 147.063C96.0521 156.208 86.4741 166.66 76.5764 176.478C81.7103 182.337 86.5511 187.527 88.2268 195.494C90.927 208.329 83.9456 223.165 71.7888 228.498C70.0746 229.25 64.1975 231.171 62.6195 231.171H52.849V274.398H63.2116C68.9762 274.398 78.5867 280.604 82.1662 285.051C92.3541 297.702 90.3556 313.761 79.8006 325.331C74.9746 330.622 74.1574 332.828 68.8488 326.211C78.6459 317.648 85.4645 307.943 79.7858 294.54C77.7399 289.711 69.1035 281.504 63.8067 281.504H46.3384V224.065C51.6203 223.556 58.0925 224.752 63.2146 224.065L63.2116 224.054Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M344.185 138.192C343.842 139.243 343.123 140.049 342.427 140.875C339.306 144.576 330.086 154.142 326.433 156.857C325.728 157.378 325.157 158.05 324.224 158.201L294.824 158.242C293.021 157.653 294.149 152.827 293.853 151.219H321.98C323.934 149.967 334.086 138.192 335.007 138.192H344.185Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M354.252 473.94H306.88V480.453H354.252V473.94Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M155.667 -3.28641C156.519 -3.43445 161.384 0.98889 159.735 2.58177L138.74 23.0878C137.938 23.2921 127.14 12.4529 126.93 11.6535C126.592 10.3685 130.249 6.71791 131.309 6.71791C133.026 6.71791 137.505 13.4565 138.927 13.2108C141.656 11.5143 154.16 -3.01995 155.669 -3.28345L155.667 -3.28641Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M141.547 293.851L138.174 300.273L200.585 333.053L203.957 326.631L141.547 293.851Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.4134 353.9C28.1919 352.378 40.772 360.384 44.0585 372.887C46.507 382.198 45.977 414.974 45.1747 425.703C42.6195 459.784 -4.6397 459.438 -7.54122 426.855C-8.65149 414.384 -8.55675 391.433 -7.57083 378.879C-6.57898 366.24 2.57561 355.427 15.4134 353.9ZM14.7975 360.982C7.4934 362.125 0.683701 369.446 -0.290381 376.685C0.6008 392.91 -2.01353 411.498 -0.438417 427.45C1.70812 449.179 34.3117 450.402 37.7787 428.374C40.1444 413.348 36.5678 393.816 38.0393 378.314C36.3458 366.37 26.8448 359.099 14.7975 360.982Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M100.025 405.479C105.831 405.461 111.525 409.949 112.513 415.755C114.642 428.238 102.03 435.429 92.9253 440.688C85.8165 435.717 75.8892 431.127 73.9588 421.745C71.9218 411.859 78.8055 404.851 88.6796 405.84C90.3583 406.009 91.889 407.071 93.3635 407C95.1192 406.917 97.6713 405.484 100.025 405.479ZM84.6619 412.469C79.1727 413.662 80.1349 421.082 82.7877 424.753C83.9217 426.319 90.835 431.779 92.5078 432.25C93.9734 432.661 99.735 428.359 101.088 427.139C104.549 424.022 107.883 419.119 104.697 414.686C100.484 408.821 94.5241 415.474 92.9223 415.225C90.9475 414.917 88.8424 411.56 84.6589 412.469H84.6619Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M305.503 439.711C305.503 447.915 298.854 454.565 290.649 454.565C282.445 454.565 275.795 447.915 275.795 439.711C275.795 431.506 282.445 424.857 290.649 424.857C298.854 424.857 305.503 431.506 305.503 439.711ZM298.635 439.717C298.635 435.29 295.046 431.702 290.62 431.702C286.193 431.702 282.605 435.29 282.605 439.717C282.605 444.143 286.193 447.731 290.62 447.731C295.046 447.731 298.635 444.143 298.635 439.717Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M391.376 439.817C391.376 448.004 384.738 454.642 376.552 454.642C368.365 454.642 361.728 448.004 361.728 439.817C361.728 431.631 368.365 424.993 376.552 424.993C384.738 424.993 391.376 431.631 391.376 439.817ZM384.602 439.829C384.602 435.376 380.993 431.767 376.54 431.767C372.087 431.767 368.478 435.376 368.478 439.829C368.478 444.282 372.087 447.891 376.54 447.891C380.993 447.891 384.602 444.282 384.602 439.829Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M322.658 204.898C321.737 205.83 313.092 211.974 312.399 212.095C304.772 208.43 295.472 202.402 297.539 192.51C298.33 188.732 302.8 185.138 306.637 185.031C308.506 184.981 310.611 186.171 312.452 186.103C313.977 186.047 315.505 184.984 317.184 185.028C327.673 185.309 329.562 197.91 322.658 204.898ZM306.128 192.181C299.514 194.073 309.077 204.859 312.811 203.687C316.434 202.55 323.753 193.813 318.306 192.19C314.936 191.186 313.145 194.328 311.922 194.257C310.83 194.195 309.003 191.361 306.131 192.181H306.128Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-6.58151 244.823C-5.40017 244.616 -1.4476 249.954 -0.0678943 250.659L6.44572 244.823C7.04379 244.72 10.8394 248.355 11.1355 248.93C11.9616 250.531 6.2444 254.262 5.51902 255.816L11.3546 262.33C11.4582 262.928 7.82247 266.724 7.24809 267.02C5.64633 267.846 1.9158 262.129 0.361416 261.403L-6.1522 267.239C-6.75027 267.343 -10.5459 263.707 -10.842 263.132C-11.668 261.531 -5.95087 257.8 -5.22549 256.246L-11.0611 249.732C-11.1766 249.063 -7.05226 244.906 -6.58151 244.823Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M17.6163 259.582H37.7493C39.0639 259.582 39.0639 266.688 37.7493 266.688H17.6163C16.3017 266.688 16.3017 259.582 17.6163 259.582Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M362.542 195.038V201.552H343.889C343.827 201.552 343.001 202.378 343.001 202.44V287.413H365.503V293.927H335.896V195.927C335.896 195.864 336.722 195.038 336.784 195.038H362.542Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M384.922 271.011C391.877 270.217 418.296 269.904 424.265 271.582C429.345 273.009 433.156 277.749 433.621 282.952C436.016 309.684 431.779 339.957 433.6 367.063C432.389 374.095 427.24 378.035 420.297 378.631C411.365 379.397 393.041 379.486 384.23 378.536C378.361 377.902 374.213 374.722 372.307 369.141L372.067 281.847C373.512 275.183 378.388 271.763 384.922 271.017V271.011ZM427.086 355.51V282.972C427.086 281.504 423.447 277.601 421.408 277.992C409.615 278.718 396.333 276.844 384.721 277.909C382.252 278.137 378.53 280.399 378.53 282.969V355.507H427.086V355.51ZM427.086 362.024H378.53C377.888 366.856 379.424 371.039 384.721 371.525C396.656 372.623 410.397 370.752 422.521 371.374C426.63 369.84 427.51 366.074 427.086 362.024Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-6.52828 146.619C4.75804 147.581 19.7601 144.848 30.6053 146.521C35.7066 147.308 38.2617 152.777 38.6585 157.416C39.3157 165.138 39.3957 180.581 38.6288 188.223C38.0574 193.928 34.7977 198.094 28.888 198.615C20.7223 199.334 3.15332 199.453 -4.891 198.591C-10.8746 197.952 -13.6133 193.247 -14.09 187.657C-14.765 179.74 -14.7769 164.75 -14.0574 156.854C-13.5807 151.616 -11.6089 148.442 -6.53124 146.616L-6.52828 146.619ZM-4.76072 153.123C-6.00127 153.718 -6.99312 154.781 -6.99015 156.223C-5.93021 166.37 -8.29584 179.027 -6.99015 188.85C-6.68816 191.124 -5.33806 191.835 -3.1264 192.092C3.75731 192.889 20.0739 192.747 27.1145 192.107C28.6541 191.968 29.8503 191.853 30.9783 190.642V154.435L27.6919 152.984L-4.76368 153.123H-4.76072Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M380.954 81.435C380.744 81.7222 382.15 85.6067 382.106 86.9568C382.035 89.1033 379.672 92.5082 379.832 93.3845C380.167 95.2291 382.402 96.8308 382.056 100.52C381.588 105.532 376.279 108.348 376.232 108.869C376.199 109.236 378.263 112.238 378.491 113.654C381.079 129.902 355.332 129.505 359.243 112.691C359.661 110.9 361.943 108.718 361.943 107.7C361.943 106.681 359.394 104.162 359.042 101.728C358.367 97.0588 360.795 94.6932 360.735 92.8931C360.706 92.0078 359.288 90.3942 359.042 88.7007C358.121 82.3025 361.727 77.3255 368.164 76.609C371.356 76.2537 377.742 78.2049 377.994 73.9444C378.21 70.273 375.142 71.0547 374.941 70.3234C374.509 68.7542 375.32 65.4352 374.98 63.5818C383.995 63.8512 388.202 73.3433 382.689 80.4935C382.227 81.0916 381.108 81.2218 380.954 81.4321V81.435ZM366.239 88.9049C367.779 90.4386 376.596 90.9686 374.867 85.3136C373.345 80.3395 361.68 84.3602 366.239 88.9049ZM366.239 101.932C367.779 103.466 376.602 103.993 374.867 98.3408C373.316 93.2839 361.638 97.346 366.239 101.932ZM371.942 115.821C371.942 114.033 370.494 112.585 368.706 112.585C366.917 112.585 365.47 114.033 365.47 115.821C365.47 117.609 366.917 119.057 368.706 119.057C370.494 119.057 371.942 117.609 371.942 115.821Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M48.1121 36.343H28.5713V42.8566H48.1121V36.343Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M35.0849 20.355H28.5713V29.8294H35.0849V20.355Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M48.1122 20.355H41.5986V29.8294H48.1122V20.355Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M213.321 473.94H148.185V480.453H213.321V473.94Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M205.031 405.843V414.429L197.925 431.897H165.061C164.999 431.897 164.173 431.071 164.173 431.009V412.652C164.173 412.111 159.8 403.267 159.341 402.98C158.103 402.204 152.398 403.755 151.403 402.328C150.935 401.656 150.935 397.005 151.403 396.333C151.954 395.542 162.562 395.445 163.587 396.066C165.055 396.961 166.974 404.564 169.206 405.843H205.031ZM197.925 412.356H171.279V425.384H193.188L197.925 412.356Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M109.767 97.9411C109.767 119.569 92.2332 137.103 70.605 137.103C48.9768 137.103 31.4434 119.569 31.4434 97.9411C31.4434 76.3129 48.9768 58.7795 70.605 58.7795C92.2332 58.7795 109.767 76.3129 109.767 97.9411ZM102.921 97.953C102.921 80.1145 88.4582 65.6513 70.6198 65.6513C52.7814 65.6513 38.3182 80.1145 38.3182 97.953C38.3182 115.791 52.7814 130.255 70.6198 130.255C88.4582 130.255 102.921 115.791 102.921 97.953Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M9.03354 97.9263C7.83149 97.6954 3.07654 98.2905 2.5821 97.8582C2.38669 97.6865 1.9337 94.48 0.462215 93.1714C-2.03072 90.9508 -6.19055 91.0396 -8.53545 93.3905C-9.59836 94.4534 -10.383 97.7161 -10.5902 97.8493C-10.9129 98.0595 -15.3659 98.0447 -16.1564 97.9322C-17.0446 97.8049 -17.0979 98.2786 -17.0328 97.044C-16.1682 80.7866 9.06019 81.0294 9.03058 97.9263H9.03354Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M6.06975 71.8718V81.9383C3.22744 81.4824 -0.627435 83.4424 -1.06562 79.8954C-1.94792 72.7097 -1.53638 70.9481 6.06975 71.8718Z",
                                                fill: colors.secundario
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip0_629_375",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 375,
                                                height: 547,
                                                rx: 40,
                                                fill: colors.quinto
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip1_629_375",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 539.446,
                                                height: 514.709,
                                                fill: colors.quinto,
                                                transform: "translate(-76.8311 -21.1989)"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 375,
                            height: 547,
                            viewBox: "0 0 375 547",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    clipPath: "url(#clip0_629_286)",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        clipPath: "url(#clip1_629_286)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M318.723 224.646V280.9H302.439C292.929 280.9 283.472 294.211 283.185 303.132C282.809 314.827 291.437 320.772 298.018 328.568C285.856 342.057 272.219 354.557 259.496 367.67C258.86 368.132 258.395 367.972 257.744 367.67C255.982 366.856 250.546 360.008 248.263 358.169C233.232 346.062 210.44 357.079 210.952 376.235H226.644C229.661 376.235 235.822 380.437 235.822 383.637V447.885H229.309V385.414C229.309 385.251 227.882 383.978 227.52 383.649L133.967 383.634C133.556 383.836 132.194 385.748 132.194 386.006V447.885H125.68V383.637C125.68 383.282 128.155 379.483 128.7 378.959C129.825 377.876 133.422 376.235 134.858 376.235H154.103C153.777 357.189 137.387 354.72 121.807 355.487C89.5561 357.071 62.5424 379.581 58.2493 412.134C57.3019 419.311 58.2671 426.642 56.7009 433.68C53.074 449.969 38.7499 462.351 22.309 464.424C21.7109 465.256 21.7701 482.763 22.0218 484.924C22.0928 485.519 22.2912 486.967 22.9396 486.967H32.1179C32.035 488.151 32.5887 493.48 31.2297 493.48H5.47129V486.967H14.6496C15.298 486.967 15.4993 485.522 15.5674 484.924C15.822 482.763 15.8812 465.256 15.2832 464.424C4.31364 462.819 -5.29987 458.052 -12.1895 449.262C-21.1664 437.813 -20.7875 424.513 -20.5832 410.574H-13.4745V429.23C-13.4745 438.671 -3.61521 450.425 4.67189 454.31C25.9684 464.297 48.9023 449.57 50.9955 426.784C52.2983 412.605 50.9689 405.304 57.0769 391.415C71.1048 359.513 102.838 345.897 136.626 349.003C150.417 350.27 161.52 362.403 161.206 376.235L203.814 376.2C204.841 350.361 232.962 337.106 253.525 353.494C254.895 354.586 258.197 358.88 259.502 358.207L289.104 328.565C278.294 319.49 273.501 306.93 278.608 293.19C283.89 278.978 296.982 272.98 311.617 273.794V231.156H301.252C299.973 231.156 294.726 229.17 293.267 228.483C276.698 220.705 271.253 198.041 282.614 183.503C283.369 182.535 290.356 175.432 290.901 175.181C292.633 174.381 296.828 178.257 295.662 179.956C294.175 182.121 290.614 184.498 288.811 186.742C280.491 197.081 281.853 211.678 292.384 219.897C294.637 221.655 300.914 224.649 303.62 224.649H318.72L318.723 224.646Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M341.225 460.912H272.536V467.426H341.225V460.912Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M160.027 34.5666C159.734 36.1743 160.859 41.0003 159.056 41.5895C157.253 42.1786 142.491 41.8826 139.575 41.696C96.499 38.9662 98.8172 -18.0338 137.203 -20.5327C149.996 -21.3646 170.13 -21.4831 182.849 -20.5268C213.732 -18.2085 222.591 22.8125 195.562 37.5273C195.968 35.1439 194.384 32.5533 195.083 30.2498C195.438 29.0804 198.668 26.6762 199.687 25.3765C209.916 12.3285 204.326 -7.52321 188.421 -12.4795C179.53 -15.2507 150.494 -14.6704 140.164 -14.0131C125.65 -13.0894 113.668 -3.73939 114.408 11.7897C114.856 21.1545 124.966 34.5666 134.858 34.5666H160.025H160.027Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M222.203 224.054C222.342 223.959 223.34 221.04 223.31 220.874C223.151 220.018 218.849 217.848 217.922 215.012C217.324 213.185 217.635 208.382 217.41 208.122C216.933 207.568 211.355 207.702 208.681 203.527C208.024 202.502 207.343 199.796 206.834 199.453C205.611 198.627 201.244 199.586 199.08 198.917C197.061 198.292 194.654 194.218 193.407 193.973C192.303 193.753 190.124 195.37 188.711 195.589C182.754 196.513 181.458 192.371 179.175 192.175C178.313 192.101 173.881 195.912 170.831 196.078C168.466 196.208 165.635 194.263 163.892 194.437C161.68 194.657 160.359 200.178 154.938 200.907C153.458 201.105 149.585 200.619 148.872 201.061C148.49 201.297 146.965 206.585 145.544 208.095C143.658 210.1 138.559 210.976 137.813 212.208C137.008 213.534 137.905 217.679 136.638 220.507C135.696 222.612 131.64 225.324 131.611 226.704C131.587 227.799 133.378 230.138 133.707 231.719C136.724 246.256 138.394 247.05 144.934 259.574C150.243 269.741 154.311 279.997 150.243 291.573C149.091 291.067 144.357 289.208 144.137 288.257C143.918 287.307 145.266 283.434 145.266 281.794C145.274 267.106 130.414 253.853 127.605 239.6C127.249 237.797 127.59 236.006 127.193 234.091C126.154 229.037 122.305 227.216 126.367 221.496C128.431 218.591 130.554 219.133 131.007 214.881C131.371 211.438 130.03 209.691 133.055 206.864C135.371 204.702 138.4 205.004 140.206 203.355C142.281 201.46 142.029 196.978 145.588 195.118C148.49 193.602 151.788 194.455 154.278 193.742C156.484 193.108 158.503 187.945 162.843 187.456C165.523 187.154 168.27 189.253 170.349 189.111C173.446 188.901 174.381 184.868 180.463 185.555C183.385 185.884 185.804 188.901 186.959 188.91C187.876 188.916 190.917 187.083 192.451 186.87C198.423 186.044 199.767 192.033 201.901 192.59C204.329 193.224 206.419 190.707 210.55 193.366C213.821 195.471 213.38 199.006 214.63 200.237C216.015 201.602 220.684 200.75 223.056 204.542C224.823 207.373 223.242 209.884 224.282 212.199C224.948 213.682 227.882 214.813 228.983 216.379C232.444 221.303 228.619 223.725 228.104 227.888C227.686 231.254 227.583 246.762 228.243 249.688C229.099 253.474 235.583 260.847 237.033 265.178C238.298 268.956 237.516 273.03 234.656 275.887C232.53 278.01 228.042 278.374 227.254 279.736C225.294 283.123 224.288 293.643 222.632 298.208C219.083 307.988 210.618 305.326 202.165 305.871C201.629 306.205 198.769 314.175 197.632 315.256C196.223 316.594 191.435 313.953 191.409 312.609C191.397 311.967 196.383 301.885 197.058 301.056C201.099 296.106 211.562 300.47 214.846 298.119C217.448 296.257 220 275.067 221.738 273.332C223.672 271.399 232.21 273.815 230.031 266.857C229.084 263.837 221.022 252.447 221.022 251.002V231.165H192.007L196.791 250.925C196.655 251.609 190.843 252.933 190.275 252.438C189.17 251.479 184.146 227.5 183.124 224.063H222.206L222.203 224.054Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M177.792 245.371V251.887C164.617 248.974 158.681 265.708 173.028 267.896C173.369 274.383 173.78 276.388 166.959 273.673C156.934 269.684 154.956 255.511 163.033 248.675C163.909 247.932 168.383 245.374 169.206 245.374H177.792V245.371Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M321.684 132.271C321.382 131.984 323.581 126.065 323.99 125.532C324.94 124.295 351.338 125.704 355.125 125.18C357.464 126.37 358.773 128.478 361.162 129.81C362.885 130.773 364.223 129.813 363.726 132.271H321.684Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281.421 71.8689C281.148 73.3996 281.93 77.3699 281.163 78.4269C280.843 78.868 276.624 79.3181 274.587 81.3255C271.754 84.1145 272.219 88.1736 271.949 88.4579C271.706 88.7154 265.119 88.677 264.864 88.4283C264.651 88.218 264.382 84.7273 263.067 82.8236C260.411 78.9805 257.72 80.0287 255.94 78.6993C254.73 77.7933 255.624 73.5239 255.36 71.8718C260.399 71.629 264.802 74.1664 268.174 77.7548C272.124 74.4684 275.825 71.4366 281.418 71.8718L281.421 71.8689Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M248.269 37.5214C249.412 38.383 249.575 36.3786 250.3 35.745C253.317 33.1159 257.835 31.2032 261.877 31.6029C261.679 32.7132 262.161 37.7761 261.847 38.0958C261.569 38.38 257.27 38.6287 254.742 41.3497C252.403 43.8633 252.633 47.3422 252.397 47.5938C252.16 47.8455 245.569 47.8159 245.317 47.5702C245.066 47.3244 245.001 43.5998 242.952 41.3526C240.447 38.611 236.124 38.383 235.846 38.0988C235.532 37.779 236.018 32.7162 235.817 31.6059C240.255 31.1588 244.391 33.2491 247.63 36.1092C248.166 36.5829 248.204 37.477 248.266 37.5244L248.269 37.5214Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M399.255 426.864C391.536 419.557 380.798 417.102 370.53 415.915L268.734 415.874C268.091 415.983 266.129 427.273 266.031 428.646C265.88 430.722 266.715 440.321 266.359 440.815C265.824 441.561 261.326 442.044 260.109 442.556C257.981 432.534 259.18 420.868 262.955 411.359C267.12 400.86 272.704 390.32 285.246 389.239C304.162 387.611 325.349 390.527 344.514 389.23L346.29 389.822L364.922 408.496C375.587 409.36 386.065 410.574 395.631 415.684C398.405 417.168 405.171 421.413 405.742 424.522C405.147 426.873 407.16 440.492 406.331 441.339C405.991 441.685 400.294 442.091 399.258 441.961V426.861L399.255 426.864ZM271.943 408.803H283.49C285.033 405.547 288.74 400.454 289.693 397.239C290.022 396.129 289.509 396.457 288.828 396.368C279.182 395.092 275.277 400.91 271.94 408.803H271.943ZM291.484 408.803H326.421L322.193 396.451C319.066 396.667 298.093 395.738 297.344 396.736L291.484 408.803ZM354.844 408.803C353.269 407.382 343.572 396.368 342.705 396.368H329.382L333.527 408.803H354.844Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M355.436 437.819H311.588V444.924H355.436V437.819Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M346.471 356.772C347.205 358.246 343.066 362.048 342.11 362.048C341.681 362.048 336.692 358.116 335.481 357.402C325.231 351.38 313.216 350.785 302.543 356.209C300.873 357.056 294.658 362.045 294.146 362.045C293.252 362.045 289.687 358.551 289.681 357.58C289.663 355.185 301.388 349.014 303.922 348.114C318.821 342.823 334.696 346.593 346.468 356.769L346.471 356.772Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M316.236 358.652C323.83 358.172 332.745 361.062 337.651 367.019L332.724 371.451C326.157 365.405 317.358 363.685 309.127 367.528C307.801 368.147 303.466 371.519 303.114 371.457C302.593 371.365 298.489 367.14 298.617 366.527C303.227 361.944 309.699 359.063 316.236 358.649V358.652Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M328.126 375.119C328.89 376.422 324.899 380.342 323.774 380.369C321.719 380.416 320.381 377.701 315.715 378.859C314.465 379.169 313.124 380.594 312.035 380.321C311.374 380.155 308.026 376.733 308.029 375.933C308.035 373.615 315.798 371.495 317.838 371.457C319.593 371.424 322.143 372.025 323.78 372.665C324.316 372.875 327.999 374.909 328.126 375.125V375.119Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-70.3174 231.159V274.386H37.7494C39.0639 274.386 39.0639 281.492 37.7494 281.492H-76.8311V224.054H37.7494C39.0639 224.054 39.0639 231.159 37.7494 231.159H-70.3174Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M14.8302 311.866C25.0299 310.818 36.5442 313.794 44.5116 320.328C49.1747 324.153 47.6914 325.035 43.1674 328.224C30.9248 316.917 13.6755 315.25 -0.281389 324.585C-1.7736 325.583 -3.89644 328.594 -5.35608 328.212C-6.27983 327.97 -9.5544 324.517 -9.26129 323.363C-9.01259 322.38 -3.64478 318.501 -2.39831 317.734C2.5846 314.679 8.99459 312.47 14.8302 311.869V311.866Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M14.8094 324.873C22.9722 323.765 33.6515 326.202 38.596 333.225C33.5657 340.165 33.0446 335.552 27.9788 333.308C20.7575 330.107 14.3357 331.078 7.64741 334.883C6.68813 335.428 5.90057 336.837 5.05676 337.074C3.1767 337.604 -1.11341 333.805 0.106416 332.097C2.2115 329.145 11.1855 325.367 14.8094 324.876V324.873Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.9821 337.888C19.3603 337.308 26.398 338.063 28.6126 340.97C29.9656 342.746 26.2736 346.341 25.2285 346.545C24.2929 346.726 21.717 344.251 19.3929 344.254C14.9636 344.256 13.6076 349.39 9.58987 343.404C7.72461 340.627 13.7615 338.273 15.9821 337.891V337.888Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M368.463 219.909V178.162C368.463 162.023 387.989 149.792 403.033 151.291C415.385 152.519 430.639 165.129 430.639 178.162V219.02C430.639 220.335 423.533 220.335 423.533 219.02V177.57C423.533 175.509 419.971 169.016 418.506 167.202C405.319 150.846 379.232 157.878 375.631 178.227L375.486 218.94C374.897 220.743 370.071 219.615 368.463 219.912V219.909Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M26.2026 204.513C26.7178 205.028 25.1486 210.881 24.4499 211.346C22.5432 212.622 4.25175 211.006 0.524189 211.536C-0.757809 211.103 -1.82071 205.996 -1.62826 204.51H26.2026V204.513Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M26.7949 139.969H-1.62815C-1.69033 138.542 -0.671841 133.941 0.524296 133.535C7.53828 134.044 16.1718 132.582 22.9785 133.423C26.0902 133.807 25.2968 137.662 26.7949 139.969Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.5439 159.51V172.537H25.0182V179.05H9.03027V159.51H15.5439Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M382.083 46.4095H373.2L370.835 70.6905L364.031 71.2886L366.687 46.4095H313.986L317.536 80.159L310.43 80.1649L307.475 46.4066C306.03 46.2112 298.59 47.0402 298.59 45.5213V27.1648C298.59 27.1026 299.416 26.2766 299.478 26.2766H381.194C381.257 26.2766 382.083 27.1026 382.083 27.1648V46.4095ZM305.696 33.3823V39.8959H374.977V33.3823H305.696Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M67.5641 29.8975C67.5641 46.1045 54.4274 59.2413 38.2203 59.2413C22.0132 59.2413 8.87646 46.1045 8.87646 29.8975C8.87646 13.6904 22.0132 0.55365 38.2203 0.55365C54.4274 0.55365 67.5641 13.6904 67.5641 29.8975ZM60.7574 29.9064C60.7574 17.4387 50.6524 7.33373 38.1848 7.33373C25.7171 7.33373 15.6121 17.4387 15.6121 29.9064C15.6121 42.374 25.7171 52.479 38.1848 52.479C50.6524 52.479 60.7574 42.374 60.7574 29.9064Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M104.958 480.453C104.464 480.021 106.148 478.099 106.513 477.567C110.208 472.11 118.421 460.166 122.735 455.891C123.365 455.266 123.741 454.479 124.81 454.414L238.067 454.529C242.896 462.704 250.763 470.162 255.597 478.147C256.048 478.89 256.743 479.447 256.551 480.45H248.261L234.964 462.067L233.632 461.031L128.366 460.924L126.548 462.067L113.251 480.45H104.961L104.958 480.453Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M171.281 437.816V444.927H164.17C163.66 437.567 163.93 437.307 171.281 437.816Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M193.792 437.81H187.258V444.936H193.792V437.81Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M51.0111 97.9915C51.2687 98.2106 51.9467 103.294 52.3878 104.606C57.8977 120.982 82.3031 121.591 88.4851 105.441C89.0417 103.99 89.921 98.2372 90.2112 97.9885C90.7086 97.5651 95.4635 98.1632 96.6685 97.9263C95.2119 132.514 45.963 132.434 44.5537 97.9263C45.7647 98.1661 50.4989 97.5622 51.0081 97.9915H51.0111Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M83.6411 78.3854H77.1274V94.9656H83.6411V78.3854Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M64.1 78.3854H57.5864V94.9656H64.1V78.3854Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M25.4388 85.0116C25.4388 101.222 12.299 114.361 -3.91099 114.361C-20.121 114.361 -33.2607 101.222 -33.2607 85.0116C-33.2607 68.8015 -20.121 55.6618 -3.91099 55.6618C12.299 55.6618 25.4388 68.8015 25.4388 85.0116ZM18.635 84.982C18.635 72.5113 8.5241 62.4004 -3.94651 62.4004C-16.4171 62.4004 -26.528 72.5113 -26.528 84.982C-26.528 97.4526 -16.4171 107.563 -3.94651 107.563C8.5241 107.563 18.635 97.4526 18.635 84.982Z",
                                                fill: colors.quinto
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip0_629_286",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 375,
                                                height: 547,
                                                rx: 40,
                                                fill: colors.quinto
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip1_629_286",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 539.446,
                                                height: 514.709,
                                                fill: colors.quinto,
                                                transform: "translate(-76.8311 -21.1989)"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: styles.content,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                style: styles.welcomeText,
                                children: [
                                    "Welcome back ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: styles.name,
                                        children: "Sam!"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: styles.menuIcon,
                                        children: " \u22EE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: handleButtonClickOnboarding,
                                style: styles.faceIdButton,
                                children: [
                                    "Sign up ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: styles.arrow,
                                        children: "\u203A"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: handleButtonClickLanding,
                                style: styles.passwordButton,
                                children: [
                                    "Log in ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: styles.arrow,
                                        children: "\u203A"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                style: styles.supportText,
                                children: [
                                    "If You Need Any Support",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: styles.clickHere,
                                        children: "Click Here"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","./SvgFondo":"01Ahv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"01Ahv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFondo = (colors)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 375,
        height: 632,
        viewBox: "0 0 375 632",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: -191.849,
                y: -126.723,
                width: 758.705,
                height: 758.705,
                fill: "url(#pattern0_271_3901)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("pattern", {
                        id: "pattern0_271_3901",
                        patternContentUnits: "objectBoundingBox",
                        width: 1,
                        height: 1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                            xlinkHref: "#image0_271_3901",
                            transform: "scale(0.000390625)"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("image", {
                        id: "image0_271_3901",
                        width: 2560,
                        height: 2560,
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
exports.default = SvgFondo;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Cxlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnboardingLandingVisaMobile", ()=>OnboardingLandingVisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const OnboardingLandingVisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const contacts = [
        {
            name: "Alejandro",
            image: "foto visa 1.png"
        },
        {
            name: "LingLing",
            image: "foto visa 2.png"
        },
        {
            name: "Pam",
            image: "foto visa 3.png"
        },
        {
            name: "Sean",
            image: "foto visa 4.png"
        }
    ];
    const handleButtonClickCardDetails = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-card_details-visa-mobile${currentParams}`);
    };
    const handleButtonRestart = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_register-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        title: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        container: {
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box",
            alignItems: "center",
            justifyContent: 'flex-start',
            margin: "16px 0 8px 0"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            width: '100%'
        },
        balance: {
            color: "#333",
            borderRadius: "12px",
            padding: "2px",
            textAlign: "center",
            marginBottom: "2px",
            display: 'flex'
        },
        balanceCard: {
            display: "flex",
            color: "white",
            borderRadius: "12px 12px 0px 0px",
            padding: "12px",
            justifyContent: "space-between",
            textAlign: "center",
            height: "160px",
            marginBottom: "0px",
            width: '90%',
            flexDirection: 'column'
        },
        balanceText: {
            fontSize: "20px",
            fontWeight: "bold"
        },
        actionButtons: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px"
        },
        actionButton: {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            width: "190px",
            margin: "0 4px",
            padding: "12px",
            backgroundColor: "#f1f1f1",
            border: "none",
            fontWeight: "500",
            cursor: "pointer"
        },
        actionButton2: {
            marginTop: 9,
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            width: "190px",
            padding: "8px",
            backgroundColor: colors.secundario,
            border: "none",
            borderRadius: 50,
            fontWeight: "500",
            cursor: "pointer"
        },
        avatarRow: {
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "29px",
            marginBottom: "16px"
        },
        avatar: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: "12px"
        },
        avatarImg: {
            width: "60px",
            height: "60px",
            border: `1px solid #f7f7f7`,
            objectFit: "cover"
        },
        promoCard: {
            display: "flex",
            alignItems: "center",
            borderRadius: "12px",
            padding: "12px"
        },
        promoImg: {
            width: "60px",
            height: "60px",
            marginRight: "12px"
        },
        bottomNav: {
            display: "flex",
            justifyContent: "space-around",
            borderTop: "1px solid #f7f7f7",
            paddingTop: "8px",
            marginTop: "auto",
            width: '100%'
        },
        navItem: {
            width: "70px",
            alignItems: "center",
            gap: 6,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            color: "#333"
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: styles.page,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    ...styles.container,
                    width: "100%",
                    backgroundColor: '#e7e7e7',
                    paddingLeft: 0,
                    paddingRight: 0
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            ...styles.header,
                            paddingLeft: 2,
                            paddingRight: 2
                        },
                        children: [
                            colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 50,
                                    maxWidth: 100,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 8,
                                    justifyItems: "center",
                                    placeItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "2,015 pts"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "https://randomuser.me/api/portraits/men/75.jpg",
                                        alt: "User",
                                        style: {
                                            ...styles.avatarImg,
                                            borderRadius: 50
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            ...styles.balanceCard,
                            background: colors.url_card ? `url(${colors.url_card})` : "linear-gradient(90deg, #c49d14, #d6c37f)",
                            borderTopRightRadius: 20,
                            borderTopLeftRadius: 20
                        },
                        onClick: handleButtonClickCardDetails,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    ...styles.container,
                                    flexDirection: "row",
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    paddingTop: 0,
                                    paddingBottom: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: 63,
                                        height: 19,
                                        viewBox: "0 0 63 19",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M36.4625 15.0292C34.5008 15.0292 33.4252 14.7603 31.7734 14.0817L31.1614 13.8025L30.4674 17.836C31.6607 18.3277 33.8119 18.7502 36.0374 18.7835C41.2642 18.7835 44.6805 16.3583 44.7215 12.6271C44.7624 10.5757 43.4154 9.0187 40.5702 7.73568C38.8441 6.90338 37.7686 6.3451 37.7686 5.49999C37.7686 4.7522 38.6879 3.95575 40.6086 3.95575C42.2604 3.93014 43.4154 4.28099 44.3348 4.64464L44.7957 4.84951L45.4897 0.951782L45.3694 0.977392C44.3783 0.608619 42.8341 0.216797 40.9134 0.216797C35.9964 0.216797 32.5263 2.65992 32.5007 6.16071C32.47 8.73444 34.9695 10.1839 36.8569 11.047C38.7955 11.9305 39.4434 12.4862 39.4383 13.2801C39.4255 14.4863 37.8889 15.0292 36.4625 15.0292ZM58.1305 0.547156H54.2891C53.0931 0.547156 52.1994 0.867272 51.6744 2.04018L44.2861 18.5325H49.513L50.5578 15.8333L56.9345 15.8385C57.0907 16.4684 57.5491 18.5325 57.5491 18.5325H62.1562L58.1305 0.547156ZM51.9894 12.143L53.9715 7.11593C53.9459 7.16715 54.3813 6.0762 54.6322 5.40011L54.9728 6.95203L56.1227 12.143H51.9894Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M22.3185 18.3891H27.297L30.4085 0.396084H25.4326V0.390963L22.3185 18.3891Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M13.3015 12.8114L12.7842 10.312V10.3196L11.0377 2.05808C10.738 0.913345 9.86219 0.575301 8.77636 0.534326H0.758115L0.694092 0.913343C2.49954 1.3359 4.12573 1.94796 5.58033 2.69831C5.84154 2.85965 5.95166 3.03635 6.0413 3.29757L10.3436 18.5069H15.6038L23.4428 0.547131H18.1698L13.3015 12.8114Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: " ****9821"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    ...styles.container,
                                    flexDirection: "row",
                                    width: '100%',
                                    justifyContent: 'flex-start',
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    marginTop: 1,
                                    marginBottom: 1
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        ...styles.balanceText,
                                        margin: 0,
                                        padding: 0
                                    },
                                    children: "$ 6,256.49 USD"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    ...styles.container,
                                    flexDirection: "column",
                                    width: '100%',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start',
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    marginTop: 1,
                                    marginBottom: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            ...styles.balanceText,
                                            margin: 0,
                                            padding: 0,
                                            fontSize: 12,
                                            fontWeight: 'bold'
                                        },
                                        children: "Card Holder"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            ...styles.balanceText,
                                            margin: 0,
                                            padding: 0,
                                            fontSize: 12
                                        },
                                        children: "Jhon Doe"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            backgroundColor: '#FFFFFF',
                            height: '80%',
                            width: '100%',
                            borderTopLeftRadius: 40,
                            borderTopRightRadius: 40,
                            marginTop: -10
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    paddingTop: 40,
                                    paddingLeft: 10,
                                    paddingRight: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            width: 70,
                                            height: 70,
                                            backgroundColor: '#f7f7f7',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "40",
                                                height: "40",
                                                viewBox: "0 0 36 36",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                        clipPath: "url(#clip0_1882_2410)",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M20.2262 18.6695H20.2248C19.8367 18.6695 19.5224 18.9852 19.5231 19.374V20.2909C19.5231 23.7777 19.5231 23.8821 18.8917 24.8503C18.377 25.6392 17.2949 25.893 14.2588 25.9366H13.9487C13.9016 25.9366 13.8552 25.9352 13.8095 25.9345L15.2474 23.4103C16.0082 22.1552 15.6109 20.5134 14.3572 19.7463C13.1008 18.9771 11.4526 19.3737 10.6806 20.6351C10.0527 21.6792 9.32569 22.5019 8.79694 22.9055C8.68514 21.7748 8.68514 20.2455 8.68514 18.2909C8.68514 14.9201 8.68514 12.8852 9.23639 11.8657C9.68498 11.036 10.6222 10.7442 13.0937 10.6641C13.4819 10.6514 13.7863 10.3266 13.7737 9.93844C13.761 9.55805 13.4488 9.25781 13.0712 9.25781C13.0635 9.25781 13.0558 9.25781 13.048 9.25781C10.4071 9.34359 8.82084 9.67758 7.99959 11.1956C7.371 12.3579 7.29084 14.0637 7.2803 16.9451C6.81483 16.9008 6.18694 16.8811 5.49928 16.969C3.58608 17.213 2.12006 18.1643 1.26014 19.7196C-0.544079 22.9814 -1.67681 24.9649 -1.68806 24.9846C-1.88072 25.3214 -1.7633 25.751 -1.4265 25.9437C-1.31611 26.0063 -1.19658 26.0365 -1.07845 26.0365C-0.834469 26.0365 -0.596813 25.9092 -0.467438 25.6821C-0.456188 25.6624 0.680765 23.6712 2.49061 20.4002C3.12834 19.2478 4.18655 18.5644 5.63709 18.3696C6.28889 18.2817 6.88373 18.3148 7.27889 18.3598C7.27889 20.4558 7.2803 21.9886 7.41108 23.1776H6.30506C5.91694 23.1776 5.60194 23.4926 5.60194 23.8807C5.60194 24.2688 5.91694 24.5838 6.30506 24.5838H8.15991C8.1817 24.5859 8.2042 24.5873 8.2267 24.5873C8.25694 24.5873 8.28717 24.5845 8.31811 24.5803C9.06905 24.5459 9.88045 23.9925 10.7959 22.8872C11.4189 22.1341 11.8682 21.3909 11.8844 21.3642C12.2486 20.7694 13.0297 20.5816 13.6246 20.9459C14.2194 21.3101 14.4079 22.0912 14.043 22.6861L12.0876 26.118C12.0109 26.1989 11.9533 26.298 11.9223 26.4084L11.5314 27.0954L11.518 27.12C9.72366 30.5801 4.17037 32.0166 4.09655 32.0348C3.71967 32.1291 3.49116 32.5109 3.58537 32.8877C3.66553 33.207 3.9517 33.4207 4.2667 33.4207C4.32295 33.4207 4.38061 33.4137 4.43756 33.3996C4.69069 33.3363 10.663 31.8028 12.7597 27.7802L13.0206 27.3225C13.2969 27.3316 13.5993 27.3387 13.9361 27.3436H14.2708H14.2757C17.0369 27.3042 19.0689 27.158 20.0715 25.6195C20.9308 24.3012 20.9308 24.1672 20.9308 20.2923C20.9308 19.9737 20.9308 19.6679 20.9308 19.3733C20.9308 18.9852 20.6158 18.6716 20.2276 18.6716L20.2262 18.6695Z",
                                                                fill: colors.primario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M15.7747 17.3305H15.7761C16.1643 17.3305 16.4786 17.0148 16.4779 16.626V15.7091C16.4779 12.2223 16.4779 12.1179 17.1093 11.1497C17.624 10.3608 18.7061 10.107 21.7422 10.0634H22.0522C22.0994 10.0634 22.1458 10.0648 22.1915 10.0655L20.7536 12.5897C19.9928 13.8448 20.3901 15.4866 21.6437 16.2537C22.9002 17.0229 24.5483 16.6263 25.3204 15.3649C25.9483 14.3208 26.6753 13.4981 27.204 13.0945C27.3158 14.2252 27.3158 15.7545 27.3158 17.7091C27.3158 21.0799 27.3158 23.1148 26.7646 24.1343C26.316 24.964 25.3787 25.2558 22.9072 25.3359C22.5191 25.3486 22.2147 25.6734 22.2273 26.0616C22.24 26.442 22.5522 26.7422 22.9297 26.7422C22.9375 26.7422 22.9452 26.7422 22.9529 26.7422C25.5939 26.6564 27.1801 26.3224 28.0014 24.8044C28.63 23.6421 28.7101 21.9363 28.7207 19.0549C29.1861 19.0992 29.814 19.1189 30.5017 19.031C32.4149 18.787 33.8809 17.8357 34.7408 16.2804C36.5451 13.0186 37.6778 11.0351 37.689 11.0154C37.8817 10.6786 37.7643 10.249 37.4275 10.0563C37.3171 9.99375 37.1976 9.96352 37.0794 9.96352C36.8354 9.96352 36.5978 10.0908 36.4684 10.3179C36.4572 10.3376 35.3202 12.3288 33.5104 15.5998C32.8726 16.7522 31.8144 17.4356 30.3639 17.6304C29.7121 17.7183 29.1172 17.6852 28.7221 17.6402C28.7221 15.5442 28.7207 14.0114 28.5899 12.8224H29.6959C30.084 12.8224 30.399 12.5074 30.399 12.1193C30.399 11.7312 30.084 11.4162 29.6959 11.4162H27.8411C27.8193 11.4141 27.7968 11.4127 27.7743 11.4127C27.744 11.4127 27.7138 11.4155 27.6829 11.4197C26.9319 11.4541 26.1205 12.0075 25.2051 13.1128C24.5821 13.8659 24.1328 14.6091 24.1166 14.6358C23.7524 15.2306 22.9712 15.4184 22.3764 15.0541C21.7815 14.6899 21.5931 13.9088 21.958 13.3139L23.9134 9.88195C23.9901 9.80109 24.0477 9.70195 24.0786 9.59156L24.4696 8.90461L24.4829 8.88C26.2773 5.41992 31.8306 3.98344 31.9044 3.96516C32.2813 3.87094 32.5098 3.48914 32.4156 3.11227C32.3354 2.79305 32.0493 2.5793 31.7343 2.5793C31.678 2.5793 31.6204 2.58633 31.5634 2.60039C31.3103 2.66367 25.3379 4.19719 23.2412 8.21977L22.9804 8.6775C22.704 8.66836 22.4017 8.66133 22.0649 8.65641H21.7302H21.7253C18.9641 8.69578 16.9321 8.84203 15.9294 10.3805C15.0702 11.6988 15.0702 11.8328 15.0702 15.7077C15.0702 16.0263 15.0702 16.3321 15.0702 16.6267C15.0702 17.0148 15.3852 17.3284 15.7733 17.3284L15.7747 17.3305Z",
                                                                fill: colors.primario
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                            id: "clip0_1882_2410",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                width: "36",
                                                                height: "36",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Open Sans, sans-serif",
                                                    fontSize: 12,
                                                    marginTop: 1
                                                },
                                                children: "Request"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            width: 70,
                                            height: 70,
                                            backgroundColor: '#f7f7f7',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "40",
                                                height: "40",
                                                viewBox: "0 0 36 36",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                        clipPath: "url(#clip0_1882_2410_tap)",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M20.2262 18.6695H20.2248C19.8367 18.6695 19.5224 18.9852 19.5231 19.374V20.2909C19.5231 23.7777 19.5231 23.8821 18.8917 24.8503C18.377 25.6392 17.2949 25.893 14.2588 25.9366H13.9487C13.9016 25.9366 13.8552 25.9352 13.8095 25.9345L15.2474 23.4103C16.0082 22.1552 15.6109 20.5134 14.3572 19.7463C13.1008 18.9771 11.4526 19.3737 10.6806 20.6351C10.0527 21.6792 9.32569 22.5019 8.79694 22.9055C8.68514 21.7748 8.68514 20.2455 8.68514 18.2909C8.68514 14.9201 8.68514 12.8852 9.23639 11.8657C9.68498 11.036 10.6222 10.7442 13.0937 10.6641C13.4819 10.6514 13.7863 10.3266 13.7737 9.93844C13.761 9.55805 13.4488 9.25781 13.0712 9.25781C13.0635 9.25781 13.0558 9.25781 13.048 9.25781C10.4071 9.34359 8.82084 9.67758 7.99959 11.1956C7.371 12.3579 7.29084 14.0637 7.2803 16.9451C6.81483 16.9008 6.18694 16.8811 5.49928 16.969C3.58608 17.213 2.12006 18.1643 1.26014 19.7196C-0.544079 22.9814 -1.67681 24.9649 -1.68806 24.9846C-1.88072 25.3214 -1.7633 25.751 -1.4265 25.9437C-1.31611 26.0063 -1.19658 26.0365 -1.07845 26.0365C-0.834469 26.0365 -0.596813 25.9092 -0.467438 25.6821C-0.456188 25.6624 0.680765 23.6712 2.49061 20.4002C3.12834 19.2478 4.18655 18.5644 5.63709 18.3696C6.28889 18.2817 6.88373 18.3148 7.27889 18.3598C7.27889 20.4558 7.2803 21.9886 7.41108 23.1776H6.30506C5.91694 23.1776 5.60194 23.4926 5.60194 23.8807C5.60194 24.2688 5.91694 24.5838 6.30506 24.5838H8.15991C8.1817 24.5859 8.2042 24.5873 8.2267 24.5873C8.25694 24.5873 8.28717 24.5845 8.31811 24.5803C9.06905 24.5459 9.88045 23.9925 10.7959 22.8872C11.4189 22.1341 11.8682 21.3909 11.8844 21.3642C12.2486 20.7694 13.0297 20.5816 13.6246 20.9459C14.2194 21.3101 14.4079 22.0912 14.043 22.6861L12.0876 26.118C12.0109 26.1989 11.9533 26.298 11.9223 26.4084L11.5314 27.0954L11.518 27.12C9.72366 30.5801 4.17037 32.0166 4.09655 32.0348C3.71967 32.1291 3.49116 32.5109 3.58537 32.8877C3.66553 33.207 3.9517 33.4207 4.2667 33.4207C4.32295 33.4207 4.38061 33.4137 4.43756 33.3996C4.69069 33.3363 10.663 31.8028 12.7597 27.7802L13.0206 27.3225C13.2969 27.3316 13.5993 27.3387 13.9361 27.3436H14.2708H14.2757C17.0369 27.3042 19.0689 27.158 20.0715 25.6195C20.9308 24.3012 20.9308 24.1672 20.9308 20.2923C20.9308 19.9737 20.9308 19.6679 20.9308 19.3733C20.9308 18.9852 20.6158 18.6716 20.2276 18.6716L20.2262 18.6695Z",
                                                                fill: colors.primario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M15.7747 17.3305H15.7761C16.1643 17.3305 16.4786 17.0148 16.4779 16.626V15.7091C16.4779 12.2223 16.4779 12.1179 17.1093 11.1497C17.624 10.3608 18.7061 10.107 21.7422 10.0634H22.0522C22.0994 10.0634 22.1458 10.0648 22.1915 10.0655L20.7536 12.5897C19.9928 13.8448 20.3901 15.4866 21.6437 16.2537C22.9002 17.0229 24.5483 16.6263 25.3204 15.3649C25.9483 14.3208 26.6753 13.4981 27.204 13.0945C27.3158 14.2252 27.3158 15.7545 27.3158 17.7091C27.3158 21.0799 27.3158 23.1148 26.7646 24.1343C26.316 24.964 25.3787 25.2558 22.9072 25.3359C22.5191 25.3486 22.2147 25.6734 22.2273 26.0616C22.24 26.442 22.5522 26.7422 22.9297 26.7422C22.9375 26.7422 22.9452 26.7422 22.9529 26.7422C25.5939 26.6564 27.1801 26.3224 28.0014 24.8044C28.63 23.6421 28.7101 21.9363 28.7207 19.0549C29.1861 19.0992 29.814 19.1189 30.5017 19.031C32.4149 18.787 33.8809 17.8357 34.7408 16.2804C36.5451 13.0186 37.6778 11.0351 37.689 11.0154C37.8817 10.6786 37.7643 10.249 37.4275 10.0563C37.3171 9.99375 37.1976 9.96352 37.0794 9.96352C36.8354 9.96352 36.5978 10.0908 36.4684 10.3179C36.4572 10.3376 35.3202 12.3288 33.5104 15.5998C32.8726 16.7522 31.8144 17.4356 30.3639 17.6304C29.7121 17.7183 29.1172 17.6852 28.7221 17.6402C28.7221 15.5442 28.7207 14.0114 28.5899 12.8224H29.6959C30.084 12.8224 30.399 12.5074 30.399 12.1193C30.399 11.7312 30.084 11.4162 29.6959 11.4162H27.8411C27.8193 11.4141 27.7968 11.4127 27.7743 11.4127C27.744 11.4127 27.7138 11.4155 27.6829 11.4197C26.9319 11.4541 26.1205 12.0075 25.2051 13.1128C24.5821 13.8659 24.1328 14.6091 24.1166 14.6358C23.7524 15.2306 22.9712 15.4184 22.3764 15.0541C21.7815 14.6899 21.5931 13.9088 21.958 13.3139L23.9134 9.88195C23.9901 9.80109 24.0477 9.70195 24.0786 9.59156L24.4696 8.90461L24.4829 8.88C26.2773 5.41992 31.8306 3.98344 31.9044 3.96516C32.2813 3.87094 32.5098 3.48914 32.4156 3.11227C32.3354 2.79305 32.0493 2.5793 31.7343 2.5793C31.678 2.5793 31.6204 2.58633 31.5634 2.60039C31.3103 2.66367 25.3379 4.19719 23.2412 8.21977L22.9804 8.6775C22.704 8.66836 22.4017 8.66133 22.0649 8.65641H21.7302H21.7253C18.9641 8.69578 16.9321 8.84203 15.9294 10.3805C15.0702 11.6988 15.0702 11.8328 15.0702 15.7077C15.0702 16.0263 15.0702 16.3321 15.0702 16.6267C15.0702 17.0148 15.3852 17.3284 15.7733 17.3284L15.7747 17.3305Z",
                                                                fill: colors.primario
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                            id: "clip0_1882_2410_tap",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                width: "36",
                                                                height: "36",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Open Sans, sans-serif",
                                                    fontSize: 12,
                                                    marginTop: 1
                                                },
                                                children: "Tap & Pay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            width: 70,
                                            height: 70,
                                            backgroundColor: '#f7f7f7',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                width: "40",
                                                height: "40",
                                                viewBox: "0 0 40 40",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M10.0455 27.1818C10.0455 27.2159 10.0455 27.2159 10.0455 27.1818C10.0795 27.2159 10.1136 27.25 10.1477 27.2841C12.7727 29.6023 16.2159 31 20 31C23.7841 31 27.2273 29.6023 29.8523 27.2841C29.8864 27.25 29.9205 27.2159 29.9545 27.1818C33.0568 24.4545 35 20.4318 35 16C35 11.5682 33.0568 7.54545 29.9545 4.81818C29.9205 4.78409 29.8864 4.75 29.8523 4.71591C27.2273 2.39773 23.7841 1 20 1C16.2159 1 12.7727 2.39773 10.1477 4.71591C10.1136 4.75 10.0795 4.78409 10.0455 4.81818C6.94318 7.54545 5 11.5682 5 16C5 20.4318 6.94318 24.4545 10.0455 27.1818ZM12.2614 16.5114C12.2955 19.375 12.7386 22 13.4886 24.2159C12.3977 24.7273 11.375 25.4091 10.4545 26.1591C7.82955 23.7386 6.15909 20.3295 6.02273 16.5114H12.2614ZM14.7841 24.7614C16.2841 24.1818 17.8523 23.8409 19.4886 23.7727V29.9432C17.6136 29.6364 15.9432 27.6591 14.7841 24.7614ZM20.5114 29.9432V23.7727C22.1477 23.8409 23.7159 24.1818 25.2159 24.7614C24.0568 27.6591 22.3864 29.6364 20.5114 29.9432ZM20.5114 22.75V16.5114H26.7159C26.6818 19.1705 26.2386 21.6932 25.5227 23.8068C23.9545 23.1591 22.25 22.8182 20.5114 22.75ZM20.5114 15.4886V9.25C22.25 9.18182 23.9545 8.84091 25.5568 8.19318C26.2727 10.3068 26.6818 12.7955 26.75 15.4886H20.5114ZM20.5114 8.22727V2.05682C22.3864 2.36364 24.0568 4.34091 25.2159 7.23864C23.7159 7.81818 22.1477 8.15909 20.5114 8.22727ZM19.4886 2.05682V8.22727C17.8523 8.15909 16.2841 7.81818 14.7841 7.23864C15.9432 4.34091 17.6136 2.36364 19.4886 2.05682ZM19.4886 9.25V15.4886H13.2841C13.3182 12.8295 13.7614 10.3068 14.4773 8.19318C16.0455 8.84091 17.75 9.18182 19.4886 9.25ZM19.4886 16.5114V22.75C17.75 22.8182 16.0455 23.1591 14.4432 23.8068C13.7273 21.6932 13.3182 19.2045 13.25 16.5114H19.4886ZM11.2045 26.875C12.0227 26.2273 12.9091 25.6477 13.8295 25.2045C14.5795 27.0455 15.5341 28.5795 16.625 29.5682C14.6136 29.0568 12.7727 28.1364 11.2045 26.875ZM26.1705 25.2045C27.0909 25.6477 27.9773 26.2273 28.7955 26.875C27.2273 28.1364 25.3864 29.0909 23.375 29.5682C24.4659 28.5455 25.4205 27.0455 26.1705 25.2045ZM29.5455 26.1932C28.5909 25.4091 27.6023 24.7614 26.5114 24.25C27.2614 22.0341 27.7045 19.4091 27.7386 16.5455H33.9773C33.8409 20.3295 32.1705 23.7386 29.5455 26.1932ZM33.9773 15.4886H27.7386C27.7045 12.625 27.2614 10 26.5114 7.78409C27.6023 7.27273 28.625 6.59091 29.5455 5.84091C32.1705 8.26136 33.8409 11.6705 33.9773 15.4886ZM28.7955 5.125C27.9773 5.77273 27.0909 6.35227 26.1705 6.79545C25.4205 4.95455 24.4659 3.42045 23.375 2.43182C25.3864 2.94318 27.2273 3.86364 28.7955 5.125ZM13.8295 6.79545C12.9091 6.35227 12.0227 5.77273 11.2045 5.125C12.7727 3.86364 14.6136 2.90909 16.625 2.43182C15.5341 3.45455 14.5795 4.95455 13.8295 6.79545ZM10.4545 5.80682C11.4091 6.59091 12.3977 7.23864 13.4886 7.75C12.7386 9.96591 12.2955 12.5909 12.2614 15.4545H6.02273C6.15909 11.6705 7.82955 8.26136 10.4545 5.80682Z",
                                                    fill: colors.primario
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Open Sans, sans-serif",
                                                    fontSize: 12,
                                                    marginTop: 1
                                                },
                                                children: "Transfer"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            width: 70,
                                            height: 70,
                                            backgroundColor: '#f7f7f7',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                width: "29",
                                                height: "31",
                                                viewBox: "0 0 29 31",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M3.50433 2.62485e-05C1.57283 2.62485e-05 0 1.5527 0 3.45952V15.501V30.4664C0.0001487 30.5523 0.0212557 30.6369 0.0615317 30.7131C0.101808 30.7892 0.160066 30.8547 0.231368 30.9038C0.30267 30.953 0.384914 30.9845 0.47113 30.9955C0.557345 31.0066 0.644991 30.997 0.726637 30.9674L5.7117 29.1646L10.6978 30.9674C10.8179 31.0109 10.9496 31.0109 11.0696 30.9674L16.0547 29.1646L21.0408 30.9674C21.1224 30.997 21.2101 31.0066 21.2963 30.9955C21.3825 30.9845 21.4648 30.953 21.5361 30.9038C21.6074 30.8547 21.6656 30.7892 21.7059 30.7131C21.7462 30.6369 21.7673 30.5523 21.7674 30.4664V11.6385H28.4614C28.6048 11.6379 28.7421 11.5811 28.8431 11.4805C28.9441 11.3799 29.0005 11.2437 29 11.1019V4.09944C29 1.86056 27.1769 0.0396945 24.9179 0.0010686C24.9134 0.000655109 24.9088 0.000298891 24.9043 0L3.50433 2.62485e-05ZM3.50433 1.06898H22.0452C21.2101 1.81885 20.6849 2.89932 20.6849 4.09944V11.1019V29.7012L16.2427 28.0915C16.1226 28.0481 15.9909 28.0481 15.8709 28.0915L10.8858 29.8985L5.8997 28.0915C5.77999 28.0483 5.6487 28.0483 5.52899 28.0915L1.08151 29.7012V8.13517V3.45952C1.08151 2.12766 2.152 1.06898 3.50433 1.06898ZM24.8451 1.06898C26.5586 1.06898 27.9185 2.41139 27.9185 4.09944V10.5696H21.7674V4.09944C21.7674 2.41139 23.1315 1.06898 24.8451 1.06898ZM5.10125 7.95353C5.03023 7.95325 4.95986 7.9668 4.89415 7.99341C4.82843 8.02002 4.76867 8.05916 4.71826 8.10859C4.66785 8.15803 4.62778 8.2168 4.60035 8.28154C4.57292 8.34628 4.55866 8.41573 4.55838 8.48592C4.5581 8.55646 4.57195 8.62636 4.59914 8.69158C4.62632 8.7568 4.6663 8.81606 4.71676 8.86594C4.76723 8.91582 4.82718 8.95533 4.89317 8.9822C4.95916 9.00907 5.02988 9.02276 5.10125 9.02248H16.6693C16.7404 9.02221 16.8106 9.00811 16.8761 8.981C16.9416 8.95389 17.0011 8.91429 17.0511 8.86446C17.1011 8.81464 17.1407 8.75556 17.1676 8.69061C17.1946 8.62566 17.2083 8.55611 17.208 8.48592C17.2074 8.34489 17.1505 8.20979 17.0496 8.11007C16.9487 8.01034 16.812 7.95407 16.6693 7.95353H5.10125ZM5.10125 13.5645C5.02988 13.5642 4.95916 13.5779 4.89317 13.6048C4.82718 13.6317 4.76723 13.6712 4.71676 13.7211C4.66629 13.7709 4.62632 13.8302 4.59913 13.8954C4.57195 13.9606 4.5581 14.0305 4.55838 14.1011C4.55866 14.1713 4.57292 14.2407 4.60035 14.3055C4.62778 14.3702 4.66785 14.429 4.71826 14.4784C4.76867 14.5278 4.82844 14.567 4.89415 14.5936C4.95986 14.6202 5.03024 14.6337 5.10125 14.6335H16.6693C16.812 14.6329 16.9487 14.5767 17.0496 14.4769C17.1505 14.3772 17.2074 14.2421 17.208 14.1011C17.2083 14.0309 17.1946 13.9613 17.1676 13.8964C17.1407 13.8314 17.1011 13.7724 17.0511 13.7225C17.0011 13.6727 16.9416 13.6331 16.8761 13.606C16.8106 13.5789 16.7404 13.5648 16.6693 13.5645H5.10125ZM5.10125 19.1745C5.02988 19.1742 4.95916 19.1879 4.89317 19.2147C4.82718 19.2416 4.76723 19.2811 4.71676 19.331C4.6663 19.3809 4.62632 19.4401 4.59914 19.5054C4.57195 19.5706 4.5581 19.6405 4.55838 19.711C4.55866 19.7812 4.57292 19.8507 4.60035 19.9154C4.62778 19.9801 4.66785 20.0389 4.71826 20.0883C4.76867 20.1378 4.82843 20.1769 4.89415 20.2035C4.95986 20.2301 5.03023 20.2437 5.10125 20.2434H16.6693C16.812 20.2429 16.9487 20.1866 17.0496 20.0869C17.1505 19.9871 17.2074 19.852 17.208 19.711C17.2083 19.6408 17.1946 19.5713 17.1676 19.5063C17.1407 19.4414 17.1011 19.3823 17.0511 19.3325C17.0011 19.2826 16.9416 19.243 16.8761 19.2159C16.8106 19.1888 16.7404 19.1747 16.6693 19.1745H5.10125Z",
                                                    fill: colors.primario
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Open Sans, sans-serif",
                                                    fontSize: 12,
                                                    marginTop: 1
                                                },
                                                children: "Bills"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingTop: 30,
                                    paddingLeft: 10,
                                    paddingRight: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontFamily: "Open Sans, sans-serif",
                                            fontWeight: 'bold',
                                            color: '#595959'
                                        },
                                        children: "Your Movements"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            marginTop: 20
                                        },
                                        children: [
                                            {
                                                "icon": "fooding",
                                                "name": "Dinner",
                                                "date": "10/09/2025 12:07",
                                                "amount": "$127.25 USD"
                                            },
                                            {
                                                "icon": "travel",
                                                "name": "American Airlines KYI299",
                                                "date": "10/09/2025 12:07",
                                                "amount": "$900.00 USD"
                                            },
                                            {
                                                "icon": "shopping",
                                                "name": "Gift",
                                                "date": "10/09/2025 12:07",
                                                "amount": "$385.12 USD"
                                            },
                                            {
                                                "icon": "transport",
                                                "name": "Taxi",
                                                "date": "10/09/2025 12:07",
                                                "amount": "$11.03 USD"
                                            }
                                        ].map((element, i)=>{
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    width: '100%',
                                                    paddingTop: 10,
                                                    paddingBottom: 10,
                                                    height: 100
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        style: {
                                                            width: '20%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center',
                                                            height: '100%'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: './img/' + element.icon + '.png',
                                                            style: {
                                                                height: '60%',
                                                                width: '60%'
                                                            },
                                                            alt: ''
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            width: '50%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center',
                                                            height: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                style: {
                                                                    fontFamily: "Open Sans, sans-serif",
                                                                    fontWeight: 'bold',
                                                                    color: '#595959'
                                                                },
                                                                children: element.name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                style: {
                                                                    fontFamily: "Open Sans, sans-serif",
                                                                    fontWeight: 'regular',
                                                                    color: '#595959'
                                                                },
                                                                children: element.date
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        style: {
                                                            width: '30%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                fontFamily: "Open Sans, sans-serif",
                                                                fontWeight: 'regular',
                                                                color: '#595959'
                                                            },
                                                            children: element.amount
                                                        })
                                                    })
                                                ]
                                            }, "row" + i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: styles.bottomNav,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: styles.navItem,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        width: 23,
                                        height: 26,
                                        viewBox: "0 0 23 26",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M0.0860297 23.9238H21.5216V8.9281L11.4826 1.79596L1.3024 8.9281V19.973",
                                            stroke: colors.primario,
                                            strokeWidth: 2.5,
                                            strokeLinejoin: "round"
                                        })
                                    }),
                                    "Home"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: styles.navItem,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: './img/visa_wallet.png',
                                        style: {
                                            height: 30,
                                            width: 30
                                        },
                                        alt: ''
                                    }),
                                    " ",
                                    "NEx"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: styles.navItem,
                                onClick: handleButtonRestart,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: './img/visa_more.png',
                                        style: {
                                            height: 30,
                                            width: 30
                                        },
                                        alt: ''
                                    }),
                                    " ",
                                    "More"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kD8NH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardDetailsVisaMobile", ()=>(0, _cardDetailsVisaMobile.CardDetailsVisaMobile));
var _cardDetailsVisaMobile = require("./CardDetailsVisaMobile");

},{"./CardDetailsVisaMobile":"aSbFc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aSbFc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardDetailsVisaMobile", ()=>CardDetailsVisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack = require("../../../../../icons/IconArrowBack");
var _regularCopyAlt = require("../../../../../icons/RegularCopyAlt");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CardDetailsVisaMobile = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        container: {
            display: "flex",
            alignItems: "center",
            margin: "16px 0 8px 0",
            flexDirection: "column",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "40px",
            height: "4px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "40px",
            height: "4px",
            backgroundColor: colors.secundario
        },
        title: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            borderRadius: "30px",
            flexDirection: "column",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            width: '100%',
            paddingLeft: 2,
            paddingRight: 2
        },
        balance: {
            marginTop: "60px",
            color: "#333",
            borderRadius: "12px",
            padding: "16px",
            textAlign: "center",
            marginBottom: "16px"
        },
        balanceCard: {
            display: "flex",
            background: "linear-gradient(90deg, #c49d14, #d6c37f)",
            color: "white",
            borderRadius: "12px 12px 0px 0px",
            padding: "16px",
            justifyContent: "space-between",
            textAlign: "center",
            height: "70px",
            marginBottom: "16px"
        },
        balanceText: {
            color: '#FFFFFF',
            fontSize: "24px",
            fontWeight: "bold"
        },
        actionButtons: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px"
        },
        actionButton: {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            width: "190px",
            margin: "0 4px",
            padding: "12px",
            backgroundColor: "#f1f1f1",
            border: "none",
            fontWeight: "500",
            cursor: "pointer"
        },
        actionButton2: {
            color: "#ffffff",
            marginTop: 9,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "90%",
            gap: 8,
            padding: "8px",
            backgroundColor: "#000000",
            border: "none",
            borderRadius: 50,
            fontWeight: "500",
            cursor: "pointer"
        },
        avatarRow: {
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "29px",
            marginBottom: "16px"
        },
        avatar: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: "12px"
        },
        avatarImg: {
            width: "60px",
            height: "60px",
            border: `1px solid #f7f7f7`,
            objectFit: "cover"
        },
        promoCard: {
            display: "flex",
            alignItems: "center",
            borderRadius: "12px",
            padding: "12px"
        },
        promoImg: {
            width: "60px",
            height: "60px",
            marginRight: "12px"
        },
        bottomNav: {
            display: "flex",
            width: "365px",
            justifyContent: "space-around",
            borderTop: "1px solid #f7f7f7",
            paddingTop: "8px",
            marginLeft: "-15px",
            marginTop: "-5px"
        },
        navItem: {
            width: "70px",
            alignItems: "center",
            gap: 6,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            color: "#333"
        }
    };
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-visa-mobile${currentParams}`);
    };
    const handleButtonRestart = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_register-visa-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "visa-card-details",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.header,
                        paddingLeft: 2,
                        paddingRight: 2
                    },
                    children: [
                        colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "inicio-de-sesion-de-2",
                            src: colors.url_logo,
                            style: {
                                height: 50,
                                maxWidth: 100,
                                objectFit: 'contain'
                            }
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: 8,
                                justifyItems: "center",
                                placeItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: "2,015 pts"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: "https://randomuser.me/api/portraits/men/75.jpg",
                                    alt: "User",
                                    style: {
                                        ...styles.avatarImg,
                                        borderRadius: 50
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-45",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-46",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "overlap-10",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-8",
                                    style: {
                                        width: 350,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        borderRadius: 29,
                                        backgroundSize: "contain",
                                        background: colors.url_card ? `url(${colors.url_card})` : "linear-gradient(90deg, #c49d14, #d6c37f)",
                                        marginLeft: 10
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-11",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    ...styles.container,
                                                    flexDirection: "row",
                                                    width: '100%',
                                                    justifyContent: 'space-between',
                                                    paddingTop: 0,
                                                    paddingBottom: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        width: 63,
                                                        height: 19,
                                                        viewBox: "0 0 63 19",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M36.4625 15.0292C34.5008 15.0292 33.4252 14.7603 31.7734 14.0817L31.1614 13.8025L30.4674 17.836C31.6607 18.3277 33.8119 18.7502 36.0374 18.7835C41.2642 18.7835 44.6805 16.3583 44.7215 12.6271C44.7624 10.5757 43.4154 9.0187 40.5702 7.73568C38.8441 6.90338 37.7686 6.3451 37.7686 5.49999C37.7686 4.7522 38.6879 3.95575 40.6086 3.95575C42.2604 3.93014 43.4154 4.28099 44.3348 4.64464L44.7957 4.84951L45.4897 0.951782L45.3694 0.977392C44.3783 0.608619 42.8341 0.216797 40.9134 0.216797C35.9964 0.216797 32.5263 2.65992 32.5007 6.16071C32.47 8.73444 34.9695 10.1839 36.8569 11.047C38.7955 11.9305 39.4434 12.4862 39.4383 13.2801C39.4255 14.4863 37.8889 15.0292 36.4625 15.0292ZM58.1305 0.547156H54.2891C53.0931 0.547156 52.1994 0.867272 51.6744 2.04018L44.2861 18.5325H49.513L50.5578 15.8333L56.9345 15.8385C57.0907 16.4684 57.5491 18.5325 57.5491 18.5325H62.1562L58.1305 0.547156ZM51.9894 12.143L53.9715 7.11593C53.9459 7.16715 54.3813 6.0762 54.6322 5.40011L54.9728 6.95203L56.1227 12.143H51.9894Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M22.3185 18.3891H27.297L30.4085 0.396084H25.4326V0.390963L22.3185 18.3891Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M13.3015 12.8114L12.7842 10.312V10.3196L11.0377 2.05808C10.738 0.913345 9.86219 0.575301 8.77636 0.534326H0.758115L0.694092 0.913343C2.49954 1.3359 4.12573 1.94796 5.58033 2.69831C5.84154 2.85965 5.95166 3.03635 6.0413 3.29757L10.3436 18.5069H15.6038L23.4428 0.547131H18.1698L13.3015 12.8114Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        style: {
                                                            color: 'white'
                                                        },
                                                        children: " ****9821"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    ...styles.container,
                                                    flexDirection: "row",
                                                    width: '100%',
                                                    justifyContent: 'flex-start',
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    marginTop: 1,
                                                    marginBottom: 1
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        ...styles.balanceText,
                                                        margin: 0,
                                                        padding: 0
                                                    },
                                                    children: "$ 6,256.49 USD"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    ...styles.container,
                                                    flexDirection: "column",
                                                    width: '100%',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'flex-start',
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    marginTop: 1,
                                                    marginBottom: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        style: {
                                                            ...styles.balanceText,
                                                            margin: 0,
                                                            padding: 0,
                                                            fontSize: 12,
                                                            fontWeight: 'bold'
                                                        },
                                                        children: "Card Holder"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        style: {
                                                            ...styles.balanceText,
                                                            margin: 0,
                                                            padding: 0,
                                                            fontSize: 12
                                                        },
                                                        children: "Jhon Doe"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "botonera-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    x: 2.55371,
                                                    y: 4.59131,
                                                    width: 19.8947,
                                                    height: 15.3311,
                                                    rx: 2,
                                                    stroke: colors.cuaternario,
                                                    strokeWidth: 1.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M5.36719 8.83466H19.5219",
                                                    stroke: colors.cuaternario,
                                                    strokeWidth: 1.5
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-53-quinto",
                                            children: "Pay"
                                        })
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M7.66145 1.25684L17.3385 1.25684C17.8657 1.25682 18.3205 1.2568 18.695 1.28741C19.0904 1.31971 19.4836 1.39103 19.862 1.58382C20.4265 1.87144 20.8854 2.33038 21.173 2.89487C21.3658 3.27325 21.4371 3.66647 21.4694 4.06181C21.5 4.43638 21.5 4.89113 21.5 5.41827V19.0954C21.5 19.6225 21.5 20.0773 21.4694 20.4519C21.4371 20.8472 21.3658 21.2404 21.173 21.6188C20.8854 22.1833 20.4265 22.6422 19.862 22.9299C19.4836 23.1227 19.0904 23.194 18.695 23.2263C18.3205 23.2569 17.8657 23.2569 17.3386 23.2568H10.5C10.1822 23.2568 9.89902 23.1086 9.71585 22.8775C9.68378 22.8516 9.65251 22.8236 9.62218 22.7932L3.96361 17.1347C3.93328 17.1043 3.90522 17.0731 3.87937 17.041C3.64825 16.8578 3.5 16.5746 3.5 16.2568L3.5 5.41829C3.49998 4.89115 3.49997 4.43638 3.53057 4.06181C3.56287 3.66646 3.63419 3.27325 3.82698 2.89487C4.1146 2.33038 4.57354 1.87144 5.13803 1.58382C5.51641 1.39102 5.90963 1.31971 6.30497 1.28741C6.67954 1.2568 7.13431 1.25682 7.66145 1.25684ZM6.91422 17.2568L9.5 19.8426L9.5 17.2568H6.91422ZM11.5 21.2568V17.2568C11.5 16.1523 10.6046 15.2568 9.5 15.2568H5.5L5.5 5.45684C5.5 4.88028 5.50078 4.50801 5.52393 4.22467C5.54612 3.95301 5.5838 3.85229 5.609 3.80285C5.70487 3.61469 5.85785 3.4617 6.04601 3.36583C6.09546 3.34064 6.19617 3.30296 6.46784 3.28077C6.75117 3.25762 7.12345 3.25684 7.7 3.25684L17.3 3.25684C17.8766 3.25684 18.2488 3.25762 18.5322 3.28077C18.8038 3.30296 18.9045 3.34064 18.954 3.36583C19.1422 3.46171 19.2951 3.61469 19.391 3.80285C19.4162 3.85229 19.4539 3.95301 19.4761 4.22467C19.4992 4.50801 19.5 4.88028 19.5 5.45684V19.0568C19.5 19.6334 19.4992 20.0057 19.4761 20.289C19.4539 20.5607 19.4162 20.6614 19.391 20.7108C19.2951 20.899 19.1422 21.052 18.954 21.1478C18.9045 21.173 18.8038 21.2107 18.5322 21.2329C18.2488 21.2561 17.8766 21.2568 17.3 21.2568H11.5ZM7.5 8.25684C7.5 7.70455 7.94772 7.25684 8.5 7.25684H16.5C17.0523 7.25684 17.5 7.70455 17.5 8.25684C17.5 8.80912 17.0523 9.25684 16.5 9.25684H8.5C7.94772 9.25684 7.5 8.80912 7.5 8.25684ZM7.5 12.2568C7.5 11.7046 7.94772 11.2568 8.5 11.2568H16.5C17.0523 11.2568 17.5 11.7046 17.5 12.2568C17.5 12.8091 17.0523 13.2568 16.5 13.2568H8.5C7.94772 13.2568 7.5 12.8091 7.5 12.2568ZM13.5 16.2568C13.5 15.7046 13.9477 15.2568 14.5 15.2568H16.5C17.0523 15.2568 17.5 15.7046 17.5 16.2568C17.5 16.8091 17.0523 17.2568 16.5 17.2568H14.5C13.9477 17.2568 13.5 16.8091 13.5 16.2568Z",
                                                fill: colors.cuaternario
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-53-quinto",
                                            children: "Details"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                    clipPath: "url(#clip0_271_6272)",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M19.7254 15.1564C19.3593 14.7903 18.7657 14.7903 18.3996 15.1564L18.125 15.431L17.8504 15.1564C17.4843 14.7903 16.8907 14.7903 16.5246 15.1564C16.1585 15.5225 16.1585 16.1162 16.5246 16.4823L16.7992 16.7568L16.5246 17.0314C16.1585 17.3976 16.1585 17.9912 16.5246 18.3573C16.8907 18.7234 17.4843 18.7234 17.8504 18.3573L18.125 18.0827L18.3996 18.3573C18.7657 18.7234 19.3593 18.7234 19.7254 18.3573C20.0916 17.9911 20.0916 17.3975 19.7254 17.0314L19.4508 16.7568L19.7254 16.4823C20.0916 16.1162 20.0916 15.5225 19.7254 15.1564Z",
                                                            fill: colors.cuaternario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M14.1004 15.1564C13.7343 14.7903 13.1407 14.7903 12.7746 15.1564L12.5 15.431L12.2254 15.1564C11.8593 14.7903 11.2657 14.7903 10.8996 15.1564C10.5335 15.5225 10.5335 16.1162 10.8996 16.4823L11.1742 16.7568L10.8996 17.0314C10.5335 17.3976 10.5335 17.9912 10.8996 18.3573C11.2657 18.7234 11.8593 18.7234 12.2254 18.3573L12.5 18.0827L12.7746 18.3573C13.1407 18.7234 13.7343 18.7234 14.1004 18.3573C14.4666 17.9911 14.4666 17.3975 14.1004 17.0314L13.8258 16.7568L14.1004 16.4823C14.4666 16.1162 14.4666 15.5225 14.1004 15.1564Z",
                                                            fill: colors.cuaternario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M8.47542 15.1564C8.10928 14.7903 7.5157 14.7903 7.14961 15.1564L6.87501 15.431L6.60042 15.1564C6.23428 14.7903 5.6407 14.7903 5.27461 15.1564C4.90846 15.5225 4.90846 16.1162 5.27461 16.4823L5.5492 16.7568L5.27461 17.0314C4.90846 17.3976 4.90846 17.9912 5.27461 18.3573C5.64075 18.7234 6.23432 18.7234 6.60042 18.3573L6.87501 18.0827L7.14961 18.3573C7.51575 18.7234 8.10932 18.7234 8.47542 18.3573C8.84156 17.9911 8.84156 17.3975 8.47542 17.0314L8.20082 16.7568L8.47542 16.4823C8.84156 16.1162 8.84156 15.5225 8.47542 15.1564Z",
                                                            fill: colors.cuaternario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M20.9375 9.25684H19.0625V6.81934C19.0625 3.20077 16.1186 0.256836 12.5 0.256836C8.88144 0.256836 5.9375 3.20077 5.9375 6.81934V9.25684H4.0625C2.51169 9.25684 1.25 10.5185 1.25 12.0693V21.4443C1.25 22.9951 2.51169 24.2568 4.0625 24.2568H20.9375C22.4883 24.2568 23.75 22.9951 23.75 21.4443V12.0693C23.75 10.5185 22.4883 9.25684 20.9375 9.25684ZM7.8125 6.81934C7.8125 4.23465 9.91531 2.13184 12.5 2.13184C15.0847 2.13184 17.1875 4.23465 17.1875 6.81934V9.25684H7.8125V6.81934ZM21.875 21.4443C21.875 21.9613 21.4544 22.3818 20.9375 22.3818H4.0625C3.54556 22.3818 3.125 21.9613 3.125 21.4443V12.0693C3.125 11.5524 3.54556 11.1318 4.0625 11.1318H20.9375C21.4544 11.1318 21.875 11.5524 21.875 12.0693V21.4443Z",
                                                            fill: colors.cuaternario
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                        id: "clip0_271_6272",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                            width: 24,
                                                            height: 24,
                                                            fill: "white",
                                                            transform: "translate(0.5 0.256836)"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-53-quinto",
                                            children: "PIN"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: 21,
                                            height: 21,
                                            viewBox: "0 0 21 21",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M20.6477 8.8976L20.1453 7.35133L17.0636 8.35261L18.3963 5.73715L16.9477 4.99899L14.8769 9.06317L11.313 10.2211V6.47389L14.5384 3.24856L13.3888 2.0989L11.313 4.17456V0.934326H9.68715V4.17456L7.61148 2.0989L6.46182 3.24856L9.68715 6.47389V10.2211L6.12341 9.06317L4.05257 4.99899L2.60391 5.73715L3.93659 8.35266L0.854884 7.35133L0.352539 8.89766L3.43414 9.89893L0.818627 11.2316L1.55673 12.6802L5.62096 10.6094L9.18469 11.7674L6.98215 14.7989L2.47703 15.5125L2.73138 17.1184L5.63061 16.6592L3.72609 19.2806L5.04149 20.2362L6.94606 17.6149L7.40526 20.5141L9.0111 20.2598L8.29755 15.7546L10.5001 12.7231L12.7027 15.7546L11.9891 20.2598L13.595 20.5141L14.0542 17.6148L15.9588 20.2362L17.2741 19.2805L15.3696 16.6592L18.2689 17.1184L18.5232 15.5125L14.018 14.7989L11.8154 11.7674L15.3793 10.6094L19.4435 12.6802L20.1816 11.2316L17.566 9.89893L20.6477 8.8976Z",
                                                fill: colors.cuaternario
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-53-quinto",
                                            children: "Freezer"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M16.5 3.25684C17.0523 3.25684 17.5 3.70455 17.5 4.25684V5.25684L21.5 5.25684C22.0523 5.25684 22.5 5.70455 22.5 6.25684C22.5 6.80912 22.0523 7.25684 21.5 7.25684L17.5 7.25684V8.25684C17.5 8.80912 17.0523 9.25684 16.5 9.25684C15.9477 9.25684 15.5 8.80912 15.5 8.25684V4.25684C15.5 3.70455 15.9477 3.25684 16.5 3.25684ZM2.5 6.25684C2.5 5.70455 2.94772 5.25684 3.5 5.25684L12.5 5.25684C13.0523 5.25684 13.5 5.70455 13.5 6.25684C13.5 6.80912 13.0523 7.25684 12.5 7.25684L3.5 7.25684C2.94772 7.25684 2.5 6.80912 2.5 6.25684ZM8.5 9.25684C9.05228 9.25684 9.5 9.70455 9.5 10.2568V14.2568C9.5 14.8091 9.05228 15.2568 8.5 15.2568C7.94772 15.2568 7.5 14.8091 7.5 14.2568V13.2568H3.5C2.94772 13.2568 2.5 12.8091 2.5 12.2568C2.5 11.7046 2.94772 11.2568 3.5 11.2568H7.5V10.2568C7.5 9.70455 7.94772 9.25684 8.5 9.25684ZM11.5 12.2568C11.5 11.7046 11.9477 11.2568 12.5 11.2568H21.5C22.0523 11.2568 22.5 11.7046 22.5 12.2568C22.5 12.8091 22.0523 13.2568 21.5 13.2568H12.5C11.9477 13.2568 11.5 12.8091 11.5 12.2568ZM16.5 15.2568C17.0523 15.2568 17.5 15.7046 17.5 16.2568V17.2568H21.5C22.0523 17.2568 22.5 17.7046 22.5 18.2568C22.5 18.8091 22.0523 19.2568 21.5 19.2568H17.5V20.2568C17.5 20.8091 17.0523 21.2568 16.5 21.2568C15.9477 21.2568 15.5 20.8091 15.5 20.2568V16.2568C15.5 15.7046 15.9477 15.2568 16.5 15.2568ZM2.5 18.2568C2.5 17.7046 2.94772 17.2568 3.5 17.2568L12.5 17.2568C13.0523 17.2568 13.5 17.7046 13.5 18.2568C13.5 18.8091 13.0523 19.2568 12.5 19.2568H3.5C2.94772 19.2568 2.5 18.8091 2.5 18.2568Z",
                                                fill: colors.cuaternario
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-53-quinto",
                                            children: "Manage"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-55",
                            style: {
                                marginTop: 15
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "tarjtetas-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "title-4",
                                            children: "Activity"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-56",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "btn-text-link-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-54",
                                                        children: "See all"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "img-3",
                                                        alt: "Btn icon chevron",
                                                        src: "/img/btn-icon-chevron-4.svg"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    style: styles.actionButton2,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "img-3",
                                            alt: "Btn icon chevron",
                                            src: "/img/visawallet.png"
                                        }),
                                        "Add to Google Wallet"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-57",
                                    style: {
                                        marginTop: -5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "movements-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-58",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-3",
                                                            alt: "Dinner",
                                                            src: "/img/dinner-1.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-50",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-55",
                                                                    children: "Starbucks coffee time"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "img-3",
                                                                    alt: "Btn icon chevron",
                                                                    src: "/img/btn-icon-chevron-5.svg"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-59",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "date-3",
                                                            children: "11/06/22"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "amount-4",
                                                            children: "- $25.11"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "movements-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-58",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "shopping-bag-2",
                                                            alt: "Shopping bag",
                                                            src: "/img/shopping-bag-1.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-50",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-55",
                                                                    children: "New gymn shoes"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "img-3",
                                                                    alt: "Btn icon chevron",
                                                                    src: "/img/btn-icon-chevron-5.svg"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-59",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "date-3",
                                                            children: "11/06/22"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "amount-4",
                                                            children: "- $158.68"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "movements-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-58",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-3",
                                                            alt: "Credit card",
                                                            src: "/img/credit-card-1.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-60",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-55",
                                                                    children: "Card payment"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "img-3",
                                                                    alt: "Btn icon chevron",
                                                                    src: "/img/btn-icon-chevron-5.svg"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-59",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "date-3",
                                                            children: "11/06/22"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "amount-5",
                                                            children: "$950.23"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.bottomNav,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: styles.navItem,
                                            onClick: handleButtonBack,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: 23,
                                                    height: 26,
                                                    viewBox: "0 0 23 26",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M0.0860297 23.9238H21.5216V8.9281L11.4826 1.79596L1.3024 8.9281V19.973",
                                                        stroke: colors.primario,
                                                        strokeWidth: 2.5,
                                                        strokeLinejoin: "round"
                                                    })
                                                }),
                                                "Home"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: styles.navItem,
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: './img/visa_wallet.png',
                                                    style: {
                                                        height: 30,
                                                        width: 30
                                                    },
                                                    alt: ''
                                                }),
                                                " ",
                                                "Wallet"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: styles.navItem,
                                            onClick: handleButtonRestart,
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: './img/visa_more.png',
                                                    style: {
                                                        height: 30,
                                                        width: 30
                                                    },
                                                    alt: ''
                                                }),
                                                " ",
                                                "More"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../icons/IconArrowBack":"dgOyH","../../../../../icons/RegularCopyAlt":"9klXy","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"5aZTK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dgOyH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconArrowBack", ()=>(0, _iconArrowBack.IconArrowBack));
var _iconArrowBack = require("./IconArrowBack");

},{"./IconArrowBack":"8ao08","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ao08":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconArrowBack", ()=>IconArrowBack);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconArrowBack = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-arrow-back ${className}`,
        fill: "none",
        height: "19",
        viewBox: "0 0 19 19",
        width: "19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            clipRule: "evenodd",
            d: "M15.8333 8.70833H6.19875L10.6242 4.28292L9.5 3.16667L3.16667 9.5L9.5 15.8333L10.6163 14.7171L6.19875 10.2917H15.8333V8.70833Z",
            fill: color,
            fillRule: "evenodd"
        })
    });
};
IconArrowBack.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9klXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegularCopyAlt", ()=>(0, _regularCopyAlt.RegularCopyAlt));
var _regularCopyAlt = require("./RegularCopyAlt");

},{"./RegularCopyAlt":"jLZyV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jLZyV":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegularCopyAlt", ()=>RegularCopyAlt);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const RegularCopyAlt = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `regular-copy-alt ${className}`,
        fill: "none",
        height: "18",
        viewBox: "0 0 18 18",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                className: "g",
                clipPath: "url(#clip0_2627_347)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    className: "path",
                    d: "M9.82869 14.6589C10.78 14.6577 11.692 14.2793 12.3647 13.6066C13.0374 12.934 13.4158 12.0219 13.4169 11.0706V4.78619C13.418 4.40897 13.3443 4.03527 13.1999 3.68677C13.0555 3.33827 12.8434 3.02189 12.5758 2.75597L10.9669 1.147C10.701 0.879445 10.3846 0.66733 10.0361 0.522952C9.68757 0.378573 9.31388 0.304804 8.93665 0.305921H5.52281C4.5715 0.30706 3.65948 0.685471 2.9868 1.35815C2.31412 2.03083 1.93571 2.94285 1.93457 3.89416V11.0706C1.93571 12.0219 2.31412 12.934 2.9868 13.6066C3.65948 14.2793 4.5715 14.6577 5.52281 14.6589H9.82869ZM3.36986 11.0706V3.89416C3.36986 3.32316 3.59669 2.77555 4.00045 2.3718C4.4042 1.96804 4.95181 1.74121 5.52281 1.74121C5.52281 1.74121 9.05291 1.75126 9.11104 1.75844V3.17651C9.11104 3.55717 9.26226 3.92225 9.53143 4.19141C9.8006 4.46058 10.1657 4.6118 10.5463 4.6118H11.9644C11.9716 4.66993 11.9816 11.0706 11.9816 11.0706C11.9816 11.6416 11.7548 12.1892 11.351 12.593C10.9473 12.9967 10.3997 13.2236 9.82869 13.2236H5.52281C4.95181 13.2236 4.4042 12.9967 4.00045 12.593C3.59669 12.1892 3.36986 11.6416 3.36986 11.0706ZM16.2875 6.0471V13.9412C16.2864 14.8925 15.908 15.8045 15.2353 16.4772C14.5626 17.1499 13.6506 17.5283 12.6993 17.5294H6.24045C6.05012 17.5294 5.86758 17.4538 5.733 17.3193C5.59842 17.1847 5.52281 17.0021 5.52281 16.8118C5.52281 16.6215 5.59842 16.4389 5.733 16.3043C5.86758 16.1698 6.05012 16.0942 6.24045 16.0942H12.6993C13.2703 16.0942 13.8179 15.8673 14.2216 15.4636C14.6254 15.0598 14.8522 14.5122 14.8522 13.9412V6.0471C14.8522 5.85676 14.9278 5.67423 15.0624 5.53964C15.197 5.40506 15.3795 5.32945 15.5699 5.32945C15.7602 5.32945 15.9427 5.40506 16.0773 5.53964C16.2119 5.67423 16.2875 5.85676 16.2875 6.0471Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2627_347",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "17.2235",
                        transform: "translate(0.5 0.305908)",
                        width: "17.2235"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5aZTK":[function() {},{}],"2l7l6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosuresVisaMobile", ()=>DisclosuresVisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const DisclosuresVisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [checked, setChecked] = (0, _react.useState)(true);
    const handleCheckboxChange = ()=>{
        setChecked(!checked);
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone_step_01-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        container: {
            display: "flex",
            alignItems: "center",
            margin: "16px 0 8px 0",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        containerStep: {
            display: "flex",
            alignItems: "baseline",
            fontFamily: "sans-serif"
        },
        current: {
            color: colors.primario,
            fontSize: "40px",
            fontWeight: "bold"
        },
        separator: {
            margin: "0 2px",
            color: "#959699",
            fontSize: "18px"
        },
        total: {
            color: "#959699",
            fontSize: "18px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            height: "160px",
            width: "90%",
            borderBottom: "1px solid #E7E7E7"
        },
        title: {
            fontSize: "18px",
            marginBottom: "20px",
            color: "#333"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            width: "90%",
            marginBottom: "40px"
        },
        checkbox: {
            marginTop: "4px",
            transform: "scale(1.2)",
            accentColor: "#0052cc"
        },
        label: {
            fontSize: "14px",
            color: "#555",
            // textAlign: "justify",
            lineHeight: "1.5"
        },
        button: {
            width: "90%",
            padding: "12px",
            height: "54px",
            backgroundColor: colors.primario,
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "absolute",
            bottom: 16
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 12
                            },
                            children: colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 70,
                                    maxWidth: 120,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerStep,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.current,
                                    children: "01"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.separator,
                                    children: " / "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.total,
                                    children: "06"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.container,
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "initial",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                                justifyItems: "center",
                                placeItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        width: "90%"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        style: styles.title,
                                        children: "Accept some disclosures below to finish your application."
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.checkboxContainer,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: checked,
                                            onChange: handleCheckboxChange,
                                            style: styles.checkbox
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: styles.label,
                                            children: "I have read, understand, and consent to the language and authorizations outlined in the Account Disclosures above. You are also signing the consent for SSA to disclose your SSN Verification to Pinnacle, and its affiliates. You agree that your electronic signature has the same legal meaning, validity, and effect as your handwritten signature."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClick,
                            style: styles.button,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBvww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhoneStep1VisaMobile", ()=>PhoneStep1VisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const PhoneStep1VisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [phone, setPhone] = (0, _react.useState)("");
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone_step_02-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        containerPhone: {
            width: "100%",
            margin: "0 auto",
            fontFamily: "sans-serif",
            padding: "20px"
        },
        description: {
            fontSize: "15px",
            marginTop: -60,
            color: "#333",
            marginBottom: "20px",
            lineHeight: "1.5"
        },
        label: {
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            marginBottom: "8px",
            color: "#555",
            lineHeight: "1.5"
        },
        input: {
            width: "100%",
            padding: "12px",
            fontSize: "16px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        containerStep: {
            display: "flex",
            alignItems: "baseline",
            fontFamily: "sans-serif"
        },
        current: {
            color: colors.primario,
            fontSize: "40px",
            fontWeight: "bold"
        },
        separator: {
            margin: "0 2px",
            color: "#959699",
            fontSize: "18px"
        },
        total: {
            color: "#959699",
            fontSize: "18px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        container: {
            display: "flex",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            height: "160px",
            width: "90%",
            borderBottom: "1px solid #E7E7E7"
        },
        title: {
            fontSize: "18px",
            marginBottom: "20px",
            color: "#333"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            width: "90%",
            marginBottom: "40px"
        },
        checkbox: {
            marginTop: "4px",
            transform: "scale(1.2)",
            accentColor: "#0052cc"
        },
        button: {
            width: "90%",
            padding: "12px",
            height: "54px",
            backgroundColor: colors.primario,
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "absolute",
            bottom: 16
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 12
                            },
                            children: colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 70,
                                    maxWidth: 120,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerStep,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.current,
                                    children: "02"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.separator,
                                    children: " / "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.total,
                                    children: "06"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.container,
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "initial",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerPhone,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        transform: "scale(0.5)",
                                        transformOrigin: "top left"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "115",
                                        height: "145",
                                        viewBox: "0 0 115 145",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M61.5803 111.956C62.5159 112.7 63.5193 117.083 64.5257 118.26H27.2711C26.6218 118.26 24.6001 117.246 23.8859 116.909C25.8751 115.642 27.8348 114.264 29.4787 112.556L29.7089 112.127C40.189 111.95 50.2914 111.98 61.5803 111.956Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M17.9704 54.3699C17.7783 54.3502 17.5875 54.3428 17.4037 54.3181C17.4026 54.2541 17.4011 54.1889 17.4 54.1255C17.5884 54.211 17.7797 54.2895 17.9704 54.3699Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0.429027 34.1884C1.58916 16.1706 16.0515 1.67456 34.0655 0.469364C36.1342 0.326694 37.9251 1.89607 38.0641 3.9648C38.203 6.03352 36.6373 7.82441 34.5686 7.96333C20.2978 8.91697 8.84284 20.402 7.92675 34.6728C7.79909 36.6589 6.14712 38.187 4.18352 38.187C4.10092 38.187 4.02208 38.187 3.93948 38.1795C1.87075 38.0443 0.301378 36.2609 0.432785 34.1922L0.429027 34.1884Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M38.852 24.723C31.0501 24.723 24.705 31.0681 24.705 38.8699C24.705 40.9424 23.023 42.6244 20.9506 42.6244C18.8781 42.6244 17.1961 40.9424 17.1961 38.8699C17.1961 26.9307 26.9089 17.214 38.852 17.214C40.9244 17.214 42.6065 18.896 42.6065 20.9685C42.6065 23.041 40.9244 24.723 38.852 24.723Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M47.6811 15.9324C54.0091 15.9299 60.3414 16.0076 66.5869 16.1621C73.1353 16.5138 78.4797 21.3504 78.9549 28.1708C79.0469 43.7925 78.9591 48.5917 78.6842 63.6238L78.6622 64.8229H73.0653H72.7727L72.4801 39.5757L64.5904 39.565H36.2083H34.8518L34.8501 32.6602L50.7259 32.6713H72.4727V28.0152C72.4715 26.0488 69.037 22.8307 66.998 22.7887L50.1925 22.7739C49.641 20.3443 48.7867 18.0483 47.6811 15.9324Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M42.1477 78.331C42.9623 82.4769 46.2441 84.6264 50.2343 84.9476C56.2462 85.431 62.866 84.5634 68.9428 84.9386C69.9699 96.0193 72.9065 107.136 78.6616 116.611C77.8204 117.004 73.2134 120.39 72.7795 120.06C67.9305 111.198 64.7313 101.597 63.0166 91.5822C54.133 90.9818 44.8069 93.9359 38.4644 85.8422C36.9622 83.9239 34.7871 78.7723 34.7871 76.3827V71.8795C34.7871 71.8465 35.1973 71.4292 35.2298 71.4292H77.0472L91.8717 86.6408L114.573 130.09L109.391 133.233L108.703 132.828L86.5741 90.8407L74.3998 78.331H42.1477Z",
                                                fill: colors.primario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M23.3023 94.0777C22.8685 93.6544 22.2517 93.7775 22.414 93.1981C27.1332 90.0249 28.1219 82.6818 24.2114 78.4398C29.2404 72.2585 25.8877 62.3366 17.8453 61.5261C14.4011 61.1778 5.95148 63.3423 7.16742 57.2391C7.66915 54.7293 10.0361 55.2217 10.3372 54.9184C10.5615 54.6933 10.3372 49.3736 10.3372 48.464C10.3372 47.8035 7.53339 48.53 7.03166 48.6981C-0.618185 51.2739 -1.95809 62.0454 4.76504 66.5215C3.20379 70.4903 3.13591 74.9064 6.15807 78.1816C1.71337 83.4383 3.45465 91.9492 10.042 94.2488C5.21364 99.2263 6.18168 107.71 12.589 110.712C22.8449 115.522 31.6546 102.192 23.3023 94.0777ZM16.9658 81.6341C16.0244 81.526 13.4774 81.499 12.6097 81.6971C9.47536 82.4176 9.50488 87.8093 13.1321 88.2447C14.0971 88.3617 16.6028 88.3737 17.5384 88.2206C20.7494 87.7013 21.2099 82.1264 16.9658 81.6341ZM13.5511 101.709C13.5511 103.543 15.0121 105.032 16.8124 105.032C18.6127 105.032 20.0736 103.543 20.0736 101.709C20.0736 99.8747 18.6127 98.3857 16.8124 98.3857C15.0121 98.3857 13.5511 99.8747 13.5511 101.709ZM10.4109 72.7058C11.1576 75.6509 17.3643 75.6719 19.0731 74.0267C21.3663 71.8202 19.7047 68.4849 16.6707 68.1246C13.5807 67.7584 9.32485 68.4189 10.4109 72.7058Z",
                                                fill: colors.primario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M41.8508 125.165H51.1268L65.1103 139.425L60.5091 144.057L41.8508 125.165Z",
                                                fill: colors.primario
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: styles.description,
                                    children: "Enter your phone to continue. We\u2019ll send you a verification code. You\u2019ll be able to use your phone number to resume your application if needed."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    style: styles.label,
                                    children: "Phone Number"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    placeholder: "517-913-4562",
                                    value: phone,
                                    onChange: (e)=>setPhone(e.target.value),
                                    style: styles.input
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClick,
                            style: styles.button,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jdi9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhoneStep2VisaMobile", ()=>PhoneStep2VisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const PhoneStep2VisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const inputs = Array.from({
        length: 6
    }, ()=>(0, _react.useRef)(null));
    const handleChange = (e, index)=>{
        const value = e.target.value;
        if (value.length > 1) return;
        if (/^[0-9]?$/.test(value)) {
            if (value && index < 5) inputs[index + 1].current.focus();
        }
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_skan_id_01-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        containerPhone: {
            width: "100%",
            margin: "0 auto",
            fontFamily: "sans-serif",
            padding: "20px"
        },
        description: {
            fontSize: "15px",
            marginTop: -60,
            color: "#333",
            marginBottom: "20px",
            lineHeight: "1.5"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        containerStep: {
            display: "flex",
            alignItems: "baseline",
            fontFamily: "sans-serif"
        },
        current: {
            color: colors.primario,
            fontSize: "40px",
            fontWeight: "bold"
        },
        separator: {
            margin: "0 2px",
            color: "#959699",
            fontSize: "18px"
        },
        inputGroup: {
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            marginBottom: "12px"
        },
        input: {
            width: "40px",
            height: "50px",
            fontSize: "20px",
            textAlign: "center",
            border: "1px solid #ccc",
            borderRadius: "6px",
            outline: "none",
            padding: "12px"
        },
        resend: {
            color: colors.primario,
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "0",
            fontSize: "14px",
            textDecoration: "underline"
        },
        total: {
            color: "#959699",
            fontSize: "18px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        container: {
            display: "flex",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box",
            alignItems: "center",
            margin: "16px 0 8px 0"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            height: "160px",
            width: "90%",
            borderBottom: "1px solid #E7E7E7"
        },
        title: {
            fontSize: "18px",
            marginBottom: "20px",
            color: "#333"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            width: "90%",
            marginBottom: "40px"
        },
        checkbox: {
            marginTop: "4px",
            transform: "scale(1.2)",
            accentColor: "#0052cc"
        },
        label: {
            lineHeight: "1.5",
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            marginBottom: "8px",
            color: "#111"
        },
        button: {
            width: "90%",
            padding: "12px",
            height: "54px",
            backgroundColor: colors.primario,
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "absolute",
            bottom: 16
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 12
                            },
                            children: colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 70,
                                    maxWidth: 120,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerStep,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.current,
                                    children: "02"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.separator,
                                    children: " / "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.total,
                                    children: "06"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.container,
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "initial",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerPhone,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        transform: "scale(0.5)",
                                        transformOrigin: "top left"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "115",
                                        height: "145",
                                        viewBox: "0 0 115 145",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M61.5803 111.956C62.5159 112.7 63.5193 117.083 64.5257 118.26H27.2711C26.6218 118.26 24.6001 117.246 23.8859 116.909C25.8751 115.642 27.8348 114.264 29.4787 112.556L29.7089 112.127C40.189 111.95 50.2914 111.98 61.5803 111.956Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M17.9704 54.3699C17.7783 54.3502 17.5875 54.3428 17.4037 54.3181C17.4026 54.2541 17.4011 54.1889 17.4 54.1255C17.5884 54.211 17.7797 54.2895 17.9704 54.3699Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M0.429027 34.1884C1.58916 16.1706 16.0515 1.67456 34.0655 0.469364C36.1342 0.326694 37.9251 1.89607 38.0641 3.9648C38.203 6.03352 36.6373 7.82441 34.5686 7.96333C20.2978 8.91697 8.84284 20.402 7.92675 34.6728C7.79909 36.6589 6.14712 38.187 4.18352 38.187C4.10092 38.187 4.02208 38.187 3.93948 38.1795C1.87075 38.0443 0.301378 36.2609 0.432785 34.1922L0.429027 34.1884Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M38.852 24.723C31.0501 24.723 24.705 31.0681 24.705 38.8699C24.705 40.9424 23.023 42.6244 20.9506 42.6244C18.8781 42.6244 17.1961 40.9424 17.1961 38.8699C17.1961 26.9307 26.9089 17.214 38.852 17.214C40.9244 17.214 42.6065 18.896 42.6065 20.9685C42.6065 23.041 40.9244 24.723 38.852 24.723Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M47.6811 15.9324C54.0091 15.9299 60.3414 16.0076 66.5869 16.1621C73.1353 16.5138 78.4797 21.3504 78.9549 28.1708C79.0469 43.7925 78.9591 48.5917 78.6842 63.6238L78.6622 64.8229H73.0653H72.7727L72.4801 39.5757L64.5904 39.565H36.2083H34.8518L34.8501 32.6602L50.7259 32.6713H72.4727V28.0152C72.4715 26.0488 69.037 22.8307 66.998 22.7887L50.1925 22.7739C49.641 20.3443 48.7867 18.0483 47.6811 15.9324Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M42.1477 78.331C42.9623 82.4769 46.2441 84.6264 50.2343 84.9476C56.2462 85.431 62.866 84.5634 68.9428 84.9386C69.9699 96.0193 72.9065 107.136 78.6616 116.611C77.8204 117.004 73.2134 120.39 72.7795 120.06C67.9305 111.198 64.7313 101.597 63.0166 91.5822C54.133 90.9818 44.8069 93.9359 38.4644 85.8422C36.9622 83.9239 34.7871 78.7723 34.7871 76.3827V71.8795C34.7871 71.8465 35.1973 71.4292 35.2298 71.4292H77.0472L91.8717 86.6408L114.573 130.09L109.391 133.233L108.703 132.828L86.5741 90.8407L74.3998 78.331H42.1477Z",
                                                fill: colors.primario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M23.3023 94.0777C22.8685 93.6544 22.2517 93.7775 22.414 93.1981C27.1332 90.0249 28.1219 82.6818 24.2114 78.4398C29.2404 72.2585 25.8877 62.3366 17.8453 61.5261C14.4011 61.1778 5.95148 63.3423 7.16742 57.2391C7.66915 54.7293 10.0361 55.2217 10.3372 54.9184C10.5615 54.6933 10.3372 49.3736 10.3372 48.464C10.3372 47.8035 7.53339 48.53 7.03166 48.6981C-0.618185 51.2739 -1.95809 62.0454 4.76504 66.5215C3.20379 70.4903 3.13591 74.9064 6.15807 78.1816C1.71337 83.4383 3.45465 91.9492 10.042 94.2488C5.21364 99.2263 6.18168 107.71 12.589 110.712C22.8449 115.522 31.6546 102.192 23.3023 94.0777ZM16.9658 81.6341C16.0244 81.526 13.4774 81.499 12.6097 81.6971C9.47536 82.4176 9.50488 87.8093 13.1321 88.2447C14.0971 88.3617 16.6028 88.3737 17.5384 88.2206C20.7494 87.7013 21.2099 82.1264 16.9658 81.6341ZM13.5511 101.709C13.5511 103.543 15.0121 105.032 16.8124 105.032C18.6127 105.032 20.0736 103.543 20.0736 101.709C20.0736 99.8747 18.6127 98.3857 16.8124 98.3857C15.0121 98.3857 13.5511 99.8747 13.5511 101.709ZM10.4109 72.7058C11.1576 75.6509 17.3643 75.6719 19.0731 74.0267C21.3663 71.8202 19.7047 68.4849 16.6707 68.1246C13.5807 67.7584 9.32485 68.4189 10.4109 72.7058Z",
                                                fill: colors.primario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M41.8508 125.165H51.1268L65.1103 139.425L60.5091 144.057L41.8508 125.165Z",
                                                fill: colors.primario
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: styles.description,
                                    children: "We texted you a one-time verification code. Enter the code below."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: styles.inputGroup,
                                    children: inputs.map((ref, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            ref: ref,
                                            maxLength: 1,
                                            style: styles.input,
                                            onChange: (e)=>handleChange(e, i)
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    style: styles.resend,
                                    children: "Resend Code"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClick,
                            style: styles.button,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Xfiv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnboardingSuccessVisaMobile", ()=>OnboardingSuccessVisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _svgFondo = require("./SvgFondo");
var _svgFondoDefault = parcelHelpers.interopDefault(_svgFondo);
const OnboardingSuccessVisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLanding = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-visa-mobile${currentParams}`);
    };
    const handleButtonClickOnboarding = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#ffffff",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        page: {
            minHeight: "100vh",
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            overflow: "hidden"
        },
        svgFondo: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "300px",
            zIndex: 0
        },
        card: {
            width: "375px",
            height: "812px",
            justifyContent: "flex-start",
            background: colors.primario,
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px",
            paddingBottom: "64px",
            position: "relative",
            color: "white",
            boxSizing: "border-box",
            zIndex: 1
        },
        content: {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            zIndex: 2
        },
        welcomeText: {
            fontFamily: "Open Sans, sans-serif",
            fontSize: "20px",
            marginBottom: "16px",
            fontWeight: "normal"
        },
        name: {
            fontWeight: "bold"
        },
        menuIcon: {
            marginLeft: "12px",
            fontWeight: "bold"
        },
        faceIdButton: {
            width: "100%",
            backgroundColor: colors.secundario,
            padding: "20px 16px",
            borderRadius: "2px",
            fontWeight: "500",
            textAlign: "center",
            color: colors.primario,
            fontSize: "15px",
            marginBottom: "16px",
            border: "none",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        passwordButton: {
            width: "100%",
            backgroundColor: "transparent",
            color: "white",
            padding: "20px 16px",
            border: "1px solid white",
            borderRadius: "2px",
            fontSize: "15px",
            fontWeight: "400",
            marginBottom: "16px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        supportText: {
            fontSize: "12px",
            color: "white"
        },
        clickHere: {
            color: colors.secundario,
            cursor: "pointer",
            textDecoration: "underline"
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: styles.page,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: styles.card,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        width: 65,
                        height: 64,
                        viewBox: "0 0 65 64",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M53.3578 11.3663C47.7865 5.85495 40.379 2.81963 32.5 2.81963C24.6208 2.81963 17.2132 5.85495 11.642 11.3663C6.07065 16.8777 3.00244 24.2056 3.00244 32C3.00244 39.7943 6.07065 47.1221 11.642 52.6336C17.2133 58.145 24.6208 61.1803 32.5 61.1803C40.379 61.1803 47.7865 58.145 53.3578 52.6336C58.9292 47.1221 61.9975 39.7943 61.9975 32C61.9975 24.2056 58.9292 16.8778 53.3578 11.3663ZM32.5 57.7608C18.141 57.7608 6.45918 46.2046 6.45918 32C6.45918 17.7954 18.141 6.2392 32.5 6.2392C46.8589 6.2392 58.5408 17.7954 58.5408 32C58.5408 46.2046 46.8589 57.7608 32.5 57.7608Z",
                                fill: colors.secundario,
                                stroke: "#F9C017",
                                strokeWidth: 1.3913
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M45.7829 19.0405L25.9667 38.6436L19.2172 31.9666L16.0437 35.106L24.3799 43.3526L25.9667 44.9595L27.5533 43.3526L48.9563 22.1797L45.7829 19.0405Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        style: {
                            fontSize: 22,
                            fontWeight: 600,
                            textAlign: "center",
                            marginTop: 12,
                            lineHeight: 1.1,
                            marginBottom: 8
                        },
                        children: "Congratulations! Your application has been approved!"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            background: colors.primario,
                            textAlign: "center",
                            fontSize: 16,
                            lineHeight: 1.1,
                            marginTop: 10,
                            fontWeight: 200
                        },
                        children: "Start using your wallet and enjoy all the benefits we\u2019ve prepared for you. Your experience begins now!"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            background: colors.primario,
                            padding: 20,
                            zIndex: 9,
                            bottom: 30,
                            height: 85,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClickOnboarding,
                            style: styles.faceIdButton,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    textAlign: "center",
                                    width: "100%",
                                    alignItems: "center",
                                    fontWeight: 600
                                },
                                children: "Lett\u2019s Start"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            bottom: -20,
                            left: 0
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 375,
                            height: 547,
                            viewBox: "0 0 375 547",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    clipPath: "url(#clip0_629_375)",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        clipPath: "url(#clip1_629_375)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M63.2116 224.054C80.7628 221.697 86.8886 199.728 76.2448 186.742C74.717 184.88 66.6668 178.242 67.1227 176.507L105.227 138.16L106.438 137.582C115.43 145.224 119.436 152.747 133.02 151.16C141.082 150.216 150.494 140.703 155.592 134.651C162.642 126.281 168.783 109.976 164.874 99.303C163.35 95.1343 152.241 83.6467 148.507 80.1412C145.251 77.0827 133.138 70.273 132.324 66.7231C130.696 59.6262 136.069 57.6307 141.976 57.0859C150.701 56.2806 157.381 58.1725 164.167 63.5906L167.764 16.5535C170.384 5.96882 184.622 6.33595 187.118 16.666C189.037 24.6126 188.954 35.2683 190.313 43.6708C190.52 44.9558 190.893 48.5175 191.562 49.234C199.921 53.61 212.415 53.8854 218.635 61.5359C228.515 73.6808 218.854 87.241 215.085 99.9988C212.021 110.373 210.159 119.238 210.926 130.237C212.258 149.381 232.874 158.589 248.207 147.332L308.36 86.6873H347.738V95.8656C347.738 96.8427 346.074 100.2 345.367 101.192C340.017 108.694 331.2 105.376 323.422 106.486C321.835 112.339 320.662 118.326 318.418 123.984C317.938 125.192 314.362 133.118 313.921 133.396C312.668 134.189 307.588 130.681 307.549 130.225C307.517 129.831 310.631 124.419 311.129 123.208C312.002 121.085 312.861 118.939 313.551 116.748C314.477 113.808 316.719 100.404 317.219 99.6909C318.232 98.249 334.018 99.7175 337.248 98.9951C339.632 98.4622 340.766 95.3978 340.632 93.201H311.913L255.082 150.654C236.175 168.297 205.78 156.901 203.823 130.823C202.846 117.808 206.011 105.313 209.937 93.0736C211.778 87.3298 217.075 77.3758 216.006 71.8541C212.909 55.8394 186.733 63.3242 183.785 47.8277C181.922 38.0306 182.061 27.2151 179.876 17.3736C176.744 13.3174 174.642 16.8791 174.245 20.6718C172.913 33.3941 173.108 46.4125 171.862 59.1466C171.299 64.8904 171.4 72.4551 163.323 71.256C160.392 70.8208 159.116 68.4196 156.883 67.031C152.108 64.0555 145.144 62.285 139.904 65.074C143.462 68.1502 147.927 70.6135 151.453 73.6453C156.019 77.5742 168.865 90.557 170.973 95.5755C182.867 123.889 142.595 174.725 113.645 153.496C112.025 152.309 107.602 147.066 106.438 147.063C96.0521 156.208 86.4741 166.66 76.5764 176.478C81.7103 182.337 86.5511 187.527 88.2268 195.494C90.927 208.329 83.9456 223.165 71.7888 228.498C70.0746 229.25 64.1975 231.171 62.6195 231.171H52.849V274.398H63.2116C68.9762 274.398 78.5867 280.604 82.1662 285.051C92.3541 297.702 90.3556 313.761 79.8006 325.331C74.9746 330.622 74.1574 332.828 68.8488 326.211C78.6459 317.648 85.4645 307.943 79.7858 294.54C77.7399 289.711 69.1035 281.504 63.8067 281.504H46.3384V224.065C51.6203 223.556 58.0925 224.752 63.2146 224.065L63.2116 224.054Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M344.185 138.192C343.842 139.243 343.123 140.049 342.427 140.875C339.306 144.576 330.086 154.142 326.433 156.857C325.728 157.378 325.157 158.05 324.224 158.201L294.824 158.242C293.021 157.653 294.149 152.827 293.853 151.219H321.98C323.934 149.967 334.086 138.192 335.007 138.192H344.185Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M354.252 473.94H306.88V480.453H354.252V473.94Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M155.667 -3.28641C156.519 -3.43445 161.384 0.98889 159.735 2.58177L138.74 23.0878C137.938 23.2921 127.14 12.4529 126.93 11.6535C126.592 10.3685 130.249 6.71791 131.309 6.71791C133.026 6.71791 137.505 13.4565 138.927 13.2108C141.656 11.5143 154.16 -3.01995 155.669 -3.28345L155.667 -3.28641Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M141.547 293.851L138.174 300.273L200.585 333.053L203.957 326.631L141.547 293.851Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.4134 353.9C28.1919 352.378 40.772 360.384 44.0585 372.887C46.507 382.198 45.977 414.974 45.1747 425.703C42.6195 459.784 -4.6397 459.438 -7.54122 426.855C-8.65149 414.384 -8.55675 391.433 -7.57083 378.879C-6.57898 366.24 2.57561 355.427 15.4134 353.9ZM14.7975 360.982C7.4934 362.125 0.683701 369.446 -0.290381 376.685C0.6008 392.91 -2.01353 411.498 -0.438417 427.45C1.70812 449.179 34.3117 450.402 37.7787 428.374C40.1444 413.348 36.5678 393.816 38.0393 378.314C36.3458 366.37 26.8448 359.099 14.7975 360.982Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M100.025 405.479C105.831 405.461 111.525 409.949 112.513 415.755C114.642 428.238 102.03 435.429 92.9253 440.688C85.8165 435.717 75.8892 431.127 73.9588 421.745C71.9218 411.859 78.8055 404.851 88.6796 405.84C90.3583 406.009 91.889 407.071 93.3635 407C95.1192 406.917 97.6713 405.484 100.025 405.479ZM84.6619 412.469C79.1727 413.662 80.1349 421.082 82.7877 424.753C83.9217 426.319 90.835 431.779 92.5078 432.25C93.9734 432.661 99.735 428.359 101.088 427.139C104.549 424.022 107.883 419.119 104.697 414.686C100.484 408.821 94.5241 415.474 92.9223 415.225C90.9475 414.917 88.8424 411.56 84.6589 412.469H84.6619Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M305.503 439.711C305.503 447.915 298.854 454.565 290.649 454.565C282.445 454.565 275.795 447.915 275.795 439.711C275.795 431.506 282.445 424.857 290.649 424.857C298.854 424.857 305.503 431.506 305.503 439.711ZM298.635 439.717C298.635 435.29 295.046 431.702 290.62 431.702C286.193 431.702 282.605 435.29 282.605 439.717C282.605 444.143 286.193 447.731 290.62 447.731C295.046 447.731 298.635 444.143 298.635 439.717Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M391.376 439.817C391.376 448.004 384.738 454.642 376.552 454.642C368.365 454.642 361.728 448.004 361.728 439.817C361.728 431.631 368.365 424.993 376.552 424.993C384.738 424.993 391.376 431.631 391.376 439.817ZM384.602 439.829C384.602 435.376 380.993 431.767 376.54 431.767C372.087 431.767 368.478 435.376 368.478 439.829C368.478 444.282 372.087 447.891 376.54 447.891C380.993 447.891 384.602 444.282 384.602 439.829Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M322.658 204.898C321.737 205.83 313.092 211.974 312.399 212.095C304.772 208.43 295.472 202.402 297.539 192.51C298.33 188.732 302.8 185.138 306.637 185.031C308.506 184.981 310.611 186.171 312.452 186.103C313.977 186.047 315.505 184.984 317.184 185.028C327.673 185.309 329.562 197.91 322.658 204.898ZM306.128 192.181C299.514 194.073 309.077 204.859 312.811 203.687C316.434 202.55 323.753 193.813 318.306 192.19C314.936 191.186 313.145 194.328 311.922 194.257C310.83 194.195 309.003 191.361 306.131 192.181H306.128Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-6.58151 244.823C-5.40017 244.616 -1.4476 249.954 -0.0678943 250.659L6.44572 244.823C7.04379 244.72 10.8394 248.355 11.1355 248.93C11.9616 250.531 6.2444 254.262 5.51902 255.816L11.3546 262.33C11.4582 262.928 7.82247 266.724 7.24809 267.02C5.64633 267.846 1.9158 262.129 0.361416 261.403L-6.1522 267.239C-6.75027 267.343 -10.5459 263.707 -10.842 263.132C-11.668 261.531 -5.95087 257.8 -5.22549 256.246L-11.0611 249.732C-11.1766 249.063 -7.05226 244.906 -6.58151 244.823Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M17.6163 259.582H37.7493C39.0639 259.582 39.0639 266.688 37.7493 266.688H17.6163C16.3017 266.688 16.3017 259.582 17.6163 259.582Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M362.542 195.038V201.552H343.889C343.827 201.552 343.001 202.378 343.001 202.44V287.413H365.503V293.927H335.896V195.927C335.896 195.864 336.722 195.038 336.784 195.038H362.542Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M384.922 271.011C391.877 270.217 418.296 269.904 424.265 271.582C429.345 273.009 433.156 277.749 433.621 282.952C436.016 309.684 431.779 339.957 433.6 367.063C432.389 374.095 427.24 378.035 420.297 378.631C411.365 379.397 393.041 379.486 384.23 378.536C378.361 377.902 374.213 374.722 372.307 369.141L372.067 281.847C373.512 275.183 378.388 271.763 384.922 271.017V271.011ZM427.086 355.51V282.972C427.086 281.504 423.447 277.601 421.408 277.992C409.615 278.718 396.333 276.844 384.721 277.909C382.252 278.137 378.53 280.399 378.53 282.969V355.507H427.086V355.51ZM427.086 362.024H378.53C377.888 366.856 379.424 371.039 384.721 371.525C396.656 372.623 410.397 370.752 422.521 371.374C426.63 369.84 427.51 366.074 427.086 362.024Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-6.52828 146.619C4.75804 147.581 19.7601 144.848 30.6053 146.521C35.7066 147.308 38.2617 152.777 38.6585 157.416C39.3157 165.138 39.3957 180.581 38.6288 188.223C38.0574 193.928 34.7977 198.094 28.888 198.615C20.7223 199.334 3.15332 199.453 -4.891 198.591C-10.8746 197.952 -13.6133 193.247 -14.09 187.657C-14.765 179.74 -14.7769 164.75 -14.0574 156.854C-13.5807 151.616 -11.6089 148.442 -6.53124 146.616L-6.52828 146.619ZM-4.76072 153.123C-6.00127 153.718 -6.99312 154.781 -6.99015 156.223C-5.93021 166.37 -8.29584 179.027 -6.99015 188.85C-6.68816 191.124 -5.33806 191.835 -3.1264 192.092C3.75731 192.889 20.0739 192.747 27.1145 192.107C28.6541 191.968 29.8503 191.853 30.9783 190.642V154.435L27.6919 152.984L-4.76368 153.123H-4.76072Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M380.954 81.435C380.744 81.7222 382.15 85.6067 382.106 86.9568C382.035 89.1033 379.672 92.5082 379.832 93.3845C380.167 95.2291 382.402 96.8308 382.056 100.52C381.588 105.532 376.279 108.348 376.232 108.869C376.199 109.236 378.263 112.238 378.491 113.654C381.079 129.902 355.332 129.505 359.243 112.691C359.661 110.9 361.943 108.718 361.943 107.7C361.943 106.681 359.394 104.162 359.042 101.728C358.367 97.0588 360.795 94.6932 360.735 92.8931C360.706 92.0078 359.288 90.3942 359.042 88.7007C358.121 82.3025 361.727 77.3255 368.164 76.609C371.356 76.2537 377.742 78.2049 377.994 73.9444C378.21 70.273 375.142 71.0547 374.941 70.3234C374.509 68.7542 375.32 65.4352 374.98 63.5818C383.995 63.8512 388.202 73.3433 382.689 80.4935C382.227 81.0916 381.108 81.2218 380.954 81.4321V81.435ZM366.239 88.9049C367.779 90.4386 376.596 90.9686 374.867 85.3136C373.345 80.3395 361.68 84.3602 366.239 88.9049ZM366.239 101.932C367.779 103.466 376.602 103.993 374.867 98.3408C373.316 93.2839 361.638 97.346 366.239 101.932ZM371.942 115.821C371.942 114.033 370.494 112.585 368.706 112.585C366.917 112.585 365.47 114.033 365.47 115.821C365.47 117.609 366.917 119.057 368.706 119.057C370.494 119.057 371.942 117.609 371.942 115.821Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M48.1121 36.343H28.5713V42.8566H48.1121V36.343Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M35.0849 20.355H28.5713V29.8294H35.0849V20.355Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M48.1122 20.355H41.5986V29.8294H48.1122V20.355Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M213.321 473.94H148.185V480.453H213.321V473.94Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M205.031 405.843V414.429L197.925 431.897H165.061C164.999 431.897 164.173 431.071 164.173 431.009V412.652C164.173 412.111 159.8 403.267 159.341 402.98C158.103 402.204 152.398 403.755 151.403 402.328C150.935 401.656 150.935 397.005 151.403 396.333C151.954 395.542 162.562 395.445 163.587 396.066C165.055 396.961 166.974 404.564 169.206 405.843H205.031ZM197.925 412.356H171.279V425.384H193.188L197.925 412.356Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M109.767 97.9411C109.767 119.569 92.2332 137.103 70.605 137.103C48.9768 137.103 31.4434 119.569 31.4434 97.9411C31.4434 76.3129 48.9768 58.7795 70.605 58.7795C92.2332 58.7795 109.767 76.3129 109.767 97.9411ZM102.921 97.953C102.921 80.1145 88.4582 65.6513 70.6198 65.6513C52.7814 65.6513 38.3182 80.1145 38.3182 97.953C38.3182 115.791 52.7814 130.255 70.6198 130.255C88.4582 130.255 102.921 115.791 102.921 97.953Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M9.03354 97.9263C7.83149 97.6954 3.07654 98.2905 2.5821 97.8582C2.38669 97.6865 1.9337 94.48 0.462215 93.1714C-2.03072 90.9508 -6.19055 91.0396 -8.53545 93.3905C-9.59836 94.4534 -10.383 97.7161 -10.5902 97.8493C-10.9129 98.0595 -15.3659 98.0447 -16.1564 97.9322C-17.0446 97.8049 -17.0979 98.2786 -17.0328 97.044C-16.1682 80.7866 9.06019 81.0294 9.03058 97.9263H9.03354Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M6.06975 71.8718V81.9383C3.22744 81.4824 -0.627435 83.4424 -1.06562 79.8954C-1.94792 72.7097 -1.53638 70.9481 6.06975 71.8718Z",
                                                fill: colors.secundario
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip0_629_375",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 375,
                                                height: 547,
                                                rx: 40,
                                                fill: colors.quinto
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip1_629_375",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 539.446,
                                                height: 514.709,
                                                fill: colors.quinto,
                                                transform: "translate(-76.8311 -21.1989)"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            bottom: -20,
                            left: 0
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 375,
                            height: 547,
                            viewBox: "0 0 375 547",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    clipPath: "url(#clip0_629_286)",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        clipPath: "url(#clip1_629_286)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M318.723 224.646V280.9H302.439C292.929 280.9 283.472 294.211 283.185 303.132C282.809 314.827 291.437 320.772 298.018 328.568C285.856 342.057 272.219 354.557 259.496 367.67C258.86 368.132 258.395 367.972 257.744 367.67C255.982 366.856 250.546 360.008 248.263 358.169C233.232 346.062 210.44 357.079 210.952 376.235H226.644C229.661 376.235 235.822 380.437 235.822 383.637V447.885H229.309V385.414C229.309 385.251 227.882 383.978 227.52 383.649L133.967 383.634C133.556 383.836 132.194 385.748 132.194 386.006V447.885H125.68V383.637C125.68 383.282 128.155 379.483 128.7 378.959C129.825 377.876 133.422 376.235 134.858 376.235H154.103C153.777 357.189 137.387 354.72 121.807 355.487C89.5561 357.071 62.5424 379.581 58.2493 412.134C57.3019 419.311 58.2671 426.642 56.7009 433.68C53.074 449.969 38.7499 462.351 22.309 464.424C21.7109 465.256 21.7701 482.763 22.0218 484.924C22.0928 485.519 22.2912 486.967 22.9396 486.967H32.1179C32.035 488.151 32.5887 493.48 31.2297 493.48H5.47129V486.967H14.6496C15.298 486.967 15.4993 485.522 15.5674 484.924C15.822 482.763 15.8812 465.256 15.2832 464.424C4.31364 462.819 -5.29987 458.052 -12.1895 449.262C-21.1664 437.813 -20.7875 424.513 -20.5832 410.574H-13.4745V429.23C-13.4745 438.671 -3.61521 450.425 4.67189 454.31C25.9684 464.297 48.9023 449.57 50.9955 426.784C52.2983 412.605 50.9689 405.304 57.0769 391.415C71.1048 359.513 102.838 345.897 136.626 349.003C150.417 350.27 161.52 362.403 161.206 376.235L203.814 376.2C204.841 350.361 232.962 337.106 253.525 353.494C254.895 354.586 258.197 358.88 259.502 358.207L289.104 328.565C278.294 319.49 273.501 306.93 278.608 293.19C283.89 278.978 296.982 272.98 311.617 273.794V231.156H301.252C299.973 231.156 294.726 229.17 293.267 228.483C276.698 220.705 271.253 198.041 282.614 183.503C283.369 182.535 290.356 175.432 290.901 175.181C292.633 174.381 296.828 178.257 295.662 179.956C294.175 182.121 290.614 184.498 288.811 186.742C280.491 197.081 281.853 211.678 292.384 219.897C294.637 221.655 300.914 224.649 303.62 224.649H318.72L318.723 224.646Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M341.225 460.912H272.536V467.426H341.225V460.912Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M160.027 34.5666C159.734 36.1743 160.859 41.0003 159.056 41.5895C157.253 42.1786 142.491 41.8826 139.575 41.696C96.499 38.9662 98.8172 -18.0338 137.203 -20.5327C149.996 -21.3646 170.13 -21.4831 182.849 -20.5268C213.732 -18.2085 222.591 22.8125 195.562 37.5273C195.968 35.1439 194.384 32.5533 195.083 30.2498C195.438 29.0804 198.668 26.6762 199.687 25.3765C209.916 12.3285 204.326 -7.52321 188.421 -12.4795C179.53 -15.2507 150.494 -14.6704 140.164 -14.0131C125.65 -13.0894 113.668 -3.73939 114.408 11.7897C114.856 21.1545 124.966 34.5666 134.858 34.5666H160.025H160.027Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M222.203 224.054C222.342 223.959 223.34 221.04 223.31 220.874C223.151 220.018 218.849 217.848 217.922 215.012C217.324 213.185 217.635 208.382 217.41 208.122C216.933 207.568 211.355 207.702 208.681 203.527C208.024 202.502 207.343 199.796 206.834 199.453C205.611 198.627 201.244 199.586 199.08 198.917C197.061 198.292 194.654 194.218 193.407 193.973C192.303 193.753 190.124 195.37 188.711 195.589C182.754 196.513 181.458 192.371 179.175 192.175C178.313 192.101 173.881 195.912 170.831 196.078C168.466 196.208 165.635 194.263 163.892 194.437C161.68 194.657 160.359 200.178 154.938 200.907C153.458 201.105 149.585 200.619 148.872 201.061C148.49 201.297 146.965 206.585 145.544 208.095C143.658 210.1 138.559 210.976 137.813 212.208C137.008 213.534 137.905 217.679 136.638 220.507C135.696 222.612 131.64 225.324 131.611 226.704C131.587 227.799 133.378 230.138 133.707 231.719C136.724 246.256 138.394 247.05 144.934 259.574C150.243 269.741 154.311 279.997 150.243 291.573C149.091 291.067 144.357 289.208 144.137 288.257C143.918 287.307 145.266 283.434 145.266 281.794C145.274 267.106 130.414 253.853 127.605 239.6C127.249 237.797 127.59 236.006 127.193 234.091C126.154 229.037 122.305 227.216 126.367 221.496C128.431 218.591 130.554 219.133 131.007 214.881C131.371 211.438 130.03 209.691 133.055 206.864C135.371 204.702 138.4 205.004 140.206 203.355C142.281 201.46 142.029 196.978 145.588 195.118C148.49 193.602 151.788 194.455 154.278 193.742C156.484 193.108 158.503 187.945 162.843 187.456C165.523 187.154 168.27 189.253 170.349 189.111C173.446 188.901 174.381 184.868 180.463 185.555C183.385 185.884 185.804 188.901 186.959 188.91C187.876 188.916 190.917 187.083 192.451 186.87C198.423 186.044 199.767 192.033 201.901 192.59C204.329 193.224 206.419 190.707 210.55 193.366C213.821 195.471 213.38 199.006 214.63 200.237C216.015 201.602 220.684 200.75 223.056 204.542C224.823 207.373 223.242 209.884 224.282 212.199C224.948 213.682 227.882 214.813 228.983 216.379C232.444 221.303 228.619 223.725 228.104 227.888C227.686 231.254 227.583 246.762 228.243 249.688C229.099 253.474 235.583 260.847 237.033 265.178C238.298 268.956 237.516 273.03 234.656 275.887C232.53 278.01 228.042 278.374 227.254 279.736C225.294 283.123 224.288 293.643 222.632 298.208C219.083 307.988 210.618 305.326 202.165 305.871C201.629 306.205 198.769 314.175 197.632 315.256C196.223 316.594 191.435 313.953 191.409 312.609C191.397 311.967 196.383 301.885 197.058 301.056C201.099 296.106 211.562 300.47 214.846 298.119C217.448 296.257 220 275.067 221.738 273.332C223.672 271.399 232.21 273.815 230.031 266.857C229.084 263.837 221.022 252.447 221.022 251.002V231.165H192.007L196.791 250.925C196.655 251.609 190.843 252.933 190.275 252.438C189.17 251.479 184.146 227.5 183.124 224.063H222.206L222.203 224.054Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M177.792 245.371V251.887C164.617 248.974 158.681 265.708 173.028 267.896C173.369 274.383 173.78 276.388 166.959 273.673C156.934 269.684 154.956 255.511 163.033 248.675C163.909 247.932 168.383 245.374 169.206 245.374H177.792V245.371Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M321.684 132.271C321.382 131.984 323.581 126.065 323.99 125.532C324.94 124.295 351.338 125.704 355.125 125.18C357.464 126.37 358.773 128.478 361.162 129.81C362.885 130.773 364.223 129.813 363.726 132.271H321.684Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281.421 71.8689C281.148 73.3996 281.93 77.3699 281.163 78.4269C280.843 78.868 276.624 79.3181 274.587 81.3255C271.754 84.1145 272.219 88.1736 271.949 88.4579C271.706 88.7154 265.119 88.677 264.864 88.4283C264.651 88.218 264.382 84.7273 263.067 82.8236C260.411 78.9805 257.72 80.0287 255.94 78.6993C254.73 77.7933 255.624 73.5239 255.36 71.8718C260.399 71.629 264.802 74.1664 268.174 77.7548C272.124 74.4684 275.825 71.4366 281.418 71.8718L281.421 71.8689Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M248.269 37.5214C249.412 38.383 249.575 36.3786 250.3 35.745C253.317 33.1159 257.835 31.2032 261.877 31.6029C261.679 32.7132 262.161 37.7761 261.847 38.0958C261.569 38.38 257.27 38.6287 254.742 41.3497C252.403 43.8633 252.633 47.3422 252.397 47.5938C252.16 47.8455 245.569 47.8159 245.317 47.5702C245.066 47.3244 245.001 43.5998 242.952 41.3526C240.447 38.611 236.124 38.383 235.846 38.0988C235.532 37.779 236.018 32.7162 235.817 31.6059C240.255 31.1588 244.391 33.2491 247.63 36.1092C248.166 36.5829 248.204 37.477 248.266 37.5244L248.269 37.5214Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M399.255 426.864C391.536 419.557 380.798 417.102 370.53 415.915L268.734 415.874C268.091 415.983 266.129 427.273 266.031 428.646C265.88 430.722 266.715 440.321 266.359 440.815C265.824 441.561 261.326 442.044 260.109 442.556C257.981 432.534 259.18 420.868 262.955 411.359C267.12 400.86 272.704 390.32 285.246 389.239C304.162 387.611 325.349 390.527 344.514 389.23L346.29 389.822L364.922 408.496C375.587 409.36 386.065 410.574 395.631 415.684C398.405 417.168 405.171 421.413 405.742 424.522C405.147 426.873 407.16 440.492 406.331 441.339C405.991 441.685 400.294 442.091 399.258 441.961V426.861L399.255 426.864ZM271.943 408.803H283.49C285.033 405.547 288.74 400.454 289.693 397.239C290.022 396.129 289.509 396.457 288.828 396.368C279.182 395.092 275.277 400.91 271.94 408.803H271.943ZM291.484 408.803H326.421L322.193 396.451C319.066 396.667 298.093 395.738 297.344 396.736L291.484 408.803ZM354.844 408.803C353.269 407.382 343.572 396.368 342.705 396.368H329.382L333.527 408.803H354.844Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M355.436 437.819H311.588V444.924H355.436V437.819Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M346.471 356.772C347.205 358.246 343.066 362.048 342.11 362.048C341.681 362.048 336.692 358.116 335.481 357.402C325.231 351.38 313.216 350.785 302.543 356.209C300.873 357.056 294.658 362.045 294.146 362.045C293.252 362.045 289.687 358.551 289.681 357.58C289.663 355.185 301.388 349.014 303.922 348.114C318.821 342.823 334.696 346.593 346.468 356.769L346.471 356.772Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M316.236 358.652C323.83 358.172 332.745 361.062 337.651 367.019L332.724 371.451C326.157 365.405 317.358 363.685 309.127 367.528C307.801 368.147 303.466 371.519 303.114 371.457C302.593 371.365 298.489 367.14 298.617 366.527C303.227 361.944 309.699 359.063 316.236 358.649V358.652Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M328.126 375.119C328.89 376.422 324.899 380.342 323.774 380.369C321.719 380.416 320.381 377.701 315.715 378.859C314.465 379.169 313.124 380.594 312.035 380.321C311.374 380.155 308.026 376.733 308.029 375.933C308.035 373.615 315.798 371.495 317.838 371.457C319.593 371.424 322.143 372.025 323.78 372.665C324.316 372.875 327.999 374.909 328.126 375.125V375.119Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M-70.3174 231.159V274.386H37.7494C39.0639 274.386 39.0639 281.492 37.7494 281.492H-76.8311V224.054H37.7494C39.0639 224.054 39.0639 231.159 37.7494 231.159H-70.3174Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M14.8302 311.866C25.0299 310.818 36.5442 313.794 44.5116 320.328C49.1747 324.153 47.6914 325.035 43.1674 328.224C30.9248 316.917 13.6755 315.25 -0.281389 324.585C-1.7736 325.583 -3.89644 328.594 -5.35608 328.212C-6.27983 327.97 -9.5544 324.517 -9.26129 323.363C-9.01259 322.38 -3.64478 318.501 -2.39831 317.734C2.5846 314.679 8.99459 312.47 14.8302 311.869V311.866Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M14.8094 324.873C22.9722 323.765 33.6515 326.202 38.596 333.225C33.5657 340.165 33.0446 335.552 27.9788 333.308C20.7575 330.107 14.3357 331.078 7.64741 334.883C6.68813 335.428 5.90057 336.837 5.05676 337.074C3.1767 337.604 -1.11341 333.805 0.106416 332.097C2.2115 329.145 11.1855 325.367 14.8094 324.876V324.873Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.9821 337.888C19.3603 337.308 26.398 338.063 28.6126 340.97C29.9656 342.746 26.2736 346.341 25.2285 346.545C24.2929 346.726 21.717 344.251 19.3929 344.254C14.9636 344.256 13.6076 349.39 9.58987 343.404C7.72461 340.627 13.7615 338.273 15.9821 337.891V337.888Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M368.463 219.909V178.162C368.463 162.023 387.989 149.792 403.033 151.291C415.385 152.519 430.639 165.129 430.639 178.162V219.02C430.639 220.335 423.533 220.335 423.533 219.02V177.57C423.533 175.509 419.971 169.016 418.506 167.202C405.319 150.846 379.232 157.878 375.631 178.227L375.486 218.94C374.897 220.743 370.071 219.615 368.463 219.912V219.909Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M26.2026 204.513C26.7178 205.028 25.1486 210.881 24.4499 211.346C22.5432 212.622 4.25175 211.006 0.524189 211.536C-0.757809 211.103 -1.82071 205.996 -1.62826 204.51H26.2026V204.513Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M26.7949 139.969H-1.62815C-1.69033 138.542 -0.671841 133.941 0.524296 133.535C7.53828 134.044 16.1718 132.582 22.9785 133.423C26.0902 133.807 25.2968 137.662 26.7949 139.969Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.5439 159.51V172.537H25.0182V179.05H9.03027V159.51H15.5439Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M382.083 46.4095H373.2L370.835 70.6905L364.031 71.2886L366.687 46.4095H313.986L317.536 80.159L310.43 80.1649L307.475 46.4066C306.03 46.2112 298.59 47.0402 298.59 45.5213V27.1648C298.59 27.1026 299.416 26.2766 299.478 26.2766H381.194C381.257 26.2766 382.083 27.1026 382.083 27.1648V46.4095ZM305.696 33.3823V39.8959H374.977V33.3823H305.696Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M67.5641 29.8975C67.5641 46.1045 54.4274 59.2413 38.2203 59.2413C22.0132 59.2413 8.87646 46.1045 8.87646 29.8975C8.87646 13.6904 22.0132 0.55365 38.2203 0.55365C54.4274 0.55365 67.5641 13.6904 67.5641 29.8975ZM60.7574 29.9064C60.7574 17.4387 50.6524 7.33373 38.1848 7.33373C25.7171 7.33373 15.6121 17.4387 15.6121 29.9064C15.6121 42.374 25.7171 52.479 38.1848 52.479C50.6524 52.479 60.7574 42.374 60.7574 29.9064Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M104.958 480.453C104.464 480.021 106.148 478.099 106.513 477.567C110.208 472.11 118.421 460.166 122.735 455.891C123.365 455.266 123.741 454.479 124.81 454.414L238.067 454.529C242.896 462.704 250.763 470.162 255.597 478.147C256.048 478.89 256.743 479.447 256.551 480.45H248.261L234.964 462.067L233.632 461.031L128.366 460.924L126.548 462.067L113.251 480.45H104.961L104.958 480.453Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M171.281 437.816V444.927H164.17C163.66 437.567 163.93 437.307 171.281 437.816Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M193.792 437.81H187.258V444.936H193.792V437.81Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M51.0111 97.9915C51.2687 98.2106 51.9467 103.294 52.3878 104.606C57.8977 120.982 82.3031 121.591 88.4851 105.441C89.0417 103.99 89.921 98.2372 90.2112 97.9885C90.7086 97.5651 95.4635 98.1632 96.6685 97.9263C95.2119 132.514 45.963 132.434 44.5537 97.9263C45.7647 98.1661 50.4989 97.5622 51.0081 97.9915H51.0111Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M83.6411 78.3854H77.1274V94.9656H83.6411V78.3854Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M64.1 78.3854H57.5864V94.9656H64.1V78.3854Z",
                                                fill: colors.quinto
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M25.4388 85.0116C25.4388 101.222 12.299 114.361 -3.91099 114.361C-20.121 114.361 -33.2607 101.222 -33.2607 85.0116C-33.2607 68.8015 -20.121 55.6618 -3.91099 55.6618C12.299 55.6618 25.4388 68.8015 25.4388 85.0116ZM18.635 84.982C18.635 72.5113 8.5241 62.4004 -3.94651 62.4004C-16.4171 62.4004 -26.528 72.5113 -26.528 84.982C-26.528 97.4526 -16.4171 107.563 -3.94651 107.563C8.5241 107.563 18.635 97.4526 18.635 84.982Z",
                                                fill: colors.quinto
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip0_629_286",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 375,
                                                height: 547,
                                                rx: 40,
                                                fill: colors.quinto
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                            id: "clip1_629_286",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 539.446,
                                                height: 514.709,
                                                fill: colors.quinto,
                                                transform: "translate(-76.8311 -21.1989)"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","./SvgFondo":"3efkv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3efkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFondo = (colors)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 375,
        height: 632,
        viewBox: "0 0 375 632",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: -191.849,
                y: -126.723,
                width: 758.705,
                height: 758.705,
                fill: "url(#pattern0_271_3901)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("pattern", {
                        id: "pattern0_271_3901",
                        patternContentUnits: "objectBoundingBox",
                        width: 1,
                        height: 1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                            xlinkHref: "#image0_271_3901",
                            transform: "scale(0.000390625)"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("image", {
                        id: "image0_271_3901",
                        width: 2560,
                        height: 2560,
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
exports.default = SvgFondo;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jkonB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoTelco", ()=>(0, _corporativoTelco.CorporativoTelco));
var _corporativoTelco = require("./CorporativoTelco");

},{"./CorporativoTelco":"fzKAi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fzKAi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoTelco", ()=>CorporativoTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _iconDropdownDown2 = require("../../../../../icons/IconDropdownDown2");
var _unitedStates2 = require("../../../../../icons/UnitedStates2");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/telco-landing-corporativo-mobile${currentParams}`);
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_tutorial_easy-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-16",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-31",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rectangle-31"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-139",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-140",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-141"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-33",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitedStates2.UnitedStates2), {
                                            className: "united-states-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDropdownDown2.IconDropdownDown2), {
                                            className: "icon-dropdown-down-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        })
                    ]
                }),
                colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: colors.url_logo
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: "/img/inicio-de-sesion-de-usuario-1-1.svg"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-5",
                    children: "Welcome, Mary"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-6",
                    children: "Enter your info"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "action-buttons-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClickLogin,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                                className: "test-button-4 highlighted-button",
                                disabled: "off",
                                endIcon: false,
                                label: "Log in by Password",
                                onColor: "off",
                                size: "large",
                                startIcon: false,
                                textClassName: "test-button-5",
                                type: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "test-button-6 highlighted-button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: handleButtonClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-126",
                                    children: "Sign in"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../components/TestButton":"7GP6t","../../../../../icons/IconDropdownDown2":"aPdpV","../../../../../icons/UnitedStates2":"bwYtW","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"396g8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7GP6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestButton", ()=>(0, _testButton.TestButton));
var _testButton = require("./TestButton");

},{"./TestButton":"4IjDU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4IjDU":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestButton", ()=>TestButton);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconOk = require("../../icons/IconOk");
var _styleCss = require("./style.css");
const TestButton = ({ endIcon = true, startIcon = true, label = "Label", type, size, disabled, onColor, className, textClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `test-button ${type} on-color-${onColor} disabled-${disabled} size-${size} ${className}`,
        children: [
            startIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconOk.IconOk), {
                className: `${type === "link" ? "class-3" : "class-4"}`,
                color: type === "primary" && disabled === "off" ? "white" : disabled === "on" ? "#8A8A8A" : disabled === "off" && onColor === "off" && type === "secondary" || disabled === "off" && type === "ghost" || disabled === "off" && type === "link" ? "#B5883E" : onColor === "on" ? "#F8F3EC" : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `label ${textClassName}`,
                children: [
                    [
                        "ghost",
                        "primary",
                        "secondary"
                    ].includes(type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: label
                    }),
                    type === "link" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-2",
                                    children: label
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "line"
                            })
                        ]
                    })
                ]
            }),
            endIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconOk.IconOk), {
                className: `${type === "link" ? "class-3" : "class-4"}`,
                color: type === "primary" && disabled === "off" ? "white" : disabled === "on" ? "#8A8A8A" : disabled === "off" && onColor === "off" && type === "secondary" || disabled === "off" && type === "ghost" || disabled === "off" && type === "link" ? "#B5883E" : onColor === "on" ? "#F8F3EC" : undefined
            })
        ]
    });
};
TestButton.propTypes = {
    endIcon: (0, _propTypesDefault.default).bool,
    startIcon: (0, _propTypesDefault.default).bool,
    label: (0, _propTypesDefault.default).string,
    type: (0, _propTypesDefault.default).oneOf([
        "primary",
        "link",
        "secondary",
        "ghost"
    ]),
    size: (0, _propTypesDefault.default).oneOf([
        "large",
        "medium",
        "small"
    ]),
    disabled: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ]),
    onColor: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/IconOk":"coyOJ","./style.css":"7KC57","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"coyOJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconOk", ()=>(0, _iconOk.IconOk));
var _iconOk = require("./IconOk");

},{"./IconOk":"kEHQ4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kEHQ4":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconOk", ()=>IconOk);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconOk = ({ color = "black", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-ok ${className}`,
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M6.66656 10.3907L4.47123 8.19533L3.52856 9.138L6.66656 12.276L13.1379 5.80467L12.1952 4.862L6.66656 10.3907Z",
            fill: color
        })
    });
};
IconOk.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KC57":[function() {},{}],"aPdpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconDropdownDown2", ()=>(0, _iconDropdownDown2.IconDropdownDown2));
var _iconDropdownDown2 = require("./IconDropdownDown2");

},{"./IconDropdownDown2":"fDz42","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fDz42":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconDropdownDown2", ()=>IconDropdownDown2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconDropdownDown2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-dropdown-down-2 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 25 24",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M7.5 9L12.1661 14.0397L17.2 9",
            stroke: "black",
            strokeWidth: "2"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwYtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnitedStates2", ()=>(0, _unitedStates2.UnitedStates2));
var _unitedStates2 = require("./UnitedStates2");

},{"./UnitedStates2":"hUTrE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hUTrE":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnitedStates2", ()=>UnitedStates2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const UnitedStates2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `united-states-2 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 25 24",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2630_4974)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
                        fill: "#F0F0F0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M11.9775 12.0001H24.4993C24.4993 10.917 24.3549 9.86774 24.0859 8.86963H11.9775V12.0001Z",
                        fill: "#D80027"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M11.9775 5.73934H22.738C22.0034 4.54065 21.0642 3.48114 19.9691 2.60889H11.9775V5.73934Z",
                        fill: "#D80027"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M12.5001 24.0003C15.3243 24.0003 17.9201 23.0242 19.9699 21.3916H5.03027C7.08012 23.0242 9.67591 24.0003 12.5001 24.0003Z",
                        fill: "#D80027"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M2.26098 18.2608H22.7384C23.3281 17.2985 23.7855 16.2467 24.0863 15.1304H0.913086C1.21388 16.2467 1.67124 17.2985 2.26098 18.2608Z",
                        fill: "#D80027"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M6.05863 1.87397H7.15217L6.13498 2.61295L6.52353 3.80869L5.50639 3.0697L4.48925 3.80869L4.82487 2.7757C3.92928 3.52172 3.14431 4.39575 2.49744 5.36963H2.84783L2.20034 5.84002C2.09947 6.0083 2.00272 6.17925 1.91 6.35273L2.21919 7.30434L1.64234 6.88523C1.49895 7.18903 1.3678 7.49967 1.24991 7.81678L1.59055 8.86528H2.84783L1.83064 9.60427L2.21919 10.8L1.20205 10.061L0.592766 10.5037C0.531781 10.9939 0.5 11.4932 0.5 12H12.5C12.5 5.37262 12.5 4.59131 12.5 0C10.1294 0 7.91961 0.687656 6.05863 1.87397ZM6.52353 10.8L5.50639 10.061L4.48925 10.8L4.8778 9.60427L3.86061 8.86528H5.11789L5.50639 7.66955L5.89489 8.86528H7.15217L6.13498 9.60427L6.52353 10.8ZM6.13498 6.10861L6.52353 7.30434L5.50639 6.56536L4.48925 7.30434L4.8778 6.10861L3.86061 5.36963H5.11789L5.50639 4.17389L5.89489 5.36963H7.15217L6.13498 6.10861ZM10.8279 10.8L9.81073 10.061L8.79359 10.8L9.18214 9.60427L8.16495 8.86528H9.42223L9.81073 7.66955L10.1992 8.86528H11.4565L10.4393 9.60427L10.8279 10.8ZM10.4393 6.10861L10.8279 7.30434L9.81073 6.56536L8.79359 7.30434L9.18214 6.10861L8.16495 5.36963H9.42223L9.81073 4.17389L10.1992 5.36963H11.4565L10.4393 6.10861ZM10.4393 2.61295L10.8279 3.80869L9.81073 3.0697L8.79359 3.80869L9.18214 2.61295L8.16495 1.87397H9.42223L9.81073 0.678234L10.1992 1.87397H11.4565L10.4393 2.61295Z",
                        fill: "#0052B4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2630_4974",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(0.5)",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"396g8":[function() {},{}],"2hnjE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoRegional", ()=>(0, _corporativoRegional.CorporativoRegional));
var _corporativoRegional = require("./CorporativoRegional");

},{"./CorporativoRegional":"h7j8j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7j8j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoRegional", ()=>CorporativoRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _iconDropdownDown2 = require("../../../../../icons/IconDropdownDown2");
var _unitedStates2 = require("../../../../../icons/UnitedStates2");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-landing-corporativo-mobile${currentParams}`);
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_tutorial_easy-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-16",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-31",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rectangle-31"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-139",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-140",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-141"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-33",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitedStates2.UnitedStates2), {
                                            className: "united-states-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDropdownDown2.IconDropdownDown2), {
                                            className: "icon-dropdown-down-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        })
                    ]
                }),
                colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: colors.url_logo
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: "/img/inicio-de-sesion-de-usuario-1-1.svg"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-5",
                    children: "Welcome, Mary"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-6",
                    children: "Enter your info"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "action-buttons-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClickLogin,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                                className: "test-button-4 highlighted-button",
                                disabled: "off",
                                endIcon: false,
                                label: "Log in by Password",
                                onColor: "off",
                                size: "large",
                                startIcon: false,
                                textClassName: "test-button-5",
                                type: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "test-button-6 highlighted-button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: handleButtonClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-126",
                                    children: "Sign in"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../components/TestButton":"7GP6t","../../../../../icons/IconDropdownDown2":"aPdpV","../../../../../icons/UnitedStates2":"bwYtW","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"lrpIi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lrpIi":[function() {},{}],"fdDqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Corporativo", ()=>(0, _corporativo.Corporativo));
var _corporativo = require("./Corporativo");

},{"./Corporativo":"5cm0C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5cm0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Corporativo", ()=>Corporativo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _iconDropdownDown2 = require("../../../../../icons/IconDropdownDown2");
var _unitedStates2 = require("../../../../../icons/UnitedStates2");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const Corporativo = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-corporativo-mobile${currentParams}`);
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_tutorial_easy-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-16",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-31",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rectangle-31"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-139",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-140",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-141"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-33",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitedStates2.UnitedStates2), {
                                            className: "united-states-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDropdownDown2.IconDropdownDown2), {
                                            className: "icon-dropdown-down-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        })
                    ]
                }),
                colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: colors.url_logo
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: "/img/inicio-de-sesion-de-usuario-1-1.svg"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-5",
                    children: "Welcome, Mary"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-6",
                    children: "Enter your info"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "action-buttons-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClickLogin,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                                className: "test-button-4 highlighted-button",
                                disabled: "off",
                                endIcon: false,
                                label: "Log in by Password",
                                onColor: "off",
                                size: "large",
                                startIcon: false,
                                textClassName: "test-button-5",
                                type: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "test-button-6 highlighted-button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: handleButtonClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-126",
                                    children: "Sign in"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"7xjml","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../icons/IconDropdownDown2":"aPdpV","../../../../../icons/UnitedStates2":"bwYtW","../../../../../hooks/useDynamicColors":"b2GRH"}],"7xjml":[function() {},{}],"5S7pv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLanding", ()=>(0, _corporativoLanding.CorporativoLanding));
var _corporativoLanding = require("./CorporativoLanding");

},{"./CorporativoLanding":"aK5ox","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aK5ox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLanding", ()=>CorporativoLanding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("../../../../../components/Button");
var _chevronsDown1 = require("../../../../../icons/ChevronsDown1");
var _chevronsDown2 = require("../../../../../icons/ChevronsDown2");
var _icons1 = require("../../../../../icons/Icons1");
var _icons19 = require("../../../../../icons/Icons19");
var _nameMenuDarkTrue = require("../../../../../icons/NameMenuDarkTrue");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _trailingIcon19 = require("../../../../../icons/TrailingIcon19");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _frameCorp = require("../../../../../components/FrameCorp");
var _styleCss = require("./style.css");
const CorporativoLanding = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const scrollRef = (0, _react.useRef)(null);
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-card_details-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "contenedor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "corporativo-landing",
            ref: scrollRef,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "div-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                                className: "header",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frameCorp.FrameCorp), {
                                                color: colors.septimo
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-7",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-11",
                                                    children: "Good morning, Mary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons1.Icons1), {
                                                            className: "icon-instance-node-2",
                                                            color: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameMenuDarkTrue.NameMenuDarkTrue), {
                                                            className: "icon-instance-node-2",
                                                            color: "white"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "vector-2",
                                alt: "Vector",
                                src: "/img/vector-101.svg"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-9",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "accounts",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "tarjtetas",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "title",
                                                        children: "Accounts"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-10",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                                className: "icon-instance-node-2",
                                                                color: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "menu-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-2"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-3"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "account highlighted-button",
                                                onClick: handleButtonClick,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-11",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-12",
                                                                children: "Balance"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "element-USD",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "span",
                                                                        children: "$13,000"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-13",
                                                                        children: ".23"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-14",
                                                                        children: "\xa0"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-15",
                                                                        children: "USD"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-12",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "main-account",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "span",
                                                                        children: "Main account "
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-16",
                                                                        children: "| ****2357"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                className: "button-instance",
                                                                divClassName: "button-4",
                                                                leadingIcon: false,
                                                                size: "small",
                                                                text: "Transactions",
                                                                trailingIcon: true,
                                                                trailingIcon14StyleOverrideClassName: "button-5",
                                                                trailingIcon14Color: colors.secundario,
                                                                type: "text"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "button-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-17",
                                                        children: "More"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon19.TrailingIcon19), {
                                                        className: "trailing-icon"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "botonera",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-13",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "invoice",
                                                        alt: "Invoice",
                                                        src: "/img/invoice.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "texto-iconos",
                                                        children: "Pay Bills"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-14",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "overlap-group-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-8",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-3"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "star",
                                                                    alt: "Star",
                                                                    src: "/img/star-1.svg"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "vector-3",
                                                                    alt: "Vector",
                                                                    src: "/img/vector-2.svg"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "texto-iconos",
                                                        children: "Goals"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-13",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "btn-icon-contacts",
                                                        alt: "Btn icon contacts",
                                                        src: "/img/btn-icon-contacts-2.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "texto-iconos",
                                                        children: "Contacts"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-15",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "plus",
                                                        alt: "Plus",
                                                        src: "/img/plus.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "texto-iconos",
                                                        children: "Hub"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "cards",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "title-2",
                                                        children: "Cards"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-16",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                                className: "icon-instance-node-2",
                                                                color: colors.secundario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "menu-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "oval-6"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "cardss",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gold",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "div-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-21",
                                                                children: "Credit GOLD ****5849"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon19.TrailingIcon19), {
                                                                className: "trailing-icon"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "balances",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "group-2",
                                                        alt: "Group",
                                                        src: "/img/group-637-2.svg"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-18",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-19",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                        className: "div-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "span",
                                                                                children: [
                                                                                    "T. Balance",
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "text-wrapper-22",
                                                                                children: "$13,000"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-19",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                        className: "div-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "span",
                                                                                children: [
                                                                                    "Debts",
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "text-wrapper-22",
                                                                                children: "$8,000"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-20",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-23",
                                                                children: "Total balance | Debts"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                className: "trailing-icon",
                                                                style: {
                                                                    color: colors.primario
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-22",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-23",
                                                                    children: "Expenses & Incomes"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                    className: "trailing-icon",
                                                                    style: {
                                                                        color: colors.primario
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "chart",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-23",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-6"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-23",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-8"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-24",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-24",
                                                                    children: "September"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-25",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "expenses-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "text-wrapper-24",
                                                                                children: [
                                                                                    "Expenses",
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                    "$2,000"
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "incomes-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "text-wrapper-24",
                                                                                children: [
                                                                                    "Incomes",
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                    "$3,200"
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "banners",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "overlap-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "image-2",
                                                            alt: "Image",
                                                            src: "/img/image-62026.png"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-26",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "image-3",
                                                                    alt: "Image",
                                                                    src: "/img/image-62032.png"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "group-3",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "overlap-group-10",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                                className: "in-all-TACOS",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                        className: "text-wrapper-25",
                                                                                        children: [
                                                                                            "in all",
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "text-wrapper-26",
                                                                                        children: "TACOS"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                                className: "element-OFF",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "text-wrapper-27",
                                                                                        children: "40"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "text-wrapper-28",
                                                                                        children: "%OFF"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "image-4",
                                                alt: "Image",
                                                src: "/img/image-62014.png"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "image-5",
                                                alt: "Image",
                                                src: "/img/image-62011.png"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "image-4",
                                                alt: "Image",
                                                src: "/img/image-62017.png"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "menu",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronsDown1.ChevronsDown1), {
                                            className: "icon-instance-node-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Send"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronsDown2.ChevronsDown2), {
                                            className: "icon-instance-node-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Receive"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 42.000000 40.000000",
                                            preserveAspectRatio: "xMidYMid meet",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
                                                fill: colors.primario,
                                                stroke: colors.primario,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 330 c0 -37 4 -50 13 -47 7 2 12 21 12 47 0 26 -5 45 -12 48 -9 2 -13 -11 -13 -48z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M82 298 l3 -83 53 -3 c42 -2 52 0 52 12 0 12 -11 16 -40 16 -33 0 -40 3 -40 19 0 16 8 20 38 23 37 3 37 3 40 51 l3 47 -56 0 -56 0 3 -82z m78 32 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M232 298 l3 -83 88 -3 87 -3 0 86 0 85 -90 0 -91 0 3 -82z m148 -3 l0 -55 -60 0 -60 0 0 55 0 55 60 0 60 0 0 -55z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M310 294 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 225 c0 -9 5 -15 11 -13 14 5 14 21 0 26 -6 2 -11 -4 -11 -13z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 85 l0 -85 90 0 91 0 -3 83 -3 82 -87 3 -88 3 0 -86z m148 -2 l3 -53 -60 0 -61 0 0 55 0 56 58 -3 57 -3 3 -52z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M87 93 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M230 121 l0 -51 90 0 90 0 0 51 c0 57 -23 66 -28 11 -2 -24 -8 -32 -22 -32 -14 0 -20 9 -22 33 -3 31 -4 32 -55 35 l-53 3 0 -50z m80 -1 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M230 15 c0 -12 13 -15 55 -15 42 0 55 3 55 15 0 12 -13 15 -55 15 -42 0 -55 -3 -55 -15z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M387 24 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "QR"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "single-tab",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "icon-and-text-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M12.25 4C7.563 4 3.75 7.813 3.75 12.5C3.75 17.187 7.563 21 12.25 21C16.937 21 20.75 17.187 20.75 12.5C20.75 7.813 16.937 4 12.25 4ZM12.25 22.5C6.736 22.5 2.25 18.014 2.25 12.5C2.25 6.986 6.736 2.5 12.25 2.5C17.764 2.5 22.25 6.986 22.25 12.5C22.25 18.014 17.764 22.5 12.25 22.5Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M12.25 3.5C7.28686 3.5 3.25 7.53686 3.25 12.5H4.25C4.25 8.08914 7.83914 4.5 12.25 4.5V3.5ZM3.25 12.5C3.25 17.4631 7.28686 21.5 12.25 21.5V20.5C7.83914 20.5 4.25 16.9109 4.25 12.5H3.25ZM12.25 21.5C17.2131 21.5 21.25 17.4631 21.25 12.5H20.25C20.25 16.9109 16.6609 20.5 12.25 20.5V21.5ZM21.25 12.5C21.25 7.53686 17.2131 3.5 12.25 3.5V4.5C16.6609 4.5 20.25 8.08914 20.25 12.5H21.25ZM12.25 22C7.01214 22 2.75 17.7379 2.75 12.5H1.75C1.75 18.2901 6.45986 23 12.25 23V22ZM2.75 12.5C2.75 7.26214 7.01214 3 12.25 3V2C6.45986 2 1.75 6.70986 1.75 12.5H2.75ZM12.25 3C17.4879 3 21.75 7.26214 21.75 12.5H22.75C22.75 6.70986 18.0401 2 12.25 2V3ZM21.75 12.5C21.75 17.7379 17.4879 22 12.25 22V23C18.0401 23 22.75 18.2901 22.75 12.5H21.75Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925Z",
                                                    fill: colors.primario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925",
                                                    stroke: colors.primario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-footer-botones",
                                            children: "Transactions"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"2prk4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/Button":"jfuTO","../../../../../icons/ChevronsDown1":"45OBA","../../../../../icons/ChevronsDown2":"aABvQ","../../../../../icons/Icons1":"gEDpR","../../../../../icons/Icons19":"2OHy7","../../../../../icons/NameMenuDarkTrue":"8A1Jb","../../../../../icons/TrailingIcon14":"1nwir","../../../../../icons/TrailingIcon19":"bdQbQ","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/FrameCorp":"aBd21"}],"2prk4":[function() {},{}],"bdQbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrailingIcon19", ()=>(0, _trailingIcon19.TrailingIcon19));
var _trailingIcon19 = require("./TrailingIcon19");

},{"./TrailingIcon19":"lr2zi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lr2zi":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrailingIcon19", ()=>TrailingIcon19);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TrailingIcon19 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `trailing-icon-19 ${className}`,
        fill: "none",
        height: "19",
        viewBox: "0 0 18 19",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M4.5 7.41016L9 11.9102L13.5 7.41016",
            stroke: "white",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFj7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoCard", ()=>(0, _corporativoCard.CorporativoCard));
var _corporativoCard = require("./CorporativoCard");

},{"./CorporativoCard":"1neFe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1neFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoCard", ()=>CorporativoCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack = require("../../../../../icons/IconArrowBack");
var _regularCopyAlt = require("../../../../../icons/RegularCopyAlt");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _frameCorp = require("../../../../../components/FrameCorp");
var _styleCss = require("./style.css");
const CorporativoCard = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-card",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper-3",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-9",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                        className: "header-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-15"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-43",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frameCorp.FrameCorp), {
                                        color: colors.septimo
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-44",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-arrow-back-wrapper highlighted-button",
                                            onClick: handleButtonBack,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack.IconArrowBack), {
                                                className: "icon-arrow-back-1",
                                                color: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-2",
                                            children: "Card details"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-45",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-46",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-10",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            style: {
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center",
                                                backgroundSize: "contain",
                                                backgroundImage: colors.url_card ? `url(${colors.url_card})` : "none",
                                                backgroundColor: colors.url_card ? "transparent" : "#e8eaed"
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-11",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-9",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group-16"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-47",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-48",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-45",
                                                                        children: "Pay date"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-46",
                                                                        children: "10 ABR"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-48",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-45",
                                                                        children: "Due date"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-46",
                                                                        children: "11/30"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-49",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-47",
                                                                children: "7531 4532 6643 5849"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regularCopyAlt.RegularCopyAlt), {
                                                                className: "regular-copy-alt-2"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "bottom-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "fecha-pago-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-48",
                                                            children: "Available (USD)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-49",
                                                                children: "13,000"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "fecha-pago-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-48",
                                                            children: "Assigned (USD)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-49",
                                                                children: "23,000"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "botonera-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "key",
                                                alt: "Key",
                                                src: "/img/key.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "CVV"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-10",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "overlap-group-17",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-7",
                                                                alt: "Vector",
                                                                src: "/img/vector-5.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-52",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-9"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-10"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-9"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-8",
                                                                alt: "Vector",
                                                                src: "/img/vector-6.svg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "PIN"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "frame-53",
                                                alt: "Frame",
                                                src: "/img/frame-1171274973.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "Pay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-54",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "group-wrapper",
                                                alt: "Regular menu dots",
                                                src: "/img/regular-menu-dots.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "More"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-55",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "tarjtetas-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title-4",
                                                children: "Last Transactions"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-56",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "btn-text-link-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-54",
                                                            children: "See all"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-3",
                                                            alt: "Btn icon chevron",
                                                            src: "/img/btn-icon-chevron-4.svg"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-57",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Dinner",
                                                                src: "/img/dinner-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Starbucks coffee time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $25.11"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Paw",
                                                                src: "/img/paw-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Bruno\u2019s tricks"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $12.42"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "shopping-bag-2",
                                                                alt: "Shopping bag",
                                                                src: "/img/shopping-bag-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "New gymn shoes"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $158.68"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Dinner",
                                                                src: "/img/dinner-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Starbucks coffee time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $25.11"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "shopping-bag-2",
                                                                alt: "Shopping bag",
                                                                src: "/img/shopping-bag-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "New gymn shoes"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $158.68"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Credit card",
                                                                src: "/img/credit-card-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Card payment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-5",
                                                                children: "$950.23"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"dXC00","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack":"dgOyH","../../../../../icons/RegularCopyAlt":"9klXy","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/FrameCorp":"aBd21"}],"dXC00":[function() {},{}],"3GLaK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasy", ()=>(0, _corporativoOnboardingTutorialEasy.CorporativoOnboardingTutorialEasy));
var _corporativoOnboardingTutorialEasy = require("./CorporativoOnboardingTutorialEasy");

},{"./CorporativoOnboardingTutorialEasy":"8ddPe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ddPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasy", ()=>CorporativoOnboardingTutorialEasy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sliderDots = require("../../../../../components/SliderDots");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingTutorialEasy = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-login-corporativo-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_steppper-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen-totirial",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-3",
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 100,
                                height: 100,
                                viewBox: "0 0 151 150",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 104.5,
                                        cy: 103,
                                        r: 26,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M100.109 109.207C100.327 109.425 100.585 109.598 100.87 109.716C101.154 109.834 101.459 109.894 101.767 109.894C102.075 109.894 102.38 109.834 102.665 109.716C102.949 109.598 103.208 109.425 103.425 109.207L112.261 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.952 99.3114 113.025 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.868 97.7535C112.751 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.859 96.5636 111.565 96.4452C111.27 96.3268 110.955 96.2695 110.637 96.2767C110.32 96.284 110.007 96.3556 109.718 96.4874C109.429 96.6191 109.17 96.8081 108.957 97.043L101.773 104.227L98.2574 100.711C98.0438 100.476 97.7847 100.287 97.4959 100.155C97.207 100.024 96.8944 99.952 96.5769 99.9447C96.2595 99.9375 95.944 99.9948 95.6494 100.113C95.3548 100.232 95.0873 100.409 94.8632 100.633C94.6391 100.858 94.4631 101.126 94.3457 101.421C94.2283 101.716 94.1721 102.032 94.1805 102.35C94.1889 102.667 94.2616 102.979 94.3944 103.268C94.5271 103.556 94.7171 103.815 94.9527 104.027L100.109 109.207Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M42.0895 37.8866L50.8903 28.0194C51.095 27.7886 51.2522 27.5197 51.3529 27.2281C51.4537 26.9365 51.496 26.6279 51.4775 26.32C51.459 26.012 51.3801 25.7107 51.2451 25.4333C51.1102 25.1559 50.9219 24.9077 50.6911 24.703C50.4602 24.4984 50.1913 24.3412 49.8998 24.2404C49.6082 24.1396 49.2996 24.0973 48.9916 24.1158C48.6837 24.1343 48.3824 24.2133 48.1049 24.3482C47.8275 24.4832 47.5794 24.6714 47.3747 24.9023L38.5856 34.7694C38.1722 35.2356 37.961 35.847 37.9984 36.4689C38.0357 37.0909 38.3186 37.6725 38.7848 38.0859C39.251 38.4992 39.8623 38.7105 40.4843 38.6731C41.1062 38.6357 41.6879 38.3528 42.1012 37.8866H42.0895Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M25.4958 38.0741C25.9581 37.6603 26.2375 37.08 26.2726 36.4606C26.3078 35.8411 26.0958 35.2329 25.6833 34.7695L16.9059 24.9023C16.4926 24.4361 15.9109 24.1532 15.289 24.1158C14.667 24.0784 14.0557 24.2897 13.5895 24.703C13.1233 25.1164 12.8404 25.698 12.8031 26.32C12.7657 26.9419 12.9769 27.5532 13.3903 28.0194L22.1794 37.8866C22.3844 38.1173 22.633 38.3052 22.9109 38.4395C23.1888 38.5738 23.4905 38.6519 23.7986 38.6693C24.1068 38.6868 24.4153 38.6431 24.7066 38.541C24.9978 38.4389 25.266 38.2802 25.4958 38.0741Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Easy and Complete"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "all-you-need-in-your",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "id-diamond-down highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1233 6.67194L0.00488281 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-wrapper highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1235 6.67194L0.00512695 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "img-slider-dots",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "slider-dots-instance",
                            status: "off"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "design-component-instance-node",
                            status: "on"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-2"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"kBVr4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/SliderDots":"gfhZb","../../../../../hooks/useDynamicColors":"b2GRH"}],"kBVr4":[function() {},{}],"gfhZb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderDots", ()=>(0, _sliderDots.SliderDots));
var _sliderDots = require("./SliderDots");

},{"./SliderDots":"OkDSH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"OkDSH":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderDots", ()=>SliderDots);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const SliderDots = ({ status, className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `slider-dots ${status} ${className}`
    });
};
SliderDots.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"cI2jO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cI2jO":[function() {},{}],"jTin8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcome", ()=>(0, _corporativoOnboardingWelcome.CorporativoOnboardingWelcome));
var _corporativoOnboardingWelcome = require("./CorporativoOnboardingWelcome");

},{"./CorporativoOnboardingWelcome":"lMGam","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lMGam":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcome", ()=>CorporativoOnboardingWelcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingWelcome = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 129,
                                height: 130,
                                viewBox: "0 0 129 130",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 28.5,
                                        cy: 108,
                                        r: 22,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M109.38 84.5799C109.415 83.6859 109.267 82.7942 108.943 81.9599C108.62 81.1257 108.129 80.3667 107.5 79.7299C105.43 77.7299 101.84 76.8699 95.5002 76.9899C88.9738 77.2737 82.4885 78.171 76.1302 79.6699C72.1334 80.5412 68.1929 81.6533 64.3302 82.9999C61.3302 83.9999 59.2602 84.7099 56.8502 84.7099H56.7602C55.988 84.7516 55.2175 84.5997 54.5189 84.2679C53.8204 83.936 53.2158 83.4349 52.7602 82.8099C52.3251 82.1192 52.0657 81.3325 52.0047 80.5184C51.9437 79.7044 52.0829 78.8877 52.4102 78.1399C54.0075 73.7814 54.6188 69.123 54.2002 64.4999C53.5402 58.0499 50.3302 54.3399 45.3802 54.2999C44.6068 54.2524 43.8321 54.3686 43.1067 54.6409C42.3813 54.9131 41.7214 55.3353 41.1702 55.8799C39.3602 57.7599 39.3302 60.6199 39.4602 63.6299C39.5702 66.3699 36.5902 69.1599 34.8102 70.8299C30.8102 74.6099 27.7302 80.1299 27.0602 84.8899C26.9602 85.5999 26.8902 86.2499 26.8202 86.8899C26.8063 87.9491 26.5855 88.9954 26.1702 89.9699C24.1746 91.7691 22.0742 93.4487 19.8802 94.9999C19.6679 95.1569 19.4888 95.3544 19.3532 95.5809C19.2176 95.8075 19.1283 96.0586 19.0902 96.3199C19.0902 96.5699 18.2802 102.46 24.2402 110.03C28.5102 115.46 34.6102 117.91 38.5402 117.91H38.6802C39.269 117.965 39.8625 117.879 40.4118 117.66C40.9611 117.441 41.4506 117.095 41.8402 116.65C42.8402 115.26 46.7102 111.06 48.2402 110.24C52.1102 108.15 56.0102 106.24 59.5202 104.69C67.8202 104.53 89.0102 104.39 93.8102 105.58C94.6146 105.782 95.4409 105.882 96.2702 105.88C99.8802 105.88 103.64 104.07 104.8 100.39C105.198 99.3389 105.369 98.2161 105.304 97.0944C105.238 95.9728 104.937 94.8775 104.42 93.8799C104.039 93.2041 103.553 92.5931 102.98 92.0699C108.13 90.3499 109.36 87.1699 109.38 84.5799ZM100.99 99.1899C100.29 101.4 97.1502 102.29 94.7802 101.7C90.8402 100.7 78.6502 100.56 69.5802 100.59L70.5202 100.24C79.0683 96.9923 87.9385 94.6658 96.9802 93.2999C98.9802 93.8799 100.32 94.7399 100.91 95.8099C101.154 96.338 101.286 96.9103 101.3 97.4916C101.314 98.0729 101.208 98.6509 100.99 99.1899ZM98.8302 88.9999C82.7602 91.4599 74.2302 94.6399 69.1302 96.5399L67.6202 96.9999C60.3156 99.7404 53.2059 102.975 46.3402 106.68C44.0102 107.93 40.1402 112.35 38.9102 113.87C37.2802 114.1 31.5202 112.79 27.3802 107.52C23.6702 102.81 23.1002 99.1199 23.0402 97.6099C24.9202 96.1999 28.4802 93.4699 29.3502 92.3499C30.3502 90.9999 30.5802 89.3499 30.8202 87.2699C30.8802 86.7099 30.9502 86.0999 31.0402 85.4299C31.5902 81.5699 34.2102 76.8699 37.5702 73.7299C39.7002 71.7299 43.6702 68.0099 43.4702 63.4399C43.4102 62.0399 43.3002 59.4399 44.0702 58.6399C44.1602 58.5499 44.4202 58.2799 45.3402 58.2799C48.1302 58.2799 49.7702 60.5199 50.2102 64.8899C50.5909 68.903 50.0751 72.9505 48.7002 76.7399C48.1404 78.091 47.9206 79.5588 48.0601 81.0145C48.1996 82.4703 48.6941 83.8697 49.5002 85.0899C50.3193 86.2452 51.4099 87.1814 52.6759 87.8161C53.9419 88.4508 55.3445 88.7646 56.7602 88.7299C59.8802 88.7299 62.2902 87.9399 65.6302 86.8199C69.38 85.5055 73.2073 84.4234 77.0902 83.5799C83.1849 82.1356 89.4027 81.2718 95.6602 80.9999C100.52 80.9099 103.56 81.4399 104.72 82.5899C104.971 82.854 105.16 83.1703 105.274 83.516C105.388 83.8618 105.424 84.2285 105.38 84.5899C105.37 85.3899 105.35 87.9999 98.8302 88.9999Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M38.2202 44C38.3702 44 53.6402 46.28 59.9402 52.58C66.2402 58.88 68.5002 74.13 68.5002 74.28C68.5002 74.8104 68.7109 75.3191 69.086 75.6942C69.4611 76.0693 69.9698 76.28 70.5002 76.28C71.0306 76.28 71.5394 76.0693 71.9144 75.6942C72.2895 75.3191 72.5002 74.8104 72.5002 74.28C72.5002 74.13 74.7802 58.86 81.0802 52.56C87.3802 46.26 102.63 44 102.78 44C103.311 44 103.819 43.7893 104.194 43.4142C104.57 43.0391 104.78 42.5304 104.78 42C104.78 41.4695 104.57 40.9608 104.194 40.5858C103.819 40.2107 103.311 40 102.78 40C102.63 40 87.3602 37.72 81.0602 31.42C74.7602 25.12 72.5002 9.86997 72.5002 9.71997C72.5002 9.18954 72.2895 8.68083 71.9144 8.30576C71.5394 7.93068 71.0306 7.71997 70.5002 7.71997C69.9698 7.71997 69.4611 7.93068 69.086 8.30576C68.7109 8.68083 68.5002 9.18954 68.5002 9.71997C68.5002 9.86997 66.2202 25.14 59.9202 31.44C53.6202 37.74 38.3702 40 38.2202 40C37.6898 40 37.1811 40.2107 36.806 40.5858C36.4309 40.9608 36.2202 41.4695 36.2202 42C36.2202 42.5304 36.4309 43.0391 36.806 43.4142C37.1811 43.7893 37.6898 44 38.2202 44ZM62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M88.4999 26C89.0295 25.9978 89.5366 25.7856 89.9099 25.41L93.9099 21.41C94.2376 21.0274 94.4088 20.5353 94.3893 20.0319C94.3699 19.5286 94.1612 19.0511 93.805 18.6949C93.4488 18.3387 92.9714 18.1301 92.468 18.1106C91.9647 18.0912 91.4725 18.2624 91.0899 18.59L87.0899 22.59C86.8119 22.8697 86.6228 23.2253 86.5463 23.6122C86.4698 23.999 86.5094 24.3999 86.6601 24.7643C86.8108 25.1287 87.0658 25.4404 87.3932 25.6603C87.7205 25.8802 88.1056 25.9984 88.4999 26Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M87.0899 58.5899C86.7174 58.9646 86.5083 59.4715 86.5083 59.9999C86.5083 60.5283 86.7174 61.0352 87.0899 61.4099L91.0899 65.4099C91.4725 65.7375 91.9646 65.9087 92.468 65.8893C92.9713 65.8699 93.4488 65.6612 93.805 65.305C94.1612 64.9488 94.3699 64.4713 94.3893 63.968C94.4087 63.4646 94.2375 62.9725 93.9099 62.5899L89.9099 58.5899C89.5352 58.2174 89.0283 58.0083 88.4999 58.0083C87.9715 58.0083 87.4646 58.2174 87.0899 58.5899Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M51.0898 25.41C51.4724 25.7377 51.9646 25.9089 52.4679 25.8895C52.9713 25.87 53.4487 25.6614 53.8049 25.3052C54.1611 24.949 54.3698 24.4715 54.3892 23.9682C54.4087 23.4648 54.2375 22.9726 53.9098 22.59L49.9098 18.59C49.5272 18.2624 49.035 18.0912 48.5317 18.1106C48.0283 18.1301 47.5509 18.3387 47.1947 18.6949C46.8385 19.0511 46.6298 19.5286 46.6104 20.0319C46.5909 20.5353 46.7621 21.0274 47.0898 21.41L51.0898 25.41Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Your account has been opened"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "all-you-need-in-your",
                    children: "Enjoy all the benefits of our App"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2",
                    onClick: handleButtonClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "highlighted-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                            className: "test-button-4 highlighted-button",
                            disabled: "off",
                            endIcon: false,
                            label: "Let\u2019s start!",
                            onColor: "off",
                            size: "large",
                            startIcon: false,
                            textClassName: "test-button-5",
                            type: "primary"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"ePnGu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../hooks/useDynamicColors":"b2GRH"}],"ePnGu":[function() {},{}],"71qD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepper", ()=>(0, _corporativoOnboardingStepper.CorporativoOnboardingStepper));
var _corporativoOnboardingStepper = require("./CorporativoOnboardingStepper");

},{"./CorporativoOnboardingStepper":"221pz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"221pz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepper", ()=>CorporativoOnboardingStepper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingStepper = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_card_id-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-stepper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Open account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "battery",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "capacity-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "capacity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "cap",
                                                alt: "Cap",
                                                src: "/img/cap-2.svg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "wifi",
                                        alt: "Wifi",
                                        src: "/img/wifi.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "cellular-connection",
                                        alt: "Cellular connection",
                                        src: "/img/cellular-connection.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "navs-statusbar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7",
                                        children: "9:50"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons",
                                        alt: "Icons",
                                        src: "/img/icons-6.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                            className: "header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-4",
                                        children: "Terms and Conditions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-4"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 180,
                                                            height: 170,
                                                            viewBox: "0 0 200 190",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.75
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 72,
                            height: 72,
                            viewBox: "0 0 72 72",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.5 72L38.893 59.6009C37.7023 58.4299 37.7023 56.5528 38.893 55.399L51.5 43L64.107 55.399C65.2977 56.5701 65.2977 58.4471 64.107 59.6009L51.5 72Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.75 66.9375H20.25C18.609 66.9375 17.0352 66.2856 15.8748 65.1252C14.7144 63.9648 14.0625 62.391 14.0625 60.75V18C14.0625 16.359 14.7144 14.7852 15.8748 13.6248C17.0352 12.4644 18.609 11.8125 20.25 11.8125H23.0625V11.25C23.0625 9.60897 23.7144 8.03516 24.8748 6.87478C26.0352 5.7144 27.609 5.0625 29.25 5.0625C30.8874 5.07428 32.4544 5.72996 33.6122 6.8878C34.77 8.04563 35.4257 9.61261 35.4375 11.25V11.8125H43.1325C43.948 11.811 44.7557 11.9713 45.5089 12.2841C46.262 12.597 46.9456 13.0561 47.52 13.635L56.115 22.23C56.6939 22.8044 57.153 23.488 57.4659 24.2411C57.7787 24.9943 57.939 25.802 57.9375 26.6175V60.75C57.9375 62.391 57.2856 63.9648 56.1252 65.1252C54.9648 66.2856 53.391 66.9375 51.75 66.9375ZM20.25 15.1875C19.5041 15.1875 18.7887 15.4838 18.2613 16.0113C17.7338 16.5387 17.4375 17.2541 17.4375 18V60.75C17.4375 61.4959 17.7338 62.2113 18.2613 62.7387C18.7887 63.2662 19.5041 63.5625 20.25 63.5625H51.75C52.4959 63.5625 53.2113 63.2662 53.7387 62.7387C54.2662 62.2113 54.5625 61.4959 54.5625 60.75V28.6875H45C43.9575 28.6816 42.9594 28.2649 42.2223 27.5277C41.4851 26.7906 41.0684 25.7925 41.0625 24.75V15.1875H35.4375V20.25C35.4375 21.891 34.7856 23.4648 33.6252 24.6252C32.4648 25.7856 30.891 26.4375 29.25 26.4375C27.609 26.4375 26.0352 25.7856 24.8748 24.6252C23.7144 23.4648 23.0625 21.891 23.0625 20.25C23.0625 19.8024 23.2403 19.3732 23.5568 19.0568C23.8732 18.7403 24.3024 18.5625 24.75 18.5625C25.1976 18.5625 25.6268 18.7403 25.9432 19.0568C26.2597 19.3732 26.4375 19.8024 26.4375 20.25C26.4375 20.9959 26.7338 21.7113 27.2613 22.2387C27.7887 22.7662 28.5041 23.0625 29.25 23.0625C29.9959 23.0625 30.7113 22.7662 31.2387 22.2387C31.7662 21.7113 32.0625 20.9959 32.0625 20.25V15.1875H20.25ZM44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025ZM26.4375 11.8125H32.0625V11.25C32.0651 10.8861 31.9948 10.5254 31.8557 10.1892C31.7166 9.85301 31.5115 9.5481 31.2525 9.2925C30.8663 8.88491 30.3661 8.60333 29.8173 8.48457C29.2685 8.36582 28.6967 8.41541 28.1765 8.62688C27.6563 8.83834 27.2121 9.20184 26.9018 9.66983C26.5916 10.1378 26.4297 10.6886 26.4375 11.25V11.8125ZM47.25 55.6875H24.75C24.3024 55.6875 23.8732 55.5097 23.5568 55.1932C23.2403 54.8768 23.0625 54.4476 23.0625 54C23.0625 53.5524 23.2403 53.1232 23.5568 52.8068C23.8732 52.4903 24.3024 52.3125 24.75 52.3125H47.25C47.6976 52.3125 48.1268 52.4903 48.4432 52.8068C48.7597 53.1232 48.9375 53.5524 48.9375 54C48.9375 54.4476 48.7597 54.8768 48.4432 55.1932C48.1268 55.5097 47.6976 55.6875 47.25 55.6875ZM47.25 46.6875H24.75C24.3024 46.6875 23.8732 46.5097 23.5568 46.1932C23.2403 45.8768 23.0625 45.4476 23.0625 45C23.0625 44.5524 23.2403 44.1232 23.5568 43.8068C23.8732 43.4903 24.3024 43.3125 24.75 43.3125H47.25C47.6976 43.3125 48.1268 43.4903 48.4432 43.8068C48.7597 44.1232 48.9375 44.5524 48.9375 45C48.9375 45.4476 48.7597 45.8768 48.4432 46.1932C48.1268 46.5097 47.6976 46.6875 47.25 46.6875ZM33.75 37.6875H24.75C24.3024 37.6875 23.8732 37.5097 23.5568 37.1932C23.2403 36.8768 23.0625 36.4476 23.0625 36C23.0625 35.5524 23.2403 35.1232 23.5568 34.8068C23.8732 34.4903 24.3024 34.3125 24.75 34.3125H33.75C34.1976 34.3125 34.6268 34.4903 34.9432 34.8068C35.2597 35.1232 35.4375 35.5524 35.4375 36C35.4375 36.4476 35.2597 36.8768 34.9432 37.1932C34.6268 37.5097 34.1976 37.6875 33.75 37.6875Z",
                                    fill: colors.primario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025Z",
                                    fill: colors.sexto
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subtitle-5",
                            children: "Welcome!"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "subtitle-6",
                            children: "Let\u2019s open your online account"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Accept Terms and Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Register your Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-7",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Scan your ID card"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: " Validate your identity"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Register your Mobile number"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Generate your credentials"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"2P0ti","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"2P0ti":[function() {},{}],"jQTyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardId", ()=>(0, _corporativoOnboardingCardId.CorporativoOnboardingCardId));
var _corporativoOnboardingCardId = require("./CorporativoOnboardingCardId");

},{"./CorporativoOnboardingCardId":"2y5RZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2y5RZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardId", ()=>CorporativoOnboardingCardId);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _iconChevronDown1 = require("../../../../../icons/IconChevronDown1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingCardId = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-13",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line-3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-14",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-4"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-7",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-3",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 98,
                            height: 73,
                            viewBox: "0 0 98 73",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-13",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-14",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-15",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "subtitle-11",
                                            children: "Now, get your ID card"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "subtitle-12",
                                        children: [
                                            "We will take a photo of the front & back.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Photos will be captured automatically."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "e-mail",
                                    children: "Country"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-16",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-17",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-15",
                                                children: "Select your country"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconChevronDown1.IconChevronDown1), {
                                                className: "icon-chevron-down",
                                                color: "#5C5C5C"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-4 highlighted-button",
                        onClick: handleButtonClickLogin,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-wrapper-16",
                            children: "I\xb4ve got my ID card!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-9",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-18",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-1-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1-instance"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-13",
                                        children: "Scan ID Card"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-13",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-14",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-5",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-6"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-19",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"gXRVJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../icons/IconChevronDown1":"ccPWd","../../../../../hooks/useDynamicColors":"b2GRH"}],"gXRVJ":[function() {},{}],"cdwRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconArrowBack1", ()=>(0, _iconArrowBack1.IconArrowBack1));
var _iconArrowBack1 = require("./IconArrowBack1");

},{"./IconArrowBack1":"2pl7E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pl7E":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconArrowBack1", ()=>IconArrowBack1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconArrowBack1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-arrow-back-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            clipRule: "evenodd",
            d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11V11Z",
            fill: "white",
            fillRule: "evenodd"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ccPWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconChevronDown1", ()=>(0, _iconChevronDown1.IconChevronDown1));
var _iconChevronDown1 = require("./IconChevronDown1");

},{"./IconChevronDown1":"hpCaT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hpCaT":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconChevronDown1", ()=>IconChevronDown1);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconChevronDown1 = ({ color = "#5C5C5C", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-chevron-down-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M16.293 9.293L12 13.586L7.707 9.293L6.293 10.707L12 16.414L17.707 10.707L16.293 9.293Z",
            fill: color
        })
    });
};
IconChevronDown1.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9BQzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhone", ()=>(0, _corporativoOnboardingPhone.CorporativoOnboardingPhone));
var _corporativoOnboardingPhone = require("./CorporativoOnboardingPhone");

},{"./CorporativoOnboardingPhone":"jYedm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jYedm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhone", ()=>CorporativoOnboardingPhone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _componenteToken = require("../../../../../components/ComponenteToken");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingPhone = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_welcome-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-8",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-10",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-2"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "atomo-step-final-no",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-2",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 65,
                            height: 87,
                            viewBox: "0 0 65 87",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z",
                                    fill: colors.sexto
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "subtitle-9",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "span",
                                            children: [
                                                "A validation code has been sent to\xa0\xa0",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-11",
                                            children: "+54 9 1122 6476"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteToken.ComponenteToken), {
                            active: false,
                            atomoTimeRectangleClassName: "componente-token-5",
                            atomoTimeSubtitleCopyClassName: "componente-token-3",
                            atomoTimeSubtitleCopyClassNameOverride: "componente-token-3",
                            atomoTimeTimelineClassName: "componente-token-4",
                            buttonActive: true,
                            buttonInactive: false,
                            buttonSmallEstado: "inactivo",
                            buttonSmallTextClassName: "componente-token-6",
                            buttonSmallTexto: "Resend code",
                            className: "componente-token-input",
                            default1: true,
                            error: false,
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName1: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName2: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenText: "8",
                            moleculaTokenNumbsAtomoNumbTokenText1: "4",
                            moleculaTokenNumbsAtomoNumbTokenText2: "9",
                            moleculaTokenNumbsAtomoNumbTokenText3: "6",
                            moleculaTokenNumbsDefaultFalseActiveClassName: "componente-token-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2 highlighted-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-3 ",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-12",
                            children: "Validate"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-10",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-5"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-10",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-10",
                                        children: "Register Mobile number"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"6Lqpl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteToken":"1K7Wn","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../hooks/useDynamicColors":"b2GRH"}],"6Lqpl":[function() {},{}],"1K7Wn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteToken", ()=>(0, _componenteToken.ComponenteToken));
var _componenteToken = require("./ComponenteToken");

},{"./ComponenteToken":"6D4pA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6D4pA":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteToken", ()=>ComponenteToken);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _atomoTime = require("../AtomoTime");
var _buttonSmall = require("../ButtonSmall");
var _moleculaTokenNumbs = require("../MoleculaTokenNumbs");
var _styleCss = require("./style.css");
const ComponenteToken = ({ default1, buttonActive, active, error, buttonInactive, className, moleculaTokenNumbsAtomoNumbTokenElementClassName, moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName, moleculaTokenNumbsAtomoNumbTokenText, moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride, moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride, moleculaTokenNumbsAtomoNumbTokenText1, moleculaTokenNumbsAtomoNumbTokenDivClassName, moleculaTokenNumbsAtomoNumbTokenText2, moleculaTokenNumbsAtomoNumbTokenText3, moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName, moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride, moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride, moleculaTokenNumbsDefaultFalseActiveClassName, moleculaTokenNumbsAtomoNumbTokenElementClassName1, moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1, moleculaTokenNumbsAtomoNumbTokenElementClassName2, moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2, atomoTimeSubtitleCopyClassName, atomoTimeTimelineClassName, atomoTimeRectangleClassName, atomoTimeSubtitleCopyClassNameOverride, buttonSmallTexto = "Lorem ipsum", buttonSmallTextClassName, buttonSmallEstado = "activo" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `componente-token active-${active} ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moleculaTokenNumbs.MoleculaTokenNumbs), {
                active: active ? true : undefined,
                atomoNumbTokenAtomoNumbTokenClassName: moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride,
                atomoNumbTokenAtomoNumbTokenClassName1: moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName,
                atomoNumbTokenAtomoNumbTokenClassName2: moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2,
                atomoNumbTokenAtomoNumbTokenClassNameOverride: moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride,
                atomoNumbTokenDivClassName: moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride,
                atomoNumbTokenDivClassNameOverride: moleculaTokenNumbsAtomoNumbTokenElementClassName1,
                atomoNumbTokenElementClassName: moleculaTokenNumbsAtomoNumbTokenDivClassName,
                atomoNumbTokenElementClassName1: moleculaTokenNumbsAtomoNumbTokenElementClassName,
                atomoNumbTokenElementClassName2: moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride,
                atomoNumbTokenElementClassNameOverride: moleculaTokenNumbsAtomoNumbTokenElementClassName2,
                atomoNumbTokenElementWrapperClassName: moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName,
                atomoNumbTokenElementWrapperClassNameOverride: moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1,
                atomoNumbTokenText: moleculaTokenNumbsAtomoNumbTokenText1,
                atomoNumbTokenText1: moleculaTokenNumbsAtomoNumbTokenText3,
                atomoNumbTokenText2: moleculaTokenNumbsAtomoNumbTokenText,
                atomoNumbTokenText3: moleculaTokenNumbsAtomoNumbTokenText2,
                className: moleculaTokenNumbsDefaultFalseActiveClassName,
                default1: !default1 ? false : true,
                error: error ? true : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTime.AtomoTime), {
                className: "atomo-time-instance",
                rectangleClassName: atomoTimeRectangleClassName,
                subtitleCopyClassName: atomoTimeSubtitleCopyClassNameOverride,
                subtitleCopyClassNameOverride: atomoTimeSubtitleCopyClassName,
                timelineClassName: atomoTimeTimelineClassName
            }),
            (buttonActive || buttonInactive) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSmall.ButtonSmall), {
                className: "button-small-instance",
                estado: buttonSmallEstado,
                iconLeft: false,
                iconRigth: false,
                textClassName: buttonSmallTextClassName,
                texto: buttonSmallTexto,
                tipo: "link"
            })
        ]
    });
};
ComponenteToken.propTypes = {
    default1: (0, _propTypesDefault.default).bool,
    buttonActive: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).bool,
    buttonInactive: (0, _propTypesDefault.default).bool,
    moleculaTokenNumbsAtomoNumbTokenText: (0, _propTypesDefault.default).string,
    moleculaTokenNumbsAtomoNumbTokenText1: (0, _propTypesDefault.default).string,
    moleculaTokenNumbsAtomoNumbTokenText2: (0, _propTypesDefault.default).string,
    moleculaTokenNumbsAtomoNumbTokenText3: (0, _propTypesDefault.default).string,
    buttonSmallTexto: (0, _propTypesDefault.default).string,
    buttonSmallEstado: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../AtomoTime":"djEQ8","../ButtonSmall":"6rhhx","../MoleculaTokenNumbs":"iitiW","./style.css":"7jQGl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"djEQ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoTime", ()=>(0, _atomoTime.AtomoTime));
var _atomoTime = require("./AtomoTime");

},{"./AtomoTime":"1ik7Y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ik7Y":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoTime", ()=>AtomoTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const AtomoTime = ({ className, timelineClassName, rectangleClassName, subtitleCopyClassName, subtitleCopyClassNameOverride })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `atomo-time ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `timeline ${timelineClassName}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `rectangle ${rectangleClassName}`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "time-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `subtitle-copy ${subtitleCopyClassName}`,
                        children: "Time remaining:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `div ${subtitleCopyClassNameOverride}`,
                        children: "1:50"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./style.css":"3crG8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3crG8":[function() {},{}],"6rhhx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonSmall", ()=>(0, _buttonSmall.ButtonSmall));
var _buttonSmall = require("./ButtonSmall");

},{"./ButtonSmall":"9EWAa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EWAa":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonSmall", ()=>ButtonSmall);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsCalendar1 = require("../../icons/IconsCalendar1");
var _styleCss = require("./style.css");
const ButtonSmall = ({ texto = "Lorem ipsum", tipo, estado, iconLeft, iconRigth, className, textClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `button-small ${tipo} ${estado} ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `content-2 icon-left-${iconLeft} icon-rigth-${iconRigth}`,
            children: [
                !iconLeft && !iconRigth && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `text ${textClassName}`,
                    children: texto
                }),
                iconRigth && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `text-2 ${textClassName}`,
                    children: texto
                }),
                (iconLeft || iconRigth) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsCalendar1.IconsCalendar1), {
                    className: "icons-calendar",
                    color: estado === "activo" && tipo === "primario" ? "white" : estado === "inactivo" && [
                        "primario",
                        "secundario"
                    ].includes(tipo) ? "#969696" : tipo === "link" && estado === "inactivo" ? "#ABABAB" : "#6773E5"
                }),
                iconLeft && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-3",
                    children: texto
                })
            ]
        })
    });
};
ButtonSmall.propTypes = {
    texto: (0, _propTypesDefault.default).string,
    tipo: (0, _propTypesDefault.default).oneOf([
        "link",
        "secundario",
        "primario"
    ]),
    estado: (0, _propTypesDefault.default).oneOf([
        "activo",
        "inactivo"
    ]),
    iconLeft: (0, _propTypesDefault.default).bool,
    iconRigth: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/IconsCalendar1":"ekeiM","./style.css":"cZLqA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekeiM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsCalendar1", ()=>(0, _iconsCalendar1.IconsCalendar1));
var _iconsCalendar1 = require("./IconsCalendar1");

},{"./IconsCalendar1":"bol2w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bol2w":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsCalendar1", ()=>IconsCalendar1);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsCalendar1 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icons-calendar-1 ${className}`,
        fill: "none",
        height: "20",
        viewBox: "0 0 21 20",
        width: "21",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M6.7963 9.33325H8.27778V10.6666H6.7963V9.33325ZM6.7963 11.9999H8.27778V13.3333H6.7963V11.9999ZM9.75926 9.33325H11.2407V10.6666H9.75926V9.33325ZM9.75926 11.9999H11.2407V13.3333H9.75926V11.9999ZM12.7222 9.33325H14.2037V10.6666H12.7222V9.33325ZM12.7222 11.9999H14.2037V13.3333H12.7222V11.9999Z",
                fill: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M5.31481 16.6666H15.6852C16.5022 16.6666 17.1667 16.0686 17.1667 15.3333V5.99992C17.1667 5.26459 16.5022 4.66659 15.6852 4.66659H14.2037V3.33325H12.7222V4.66659H8.27777V3.33325H6.79629V4.66659H5.31481C4.49777 4.66659 3.83333 5.26459 3.83333 5.99992V15.3333C3.83333 16.0686 4.49777 16.6666 5.31481 16.6666ZM15.6852 7.33325L15.6859 15.3333H5.31481V7.33325H15.6852Z",
                fill: color
            })
        ]
    });
};
IconsCalendar1.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZLqA":[function() {},{}],"iitiW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoleculaTokenNumbs", ()=>(0, _moleculaTokenNumbs.MoleculaTokenNumbs));
var _moleculaTokenNumbs = require("./MoleculaTokenNumbs");

},{"./MoleculaTokenNumbs":"aw13v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aw13v":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoleculaTokenNumbs", ()=>MoleculaTokenNumbs);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _atomoNumbToken = require("../AtomoNumbToken");
var _styleCss = require("./style.css");
const MoleculaTokenNumbs = ({ default1, active, error, className, atomoNumbTokenElementClassName, atomoNumbTokenAtomoNumbTokenClassName, atomoNumbTokenElementClassNameOverride, atomoNumbTokenAtomoNumbTokenClassNameOverride, atomoNumbTokenDivClassName, atomoNumbTokenText, atomoNumbTokenElementWrapperClassName, atomoNumbTokenDivClassNameOverride, atomoNumbTokenText1, atomoNumbTokenElementWrapperClassNameOverride, atomoNumbTokenElementClassName1, atomoNumbTokenText2, atomoNumbTokenAtomoNumbTokenClassName1, atomoNumbTokenElementClassName2, atomoNumbTokenText3, atomoNumbTokenAtomoNumbTokenClassName2 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `molecula-token-numbs ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "numbs",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenAtomoNumbTokenClassName,
                            elementClassName: atomoNumbTokenElementClassName,
                            hasElement: !active ? false : undefined,
                            text: active ? "0" : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenAtomoNumbTokenClassNameOverride,
                            elementClassName: atomoNumbTokenElementClassNameOverride,
                            hasElement: !active ? false : undefined,
                            text: active ? "0" : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenElementWrapperClassName,
                            elementClassName: atomoNumbTokenDivClassName,
                            hasElement: !active ? false : undefined,
                            text: atomoNumbTokenText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenElementWrapperClassNameOverride,
                            elementClassName: atomoNumbTokenDivClassNameOverride,
                            hasElement: !active ? false : undefined,
                            text: atomoNumbTokenText1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenAtomoNumbTokenClassName1,
                            elementClassName: atomoNumbTokenElementClassName1,
                            hasElement: !active ? false : undefined,
                            text: atomoNumbTokenText2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoNumbToken.AtomoNumbToken), {
                            className: atomoNumbTokenAtomoNumbTokenClassName2,
                            elementClassName: atomoNumbTokenElementClassName2,
                            hasElement: !active ? false : undefined,
                            text: atomoNumbTokenText3
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-wrapper",
                    children: "Mensaje de error del campo"
                })
            ]
        })
    });
};
MoleculaTokenNumbs.propTypes = {
    default1: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).bool,
    atomoNumbTokenText: (0, _propTypesDefault.default).string,
    atomoNumbTokenText1: (0, _propTypesDefault.default).string,
    atomoNumbTokenText2: (0, _propTypesDefault.default).string,
    atomoNumbTokenText3: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../AtomoNumbToken":"1KXnF","./style.css":"dVeE1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1KXnF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoNumbToken", ()=>(0, _atomoNumbToken.AtomoNumbToken));
var _atomoNumbToken = require("./AtomoNumbToken");

},{"./AtomoNumbToken":"jplkG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jplkG":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoNumbToken", ()=>AtomoNumbToken);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const AtomoNumbToken = ({ className, elementClassName, text = "0", hasElement = true })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `atomo-numb-token ${className}`,
        children: hasElement && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `element ${elementClassName}`,
            children: text
        })
    });
};
AtomoNumbToken.propTypes = {
    text: (0, _propTypesDefault.default).string,
    hasElement: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"eCfe0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eCfe0":[function() {},{}],"dVeE1":[function() {},{}],"7jQGl":[function() {},{}],"49Gaw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingLoginWeb", ()=>(0, _corporativoBusinessBankingLoginWeb.CorporativoBusinessBankingLoginWeb));
var _corporativoBusinessBankingLoginWeb = require("./CorporativoBusinessBankingLoginWeb");

},{"./CorporativoBusinessBankingLoginWeb":"6KOaL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6KOaL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingLoginWeb", ()=>CorporativoBusinessBankingLoginWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _reactRouterDom = require("react-router-dom");
var _componenteTabsWeb = require("../../../../../components/ComponenteTabsWeb");
var _componenteText = require("../../../../../components/ComponenteText");
var _iconsOpenEye1 = require("../../../../../icons/IconsOpenEye1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingLoginWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-signup-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-login",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-cbblw"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteTabsWeb.ComponenteTabsWeb), {
                                                        login: true,
                                                        signup: false,
                                                        atomoTabDivClassName: "componente-tabs-web-2",
                                                        atomoTabDivClassNameOverride: "componente-tabs-web-2",
                                                        atomoTabFrameClassName: "componente-tabs-web-instance",
                                                        atomoTabFrameClassNameOverride: "componente-tabs-web-3",
                                                        atomoTabLine: "/img/line-49-2.svg",
                                                        atomoTabText: "Sign up",
                                                        className: "design-component-instance-node"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "subtitle-222",
                                                                children: "Welcome!"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "p",
                                                                children: "Start the VERIBANK Business experience"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteText.ComponenteText), {
                                                                active: true,
                                                                className: "design-component-instance-node",
                                                                default1: false,
                                                                disabled: false,
                                                                divClassName: "componente-text-default",
                                                                error: false,
                                                                focus: false,
                                                                iconDer: false,
                                                                iconIz: false,
                                                                labelDer: false,
                                                                msjDer: false,
                                                                msjIz: false,
                                                                msjIz2: false,
                                                                text: "ID Number",
                                                                text1: "Enter ID number"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteText.ComponenteText), {
                                                                active: true,
                                                                className: "design-component-instance-node",
                                                                default1: false,
                                                                color: colors.sexto,
                                                                disabled: false,
                                                                divClassName: "componente-text-default",
                                                                error: false,
                                                                focus: false,
                                                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsOpenEye1.IconsOpenEye1), {
                                                                    className: "mask-group"
                                                                }),
                                                                iconDer: true,
                                                                iconIz: false,
                                                                labelDer: false,
                                                                mensajeIzqClassName: "componente-text-instance",
                                                                msjDer: false,
                                                                msjIz: false,
                                                                msjIz2: true,
                                                                text: "Password",
                                                                text1: "Enter password",
                                                                text2: "Need help logging in?"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        onClick: handleButtonClick,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                            className: "button-large-WEB-instance",
                                                            iconLeft: false,
                                                            iconRigth: false,
                                                            primarioActive: false,
                                                            primarioInactive: false,
                                                            secundarioActive: false,
                                                            secundarioInactive: true,
                                                            terciarioActive: false,
                                                            terciarioInactive: false,
                                                            text: "Login"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-wrapper-login-bb",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "span",
                                                            children: "Already started an application?"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-wrapper-2",
                                                            children: "Click here"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-4",
                                                    children: [
                                                        "\xa9 2025 All rights reserved",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            width: 100,
                                                            height: "auto",
                                                            src: "/img/veritran.svg"
                                                        }),
                                                        "Innovation Lab"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "component",
                                                children: [
                                                    colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        width: 30,
                                                        height: "auto",
                                                        src: colors.url_logo
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "language",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                            height: 30,
                                                            width: 30
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "slider-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "slider",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "imagen-slider",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "imagen-texto",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mobile-login-pana-wrapper",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mobile-login-pana",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "freepik-background",
                                                                            alt: "Freepik background",
                                                                            src: "/img/imagen-login.png"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-2"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "texto",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "subtitle-2",
                                                                    children: [
                                                                        "VERIBANK ",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                        "Small Business Checking"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    className: "subtitle-3",
                                                                    children: "An account for your every day business banking needs"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"2qhGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteTabsWeb":"7CV9C","../../../../../components/ComponenteText":"5oqwO","../../../../../icons/IconsOpenEye1":"aXnM3","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/ButtonLargeWeb":"ichH4"}],"2qhGb":[function() {},{}],"7CV9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteTabsWeb", ()=>(0, _componenteTabsWeb.ComponenteTabsWeb));
var _componenteTabsWeb = require("./ComponenteTabsWeb");

},{"./ComponenteTabsWeb":"a1lhX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a1lhX":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteTabsWeb", ()=>ComponenteTabsWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _atomoTab = require("../AtomoTab");
var _styleCss = require("./style.css");
const ComponenteTabsWeb = ({ className, atomoTabFrameClassName, atomoTabDivClassName, atomoTabLine = "/img/line-49.svg", atomoTabFrameClassNameOverride, atomoTabText = "Log in", login = true, signup = false, atomoTabDivClassNameOverride })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `componente-tabs-web ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTab.AtomoTab), {
                active: login,
                className: "atomo-tab-instance",
                divClassName: atomoTabDivClassName,
                line: atomoTabLine,
                text: "Log in"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTab.AtomoTab), {
                active: signup,
                className: "atomo-tab-instance",
                divClassName: atomoTabDivClassNameOverride,
                text: atomoTabText
            })
        ]
    });
};
ComponenteTabsWeb.propTypes = {
    atomoTabLine: (0, _propTypesDefault.default).string,
    atomoTabText: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../AtomoTab":"m5X1G","./style.css":"1cG5r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"m5X1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoTab", ()=>(0, _atomoTab.AtomoTab));
var _atomoTab = require("./AtomoTab");

},{"./AtomoTab":"dQj5N","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQj5N":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomoTab", ()=>AtomoTab);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const AtomoTab = ({ active, className, frameClassName, divClassName, line = "/img/line-49-1.svg", text = "Log in" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `atomo-tab`,
        style: active ? {
            background: "#f9f9f9",
            borderBottom: "2px solid var(--primario)"
        } : {
            background: "#ffffff"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame ${frameClassName}`,
            style: active ? {
                background: "#f9f9f9",
                borderBottom: "2px solid var(--primario)"
            } : {
                background: "#ffffff"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `log-in active-${active} ${divClassName}`,
                children: text
            })
        })
    });
};
AtomoTab.propTypes = {
    active: (0, _propTypesDefault.default).bool,
    line: (0, _propTypesDefault.default).string,
    text: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"lbv4J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lbv4J":[function() {},{}],"1cG5r":[function() {},{}],"5oqwO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteText", ()=>(0, _componenteText.ComponenteText));
var _componenteText = require("./ComponenteText");

},{"./ComponenteText":"iYnYW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iYnYW":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponenteText", ()=>ComponenteText);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsError = require("../../icons/IconsError");
var _styleCss = require("./style.css");
const ComponenteText = ({ iconDer, iconIz, default1, active, color, focus, error, msjIz, msjDer, labelDer, disabled, msjIz2, className, text = "Label", divClassName, text1 = "Placeholder", icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsError.IconsError), {
    className: "icon-iz"
}), mensajeIzqClassName, text2 = "Mensaje de apoyo al campo" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `componente-text ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "labels",
                style: {
                    marginBottom: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "label-izq",
                    style: {
                        marginBottom: 2
                    },
                    children: text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "campo",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `placeholder ${divClassName}`,
                            style: {
                                color: color
                            },
                            children: text1
                        }),
                        msjIz2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: icon
                        })
                    ]
                })
            }),
            msjIz2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mensajes",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "msj-izq",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: `mensaje-izq ${mensajeIzqClassName}`,
                        style: {
                            color: color
                        },
                        children: text2
                    })
                })
            })
        ]
    });
};
ComponenteText.propTypes = {
    iconDer: (0, _propTypesDefault.default).bool,
    iconIz: (0, _propTypesDefault.default).bool,
    default1: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    focus: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).bool,
    msjIz: (0, _propTypesDefault.default).bool,
    msjDer: (0, _propTypesDefault.default).bool,
    labelDer: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    msjIz2: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).string,
    text1: (0, _propTypesDefault.default).string,
    text2: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/IconsError":"bq1nh","./style.css":"fEbCL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bq1nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsError", ()=>(0, _iconsError.IconsError));
var _iconsError = require("./IconsError");

},{"./IconsError":"ebcIn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ebcIn":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsError", ()=>IconsError);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsError = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icons-error ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M11.2 14.4H12.8V16H11.2V14.4ZM11.2 8H12.8V12.8H11.2V8ZM11.992 4C7.576 4 4 7.584 4 12C4 16.416 7.576 20 11.992 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 11.992 4ZM12 18.4C8.464 18.4 5.6 15.536 5.6 12C5.6 8.464 8.464 5.6 12 5.6C15.536 5.6 18.4 8.464 18.4 12C18.4 15.536 15.536 18.4 12 18.4Z",
            fill: "#969696"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fEbCL":[function() {},{}],"aXnM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsOpenEye1", ()=>(0, _iconsOpenEye1.IconsOpenEye1));
var _iconsOpenEye1 = require("./IconsOpenEye1");

},{"./IconsOpenEye1":"dkyRI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dkyRI":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsOpenEye1", ()=>IconsOpenEye1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconsOpenEye1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icons-open-eye-1 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 24 25",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M12 4.58423C7 4.58423 2.73 7.69423 1 12.0842C2.73 16.4742 7 19.5842 12 19.5842C17 19.5842 21.27 16.4742 23 12.0842C21.27 7.69423 17 4.58423 12 4.58423ZM12 17.0842C9.24 17.0842 7 14.8442 7 12.0842C7 9.32423 9.24 7.08423 12 7.08423C14.76 7.08423 17 9.32423 17 12.0842C17 14.8442 14.76 17.0842 12 17.0842ZM12 9.08423C10.34 9.08423 9 10.4242 9 12.0842C9 13.7442 10.34 15.0842 12 15.0842C13.66 15.0842 15 13.7442 15 12.0842C15 10.4242 13.66 9.08423 12 9.08423Z",
            fill: "#DDDDDD"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ichH4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonLargeWeb", ()=>(0, _buttonLargeWeb.ButtonLargeWeb));
var _buttonLargeWeb = require("./ButtonLargeWeb");

},{"./ButtonLargeWeb":"l9Uov","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9Uov":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonLargeWeb", ()=>ButtonLargeWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const ButtonLargeWeb = ({ primarioActive, primarioInactive, secundarioActive, secundarioInactive, terciarioActive, iconLeft, iconRigth, terciarioInactive, className, text = "Estado normal" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `button-large-WEB ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "div",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text",
                children: text
            })
        })
    });
};
ButtonLargeWeb.propTypes = {
    primarioActive: (0, _propTypesDefault.default).bool,
    primarioInactive: (0, _propTypesDefault.default).bool,
    secundarioActive: (0, _propTypesDefault.default).bool,
    secundarioInactive: (0, _propTypesDefault.default).bool,
    terciarioActive: (0, _propTypesDefault.default).bool,
    iconLeft: (0, _propTypesDefault.default).bool,
    iconRigth: (0, _propTypesDefault.default).bool,
    terciarioInactive: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"hYuJn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYuJn":[function() {},{}],"1tKSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingProductSelectionCodeWeb", ()=>(0, _corporativoBusinessBankingProductSelectionCodeWeb.CorporativoBusinessBankingProductSelectionCodeWeb));
var _corporativoBusinessBankingProductSelectionCodeWeb = require("./CorporativoBusinessBankingProductSelectionCodeWeb");

},{"./CorporativoBusinessBankingProductSelectionCodeWeb":"9yHTU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9yHTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingProductSelectionCodeWeb", ()=>CorporativoBusinessBankingProductSelectionCodeWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _checkbox = require("../../../../../components/Checkbox");
var _reactRouterDom = require("react-router-dom");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingProductSelectionCodeWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-document_id-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-select-producto",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "group-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "overlap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "div-wrapper-sp",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "group-3",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "frame-wrapper",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "frame-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "text-wrapper-2",
                                                                                            children: "Product Selection"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                            className: "subtitle",
                                                                                            children: "Choose the product\xa0\xa0that best suits your company's needs."
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-4"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "card-violet-dark",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "overlap-wrapper",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "card-violet-dark-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "business-credit-card-wrapper",
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                className: "business-credit-card",
                                                                                                children: [
                                                                                                    "Business Credit",
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                                    "Card"
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "text-wrapper-3",
                                                                                            children: "View details"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "tarjetas-de-credito",
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "overlap-group-2",
                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                    className: "vector-2",
                                                                                                    alt: "Vector",
                                                                                                    src: "/img/producto2.png"
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                                                    boxClassName: "checkbox-2",
                                                                                    className: "checkbox-instance",
                                                                                    label: "none",
                                                                                    variant: "not-selected"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "card-violet-dark-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-3",
                                                                                children: "View details"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-4",
                                                                                children: "Business Checking Account"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                                                boxClassName: "checkbox-2",
                                                                                className: "checkbox-3",
                                                                                label: "none",
                                                                                variant: "not-selected"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "repetitivo",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "bank",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "overlap-group-3",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                            className: "vector-11",
                                                                                            alt: "Vector",
                                                                                            src: "/img/producto3.png"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "card-violet-dark-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "overlap-5",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                                                    boxClassName: "checkbox-2",
                                                                                    className: "checkbox-4",
                                                                                    label: "none",
                                                                                    variant: "not-selected"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-5",
                                                                                children: "Money Market"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-6",
                                                                                children: "View details"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "transaccion",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "group-6",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "overlap-group-4",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                className: "vector-23",
                                                                                                alt: "Vector",
                                                                                                src: "/img/producto4.png"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "group-7"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "group-8"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "group-9"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "group-10",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-6",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "card-violet-dark-2",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "overlap-4",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                className: "group-11",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                        className: "overlap-group-5",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                className: "text-wrapper-7",
                                                                                                                children: "Veribank"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                className: "text-wrapper-8",
                                                                                                                children: "Paquete 2"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "text-2",
                                                                                                        children: ""
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                className: "help-2",
                                                                                                alt: "Help",
                                                                                                src: "/img/image.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "text-wrapper-9",
                                                                                                children: "Optimiza tu negocio"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "repetitivo-2",
                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                    className: "group-12",
                                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                        className: "overlap-7",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-13",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-5.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-14",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-6.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-15",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-7.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-16",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-8.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-17",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-9.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-18",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-10.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-19",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-11.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                className: "group-20",
                                                                                                                alt: "Group",
                                                                                                                src: "/img/group-12.png"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                className: "group-21",
                                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                    className: "group-22"
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                className: "group-23",
                                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                                    className: "vector-wrapper",
                                                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                                        className: "vector-34",
                                                                                                                        alt: "Vector",
                                                                                                                        src: "/img/vector-33.svg"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "card-violet-dark-5",
                                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                    className: "group-24",
                                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "text-wrapper-10",
                                                                                                        children: "Saving"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-11",
                                                                                    children: "View details"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                                                    boxClassName: "checkbox-2",
                                                                                    className: "checkbox-5",
                                                                                    label: "none",
                                                                                    variant: "not-selected"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-5",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "frame-4"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-3",
                                                                children: "Continue later"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                onClick: handleButtonClick,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                                    className: "button-large-WEB-instance",
                                                                    iconLeft: false,
                                                                    iconRigth: false,
                                                                    primarioActive: true,
                                                                    primarioInactive: false,
                                                                    secundarioActive: false,
                                                                    secundarioInactive: false,
                                                                    terciarioActive: false,
                                                                    terciarioInactive: false,
                                                                    text: "Continue",
                                                                    textClassName: "button-large-WEB-2"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "monedas",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "overlap-9",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "vector-35",
                                                    alt: "Vector",
                                                    width: 50,
                                                    src: "/img/producto1.png"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-30",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-12",
                                                children: "Account opening application"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-31",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-32",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-33",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            className: "stepper-ingles-largo-instance",
                                                            componentsStepsClassName: "stepper-ingles-largo-2",
                                                            componentsStepsClassNameOverride: "stepper-ingles-largo-2",
                                                            numberWrapperClassName: "stepper-ingles-largo-2",
                                                            prendido: "three",
                                                            prendidoHasta: 3,
                                                            property2: "three",
                                                            vector: "/img/vector-41-1.svg"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"gPuhp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/Checkbox":"equhV","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"gPuhp":[function() {},{}],"equhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkbox.Checkbox));
var _checkbox = require("./Checkbox");

},{"./Checkbox":"bzVcZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bzVcZ":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const Checkbox = ({ variant, label, className, boxClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `checkbox ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `box ${boxClassName}`
        })
    });
};
Checkbox.propTypes = {
    variant: (0, _propTypesDefault.default).oneOf([
        "not-selected"
    ]),
    label: (0, _propTypesDefault.default).oneOf([
        "none"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"5RVg6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5RVg6":[function() {},{}],"iJ3IU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepperInglesLargo", ()=>(0, _stepperInglesLargo.StepperInglesLargo));
var _stepperInglesLargo = require("./StepperInglesLargo");

},{"./StepperInglesLargo":"lDbjY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDbjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StepperInglesLargo", ()=>StepperInglesLargo);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const StepperInglesLargo = ({ prendidoHasta = 0, property2, className, vector = "/img/vector-41.svg" })=>{
    const steps = [
        "Enter Employer Indentification Number",
        "Register your Email",
        "Select your product",
        "Accept Terms and Conditions",
        "Validate your identity",
        "Generate your password",
        "Fill in your company information",
        "Attach the required documents",
        "Checkout"
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `stepper-ingles-largo ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "group",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "vector",
                        alt: "Vector",
                        src: vector
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "img",
                        alt: "Vector",
                        src: "/img/vector-42.svg"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame",
                        children: steps.map((title, index)=>{
                            const stepNumber = index + 1;
                            const isActive = stepNumber <= prendidoHasta;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "head",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "overlap-group-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: ` overlap-group ${isActive ? "active" : ""}`,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `number-2 ${isActive ? "active" : ""}`,
                                                children: stepNumber
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: `title ${stepNumber > 5 ? "title-step" : ""}`,
                                        children: title
                                    })
                                ]
                            }, stepNumber);
                        })
                    })
                ]
            })
        })
    });
};
StepperInglesLargo.propTypes = {
    prendidoHasta: (0, _propTypesDefault.default).number,
    property2: (0, _propTypesDefault.default).oneOf([
        "three"
    ]),
    vector: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"k8UgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k8UgC":[function() {},{}],"ar8LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingDocumentsWeb", ()=>(0, _corporativoBusinessBankingDocumentsWeb.CorporativoBusinessBankingDocumentsWeb));
var _corporativoBusinessBankingDocumentsWeb = require("./CorporativoBusinessBankingDocumentsWeb");

},{"./CorporativoBusinessBankingDocumentsWeb":"37CKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37CKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingDocumentsWeb", ()=>CorporativoBusinessBankingDocumentsWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _iconImgUpload2 = require("../../../../../icons/IconImgUpload2");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingDocumentsWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-checkout-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-documentos",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "div-wrapper-sp",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "group-3",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "frame-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-3",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-2",
                                                                                        children: "Attach documents"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                        className: "subtitle",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                                            children: "Upload documents or photos from your device."
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "frame-4"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "document-upload",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "section-documento  ",
                                                                children: [
                                                                    "Legal document(s) establishing your business",
                                                                    "Doing Business As (DBA) Certificate",
                                                                    "Business License",
                                                                    "Power of Attorney"
                                                                ].map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "other-item",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                                                children: [
                                                                                    "\u2022 ",
                                                                                    item
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconImgUpload2.IconImgUpload2), {
                                                                                className: "icon-img-upload-3",
                                                                                color: "#0F316D"
                                                                            })
                                                                        ]
                                                                    }, idx))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-4"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-3",
                                                            children: "Continue later"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            onClick: handleButtonClick,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                                className: "button-large-WEB-instance",
                                                                iconLeft: false,
                                                                iconRigth: false,
                                                                primarioActive: true,
                                                                primarioInactive: false,
                                                                secundarioActive: false,
                                                                secundarioInactive: false,
                                                                terciarioActive: false,
                                                                terciarioInactive: false,
                                                                text: "Continue",
                                                                textClassName: "button-large-WEB-2"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-30",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-12",
                                                children: "Account opening application"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-31",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-32",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-33",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            className: "stepper-ingles-largo-instance",
                                                            componentsStepsClassName: "stepper-ingles-largo-2",
                                                            componentsStepsClassNameOverride: "stepper-ingles-largo-2",
                                                            numberWrapperClassName: "stepper-ingles-largo-2",
                                                            prendidoHasta: 8,
                                                            prendido: "three",
                                                            property2: "three",
                                                            vector: "/img/vector-41-1.svg"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"eNidB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../icons/IconImgUpload2":"2doKJ","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"eNidB":[function() {},{}],"2doKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconImgUpload2", ()=>(0, _iconImgUpload2.IconImgUpload2));
var _iconImgUpload2 = require("./IconImgUpload2");

},{"./IconImgUpload2":"b7mOT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b7mOT":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconImgUpload2", ()=>IconImgUpload2);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconImgUpload2 = ({ color = "#0F316D", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `icon-img-upload-2 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M17 8L12 3L7 8",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M12 3V15",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
};
IconImgUpload2.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9gVqk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingMailWeb", ()=>(0, _corporativoBusinessBankingMailWeb.CorporativoBusinessBankingMailWeb));
var _corporativoBusinessBankingMailWeb = require("./CorporativoBusinessBankingMailWeb");

},{"./CorporativoBusinessBankingMailWeb":"6CkHZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6CkHZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingMailWeb", ()=>CorporativoBusinessBankingMailWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _defaultTrueFocus = require("../../../../../components/DefaultTrueFocus");
var _navigationButton = require("../../../../../components/NavigationButton");
var _reactRouterDom = require("react-router-dom");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingMailWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-mail_code-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-mail",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "div-wrapper-mail-banking",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "group-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultTrueFocus.DefaultTrueFocus), {
                                                                className: "inputs-text",
                                                                divClassName: "default-true-focus-false-error-false-mensaje-false-success-false-round-corner-false-deshabilitado-false-bigger-placeholder-false-icon-rigth-false-activo-false-icon-left-false-input-sinborde-false",
                                                                text: "Email",
                                                                text1: "user@company.com"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-3",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-2",
                                                                    children: "What is your Email?"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-2",
                                                        children: "Continue later"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        onClick: handleButtonClick,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                            className: "button-large-WEB-instance",
                                                            iconLeft: false,
                                                            iconRigth: false,
                                                            primarioActive: true,
                                                            primarioInactive: false,
                                                            secundarioActive: false,
                                                            secundarioInactive: false,
                                                            terciarioActive: false,
                                                            terciarioInactive: false,
                                                            text: "Continue",
                                                            textClassName: "button-large-WEB-2"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-5",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-7",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationButton.NavigationButton), {
                                                    className: "nav-button-left",
                                                    defaultMasterButtonNavDivClassName: "navigation-button-instance",
                                                    focus: false,
                                                    platform: "web-react",
                                                    state: "default",
                                                    theme: "light",
                                                    type: "back"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-3",
                                                    children: "Account opening application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            className: "stepper-ingles-largo-instance",
                                                            prendidoHasta: 2,
                                                            prendido: "two",
                                                            property2: "two"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"c3mW1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/DefaultTrueFocus":"jACB4","../../../../../components/NavigationButton":"kzMNm","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"c3mW1":[function() {},{}],"jACB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTrueFocus", ()=>(0, _defaultTrueFocus.DefaultTrueFocus));
var _defaultTrueFocus = require("./DefaultTrueFocus");

},{"./DefaultTrueFocus":"hO9qH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hO9qH":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTrueFocus", ()=>DefaultTrueFocus);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const DefaultTrueFocus = ({ className, text = "Label", divClassName, text1 = "Placeholder" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `default-true-focus ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                style: {
                    marginBottom: 8
                },
                children: text
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "campo",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `placeholder ${divClassName}`,
                        style: {
                            marginTop: 8
                        },
                        children: text1
                    })
                })
            })
        ]
    });
};
DefaultTrueFocus.propTypes = {
    text: (0, _propTypesDefault.default).string,
    text1: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"aW5A7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aW5A7":[function() {},{}],"kzMNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigationButton", ()=>(0, _navigationButton.NavigationButton));
var _navigationButton = require("./NavigationButton");

},{"./NavigationButton":"3IAx1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3IAx1":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigationButton", ()=>NavigationButton);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _default = require("../Default");
var _styleCss = require("./style.css");
const NavigationButton = ({ type, platform, state, theme, focus, className, defaultMasterButtonNavDivClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `navigation-button ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _default.Default), {
            className: "master",
            masterButtonNavDivClassName: defaultMasterButtonNavDivClassName,
            masterButtonNavHasIconButton: false,
            masterButtonNavText: "Back"
        })
    });
};
NavigationButton.propTypes = {
    type: (0, _propTypesDefault.default).oneOf([
        "back"
    ]),
    platform: (0, _propTypesDefault.default).oneOf([
        "web-react"
    ]),
    state: (0, _propTypesDefault.default).oneOf([
        "default"
    ]),
    theme: (0, _propTypesDefault.default).oneOf([
        "light"
    ]),
    focus: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../Default":"9kvg9","./style.css":"fW3sc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9kvg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>(0, _default.Default));
var _default = require("./Default");

},{"./Default":"bfJTS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bfJTS":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Default", ()=>Default);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _masterButtonNav = require("../MasterButtonNav");
var _styleCss = require("./style.css");
const Default = ({ className, masterButtonNavText = "Label", masterButtonNavDivClassName, masterButtonNavHasIconButton })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `default ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _masterButtonNav.MasterButtonNav), {
            className: "design-component-instance-node",
            divClassName: masterButtonNavDivClassName,
            hasIconButton: masterButtonNavHasIconButton,
            iconButtonClassName: "master-button-nav-instance",
            text: masterButtonNavText,
            visible: false
        })
    });
};
Default.propTypes = {
    masterButtonNavText: (0, _propTypesDefault.default).string,
    masterButtonNavHasIconButton: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../MasterButtonNav":"9TudR","./style.css":"6wSPh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9TudR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MasterButtonNav", ()=>(0, _masterButtonNav.MasterButtonNav));
var _masterButtonNav = require("./MasterButtonNav");

},{"./MasterButtonNav":"5LCr2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5LCr2":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MasterButtonNav", ()=>MasterButtonNav);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _arrowLeft3 = require("../../icons/ArrowLeft3");
var _size18PxColourWhiteDarkThemeFalse = require("../../icons/Size18PxColourWhiteDarkThemeFalse");
var _masterShapesLink = require("../MasterShapesLink");
var _styleCss = require("./style.css");
const MasterButtonNav = ({ className, divClassName, text = "Label", visible = true, hasIconButton = true, iconButtonClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `master-button-nav ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowLeft3.ArrowLeft3), {
                className: "arrow-left"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "label",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `label-2 ${divClassName}`,
                        children: text
                    }),
                    visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _masterShapesLink.MasterShapesLink), {
                        className: "line"
                    })
                ]
            }),
            hasIconButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `icon-button ${iconButtonClassName}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _size18PxColourWhiteDarkThemeFalse.Size18PxColourWhiteDarkThemeFalse), {
                    className: "arrow-right"
                })
            })
        ]
    });
};
MasterButtonNav.propTypes = {
    text: (0, _propTypesDefault.default).string,
    visible: (0, _propTypesDefault.default).bool,
    hasIconButton: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/ArrowLeft3":"acfHk","../../icons/Size18PxColourWhiteDarkThemeFalse":"eCAgT","../MasterShapesLink":"hcMiK","./style.css":"cD8Kf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"acfHk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowLeft3", ()=>(0, _arrowLeft3.ArrowLeft3));
var _arrowLeft3 = require("./ArrowLeft3");

},{"./ArrowLeft3":"aHn7D","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aHn7D":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowLeft3", ()=>ArrowLeft3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ArrowLeft3 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `arrow-left-3 ${className}`,
        fill: "none",
        height: "19",
        viewBox: "0 0 18 19",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M0.899902 9.5H17.0999",
                stroke: "#333333",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M7.23903 3.16089L0.899902 9.50002L7.23903 15.8392",
                stroke: "#333333",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eCAgT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Size18PxColourWhiteDarkThemeFalse", ()=>(0, _size18PxColourWhiteDarkThemeFalse.Size18PxColourWhiteDarkThemeFalse));
var _size18PxColourWhiteDarkThemeFalse = require("./Size18PxColourWhiteDarkThemeFalse");

},{"./Size18PxColourWhiteDarkThemeFalse":"62dbZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"62dbZ":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Size18PxColourWhiteDarkThemeFalse", ()=>Size18PxColourWhiteDarkThemeFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Size18PxColourWhiteDarkThemeFalse = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `size-18px-colour-white-dark-theme-false ${className}`,
        fill: "none",
        height: "18",
        viewBox: "0 0 18 18",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M16.802 9H0.899976",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M10.7609 2.66087L17.1 9L10.7609 15.3391",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hcMiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MasterShapesLink", ()=>(0, _masterShapesLink.MasterShapesLink));
var _masterShapesLink = require("./MasterShapesLink");

},{"./MasterShapesLink":"dtnKO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dtnKO":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MasterShapesLink", ()=>MasterShapesLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const MasterShapesLink = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `master-shapes-link ${className}`
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./style.css":"6e4pC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6e4pC":[function() {},{}],"cD8Kf":[function() {},{}],"6wSPh":[function() {},{}],"fW3sc":[function() {},{}],"dRXlT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingMailCodeWeb", ()=>(0, _corporativoBusinessBankingMailCodeWeb.CorporativoBusinessBankingMailCodeWeb));
var _corporativoBusinessBankingMailCodeWeb = require("./CorporativoBusinessBankingMailCodeWeb");

},{"./CorporativoBusinessBankingMailCodeWeb":"6qCHd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qCHd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingMailCodeWeb", ()=>CorporativoBusinessBankingMailCodeWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _atomoTime = require("../../../../../components/AtomoTime");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _buttonSmall = require("../../../../../components/ButtonSmall");
var _reactRouterDom = require("react-router-dom");
var _defaultTrueFocus = require("../../../../../components/DefaultTrueFocus");
var _navigationButton = require("../../../../../components/NavigationButton");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingMailCodeWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-product_selection-corporativo-web${currentParams}`);
    };
    const boxes = Array(6).fill("");
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: laptop,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: screen,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-mail-code",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "div-wrapper-mail-code",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-3",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-2",
                                                                            children: "Validate your Email"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            className: "subtitle",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "span",
                                                                                children: "Enter the validation code sent to your email account"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultTrueFocus.DefaultTrueFocus), {
                                                        className: "inputs-text",
                                                        text: "Email",
                                                        text1: "user@company.com"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-3",
                                                        children: "Validation code"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "auth-code-container",
                                                        children: boxes.map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "auth-code-box"
                                                            }, index))
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "componente-token",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTime.AtomoTime), {
                                                                className: "atomo-time-instance",
                                                                rectangleClassName: "atomo-time-2",
                                                                subtitleCopyClassName: "atomo-time-3",
                                                                text: "Remaining time:",
                                                                text1: "0:50"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSmall.ButtonSmall), {
                                                                className: "button-small-instance",
                                                                estado: "inactivo",
                                                                iconLeft: false,
                                                                iconRigth: false,
                                                                textClassName: "button-small-2",
                                                                texto: "Resend code",
                                                                tipo: "link"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-5",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-4",
                                                                children: "Continue later"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                onClick: handleButtonClick,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                                    className: "button-large-WEB-instance",
                                                                    iconLeft: false,
                                                                    iconRigth: false,
                                                                    primarioActive: true,
                                                                    primarioInactive: false,
                                                                    secundarioActive: false,
                                                                    secundarioInactive: false,
                                                                    terciarioActive: false,
                                                                    terciarioInactive: false,
                                                                    text: "Continue",
                                                                    textClassName: "button-large-WEB-2"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-6"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-9",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationButton.NavigationButton), {
                                                    className: "nav-button-left",
                                                    defaultMasterButtonNavDivClassName: "navigation-button-instance",
                                                    focus: false,
                                                    platform: "web-react",
                                                    state: "default",
                                                    theme: "light",
                                                    type: "back"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-4",
                                                    children: "Account opening application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-5",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            prendidoHasta: 2,
                                                            className: "stepper-ingles-largo-instance",
                                                            prendido: "two",
                                                            property2: "two"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: base
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"7u7vA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/AtomoTime":"djEQ8","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/ButtonSmall":"6rhhx","../../../../../components/DefaultTrueFocus":"jACB4","../../../../../components/NavigationButton":"kzMNm","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"7u7vA":[function() {},{}],"LvJ0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingSignupWeb", ()=>(0, _corporativoBusinessBankingSignupWeb.CorporativoBusinessBankingSignupWeb));
var _corporativoBusinessBankingSignupWeb = require("./CorporativoBusinessBankingSignupWeb");

},{"./CorporativoBusinessBankingSignupWeb":"kBVz0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kBVz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingSignupWeb", ()=>CorporativoBusinessBankingSignupWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _componenteTabsWeb = require("../../../../../components/ComponenteTabsWeb");
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingSignupWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-mail-corporativo-web${currentParams}`);
    };
    const options = [
        {
            icon: "/img/empresa.png",
            title: "I am a Legal Representative of a Business and want to open an account",
            subtitle: "I am an Attorney-in-Fact of a Legal Entity"
        },
        {
            icon: "/img/tienda.png",
            title: "I am a Guest of a Business and want to log in for the first time",
            subtitle: "I received an invitation to become a user of a VeriBank client company"
        },
        {
            icon: "/img/estampilla.png",
            title: "I am an Entrepreneur and want to open an account",
            subtitle: "I am a Sole Proprietor with Commercial Activity"
        }
    ];
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-signup",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-cbblw"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteTabsWeb.ComponenteTabsWeb), {
                                                        login: false,
                                                        signup: true,
                                                        atomoTabDivClassName: "componente-tabs-web-2",
                                                        atomoTabDivClassNameOverride: "componente-tabs-web-2",
                                                        atomoTabFrameClassName: "componente-tabs-web-instance",
                                                        atomoTabFrameClassNameOverride: "componente-tabs-web-3",
                                                        atomoTabLine: "/img/line-49-2.svg",
                                                        atomoTabText: "Sign up",
                                                        className: "design-component-instance-node"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "account-options-container",
                                                        children: options.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "account-option-card",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: option.icon,
                                                                        alt: "Icon",
                                                                        className: "account-option-icon"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "account-option-texts",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "account-option-title",
                                                                                children: option.title
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "account-option-subtitle",
                                                                                children: option.subtitle
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, index))
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        onClick: handleButtonClick,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "span",
                                                                    children: [
                                                                        "Already started an application?",
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-2",
                                                                    children: "Click here"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-4",
                                                    children: [
                                                        "\xa9 2025 All rights reserved",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            width: 100,
                                                            height: "auto",
                                                            src: "/img/veritran.svg"
                                                        }),
                                                        "Innovation Lab"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "component",
                                                children: [
                                                    colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        width: 30,
                                                        height: "auto",
                                                        src: colors.url_logo
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "language",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                            height: 30,
                                                            width: 30
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "slider-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "slider",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "imagen-slider",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "imagen-texto",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mobile-login-pana-wrapper",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mobile-login-pana",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "freepik-background",
                                                                            alt: "Freepik background",
                                                                            src: "/img/imagen-login.png"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-2"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "texto",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "subtitle-2",
                                                                    children: [
                                                                        "VERIBANK ",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                        "Small Business Checking"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    className: "subtitle-3",
                                                                    children: "An account for your every day business banking needs"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"bdQX9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteTabsWeb":"7CV9C","../../../../../hooks/useDynamicColors":"b2GRH"}],"bdQX9":[function() {},{}],"an1mT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingStepperWeb", ()=>(0, _corporativoBusinessBankingStepperWeb.CorporativoBusinessBankingStepperWeb));
var _corporativoBusinessBankingStepperWeb = require("./CorporativoBusinessBankingStepperWeb");

},{"./CorporativoBusinessBankingStepperWeb":"9eVFU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9eVFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingStepperWeb", ()=>CorporativoBusinessBankingStepperWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _componenteTabsWeb = require("../../../../../components/ComponenteTabsWeb");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingStepperWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-mail-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-stepper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-cbblw"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteTabsWeb.ComponenteTabsWeb), {
                                                        atomoTabDivClassName: "componente-tabs-web-2",
                                                        atomoTabDivClassNameOverride: "componente-tabs-web-2",
                                                        atomoTabFrameClassName: "componente-tabs-web-instance",
                                                        atomoTabFrameClassNameOverride: "componente-tabs-web-3",
                                                        atomoTabLine: "/img/line-49-2.svg",
                                                        atomoTabText: "Sign up",
                                                        className: "design-component-instance-node"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-step",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "subtitle-222",
                                                                children: "Welcome!"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "p",
                                                                children: "Start the VERIBANK Business experience"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "steps-box",
                                                        children: [
                                                            "Enter Employer Indentification Number",
                                                            "Register your Email",
                                                            "Select your product",
                                                            "Accept Terms and Conditions",
                                                            "Validate your identity",
                                                            "Generate your password",
                                                            "Fill in your company information",
                                                            "Attach the required documents"
                                                        ].map((text, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "step",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "circle",
                                                                        children: index + 1
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "step-text",
                                                                        children: text
                                                                    })
                                                                ]
                                                            }, index))
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "reminder",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                role: "img",
                                                                "aria-label": "megaphone",
                                                                style: {
                                                                    dispaly: "flex",
                                                                    placeContent: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/aviso.png",
                                                                    height: 20,
                                                                    width: 20
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    dispaly: "flex",
                                                                    placeContent: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: " Remember"
                                                                        }),
                                                                        ", after completing the application, an executive will contact you."
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        onClick: handleButtonClick,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                            className: "button-large-WEB-instance",
                                                            iconLeft: false,
                                                            iconRigth: false,
                                                            primarioActive: false,
                                                            primarioInactive: false,
                                                            secundarioActive: false,
                                                            secundarioInactive: true,
                                                            terciarioActive: false,
                                                            terciarioInactive: false,
                                                            text: "Continue"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-wrapper-login-bb",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "span",
                                                            children: "Already started an application?"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-wrapper-2",
                                                            children: "Click here"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-4",
                                                    children: [
                                                        "\xa9 2025 All rights reserved",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            width: 100,
                                                            height: "auto",
                                                            src: "/img/veritran.svg"
                                                        }),
                                                        "Innovation Lab"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "component",
                                                children: [
                                                    colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        width: 30,
                                                        height: "auto",
                                                        src: colors.url_logo
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "language",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                            height: 30,
                                                            width: 30
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "slider-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "slider",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "imagen-slider",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "imagen-texto",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mobile-login-pana-wrapper",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mobile-login-pana",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "freepik-background",
                                                                            alt: "Freepik background",
                                                                            src: "/img/imagen-login.png"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-2"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "texto",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "subtitle-2",
                                                                    children: [
                                                                        "VERIBANK ",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                        "Safety Tips!"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    className: "subtitle-3",
                                                                    children: "Learn more"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"ct7hF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/ComponenteTabsWeb":"7CV9C","../../../../../hooks/useDynamicColors":"b2GRH"}],"ct7hF":[function() {},{}],"hgljw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingCredentialsWeb", ()=>(0, _corporativoBusinessBankingCredentialsWeb.CorporativoBusinessBankingCredentialsWeb));
var _corporativoBusinessBankingCredentialsWeb = require("./CorporativoBusinessBankingCredentialsWeb");

},{"./CorporativoBusinessBankingCredentialsWeb":"3KKOE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3KKOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingCredentialsWeb", ()=>CorporativoBusinessBankingCredentialsWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _navigationButton = require("../../../../../components/NavigationButton");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingCredentialsWeb = ()=>{
    const [password, setPassword] = (0, _react.useState)("");
    const requirements = [
        {
            label: "A capital letter",
            test: /[A-Z]/
        },
        {
            label: "A lowercase letter",
            test: /[a-z]/
        },
        {
            label: "One number",
            test: /[0-9]/
        },
        {
            label: "A special character",
            test: /[^A-Za-z0-9]/
        },
        {
            label: "8 to 10 characters",
            test: /^.{8,10}$/
        }
    ];
    const colors = (0, _useDynamicColorsDefault.default)();
    const boxes = Array(6).fill("");
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-document-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: laptop,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: screen,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-credentials",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "div-wrapper-mail-code",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-3",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-2",
                                                                            children: "Create your password"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            className: "subtitle",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "span",
                                                                                children: "You will use it to log in"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "password-container",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "input-wrapper",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        type: "password",
                                                                        placeholder: "Enter a password",
                                                                        value: password,
                                                                        onChange: (e)=>setPassword(e.target.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: "/img/eye.png",
                                                                        alt: "toggle visibility",
                                                                        className: "eye-icon"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "requirement-title",
                                                                children: "The password must contain"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "requirements-list",
                                                                children: requirements.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                                                        className: "requirement-item",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: `checkbox ${item.test.test(password) ? "checked" : ""}`
                                                                            }),
                                                                            item.label
                                                                        ]
                                                                    }, idx))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-5",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-4",
                                                                children: "Continue later"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                onClick: handleButtonClick,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                                    className: "button-large-WEB-instance",
                                                                    iconLeft: false,
                                                                    iconRigth: false,
                                                                    primarioActive: true,
                                                                    primarioInactive: false,
                                                                    secundarioActive: false,
                                                                    secundarioInactive: false,
                                                                    terciarioActive: false,
                                                                    terciarioInactive: false,
                                                                    text: "Continue",
                                                                    textClassName: "button-large-WEB-2"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-6"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-9",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationButton.NavigationButton), {
                                                    className: "nav-button-left",
                                                    defaultMasterButtonNavDivClassName: "navigation-button-instance",
                                                    focus: false,
                                                    platform: "web-react",
                                                    state: "default",
                                                    theme: "light",
                                                    type: "back"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-4",
                                                    children: "Account opening application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-5",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            prendidoHasta: 6,
                                                            className: "stepper-ingles-largo-instance",
                                                            prendido: "two",
                                                            property2: "two"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: base
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"liCIW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/NavigationButton":"kzMNm","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"liCIW":[function() {},{}],"2SC88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingDocumentIdWeb", ()=>(0, _corporativoBusinessBankingDocumentIdWeb.CorporativoBusinessBankingDocumentIdWeb));
var _corporativoBusinessBankingDocumentIdWeb = require("./CorporativoBusinessBankingDocumentIdWeb");

},{"./CorporativoBusinessBankingDocumentIdWeb":"cxCEU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cxCEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingDocumentIdWeb", ()=>CorporativoBusinessBankingDocumentIdWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _navigationButton = require("../../../../../components/NavigationButton");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingDocumentIdWeb = ({ countries = [], onSelectCountry })=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-credentials-corporativo-web${currentParams}`);
    };
    const colors = (0, _useDynamicColorsDefault.default)();
    const boxes = Array(6).fill("");
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-document-id",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "div-wrapper-mail-code",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-3",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-2",
                                                                            children: "Identity validation"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            className: "subtitle",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "span",
                                                                                children: "Take a picture of your document"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "document-instructions",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "instructions-text",
                                                                children: "We will take a picture of the front and back. Center your document in the frame and make sure there is no glare or shadows. The photos will be captured automatically."
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "image-wrapper",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: "/img/card_id.png",
                                                                    width: 150,
                                                                    height: 150,
                                                                    alt: "Document Capture Illustration",
                                                                    className: "illustration"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "select-wrapper",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                        htmlFor: "country-select",
                                                                        children: "Country"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                                        id: "country-select",
                                                                        // value={selectedCountry}
                                                                        onChange: (e)=>onSelectCountry(e.target.value),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select Country"
                                                                            }),
                                                                            countries.map((country, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                                    value: country,
                                                                                    children: country
                                                                                }, index))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-5",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-4",
                                                                children: "Continue later"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                onClick: handleButtonClick,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                                    className: "button-large-WEB-instance",
                                                                    iconLeft: false,
                                                                    iconRigth: false,
                                                                    primarioActive: true,
                                                                    primarioInactive: false,
                                                                    secundarioActive: false,
                                                                    secundarioInactive: false,
                                                                    terciarioActive: false,
                                                                    terciarioInactive: false,
                                                                    text: "Take photos",
                                                                    textClassName: "button-large-WEB-2"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-6"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-9",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationButton.NavigationButton), {
                                                    className: "nav-button-left",
                                                    defaultMasterButtonNavDivClassName: "navigation-button-instance",
                                                    focus: false,
                                                    platform: "web-react",
                                                    state: "default",
                                                    theme: "light",
                                                    type: "back"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-4",
                                                    children: "Account opening application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-5",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            prendidoHasta: 5,
                                                            className: "stepper-ingles-largo-instance",
                                                            prendido: "two",
                                                            property2: "two"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"l9epJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/NavigationButton":"kzMNm","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"l9epJ":[function() {},{}],"7BMlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingCheckoutWeb", ()=>(0, _corporativoBusinessBankingCheckoutWeb.CorporativoBusinessBankingCheckoutWeb));
var _corporativoBusinessBankingCheckoutWeb = require("./CorporativoBusinessBankingCheckoutWeb");

},{"./CorporativoBusinessBankingCheckoutWeb":"3dRoP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3dRoP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoBusinessBankingCheckoutWeb", ()=>CorporativoBusinessBankingCheckoutWeb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonLargeWeb = require("../../../../../components/ButtonLargeWeb");
var _navigationButton = require("../../../../../components/NavigationButton");
var _stepperInglesLargo = require("../../../../../components/StepperInglesLargo");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoBusinessBankingCheckoutWeb = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/business_banking-login-corporativo-web${currentParams}`);
    };
    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "17px",
        width: "1400px",
        height: "800px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
    };
    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "800px"
    };
    const container = {
        display: "flex",
        height: "100vh"
    };
    const base = {
        position: "absolute",
        width: "1600px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "corporativo-business-checkout",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "div-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "div-wrapper-mail-code",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "review-container",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                                className: "title-2",
                                                                children: "Review and confirm"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "subtitle",
                                                                children: "Please review and confirm your company\u2019s information to proceed."
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "section-checkout",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        className: "section-checkout-title",
                                                                        children: "Business information"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Nature of the business"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "Software Development"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Category"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "Technology Services"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "section-checkout",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        className: "section-checkout-title",
                                                                        children: "Legal address"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Address 1"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "1234 Elm Street"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Address 2"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "Suite 501"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "City"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "San Francisco"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "State"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "California"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Zip Code"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "94107"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "section-checkout",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        className: "section-checkout-title",
                                                                        children: "Company's main contact information"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "First and Last Name"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "Ana Rodr\xedguez"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Email"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "ana@company.com"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Cell phone"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "+1 (415) 555-0123"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "section-checkout",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        className: "section-checkout-title",
                                                                        children: "Legal representatives"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "First and Last Name"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "Carlos M\xe9ndez"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "ID Number"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "A123456789"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Email"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "carlos@company.com"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "row-step",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "label",
                                                                                children: "Cell phone"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "value",
                                                                                children: "+1 (415) 555-6789"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-5",
                                                        onClick: handleButtonClick,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLargeWeb.ButtonLargeWeb), {
                                                            className: "button-large-WEB-instance",
                                                            iconLeft: false,
                                                            iconRigth: false,
                                                            primarioActive: true,
                                                            primarioInactive: false,
                                                            secundarioActive: false,
                                                            secundarioInactive: false,
                                                            terciarioActive: false,
                                                            terciarioInactive: false,
                                                            text: "Confirm",
                                                            textClassName: "button-large-WEB-2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-6"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "component-7",
                                    children: [
                                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: 30,
                                            height: "auto",
                                            src: colors.url_logo
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "language",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                                height: 30,
                                                width: 30
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            "\xa9 2025 All rights reserved",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                width: 100,
                                                height: "auto",
                                                src: "/img/veritran.svg"
                                            }),
                                            "Innovation Lab"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-9",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationButton.NavigationButton), {
                                                    className: "nav-button-left",
                                                    defaultMasterButtonNavDivClassName: "navigation-button-instance",
                                                    focus: false,
                                                    platform: "web-react",
                                                    state: "default",
                                                    theme: "light",
                                                    type: "back"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-4",
                                                    children: "Account opening application"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-5",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "stepper-ingles-largo-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stepperInglesLargo.StepperInglesLargo), {
                                                            prendidoHasta: 9,
                                                            className: "stepper-ingles-largo-instance",
                                                            prendido: "two",
                                                            property2: "two"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"gQhkP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ButtonLargeWeb":"ichH4","../../../../../components/NavigationButton":"kzMNm","../../../../../components/StepperInglesLargo":"iJ3IU","../../../../../hooks/useDynamicColors":"b2GRH"}],"gQhkP":[function() {},{}],"gbhH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboarding", ()=>(0, _pixieOnboarding.PixieOnboarding));
var _pixieOnboarding = require("./PixieOnboarding");

},{"./PixieOnboarding":"5nZn5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5nZn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboarding", ()=>PixieOnboarding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _iconDropdownDown2 = require("../../../../../icons/IconDropdownDown2");
var _unitedStates2 = require("../../../../../icons/UnitedStates2");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboarding = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-pixie-mobile${currentParams}`);
    };
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_tutorial_easy-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-16",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-31",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rectangle-31"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-139",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-140",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-141"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-33",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitedStates2.UnitedStates2), {
                                            className: "united-states-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDropdownDown2.IconDropdownDown2), {
                                            className: "icon-dropdown-down-2"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-125",
                            children: "\uEA08"
                        })
                    ]
                }),
                colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: colors.url_logo
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "inicio-de-sesion-de-2",
                    src: "/img/inicio-de-sesion-de-usuario-1-1.svg"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-5",
                    children: "Welcome, Mary"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subtitle-6",
                    children: "Enter your info"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "action-buttons-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClickLogin,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                                className: "test-button-4 highlighted-button",
                                disabled: "off",
                                endIcon: false,
                                label: "Log in by Password",
                                onColor: "off",
                                size: "large",
                                startIcon: false,
                                textClassName: "test-button-5",
                                type: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClick,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "test-button-6 highlighted-button",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-wrapper-126",
                                    children: "Sign in"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"7hfXP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../icons/IconDropdownDown2":"aPdpV","../../../../../icons/UnitedStates2":"bwYtW","../../../../../hooks/useDynamicColors":"b2GRH"}],"7hfXP":[function() {},{}],"4WDBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieLanding", ()=>(0, _pixieLanding.PixieLanding));
var _pixieLanding = require("./PixieLanding");

},{"./PixieLanding":"1EntR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EntR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieLanding", ()=>PixieLanding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _btnIcon = require("../../../../../components/BtnIcon");
var _btnIconFilterWrapper = require("../../../../../components/BtnIconFilterWrapper");
var _diamondTextIcon = require("../../../../../components/DiamondTextIcon");
var _idDiamondDown = require("../../../../../components/IdDiamondDown");
var _mainMenu = require("../../../../../components/MainMenu");
var _movements = require("../../../../../components/Movements");
var _orientationWrapper = require("../../../../../components/OrientationWrapper");
var _section = require("../../../../../components/Section");
var _statusOnWrapper = require("../../../../../components/StatusOnWrapper");
var _subsection = require("../../../../../components/Subsection");
var _btnIconActivity1 = require("../../../../../icons/BtnIconActivity1");
var _btnIconClose1 = require("../../../../../icons/BtnIconClose1");
var _btnIconEyeOff1 = require("../../../../../icons/BtnIconEyeOff1");
var _btnIconMenu1 = require("../../../../../icons/BtnIconMenu1");
var _btnIconSearch = require("../../../../../icons/BtnIconSearch");
var _btnIconSettings2 = require("../../../../../icons/BtnIconSettings2");
var _idDiamondCar1 = require("../../../../../icons/IdDiamondCar1");
var _idDiamondCard1 = require("../../../../../icons/IdDiamondCard1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieLanding = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-card_details-pixie-mobile${currentParams}`);
    };
    const scrollRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pixie-landing",
        ref: scrollRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-17",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-25",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-32"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-142",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "account-balance",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-143",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "quick-pay-main",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-127",
                                                        children: "Balance (USD) | ****2357"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-144",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconEyeOff1.BtnIconEyeOff1), {
                                                                className: "btn-icon-chevron-2",
                                                                color: colors.secundario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-128",
                                                                children: "$13,000.23"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                width: 25,
                                                                height: 25,
                                                                viewBox: "0 0 25 25",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M9 19L16 13L9 7",
                                                                    stroke: colors.secundario,
                                                                    strokeWidth: 2,
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-2"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-145",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _diamondTextIcon.DiamondTextIcon), {
                                                                btnDiamondIconBtnIconAdd6Color: colors.secundario,
                                                                className: "diamond-text-icon-instance",
                                                                label: "Add money",
                                                                orientation: "horizontal",
                                                                textClassName: "diamond-text-icon-2"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _diamondTextIcon.DiamondTextIcon), {
                                                                btnDiamondIconIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconActivity1.BtnIconActivity1), {
                                                                    className: "icon-instance-node-4"
                                                                }),
                                                                className: "diamond-text-icon-3",
                                                                label: "View activity",
                                                                orientation: "horizontal",
                                                                textClassName: "diamond-text-icon-2"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "img-slider-dots-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusOnWrapper.StatusOnWrapper), {
                                                    className: "slider-dots-3",
                                                    status: "on"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusOnWrapper.StatusOnWrapper), {
                                                    className: "slider-dots-4",
                                                    status: "off"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusOnWrapper.StatusOnWrapper), {
                                                    className: "slider-dots-4",
                                                    status: "off"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _section.Section), {
                                    className: "section-instance",
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconFilterWrapper.BtnIconFilterWrapper), {}),
                                    override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconSettings2.BtnIconSettings2), {
                                        className: "btn-icon-settings"
                                    }),
                                    section: "MY SHORTCUTS",
                                    sectionClassName: "section-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "botonera-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-146",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 107,
                                                            height: 108,
                                                            viewBox: "0 0 107 108",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M10.0919 64.1114C4.62453 58.6441 4.62454 49.7798 10.0919 44.3124L53.3671 1.03721L96.6423 44.3124C102.11 49.7798 102.11 58.6441 96.6423 64.1114L53.3671 107.387L10.0919 64.1114Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                                    clipPath: "url(#clip0_2627_1420)",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M72.1035 63.9575C72.1035 73.3263 64.5148 80.915 55.146 80.915C45.7772 80.915 38.1885 73.3263 38.1885 63.9575C38.1885 54.5887 45.7772 47 55.146 47C64.5148 47 72.1035 54.5887 72.1035 63.9575Z",
                                                                            fill: colors.primario
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M80.2483 53.3717C78.3759 54.9148 75.4164 55.0472 73.474 52.9626L68.652 47.7862C68.0285 49.7898 66.1573 51.2488 63.9514 51.2488H55.3463C54.6933 51.2488 54.4747 51.4982 53.3405 52.372C49.016 56.1419 42.5207 56.1299 38.2093 52.3359L35.0464 49.5514C33.6246 50.3039 31.9644 50.3225 30.5349 49.6083L26.9072 47.795C26.0967 47.3892 25.7687 46.4038 26.1733 45.5933L36.0165 25.9071C36.4222 25.0966 37.4076 24.7686 38.2181 25.1731L41.8458 26.9876C43.634 27.8811 44.6292 29.7054 44.5647 31.5624H63.9513C67.5462 31.5624 70.9815 33.2795 73.1382 36.1558L81.0139 46.6573C82.5417 48.6928 82.3 51.6776 80.2483 53.3717ZM40.378 29.922L38.218 28.8415L29.8415 45.5933L32.0026 46.6739C32.8131 47.0785 33.7973 46.7515 34.2031 45.94L41.1119 32.1224C41.5166 31.312 41.1885 30.3278 40.378 29.922ZM78.389 48.6261L70.5134 38.1246C68.9725 36.0695 66.5193 34.8435 63.9514 34.8435H43.4196L37.272 47.1398L40.3769 49.8729C43.4665 52.5907 48.1257 52.5907 51.2153 49.8729C53.0352 48.2706 54.1671 47.9677 55.3462 47.9677H63.9513C64.8558 47.9677 65.5918 47.2316 65.5918 46.3271C65.5918 45.4227 64.8557 44.6866 63.9513 44.6866H55.5726C54.667 44.6866 53.9321 43.9516 53.9321 43.0461C53.9321 42.1406 54.6671 41.4056 55.5726 41.4056H65.0505C66.4121 41.4056 67.7246 41.9765 68.652 42.9728L75.8747 50.726C76.5353 51.4347 77.548 51.3757 78.1693 50.8321C78.8188 50.2634 78.8889 49.2911 78.389 48.6261Z",
                                                                            fill: colors.terciario
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M40.378 29.922L38.218 28.8415L29.8415 45.5933L32.0026 46.6739C32.8131 47.0785 33.7973 46.7515 34.2031 45.94L41.1119 32.1224C41.5166 31.312 41.1885 30.3278 40.378 29.922Z",
                                                                            fill: colors.septimo
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M55.135 58.6953C56.0138 58.6953 56.7288 59.4103 56.7288 60.2891H59.5629C59.5629 58.3431 58.3005 56.6875 56.552 56.0951V53.792H53.7179V56.0951C51.9694 56.6875 50.707 58.3431 50.707 60.2891C50.707 62.7307 52.6934 64.7171 55.135 64.7171C56.0138 64.7171 56.7288 65.432 56.7288 66.3109C56.7288 67.1897 56.0138 67.9047 55.135 67.9047C54.2561 67.9047 53.5412 67.1897 53.5412 66.3109H50.707C50.707 68.2569 51.9694 69.9125 53.7179 70.5049V72.808H56.552V70.5049C58.3005 69.9125 59.5629 68.2569 59.5629 66.3109C59.5629 63.8693 57.5766 61.8829 55.135 61.8829C54.2561 61.8829 53.5412 61.168 53.5412 60.2891C53.5412 59.4103 54.2561 58.6953 55.135 58.6953Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                        id: "clip0_2627_1420",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                            width: 56,
                                                                            height: 56,
                                                                            fill: "white",
                                                                            transform: "translate(26 25)"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "Send"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 107,
                                                            height: 107,
                                                            viewBox: "0 0 107 107",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M9.91805 63.4893C4.45071 58.022 4.45071 49.1577 9.91805 43.6903L53.1153 0.493134L96.3125 43.6903C101.78 49.1577 101.78 58.022 96.3125 63.4893L53.1153 106.687L9.91805 63.4893Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                                    clipPath: "url(#clip0_2627_1430)",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M71.2187 42.9575C71.2187 52.3263 63.63 59.915 54.2612 59.915C44.8924 59.915 37.3037 52.3263 37.3037 42.9575C37.3037 33.5887 44.8924 26 54.2612 26C63.63 26 71.2187 33.5887 71.2187 42.9575Z",
                                                                            fill: colors.primario
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M79.3635 53.6269C77.4911 52.0837 74.5316 51.9514 72.5892 54.0359L67.7672 59.2123C67.1438 57.2087 65.2725 55.7497 63.0666 55.7497H54.4615C53.8086 55.7497 53.5899 55.5004 52.4557 54.6266C48.1312 50.8566 41.6359 50.8687 37.3245 54.6627L34.1616 57.4471C32.7399 56.6946 31.0797 56.676 29.6501 57.3903L26.0224 59.2036C25.2119 59.6094 24.8839 60.5947 25.2885 61.4052L35.1317 81.0915C35.5375 81.902 36.5228 82.23 37.3333 81.8254L40.961 80.011C42.7492 79.1175 43.7444 77.2931 43.6799 75.4361H63.0665C66.6614 75.4361 70.0967 73.7191 72.2535 70.8427L80.1291 60.3412C81.657 58.3057 81.4153 55.321 79.3635 53.6269ZM39.4932 77.0765L37.3332 78.1571L28.9567 61.4052L31.1178 60.3247C31.9283 59.92 32.9126 60.247 33.3184 61.0586L40.2271 74.8761C40.6318 75.6865 40.3037 76.6708 39.4932 77.0765ZM77.5042 58.3724L69.6287 68.874C68.0877 70.929 65.6345 72.155 63.0666 72.155H42.5348L36.3872 59.8587L39.4921 57.1257C42.5818 54.4078 47.2409 54.4078 50.3305 57.1257C52.1504 58.7279 53.2824 59.0309 54.4614 59.0309H63.0665C63.971 59.0309 64.707 59.767 64.707 60.6714C64.707 61.5758 63.9709 62.3119 63.0665 62.3119H54.6878C53.7822 62.3119 53.0473 63.0469 53.0473 63.9524C53.0473 64.8579 53.7823 65.5929 54.6878 65.5929H64.1657C65.5273 65.5929 66.8398 65.022 67.7672 64.0257L74.9899 56.2725C75.6505 55.5638 76.6632 55.6229 77.2845 56.1665C77.9341 56.7351 78.0042 57.7074 77.5042 58.3724Z",
                                                                            fill: colors.terciario
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M39.4932 77.0765L37.3332 78.1571L28.9567 61.4052L31.1178 60.3247C31.9283 59.92 32.9126 60.247 33.3184 61.0586L40.2271 74.8761C40.6318 75.6865 40.3037 76.6708 39.4932 77.0765Z",
                                                                            fill: colors.septimo
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M54.2502 37.6953C55.1291 37.6953 55.844 38.4103 55.844 39.2891H58.6781C58.6781 37.3431 57.4157 35.6875 55.6673 35.0951V32.792H52.8331V35.0951C51.0847 35.6875 49.8223 37.3431 49.8223 39.2891C49.8223 41.7307 51.8086 43.7171 54.2502 43.7171C55.1291 43.7171 55.844 44.432 55.844 45.3109C55.844 46.1897 55.1291 46.9047 54.2502 46.9047C53.3713 46.9047 52.6564 46.1897 52.6564 45.3109H49.8223C49.8223 47.2569 51.0847 48.9125 52.8331 49.5049V51.808H55.6673V49.5049C57.4157 48.9125 58.6781 47.2569 58.6781 45.3109C58.6781 42.8693 56.6918 40.8829 54.2502 40.8829C53.3713 40.8829 52.6564 40.168 52.6564 39.2891C52.6564 38.4103 53.3713 37.6953 54.2502 37.6953Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                        id: "clip0_2627_1430",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                            width: 56,
                                                                            height: 56,
                                                                            fill: "white",
                                                                            transform: "translate(25.1152 26)"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "Receive"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "btn-diamond-icon-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-group-28",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "rectangle-34"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "global",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                            width: 50,
                                                                            height: 50,
                                                                            viewBox: "0 0 50 50",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                                                    clipPath: "url(#clip0_2627_1442)",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M0.154297 24.6866C0.154297 38.1544 11.146 49.1472 24.6142 49.1482C38.083 49.148 49.0774 38.1549 49.0774 24.6866C49.0774 11.2176 38.0841 0.225098 24.6158 0.225098C11.164 0.225098 0.154297 11.2059 0.154297 24.6866ZM3.02088 24.6866C3.02088 20.3998 4.27664 16.4008 6.43938 13.0378L9.1613 13.7006C9.63935 13.8202 10.0268 14.1479 10.2241 14.5998C10.4213 15.051 10.3974 15.559 10.1587 15.9936C9.12174 17.8815 9.74513 20.3175 11.5777 21.5392L17.7708 25.6679L19.1945 28.5153C19.6795 29.4851 19.4901 30.6517 18.7235 31.4184L17.8691 32.2728C17.3094 32.8325 17.3094 33.74 17.8691 34.2997L19.5793 36.0099C20.0543 36.4849 20.3159 37.1163 20.3159 37.7881C20.3159 40.7005 20.9794 43.5875 22.2331 46.1493C11.4428 44.9597 3.02088 35.7888 3.02088 24.6866ZM21.7586 27.2335L21.2018 26.1199H21.4109C22.8414 26.1199 24.1275 26.9147 24.7672 28.1942C25.8957 30.4511 28.1641 31.8531 30.6875 31.8531H31.7823V33.2864C31.7823 34.4453 31.3281 35.5319 30.5033 36.3463C27.8578 38.9584 25.8793 41.5689 24.5153 44.2571C23.6525 42.2597 23.1825 39.9935 23.1825 37.7883C23.1825 36.3509 22.6228 34.9996 21.6064 33.9832L20.9064 33.2831C22.4158 31.6434 22.7625 29.2412 21.7586 27.2335ZM26.7714 46.1743C27.9934 43.5478 29.8875 40.9828 32.5173 38.3861C33.8919 37.029 34.6489 35.2179 34.6489 33.2864V30.4198C34.6489 29.6282 34.0072 28.9865 33.2156 28.9865H30.6874C29.2568 28.9865 27.9708 28.1917 27.3311 26.9123C26.2027 24.6554 23.9342 23.2533 21.4109 23.2533H19.7685L19.3327 22.3816C18.5604 20.837 19.2608 18.9576 20.9272 18.1028C22.2971 17.4002 23.1825 15.863 23.1825 14.1866V13.2203C23.1825 12.43 23.8255 11.787 24.6158 11.787H26.3452C29.2931 11.787 31.3613 8.87951 30.4187 6.1101L29.6066 3.67494C32.8208 4.43831 35.7588 5.92196 38.2406 7.94558L37.8031 9.25838C37.733 9.4685 37.6133 9.66219 37.4568 9.8187L35.9083 11.3672C35.0962 12.1793 34.6489 13.2592 34.6489 14.4077V16.0869C34.6489 18.4578 36.5778 20.3868 38.9488 20.3868C39.7391 20.3868 40.3821 21.0297 40.3821 21.82V24.0099C40.3821 24.2312 40.3297 24.4529 40.2308 24.6509L39.7411 25.6303C39.0698 26.973 39.1402 28.5369 39.9293 29.8138C40.7186 31.0908 42.0859 31.8521 43.587 31.8521H44.9868C42.254 39.5976 35.2226 45.3328 26.7714 46.1743ZM46.2108 24.6866C46.2108 26.1586 46.0622 27.5965 45.7802 28.9865H43.587C42.8658 28.9865 42.4941 28.5111 42.3677 28.3067C42.2414 28.1024 41.9825 27.5573 42.305 26.9123L42.7948 25.9328C43.0917 25.3389 43.2486 24.6739 43.2486 24.0099V21.82C43.2486 19.4491 41.3197 17.5202 38.9488 17.5202C38.1584 17.5202 37.5155 16.8772 37.5155 16.0869V14.4076C37.5155 14.0247 37.6645 13.6648 37.9352 13.3942L39.4838 11.8458C39.9533 11.3763 40.3125 10.7952 40.5226 10.165L40.5392 10.1152C44.0595 13.9588 46.2108 19.0761 46.2108 24.6866ZM24.6158 3.09168C25.2219 3.09168 25.8219 3.11806 26.4156 3.16727L27.7021 7.02521C28.019 7.95628 27.3284 8.92041 26.3452 8.92041H24.6158C22.2449 8.92041 20.316 10.8493 20.316 13.2202V14.1865C20.316 14.7896 20.0359 15.3384 19.619 15.5523C17.3825 16.6993 16.1096 18.8902 16.1465 21.1399L13.1679 19.1542C12.5628 18.7507 12.3446 17.9686 12.6714 17.3736C13.3414 16.1538 13.4068 14.7246 12.8512 13.4524C12.2952 12.1795 11.2037 11.2564 9.84814 10.9176L8.31021 10.543C12.2726 5.98101 18.1131 3.09168 24.6158 3.09168Z",
                                                                                            fill: colors.terciario
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M24.6158 3.09168C25.2219 3.09168 25.8219 3.11806 26.4156 3.16727L27.7021 7.02521C28.019 7.95628 27.3284 8.92041 26.3452 8.92041H24.6158C22.2449 8.92041 20.316 10.8493 20.316 13.2202V14.1865C20.316 14.7896 20.0359 15.3384 19.619 15.5523C17.3825 16.6993 16.1096 18.8902 16.1465 21.1399L13.1679 19.1542C12.5628 18.7507 12.3446 17.9686 12.6714 17.3736C13.3414 16.1538 13.4068 14.7246 12.8512 13.4524C12.2952 12.1795 11.2037 11.2564 9.84814 10.9176L8.31021 10.543C12.2726 5.98101 18.1131 3.09168 24.6158 3.09168Z",
                                                                                            fill: colors.septimo
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M21.7586 27.2335L21.2018 26.1199H21.4109C22.8414 26.1199 24.1275 26.9147 24.7672 28.1942C25.8957 30.4511 28.1641 31.8531 30.6875 31.8531H31.7823V33.2864C31.7823 34.4453 31.3281 35.5319 30.5033 36.3463C27.8578 38.9584 25.8793 41.5689 24.5153 44.2571C23.6525 42.2597 23.1825 39.9935 23.1825 37.7883C23.1825 36.3509 22.6228 34.9996 21.6064 33.9832L20.9064 33.2831C22.4158 31.6434 22.7625 29.2412 21.7586 27.2335Z",
                                                                                            fill: colors.septimo
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M46.2108 24.6866C46.2108 26.1586 46.0622 27.5965 45.7802 28.9865H43.587C42.8658 28.9865 42.4941 28.5111 42.3677 28.3067C42.2414 28.1024 41.9825 27.5573 42.305 26.9123L42.7948 25.9328C43.0917 25.3389 43.2486 24.6739 43.2486 24.0099V21.82C43.2486 19.4491 41.3197 17.5202 38.9488 17.5202C38.1584 17.5202 37.5155 16.8772 37.5155 16.0869V14.4076C37.5155 14.0247 37.6645 13.6648 37.9352 13.3942L39.4838 11.8458C39.9533 11.3763 40.3125 10.7952 40.5226 10.165L40.5392 10.1152C44.0595 13.9588 46.2108 19.0761 46.2108 24.6866Z",
                                                                                            fill: colors.septimo
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                                        id: "clip0_2627_1442",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                                            width: 48.9231,
                                                                                            height: 48.9231,
                                                                                            fill: "white",
                                                                                            transform: "translate(0.154297 0.224609)"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "Global Transf"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-146",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "btn-diamond-img-6",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-150",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "group-38",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "overlap-group-29",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "ellipse-20"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "goals",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                    width: 44,
                                                                                    height: 44,
                                                                                    viewBox: "0 0 44 44",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                        d: "M43.0276 8.96379C43.1298 9.21109 43.1567 9.48328 43.1049 9.74593C43.0531 10.0086 42.9249 10.2499 42.7365 10.4394L37.3452 15.8544C37.2198 15.98 37.071 16.0796 36.9073 16.1474C36.7435 16.2152 36.5681 16.25 36.391 16.2496H28.8621L25.2149 19.9129C25.626 20.7774 25.7196 21.76 25.4792 22.6871C25.2387 23.6142 24.6797 24.4261 23.9009 24.9792C23.1221 25.5324 22.1737 25.7912 21.2233 25.7099C20.2728 25.6286 19.3816 25.2125 18.7072 24.535C18.0327 23.8576 17.6184 22.9625 17.5375 22.0079C17.4565 21.0533 17.7142 20.1007 18.2649 19.3185C18.8157 18.5362 19.624 17.9748 20.547 17.7332C21.4701 17.4917 22.4484 17.5858 23.3091 17.9987L26.9563 14.3354V6.77343C26.956 6.59554 26.9906 6.41932 27.0581 6.25486C27.1256 6.09041 27.2248 5.94093 27.3498 5.81498L32.7411 0.400003C32.9296 0.210189 33.17 0.0808679 33.4317 0.0284326C33.6935 -0.0240028 33.9649 0.00280972 34.2115 0.105471C34.458 0.208132 34.6687 0.382019 34.8168 0.605087C34.9649 0.828154 35.0436 1.09036 35.0432 1.35845V8.12718H41.7822C42.0489 8.12722 42.3096 8.20674 42.5313 8.35566C42.753 8.50459 42.9257 8.71623 43.0276 8.96379ZM38.5286 10.8347H33.6953C33.3379 10.8347 32.9951 10.692 32.7423 10.4382C32.4895 10.1843 32.3475 9.83996 32.3475 9.48092V4.62639L29.6519 7.33388V13.5422H35.833L38.5286 10.8347ZM42.0707 14.9365C42.7581 17.0538 43.13 19.3172 43.13 21.6646C43.1291 26.2401 41.6855 30.6978 39.0064 34.3983C36.3273 38.0989 32.5503 40.8523 28.217 42.2636C23.8837 43.675 19.2167 43.6718 14.8853 42.2546C10.5539 40.8373 6.78057 38.0788 4.10646 34.3746C1.43236 30.6703 -0.00517258 26.2107 1.39855e-05 21.6352C0.00520055 17.0598 1.45284 12.6035 4.13533 8.90537C6.81783 5.20728 10.5974 2.45739 14.932 1.05005C19.2666 -0.357296 23.9336 -0.3498 28.2637 1.07146L26.0856 3.25911C22.0842 2.26815 17.8698 2.62023 14.0863 4.26156C10.3029 5.90288 7.15852 8.74318 5.13361 12.3485C3.1087 15.9538 2.31463 20.1258 2.87274 24.227C3.43086 28.3283 5.31045 32.1332 8.22433 35.0605C11.1382 37.9878 14.9261 39.8764 19.0093 40.4378C23.0925 40.9991 27.2464 40.2024 30.8363 38.1693C34.4262 36.1362 37.2546 32.9785 38.8895 29.1787C40.5244 25.379 40.8757 21.1461 39.8899 17.1269L42.0707 14.9365ZM34.7736 18.9571C35.3525 21.8083 35.0014 24.7709 33.7722 27.4059C32.5431 30.0409 30.5013 32.2079 27.9496 33.5858C25.3979 34.9637 22.472 35.4791 19.6058 35.0556C16.7395 34.6322 14.0854 33.2923 12.0368 31.2347C9.98826 29.1772 8.6543 26.5114 8.23267 23.6325C7.81104 20.7536 8.32418 17.8149 9.69604 15.252C11.0679 12.689 13.2255 10.6383 15.8489 9.40371C18.4723 8.16914 21.422 7.81645 24.2607 8.39792V11.1758C21.9706 10.5824 19.5499 10.7617 17.3713 11.6861C15.1927 12.6105 13.3772 14.2286 12.2042 16.2913C11.0313 18.3539 10.5661 20.7467 10.8802 23.1011C11.1944 25.4554 12.2705 27.6407 13.9428 29.3204C15.6151 31 17.7908 32.0809 20.1349 32.3964C22.4789 32.712 24.8612 32.2447 26.9148 31.0666C28.9685 29.8885 30.5795 28.0649 31.4998 25.8768C32.4201 23.6886 32.5987 21.2572 32.0079 18.9571H34.7736Z",
                                                                                        fill: colors.terciario
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "My Goals"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 108,
                                                            height: 108,
                                                            viewBox: "0 0 108 108",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M10.5919 64.1114C5.12453 58.6441 5.12454 49.7798 10.5919 44.3124L53.8671 1.03721L97.1423 44.3124C102.61 49.7798 102.61 58.6441 97.1423 64.1114L53.8671 107.387L10.5919 64.1114Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M52.4909 43.5541L45.6906 50.3543C45.0484 50.9965 44.0189 50.9965 43.3861 50.3543L36.5859 43.5541L43.3861 36.7539C44.0284 36.1116 45.0579 36.1116 45.6906 36.7539L52.4909 43.5541Z",
                                                                    fill: colors.septimo
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M55.0001 60.4659C61.637 60.4659 67.0129 65.7537 67.0129 72.2818C67.0129 78.8099 61.637 84.0977 55.0001 84.0977C48.3632 84.0977 42.9873 78.8099 42.9873 72.2818C42.9873 65.7537 48.3632 60.4659 55.0001 60.4659Z",
                                                                    fill: colors.primario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M74.3946 45.8509C74.3946 46.5119 74.2661 47.18 74.0014 47.8187C73.21 49.7313 71.3679 50.9671 69.3089 50.9671L64.9386 50.9671C63.8166 50.9671 62.9069 50.0578 62.9069 48.9359C62.9069 47.8139 63.8166 46.9042 64.9386 46.9042L69.3089 46.9042C69.9175 46.9042 70.1678 46.4571 70.2476 46.2651C70.3285 46.0695 70.4694 45.5673 70.031 45.1293L56.5406 31.6556C55.746 30.8617 54.453 30.8617 53.6584 31.6556L40.1684 45.1293C39.73 45.5673 39.8705 46.0695 39.9514 46.2647C40.0311 46.4571 40.2819 46.9042 40.8904 46.9042L53.1696 46.9042C55.4099 46.9042 57.2325 48.7268 57.2325 50.9671L57.2325 76.9687C57.2325 78.0907 56.3232 79 55.2012 79C54.0793 79 53.1696 78.0907 53.1696 76.9687L53.1696 50.9671L40.8904 50.9671C38.8314 50.9671 36.989 49.7313 36.1975 47.8187C35.4033 45.8993 35.8349 43.7153 37.2973 42.255L50.7872 28.7813C53.1652 26.4064 57.0341 26.4064 59.4121 28.7813L72.9021 42.255C73.8777 43.2293 74.3942 44.5258 74.3946 45.8509Z",
                                                                    fill: colors.terciario
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "Top-ups"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "diamond-text-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 107,
                                                            height: 108,
                                                            viewBox: "0 0 107 108",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M10.0919 64.1114C4.62453 58.6441 4.62454 49.7798 10.0919 44.3124L53.3671 1.03721L96.6423 44.3124C102.11 49.7798 102.11 58.6441 96.6423 64.1114L53.3671 107.387L10.0919 64.1114Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M39.5533 49.0437L29.3652 38.8556C28.403 37.8934 28.403 36.351 29.3652 35.403L39.5533 25.2148L49.7415 35.403C50.7037 36.3652 50.7037 37.9075 49.7415 38.8556L39.5533 49.0437Z",
                                                                    fill: colors.septimo
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M46.3613 53.9658H45.541C44.6349 53.9658 43.9004 54.7003 43.9004 55.6064C43.9004 56.5126 44.6349 57.2471 45.541 57.2471H46.3613C47.2674 57.2471 48.002 56.5126 48.002 55.6064C48.002 54.7003 47.2674 53.9658 46.3613 53.9658Z",
                                                                    fill: colors.primario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.5215 47.4033H52.1035C51.1974 47.4033 50.4629 48.1378 50.4629 49.0439C50.4629 49.9501 51.1974 50.6846 52.1035 50.6846H62.5215C63.4276 50.6846 64.1621 49.9501 64.1621 49.0439C64.1621 48.1378 63.4276 47.4033 62.5215 47.4033Z",
                                                                    fill: colors.terciario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M59.8874 71.9307H43.9004C42.0911 71.9307 40.6191 70.4587 40.6191 68.6494V39.7744C40.6191 37.9651 42.0911 36.4932 43.9004 36.4932H64.071C65.8803 36.4932 67.3522 37.9651 67.3522 39.7744V49.0439C67.3522 49.9501 68.0867 50.6846 68.9928 50.6846C69.899 50.6846 70.6335 49.9501 70.6335 49.0439V39.7744C70.6335 36.1559 67.6895 33.2119 64.071 33.2119H43.9004C40.2818 33.2119 37.3379 36.1559 37.3379 39.7744V68.6494C37.3379 72.268 40.2818 75.2119 43.9004 75.2119H59.8874C60.7935 75.2119 61.528 74.4774 61.528 73.5713C61.528 72.6652 60.7935 71.9307 59.8874 71.9307Z",
                                                                    fill: colors.terciario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M46.3613 60.5283H45.541C44.6349 60.5283 43.9004 61.2628 43.9004 62.1689C43.9004 63.0751 44.6349 63.8096 45.541 63.8096H46.3613C47.2674 63.8096 48.002 63.0751 48.002 62.1689C48.002 61.2628 47.2674 60.5283 46.3613 60.5283Z",
                                                                    fill: colors.primario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.5215 40.8408H52.1035C51.1974 40.8408 50.4629 41.5753 50.4629 42.4814C50.4629 43.3876 51.1974 44.1221 52.1035 44.1221H62.5215C63.4276 44.1221 64.1621 43.3876 64.1621 42.4814C64.1621 41.5753 63.4276 40.8408 62.5215 40.8408Z",
                                                                    fill: colors.terciario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M70.0388 62.7394H68.5354C67.8001 62.7394 67.202 62.1306 67.202 61.3822V61.1605C67.202 60.4259 67.7752 59.8721 68.5354 59.8721H69.957C70.3749 59.8721 70.807 60.1518 70.807 60.6199C70.807 61.526 71.5415 62.2605 72.4476 62.2605C73.3537 62.2605 74.0882 61.526 74.0882 60.6199C74.0882 58.6537 72.6363 57.013 70.7233 56.6614V55.6064C70.7233 54.7003 69.9888 53.9658 69.0827 53.9658C68.1766 53.9658 67.4421 54.7003 67.4421 55.6064V56.7178C66.6301 56.9094 65.8863 57.3143 65.2831 57.9046C64.4045 58.7642 63.9207 59.9205 63.9207 61.1605V61.3822C63.9207 63.9398 65.9908 66.0206 68.5354 66.0206H70.0388C70.7789 66.0206 71.3812 66.6203 71.3812 67.3573V68.1366C71.3812 68.8498 70.8041 69.3877 70.0388 69.3877H67.5955C67.133 69.3877 66.7842 69.0566 66.7842 68.6175C66.7842 67.7114 66.0497 66.9769 65.1436 66.9769C64.2374 66.9769 63.5029 67.7114 63.5029 68.6175C63.5029 69.7164 63.9336 70.7419 64.7156 71.5054C65.448 72.2204 66.4112 72.6283 67.4421 72.6653V73.5713C67.4421 74.4774 68.1766 75.2119 69.0827 75.2119C69.9888 75.2119 70.7233 74.4774 70.7233 73.5713V72.6211C72.9801 72.3058 74.6625 70.4496 74.6625 68.1366V67.3573C74.6625 64.811 72.5883 62.7394 70.0388 62.7394Z",
                                                                    fill: colors.primario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M59.2402 63.8096C60.1464 63.8096 60.8809 63.0751 60.8809 62.1689C60.8809 61.2628 60.1464 60.5283 59.2402 60.5283H52.1035C51.1974 60.5283 50.4629 61.2628 50.4629 62.1689C50.4629 63.0751 51.1974 63.8096 52.1035 63.8096H59.2402Z",
                                                                    fill: colors.terciario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M46.3613 47.4033H45.541C44.6349 47.4033 43.9004 48.1378 43.9004 49.0439C43.9004 49.9501 44.6349 50.6846 45.541 50.6846H46.3613C47.2674 50.6846 48.002 49.9501 48.002 49.0439C48.002 48.1378 47.2674 47.4033 46.3613 47.4033Z",
                                                                    fill: colors.primario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M64.1621 55.6064C64.1621 54.7003 63.4276 53.9658 62.5215 53.9658H52.1035C51.1974 53.9658 50.4629 54.7003 50.4629 55.6064C50.4629 56.5126 51.1974 57.2471 52.1035 57.2471H62.5215C63.4276 57.2471 64.1621 56.5126 64.1621 55.6064Z",
                                                                    fill: colors.terciario
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M46.3613 40.8408H45.541C44.6349 40.8408 43.9004 41.5753 43.9004 42.4814C43.9004 43.3876 44.6349 44.1221 45.541 44.1221H46.3613C47.2674 44.1221 48.002 43.3876 48.002 42.4814C48.002 41.5753 47.2674 40.8408 46.3613 40.8408Z",
                                                                    fill: colors.primario
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-135",
                                                            children: "Pay bills"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "tarjetas-accion",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subsection.Subsection), {
                                            subsection: "My cards",
                                            subsectionClassName: "subsection-instance"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "highlighted-button",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-151 highlighted-button",
                                                    onClick: handleButtonClick,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "credit-card-main",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "contenido",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "tarjeta",
                                                                    style: {
                                                                        backgroundImage: colors.url_card ? `url(${colors.url_card})` : "url(../../../../../../static/img/image-2.png)",
                                                                        backgroundColor: colors.url_card ? "transparent" : "#F2F3F7",
                                                                        backgroundSize: "100% 100%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "overlap-group-30",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "image-12"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "btn-icon-chevron-4",
                                                                                alt: "Btn icon chevron",
                                                                                src: "/img/btn-icon-chevron-4.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-152",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-136",
                                                                                        children: "GOLD"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-137",
                                                                                        children: "****5849"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "txt",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "frame-153",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-138",
                                                                                    children: "$ 1,250"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-139",
                                                                                    children: "Available"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "frame-154",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-140",
                                                                                    children: "Pay date"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-141",
                                                                                    children: "04/14"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orientationWrapper.OrientationWrapper), {
                                                                    btnDiamondIconIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconSearch.BtnIconSearch), {
                                                                        className: "icon-instance-node-4",
                                                                        color: "white"
                                                                    }),
                                                                    btnDiamondIconRectangleClassName: "diamond-text-icon-6",
                                                                    className: "diamond-text-icon-5",
                                                                    label: "CVV",
                                                                    orientation: "vertical",
                                                                    textClassName: "diamond-text-icon-7"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-155",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "latest-transactions",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "subsection-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-156",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subsection-7",
                                                            children: "Last Transactions"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-157",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "btn-text-link-5",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-link-3",
                                                                    children: "More"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                    width: 25,
                                                                    height: 25,
                                                                    viewBox: "0 0 25 25",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M9 19L16 13L9 7",
                                                                        stroke: colors.secundario,
                                                                        strokeWidth: 2,
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "latest-transactions-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-158",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movements.Movements), {
                                                        amountClassName: "movements-6",
                                                        className: "movements-instance",
                                                        dateClassName: "movements-5",
                                                        divClassName: "movements-2-instance",
                                                        frameClassName: "movements-4",
                                                        movement: "Purchase Starbucks",
                                                        override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idDiamondCard1.IdDiamondCard1), {
                                                            className: "icon-instance-node-5",
                                                            color: colors.terciario
                                                        }),
                                                        text: "- $18.40"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movements.Movements), {
                                                        amountClassName: "movements-6",
                                                        className: "movements-instance",
                                                        dateClassName: "movements-5",
                                                        divClassName: "movements-2-instance",
                                                        frameClassName: "movements-7",
                                                        movement: "Purchase Merchant ABC Cash out",
                                                        override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idDiamondCar1.IdDiamondCar1), {
                                                            className: "icon-instance-node-5",
                                                            color: colors.terciario
                                                        }),
                                                        text: "- $90.10"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movements.Movements), {
                                                        className: "movements-8",
                                                        dateClassName: "movements-5",
                                                        divClassName: "movements-2-instance",
                                                        frameClassName: "movements-9",
                                                        movement: "Money received from Luz Marina",
                                                        override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idDiamondDown.IdDiamondDown), {
                                                            btnIconArrowColor: colors.terciario,
                                                            className: "design-component-instance-node-3",
                                                            rectangleClassName: "id-diamond-down-2"
                                                        }),
                                                        text: "$600.50"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "banner-promo-small",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-39",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group-31",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-142",
                                                        children: "We have great news"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-143",
                                                        children: "Wait our new launch"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconClose1.BtnIconClose1), {
                                            className: "btn-icon-close",
                                            color: "white"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "like",
                                            alt: "Like",
                                            src: "/img/like.svg"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-159",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-160",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "ellipse-21",
                                    alt: "Ellipse",
                                    src: "/img/ellipse-110.png"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "nice-to-see-u-mary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-144",
                                            children: "Nice to see u "
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-145",
                                            children: "Mary!"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-161",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIcon.BtnIcon), {
                                    className: "btn-icon-menu",
                                    divClassName: "btn-icon-2",
                                    ellipseClassName: "btn-icon-notifications-on-instance",
                                    overlapGroupClassName: "btn-icon-notifications-on",
                                    vector: "/img/vector-8.svg",
                                    vectorClassName: "btn-icon-instance"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMenu1.BtnIconMenu1), {
                                    className: "btn-icon-menu"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainMenu.MainMenu), {
                    btnMenuHomeFluentHome: "/img/fluent-home-12-filled-2.svg",
                    btnMenuMoreRegularMenuDots: "/img/regular-menu-dots-4.svg",
                    color: colors.primario,
                    btnMenuRequestProfits: "/img/profits-1-2.svg",
                    btnMenuSendMingcuteSendPlane: "/img/mingcute-send-plane-line-2.svg",
                    className: "main-menu-instance"
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"49Ngc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/BtnIcon":"az1oC","../../../../../components/BtnIconFilterWrapper":"ayG5A","../../../../../components/DiamondTextIcon":"22Bgs","../../../../../components/IdDiamondDown":"hJ445","../../../../../components/MainMenu":"bp4q3","../../../../../components/Movements":"7XzSY","../../../../../components/OrientationWrapper":"1xiyT","../../../../../components/Section":"2HPcb","../../../../../components/StatusOnWrapper":"gA1Ca","../../../../../components/Subsection":"9CEPp","../../../../../icons/BtnIconActivity1":"kgF93","../../../../../icons/BtnIconClose1":"1whhR","../../../../../icons/BtnIconEyeOff1":"7a5lB","../../../../../icons/BtnIconMenu1":"4QzDR","../../../../../icons/BtnIconSearch":"abtTV","../../../../../icons/BtnIconSettings2":"7zjj0","../../../../../icons/IdDiamondCar1":"1b9fi","../../../../../icons/IdDiamondCard1":"81oQv","../../../../../hooks/useDynamicColors":"b2GRH"}],"49Ngc":[function() {},{}],"az1oC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIcon", ()=>(0, _btnIcon.BtnIcon));
var _btnIcon = require("./BtnIcon");

},{"./BtnIcon":"bDX4X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bDX4X":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIcon", ()=>BtnIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnIcon = ({ className, overlapGroupClassName, vectorClassName, vector = "/img/vector-7.svg", ellipseClassName, divClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `btn-icon ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `overlap-group-3 ${overlapGroupClassName}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: `vector ${vectorClassName}`,
                    alt: "Vector",
                    src: vector
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `ellipse ${ellipseClassName}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `text-wrapper-5 ${divClassName}`,
                    children: "+9"
                })
            ]
        })
    });
};
BtnIcon.propTypes = {
    vector: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"l9h6M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9h6M":[function() {},{}],"ayG5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconFilterWrapper", ()=>(0, _btnIconFilterWrapper.BtnIconFilterWrapper));
var _btnIconFilterWrapper = require("./BtnIconFilterWrapper");

},{"./BtnIconFilterWrapper":"cYepR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cYepR":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconFilterWrapper", ()=>BtnIconFilterWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconFilter = require("../../icons/BtnIconFilter");
var _styleCss = require("./style.css");
const BtnIconFilterWrapper = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconFilter.BtnIconFilter), {
        className: "btn-icon-filter"
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../icons/BtnIconFilter":"9lZry","./style.css":"cMBm2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9lZry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconFilter", ()=>(0, _btnIconFilter.BtnIconFilter));
var _btnIconFilter = require("./BtnIconFilter");

},{"./BtnIconFilter":"gMTwf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMTwf":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconFilter", ()=>BtnIconFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconFilter = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-filter ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M21.3354 12.7703V3.39866C21.3354 3.17721 21.2474 2.96482 21.0909 2.80822C20.9343 2.65163 20.7219 2.56365 20.5004 2.56365C20.2789 2.56365 20.0666 2.65163 19.91 2.80822C19.7534 2.96482 19.6654 3.17721 19.6654 3.39866V12.7786C18.9891 12.96 18.3914 13.3594 17.9652 13.915C17.539 14.4705 17.308 15.1512 17.308 15.8515C17.308 16.5517 17.539 17.2324 17.9652 17.7879C18.3914 18.3435 18.9891 18.7429 19.6654 18.9243V21.5212C19.6654 21.7426 19.7534 21.955 19.91 22.1116C20.0666 22.2682 20.2789 22.3562 20.5004 22.3562C20.7219 22.3562 20.9343 22.2682 21.0909 22.1116C21.2474 21.955 21.3354 21.7426 21.3354 21.5212V18.9159C22.0118 18.7346 22.6094 18.3352 23.0356 17.7796C23.4618 17.224 23.6928 16.5433 23.6928 15.8431C23.6928 15.1429 23.4618 14.4622 23.0356 13.9066C22.6094 13.3511 22.0118 12.9516 21.3354 12.7703ZM22.2195 15.8648C22.2195 16.8142 21.4498 17.5839 20.5004 17.5839C19.551 17.5839 18.7813 16.8142 18.7813 15.8648C18.7813 14.9153 19.551 14.1457 20.5004 14.1457C21.4498 14.1457 22.2195 14.9153 22.2195 15.8648Z",
                fill: "var(--secundario)",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M12 2.63649C11.2252 2.63406 10.4761 2.9137 9.89239 3.4232C9.30871 3.93269 8.93042 4.63721 8.82816 5.4052C8.7259 6.17319 8.90665 6.95215 9.33667 7.59663C9.7667 8.24111 10.4166 8.70704 11.165 8.90742V21.5857C11.165 21.8071 11.253 22.0195 11.4096 22.1761C11.5662 22.3327 11.7785 22.4207 12 22.4207C12.2215 22.4207 12.4339 22.3327 12.5904 22.1761C12.747 22.0195 12.835 21.8071 12.835 21.5857V8.89907C13.5834 8.69869 14.2333 8.23275 14.6633 7.58828C15.0934 6.9438 15.2741 6.16484 15.1719 5.39685C15.0696 4.62886 14.6913 3.92434 14.1076 3.41485C13.5239 2.90535 12.7748 2.62571 12 2.62814V2.63649ZM13.7174 5.82151C13.7174 6.76998 12.9485 7.53888 12 7.53888C11.0515 7.53888 10.2826 6.76998 10.2826 5.82151C10.2826 4.87303 11.0515 4.10414 12 4.10414C12.9485 4.10414 13.7174 4.87303 13.7174 5.82151Z",
                fill: "var(--secundario)",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M4.33461 3.47151V8.89907C5.01095 9.08043 5.60856 9.47986 6.03479 10.0354C6.46102 10.591 6.69204 11.2717 6.69204 11.9719C6.69204 12.6721 6.46102 13.3528 6.03479 13.9084C5.60856 14.464 5.01095 14.8634 4.33461 15.0448V21.5857C4.33461 21.8071 4.24663 22.0195 4.09004 22.1761C3.93344 22.3327 3.72106 22.4207 3.4996 22.4207C3.27814 22.4207 3.06575 22.3327 2.90916 22.1761C2.75256 22.0195 2.66459 21.8071 2.66459 21.5857V15.0448C1.98824 14.8634 1.39063 14.464 0.964403 13.9084C0.538177 13.3528 0.307153 12.6721 0.307153 11.9719C0.307153 11.2717 0.538177 10.591 0.964403 10.0354C1.39063 9.47986 1.98824 9.08043 2.66459 8.89907V3.47151C2.66459 3.25005 2.75256 3.03766 2.90916 2.88106C3.06575 2.72447 3.27814 2.63649 3.4996 2.63649C3.72106 2.63649 3.93344 2.72447 4.09004 2.88106C4.24663 3.03766 4.33461 3.25005 4.33461 3.47151ZM3.4996 13.6942C4.45079 13.6942 5.22188 12.9231 5.22188 11.9719C5.22188 11.0207 4.45079 10.2496 3.4996 10.2496C2.54841 10.2496 1.77731 11.0207 1.77731 11.9719C1.77731 12.9231 2.54841 13.6942 3.4996 13.6942Z",
                fill: "var(--secundario)",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M21.5354 12.6205V3.39871C21.5354 3.12421 21.4264 2.86095 21.2323 2.66685C21.0382 2.47275 20.7749 2.3637 20.5004 2.3637C20.2259 2.3637 19.9626 2.47275 19.7685 2.66685C19.5744 2.86095 19.4654 3.12421 19.4654 3.39871V12.6289C18.8076 12.8379 18.2282 13.2437 17.8065 13.7933C17.3535 14.3838 17.108 15.1072 17.108 15.8515C17.108 16.5958 17.3535 17.3192 17.8065 17.9097C18.2282 18.4593 18.8076 18.8651 19.4654 19.0741V21.5212C19.4654 21.7957 19.5744 22.059 19.7685 22.2531C19.9626 22.4472 20.2259 22.5562 20.5004 22.5562C20.7749 22.5562 21.0382 22.4472 21.2323 22.2531C21.4264 22.059 21.5354 21.7957 21.5354 21.5212V19.0658C22.1932 18.8568 22.7727 18.451 23.1943 17.9014C23.6473 17.3109 23.8929 16.5874 23.8929 15.8432C23.8929 15.0989 23.6473 14.3754 23.1943 13.7849C22.7727 13.2354 22.1932 12.8295 21.5354 12.6205ZM21.3354 18.9159C22.0118 18.7346 22.6094 18.3352 23.0356 17.7796C23.4618 17.224 23.6928 16.5433 23.6928 15.8431C23.6928 15.1429 23.4618 14.4622 23.0356 13.9066C22.6094 13.3511 22.0118 12.9516 21.3354 12.7703V3.39866C21.3354 3.17721 21.2474 2.96482 21.0909 2.80822C20.9343 2.65163 20.7219 2.56365 20.5004 2.56365C20.2789 2.56365 20.0666 2.65163 19.91 2.80822C19.7534 2.96482 19.6654 3.17721 19.6654 3.39866V12.7786C18.9891 12.96 18.3914 13.3594 17.9652 13.915C17.539 14.4705 17.308 15.1512 17.308 15.8515C17.308 16.5517 17.539 17.2324 17.9652 17.7879C18.3914 18.3435 18.9891 18.7429 19.6654 18.9243V21.5212C19.6654 21.7426 19.7534 21.955 19.91 22.1116C20.0666 22.2682 20.2789 22.3562 20.5004 22.3562C20.7219 22.3562 20.9343 22.2682 21.0909 22.1116C21.2474 21.955 21.3354 21.7426 21.3354 21.5212V18.9159ZM4.53461 8.74933C5.19242 8.95834 5.77185 9.36416 6.19348 9.91374C6.6465 10.5042 6.89204 11.2277 6.89204 11.972C6.89204 12.7162 6.6465 13.4397 6.19347 14.0302C5.77185 14.5798 5.19242 14.9856 4.53461 15.1946V21.5857C4.53461 21.8602 4.42556 22.1235 4.23146 22.3176C4.03736 22.5117 3.7741 22.6207 3.4996 22.6207C3.2251 22.6207 2.96184 22.5117 2.76774 22.3176C2.57364 22.1235 2.46459 21.8602 2.46459 21.5857V15.1946C1.80677 14.9856 1.22735 14.5798 0.805724 14.0302C0.352703 13.4397 0.107156 12.7162 0.107156 11.972C0.107156 11.2277 0.352703 10.5042 0.805724 9.91374C1.22735 9.36416 1.80677 8.95834 2.46459 8.74933V3.47155C2.46459 3.19705 2.57363 2.93379 2.76774 2.73969C2.96184 2.54559 3.2251 2.43654 3.4996 2.43654C3.7741 2.43654 4.03736 2.54559 4.23146 2.73969C4.42556 2.93379 4.53461 3.19705 4.53461 3.47155V8.74933ZM2.66459 15.0448V21.5857C2.66459 21.8071 2.75256 22.0195 2.90916 22.1761C3.06575 22.3327 3.27814 22.4207 3.4996 22.4207C3.72106 22.4207 3.93344 22.3327 4.09004 22.1761C4.24663 22.0195 4.33461 21.8071 4.33461 21.5857V15.0448C5.01095 14.8634 5.60856 14.464 6.03479 13.9084C6.46102 13.3528 6.69204 12.6721 6.69204 11.9719C6.69204 11.2717 6.46102 10.591 6.03479 10.0354C5.60856 9.47986 5.01095 9.08043 4.33461 8.89907V3.47151C4.33461 3.25005 4.24663 3.03766 4.09004 2.88106C3.93344 2.72447 3.72106 2.63649 3.4996 2.63649C3.27814 2.63649 3.06575 2.72447 2.90916 2.88106C2.75256 3.03766 2.66459 3.25005 2.66459 3.47151V8.89907C1.98824 9.08043 1.39063 9.47986 0.964403 10.0354C0.538177 10.591 0.307153 11.2717 0.307153 11.9719C0.307153 12.6721 0.538177 13.3528 0.964403 13.9084C1.39063 14.464 1.98824 14.8634 2.66459 15.0448ZM12 7.33892C12.838 7.33892 13.5174 6.65957 13.5174 5.82156C13.5174 4.98354 12.838 4.30419 12 4.30419C11.162 4.30419 10.4826 4.98354 10.4826 5.82156C10.4826 6.65958 11.162 7.33892 12 7.33892ZM20.5004 17.3839C21.3394 17.3839 22.0195 16.7038 22.0195 15.8648C22.0195 15.0259 21.3394 14.3457 20.5004 14.3457C19.6615 14.3457 18.9813 15.0259 18.9813 15.8648C18.9813 16.7038 19.6615 17.3839 20.5004 17.3839ZM3.4996 13.4942C4.34034 13.4942 5.02189 12.8127 5.02189 11.972C5.02189 11.1312 4.34034 10.4497 3.4996 10.4497C2.65887 10.4497 1.97732 11.1312 1.97732 11.972C1.97732 12.8127 2.65887 13.4942 3.4996 13.4942ZM12 7.53888C12.9485 7.53888 13.7174 6.76998 13.7174 5.82151C13.7174 4.87303 12.9485 4.10414 12 4.10414C11.0515 4.10414 10.2826 4.87303 10.2826 5.82151C10.2826 6.76998 11.0515 7.53888 12 7.53888ZM20.5004 17.5839C21.4498 17.5839 22.2195 16.8142 22.2195 15.8648C22.2195 14.9153 21.4498 14.1457 20.5004 14.1457C19.551 14.1457 18.7813 14.9153 18.7813 15.8648C18.7813 16.8142 19.551 17.5839 20.5004 17.5839ZM5.22188 11.9719C5.22188 12.9231 4.45079 13.6942 3.4996 13.6942C2.54841 13.6942 1.77731 12.9231 1.77731 11.9719C1.77731 11.0207 2.54841 10.2496 3.4996 10.2496C4.45079 10.2496 5.22188 11.0207 5.22188 11.9719Z",
                fill: "var(--secundario)",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M11.9994 2.43654C11.9327 2.43636 11.8662 2.43814 11.8 2.44185C11.0487 2.48401 10.3306 2.77525 9.76087 3.27257C9.14059 3.81402 8.73859 4.56271 8.62991 5.37885C8.52124 6.195 8.71333 7.0228 9.17031 7.70768C9.59866 8.34965 10.2323 8.82491 10.965 9.05733V21.5857C10.965 21.8602 11.074 22.1235 11.2681 22.3176C11.4622 22.5117 11.7255 22.6207 12 22.6207C12.2745 22.6207 12.5378 22.5117 12.7319 22.3176C12.926 22.1235 13.035 21.8602 13.035 21.5857V9.04897C13.7677 8.81656 14.4014 8.3413 14.8297 7.69933C15.2867 7.01445 15.4788 6.18665 15.3701 5.3705C15.2614 4.55436 14.8594 3.80567 14.2391 3.26422C13.6189 2.72278 12.8542 2.43396 12.0309 2.43654H11.9994ZM12.2 2.63384C12.9029 2.67576 13.5743 2.94934 14.1076 3.41485C14.6913 3.92434 15.0696 4.62886 15.1719 5.39685C15.2741 6.16484 15.0934 6.9438 14.6633 7.58828C14.2333 8.23275 13.5834 8.69869 12.835 8.89907V21.5857C12.835 21.8071 12.747 22.0195 12.5904 22.1761C12.4339 22.3327 12.2215 22.4207 12 22.4207C11.7785 22.4207 11.5662 22.3327 11.4096 22.1761C11.253 22.0195 11.165 21.8071 11.165 21.5857V8.90742C10.4166 8.70704 9.7667 8.24111 9.33667 7.59663C8.90665 6.95215 8.7259 6.17319 8.82816 5.4052C8.93042 4.63721 9.30871 3.93269 9.89239 3.4232C10.471 2.9181 11.2123 2.63895 11.98 2.63654L12.2 2.63384Z",
                fill: "var(--secundario)",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cMBm2":[function() {},{}],"22Bgs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiamondTextIcon", ()=>(0, _diamondTextIcon.DiamondTextIcon));
var _diamondTextIcon = require("./DiamondTextIcon");

},{"./DiamondTextIcon":"cPOrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cPOrs":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiamondTextIcon", ()=>DiamondTextIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconAdd6 = require("../../icons/BtnIconAdd6");
var _btnDiamondIcon = require("../BtnDiamondIcon");
var _styleCss = require("./style.css");
const DiamondTextIcon = ({ label = "Text", orientation, className, btnDiamondIconBtnIconAdd6Color, textClassName, btnDiamondIconIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconAdd6.BtnIconAdd6), {
    className: "btn-icon-add-6",
    color: btnDiamondIconBtnIconAdd6Color
}) })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `diamond-text-icon ${orientation} ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnDiamondIcon.BtnDiamondIcon), {
                btnIconAdd6Color: btnDiamondIconBtnIconAdd6Color,
                className: "btn-diamond-icon-instance",
                icon: btnDiamondIconIcon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-2 ${textClassName}`,
                children: label
            })
        ]
    });
};
DiamondTextIcon.propTypes = {
    label: (0, _propTypesDefault.default).string,
    orientation: (0, _propTypesDefault.default).oneOf([
        "vertical",
        "horizontal"
    ]),
    btnDiamondIconBtnIconAdd6Color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconAdd6":"87Gzw","../BtnDiamondIcon":"2YX4i","./style.css":"eou0a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"87Gzw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconAdd6", ()=>(0, _btnIconAdd6.BtnIconAdd6));
var _btnIconAdd6 = require("./BtnIconAdd6");

},{"./BtnIconAdd6":"jf8UX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jf8UX":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconAdd6", ()=>BtnIconAdd6);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconAdd6 = ({ color = "var(--secundario)", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-add-6 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M12 5V19M5 12H19",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
BtnIconAdd6.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2YX4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnDiamondIcon", ()=>(0, _btnDiamondIcon.BtnDiamondIcon));
var _btnDiamondIcon = require("./BtnDiamondIcon");

},{"./BtnDiamondIcon":"lnXQb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnXQb":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnDiamondIcon", ()=>BtnDiamondIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconAdd6 = require("../../icons/BtnIconAdd6");
var _styleCss = require("./style.css");
const BtnDiamondIcon = ({ className, btnIconAdd6Color = "white", icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconAdd6.BtnIconAdd6), {
    className: "btn-icon-add",
    color: btnIconAdd6Color
}), rectangleClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `btn-diamond-icon ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `rectangle ${rectangleClassName}`
                }),
                icon
            ]
        })
    });
};
BtnDiamondIcon.propTypes = {
    btnIconAdd6Color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconAdd6":"87Gzw","./style.css":"e0ND3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e0ND3":[function() {},{}],"eou0a":[function() {},{}],"hJ445":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondDown", ()=>(0, _idDiamondDown.IdDiamondDown));
var _idDiamondDown = require("./IdDiamondDown");

},{"./IdDiamondDown":"hg68H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hg68H":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondDown", ()=>IdDiamondDown);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconArrow = require("../../icons/BtnIconArrow");
var _styleCss = require("./style.css");
const IdDiamondDown = ({ className, rectangleClassName, btnIconArrowColor = "black" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `id-diamond-down ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `rectangle-2 ${rectangleClassName}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconArrow.BtnIconArrow), {
                    className: "btn-icon-arrow",
                    color: btnIconArrowColor
                })
            ]
        })
    });
};
IdDiamondDown.propTypes = {
    btnIconArrowColor: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconArrow":"gMI3s","./style.css":"2175U","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMI3s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconArrow", ()=>(0, _btnIconArrow.BtnIconArrow));
var _btnIconArrow = require("./BtnIconArrow");

},{"./BtnIconArrow":"hH1AT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hH1AT":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconArrow", ()=>BtnIconArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconArrow = ({ color = "#0066FF", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-arrow ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 25 25",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M12.6895 5.96387V19.9639M12.6895 19.9639L5.68945 12.9639M12.6895 19.9639L19.6895 12.9639",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
BtnIconArrow.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2175U":[function() {},{}],"bp4q3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainMenu", ()=>(0, _mainMenu.MainMenu));
var _mainMenu = require("./MainMenu");

},{"./MainMenu":"3nSGH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nSGH":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainMenu", ()=>MainMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnMenuHome = require("../BtnMenuHome");
var _btnMenuMore = require("../BtnMenuMore");
var _btnMenuRequest = require("../BtnMenuRequest");
var _btnMenuSend = require("../BtnMenuSend");
var _styleCss = require("./style.css");
const MainMenu = ({ className, color = "black", btnMenuHomeFluentHome = "/img/fluent-home-12-filled.svg", btnMenuSendMingcuteSendPlane = "/img/mingcute-send-plane-line.svg", btnMenuRequestProfits = "/img/profits-1.svg", btnMenuMoreRegularMenuDots = "/img/regular-menu-dots-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `main-menu ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnMenuHome.BtnMenuHome), {
                    color: color,
                    className: "design-component-instance-node-2",
                    fluentHome: btnMenuHomeFluentHome,
                    status: "on"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnMenuSend.BtnMenuSend), {
                    color: color,
                    className: "design-component-instance-node-2",
                    mingcuteSendPlane: btnMenuSendMingcuteSendPlane,
                    status: "off"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnMenuRequest.BtnMenuRequest), {
                    color: color,
                    className: "design-component-instance-node-2",
                    profits: btnMenuRequestProfits,
                    status: "off"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnMenuMore.BtnMenuMore), {
                    color: color,
                    className: "design-component-instance-node-2",
                    regularMenuDots: btnMenuMoreRegularMenuDots,
                    status: "off"
                })
            ]
        })
    });
};
MainMenu.propTypes = {
    btnMenuHomeFluentHome: (0, _propTypesDefault.default).string,
    btnMenuSendMingcuteSendPlane: (0, _propTypesDefault.default).string,
    btnMenuRequestProfits: (0, _propTypesDefault.default).string,
    btnMenuMoreRegularMenuDots: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../BtnMenuHome":"bExkf","../BtnMenuMore":"cuGWZ","../BtnMenuRequest":"fsXxf","../BtnMenuSend":"8Ob6l","./style.css":"2LALq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bExkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuHome", ()=>(0, _btnMenuHome.BtnMenuHome));
var _btnMenuHome = require("./BtnMenuHome");

},{"./BtnMenuHome":"5A2LB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5A2LB":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuHome", ()=>BtnMenuHome);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnMenuHome = ({ status, color, fluentHome = "/img/fluent-home-12-filled-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: `btn-menu-home status-0-${status}`,
        children: [
            status === "on" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "fluent-home",
                    alt: "Fluent home",
                    src: fluentHome
                })
            }),
            status === "off" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                width: 27,
                height: 27,
                viewBox: "0 0 27 27",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22.2855 4.5199L22.2946 4.51731C22.4489 4.47933 22.6107 4.48365 22.7628 4.52991C22.9182 4.57717 23.0576 4.66637 23.1656 4.78772C23.2736 4.90906 23.3461 5.05784 23.375 5.21769C23.404 5.37754 23.3883 5.54228 23.3296 5.69378L16.8296 22.4855C16.7772 22.6211 16.6921 22.7417 16.5819 22.8365C16.4717 22.9314 16.3398 22.9975 16.1979 23.0292C16.056 23.0608 15.9085 23.0569 15.7684 23.0178C15.6284 22.9788 15.5001 22.9058 15.3951 22.8053L11.7312 19.3007C11.6527 19.2255 11.5285 19.2269 11.4516 19.3037L10.1483 20.606C9.5852 21.1691 8.62208 20.7705 8.62208 19.9739V16.4119C8.62208 16.3573 8.59976 16.3051 8.56032 16.2673L2.93673 10.8886C2.82297 10.7797 2.74037 10.6425 2.69748 10.491C2.65458 10.3395 2.65296 10.1793 2.69277 10.027C2.73259 9.87462 2.8124 9.73569 2.92395 9.62457C3.03549 9.51344 3.1747 9.43414 3.32719 9.39489L22.2855 4.5199ZM19.9494 6.80578C20.0236 6.63781 19.6545 6.7261 19.6545 6.7261L5.65421 10.6195C5.58387 10.6376 5.52886 10.6924 5.5105 10.7626C5.49213 10.8329 5.51329 10.9076 5.56578 10.9578L9.56544 14.7819C9.63873 14.852 9.75286 14.8561 9.83103 14.7916L19.6756 7.07863C19.7327 7.04278 19.921 6.87001 19.9494 6.80578ZM20.7286 8.49644C20.7614 8.41159 21.0001 7.9565 20.9263 7.90328C20.8525 7.85005 20.5148 8.22556 20.4446 8.28351L11.1525 15.9933C11.1085 16.0297 11.0821 16.0832 11.08 16.1403C11.078 16.1973 11.1004 16.2526 11.1417 16.2921L15.3953 20.3545C15.4436 20.4007 15.5118 20.4197 15.5771 20.4052C15.6423 20.3907 15.696 20.3445 15.7201 20.2822L20.7286 8.49644Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper-6",
                children: "Home"
            })
        ]
    });
};
BtnMenuHome.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ]),
    fluentHome: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"hViTa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hViTa":[function() {},{}],"cuGWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuMore", ()=>(0, _btnMenuMore.BtnMenuMore));
var _btnMenuMore = require("./BtnMenuMore");

},{"./BtnMenuMore":"cemiJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cemiJ":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuMore", ()=>BtnMenuMore);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnMenuMore = ({ status, color, className, regularMenuDots = "/img/regular-menu-dots-3.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `btn-menu-more status-6-${status} ${className}`,
        children: [
            status === "on" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "regular-menu-dots-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 27,
                    height: 27,
                    viewBox: "0 0 27 27",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M4.96354 15.1668C5.88402 15.1668 6.63021 14.4206 6.63021 13.5002C6.63021 12.5797 5.88402 11.8335 4.96354 11.8335C4.04307 11.8335 3.29688 12.5797 3.29688 13.5002C3.29688 14.4206 4.04307 15.1668 4.96354 15.1668Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M13.2965 15.1668C14.217 15.1668 14.9632 14.4206 14.9632 13.5002C14.9632 12.5797 14.217 11.8335 13.2965 11.8335C12.3761 11.8335 11.6299 12.5797 11.6299 13.5002C11.6299 14.4206 12.3761 15.1668 13.2965 15.1668Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M21.6305 15.1668C22.551 15.1668 23.2972 14.4206 23.2972 13.5002C23.2972 12.5797 22.551 11.8335 21.6305 11.8335C20.7101 11.8335 19.9639 12.5797 19.9639 13.5002C19.9639 14.4206 20.7101 15.1668 21.6305 15.1668Z",
                            fill: color
                        })
                    ]
                })
            }),
            status === "off" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                width: 27,
                height: 27,
                viewBox: "0 0 27 27",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M4.96354 15.1668C5.88402 15.1668 6.63021 14.4206 6.63021 13.5002C6.63021 12.5797 5.88402 11.8335 4.96354 11.8335C4.04307 11.8335 3.29688 12.5797 3.29688 13.5002C3.29688 14.4206 4.04307 15.1668 4.96354 15.1668Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M13.2965 15.1668C14.217 15.1668 14.9632 14.4206 14.9632 13.5002C14.9632 12.5797 14.217 11.8335 13.2965 11.8335C12.3761 11.8335 11.6299 12.5797 11.6299 13.5002C11.6299 14.4206 12.3761 15.1668 13.2965 15.1668Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M21.6305 15.1668C22.551 15.1668 23.2972 14.4206 23.2972 13.5002C23.2972 12.5797 22.551 11.8335 21.6305 11.8335C20.7101 11.8335 19.9639 12.5797 19.9639 13.5002C19.9639 14.4206 20.7101 15.1668 21.6305 15.1668Z",
                        fill: color
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper-9",
                children: "More"
            })
        ]
    });
};
BtnMenuMore.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ]),
    regularMenuDots: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"SwuCE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"SwuCE":[function() {},{}],"fsXxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuRequest", ()=>(0, _btnMenuRequest.BtnMenuRequest));
var _btnMenuRequest = require("./BtnMenuRequest");

},{"./BtnMenuRequest":"k9PWS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k9PWS":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuRequest", ()=>BtnMenuRequest);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnMenuRequest = ({ status, color, className, profits = "/img/profits-1-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `btn-menu-request status-4-${status} ${className}`,
        children: [
            status === "on" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                width: 27,
                height: 27,
                viewBox: "0 0 27 27",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        clipPath: "url(#clip0_2633_400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M25.484 14.8011C24.5493 14.0116 23.1657 14.1024 22.3391 14.9898L20.1004 17.3932C19.8299 16.5236 19.053 15.8757 18.1164 15.7946C18.5136 15.5168 18.8902 15.203 19.2418 14.8546C20.8439 13.267 21.7263 11.1629 21.7263 8.93004C21.7263 4.31254 17.9305 0.500488 13.2967 0.500488C8.67514 0.500488 4.91798 4.30198 4.91798 8.93004C4.91798 11.0204 5.69097 13.003 7.07136 14.5326C6.70177 14.7201 6.34971 14.9532 6.02344 15.2323C5.60937 14.6459 4.92697 14.262 4.15626 14.262H1.0586C0.637923 14.262 0.296875 14.603 0.296875 15.0237V25.7384C0.296875 26.1591 0.637923 26.5001 1.0586 26.5001H4.15621C5.15345 26.5001 6.00297 25.8577 6.31416 24.9652C6.3556 24.9722 6.3979 24.9767 6.44132 24.9767H17.9177C19.587 24.9767 21.1816 24.1794 22.1855 22.8409L25.8401 17.9174C26.5661 16.9498 26.4116 15.5847 25.484 14.8011ZM4.91793 24.215C4.91793 24.635 4.57622 24.9767 4.15621 24.9767H1.82032V15.7855H4.15621C4.57622 15.7855 4.91793 16.1272 4.91793 16.5472V24.215ZM6.44132 8.93009C6.44132 5.122 9.51663 2.02393 13.2967 2.02393C17.1048 2.02393 20.2029 5.122 20.2029 8.93009C20.2029 12.5662 17.3362 15.5496 13.7285 15.7717C13.5957 15.7463 13.4712 15.6861 13.3684 15.5956L13.0106 15.2808C11.7974 14.2131 10.2119 13.7916 8.70378 14.014C7.26199 12.7116 6.44132 10.8777 6.44132 8.93009ZM24.6192 17.0063L20.9646 21.93C20.2491 22.8839 19.1101 23.4534 17.9177 23.4534H6.44132V16.8915L6.97213 16.4244C8.4065 15.1621 10.5699 15.1621 12.0042 16.4244C12.2631 16.6523 12.9655 17.3089 13.2967 17.3089C13.9412 17.3089 17.5159 17.3089 17.9177 17.3089C18.3378 17.3089 18.6795 17.6506 18.6795 18.0706C18.6795 18.4906 18.3378 18.8323 17.9177 18.8323C17.3764 18.8323 12.9996 18.8323 12.4535 18.8323C12.0328 18.8323 11.6918 19.1733 11.6918 19.594C11.6918 20.0147 12.0328 20.3557 12.4535 20.3557C12.8574 20.3557 12.7064 20.3557 18.4283 20.3557C19.0602 20.3557 19.6697 20.0906 20.1003 19.6281L23.4538 16.0282C23.7264 15.7356 24.1645 15.7095 24.4684 15.9381C24.8014 16.1886 24.8767 16.663 24.6192 17.0063Z",
                                fill: color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M13.2968 8.16788C12.8768 8.16788 12.5351 7.82617 12.5351 7.40616C12.5351 7.08694 12.7365 6.79912 13.0361 6.68999C13.4273 6.54755 13.8828 6.74077 14.2856 7.2204C14.5562 7.5425 15.0367 7.58435 15.3588 7.31378C15.6809 7.04322 15.7228 6.56273 15.4522 6.24062C15.0404 5.75028 14.5611 5.41324 14.0585 5.24404V4.35938C14.0585 3.9387 13.7175 3.59766 13.2968 3.59766C12.8761 3.59766 12.5351 3.9387 12.5351 4.35938V5.25171C12.5283 5.25409 12.5214 5.25618 12.5147 5.25866C11.6157 5.5861 11.0117 6.44918 11.0117 7.40621C11.0117 8.66624 12.0368 9.69132 13.2968 9.69132C13.7168 9.69132 14.0585 10.033 14.0585 10.453C14.0585 10.7599 13.876 11.0354 13.5934 11.1551C13.2523 11.2995 12.8441 11.1763 12.4733 10.8169C12.1711 10.5242 11.6889 10.5318 11.3962 10.8339C11.1034 11.1361 11.1111 11.6183 11.4132 11.911C11.7571 12.2442 12.1394 12.4796 12.5351 12.6125V13.4999C12.5351 13.9205 12.8762 14.2616 13.2968 14.2616C13.7175 14.2616 14.0585 13.9205 14.0585 13.4999V12.6076C14.1018 12.5923 14.1448 12.576 14.1875 12.5578C15.0346 12.1991 15.582 11.3729 15.582 10.453C15.5819 9.193 14.5569 8.16788 13.2968 8.16788Z",
                                fill: color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                            id: "clip0_2633_400",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 26,
                                height: 26,
                                fill: "white",
                                transform: "translate(0.296875 0.5)"
                            })
                        })
                    })
                ]
            }),
            status === "off" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                width: 27,
                height: 27,
                viewBox: "0 0 27 27",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        clipPath: "url(#clip0_2633_400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M25.484 14.8011C24.5493 14.0116 23.1657 14.1024 22.3391 14.9898L20.1004 17.3932C19.8299 16.5236 19.053 15.8757 18.1164 15.7946C18.5136 15.5168 18.8902 15.203 19.2418 14.8546C20.8439 13.267 21.7263 11.1629 21.7263 8.93004C21.7263 4.31254 17.9305 0.500488 13.2967 0.500488C8.67514 0.500488 4.91798 4.30198 4.91798 8.93004C4.91798 11.0204 5.69097 13.003 7.07136 14.5326C6.70177 14.7201 6.34971 14.9532 6.02344 15.2323C5.60937 14.6459 4.92697 14.262 4.15626 14.262H1.0586C0.637923 14.262 0.296875 14.603 0.296875 15.0237V25.7384C0.296875 26.1591 0.637923 26.5001 1.0586 26.5001H4.15621C5.15345 26.5001 6.00297 25.8577 6.31416 24.9652C6.3556 24.9722 6.3979 24.9767 6.44132 24.9767H17.9177C19.587 24.9767 21.1816 24.1794 22.1855 22.8409L25.8401 17.9174C26.5661 16.9498 26.4116 15.5847 25.484 14.8011ZM4.91793 24.215C4.91793 24.635 4.57622 24.9767 4.15621 24.9767H1.82032V15.7855H4.15621C4.57622 15.7855 4.91793 16.1272 4.91793 16.5472V24.215ZM6.44132 8.93009C6.44132 5.122 9.51663 2.02393 13.2967 2.02393C17.1048 2.02393 20.2029 5.122 20.2029 8.93009C20.2029 12.5662 17.3362 15.5496 13.7285 15.7717C13.5957 15.7463 13.4712 15.6861 13.3684 15.5956L13.0106 15.2808C11.7974 14.2131 10.2119 13.7916 8.70378 14.014C7.26199 12.7116 6.44132 10.8777 6.44132 8.93009ZM24.6192 17.0063L20.9646 21.93C20.2491 22.8839 19.1101 23.4534 17.9177 23.4534H6.44132V16.8915L6.97213 16.4244C8.4065 15.1621 10.5699 15.1621 12.0042 16.4244C12.2631 16.6523 12.9655 17.3089 13.2967 17.3089C13.9412 17.3089 17.5159 17.3089 17.9177 17.3089C18.3378 17.3089 18.6795 17.6506 18.6795 18.0706C18.6795 18.4906 18.3378 18.8323 17.9177 18.8323C17.3764 18.8323 12.9996 18.8323 12.4535 18.8323C12.0328 18.8323 11.6918 19.1733 11.6918 19.594C11.6918 20.0147 12.0328 20.3557 12.4535 20.3557C12.8574 20.3557 12.7064 20.3557 18.4283 20.3557C19.0602 20.3557 19.6697 20.0906 20.1003 19.6281L23.4538 16.0282C23.7264 15.7356 24.1645 15.7095 24.4684 15.9381C24.8014 16.1886 24.8767 16.663 24.6192 17.0063Z",
                                fill: color
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M13.2968 8.16788C12.8768 8.16788 12.5351 7.82617 12.5351 7.40616C12.5351 7.08694 12.7365 6.79912 13.0361 6.68999C13.4273 6.54755 13.8828 6.74077 14.2856 7.2204C14.5562 7.5425 15.0367 7.58435 15.3588 7.31378C15.6809 7.04322 15.7228 6.56273 15.4522 6.24062C15.0404 5.75028 14.5611 5.41324 14.0585 5.24404V4.35938C14.0585 3.9387 13.7175 3.59766 13.2968 3.59766C12.8761 3.59766 12.5351 3.9387 12.5351 4.35938V5.25171C12.5283 5.25409 12.5214 5.25618 12.5147 5.25866C11.6157 5.5861 11.0117 6.44918 11.0117 7.40621C11.0117 8.66624 12.0368 9.69132 13.2968 9.69132C13.7168 9.69132 14.0585 10.033 14.0585 10.453C14.0585 10.7599 13.876 11.0354 13.5934 11.1551C13.2523 11.2995 12.8441 11.1763 12.4733 10.8169C12.1711 10.5242 11.6889 10.5318 11.3962 10.8339C11.1034 11.1361 11.1111 11.6183 11.4132 11.911C11.7571 12.2442 12.1394 12.4796 12.5351 12.6125V13.4999C12.5351 13.9205 12.8762 14.2616 13.2968 14.2616C13.7175 14.2616 14.0585 13.9205 14.0585 13.4999V12.6076C14.1018 12.5923 14.1448 12.576 14.1875 12.5578C15.0346 12.1991 15.582 11.3729 15.582 10.453C15.5819 9.193 14.5569 8.16788 13.2968 8.16788Z",
                                fill: color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                            id: "clip0_2633_400",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 26,
                                height: 26,
                                fill: "white",
                                transform: "translate(0.296875 0.5)"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper-8",
                children: "Request"
            })
        ]
    });
};
BtnMenuRequest.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ]),
    profits: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"j4aue","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j4aue":[function() {},{}],"8Ob6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuSend", ()=>(0, _btnMenuSend.BtnMenuSend));
var _btnMenuSend = require("./BtnMenuSend");

},{"./BtnMenuSend":"kTXpl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kTXpl":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnMenuSend", ()=>BtnMenuSend);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnMenuSend = ({ status, className, color, mingcuteSendPlane = "/img/mingcute-send-plane-line-1.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: `btn-menu-send status-2-${status} ${className}`,
        children: [
            status === "on" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mingcute-send-plane-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 27,
                    height: 27,
                    viewBox: "0 0 27 27",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M22.2855 4.5199L22.2946 4.51731C22.4489 4.47933 22.6107 4.48365 22.7628 4.52991C22.9182 4.57717 23.0576 4.66637 23.1656 4.78772C23.2736 4.90906 23.3461 5.05784 23.375 5.21769C23.404 5.37754 23.3883 5.54228 23.3296 5.69378L16.8296 22.4855C16.7772 22.6211 16.6921 22.7417 16.5819 22.8365C16.4717 22.9314 16.3398 22.9975 16.1979 23.0292C16.056 23.0608 15.9085 23.0569 15.7684 23.0178C15.6284 22.9788 15.5001 22.9058 15.3951 22.8053L11.7312 19.3007C11.6527 19.2255 11.5285 19.2269 11.4516 19.3037L10.1483 20.606C9.5852 21.1691 8.62208 20.7705 8.62208 19.9739V16.4119C8.62208 16.3573 8.59976 16.3051 8.56032 16.2673L2.93673 10.8886C2.82297 10.7797 2.74037 10.6425 2.69748 10.491C2.65458 10.3395 2.65296 10.1793 2.69277 10.027C2.73259 9.87462 2.8124 9.73569 2.92395 9.62457C3.03549 9.51344 3.1747 9.43414 3.32719 9.39489L22.2855 4.5199ZM19.9494 6.80578C20.0236 6.63781 19.6545 6.7261 19.6545 6.7261L5.65421 10.6195C5.58387 10.6376 5.52886 10.6924 5.5105 10.7626C5.49213 10.8329 5.51329 10.9076 5.56578 10.9578L9.56544 14.7819C9.63873 14.852 9.75286 14.8561 9.83103 14.7916L19.6756 7.07863C19.7327 7.04278 19.921 6.87001 19.9494 6.80578ZM20.7286 8.49644C20.7614 8.41159 21.0001 7.9565 20.9263 7.90328C20.8525 7.85005 20.5148 8.22556 20.4446 8.28351L11.1525 15.9933C11.1085 16.0297 11.0821 16.0832 11.08 16.1403C11.078 16.1973 11.1004 16.2526 11.1417 16.2921L15.3953 20.3545C15.4436 20.4007 15.5118 20.4197 15.5771 20.4052C15.6423 20.3907 15.696 20.3445 15.7201 20.2822L20.7286 8.49644Z",
                        fill: color
                    })
                })
            }),
            status === "off" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                width: 27,
                height: 27,
                viewBox: "0 0 27 27",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22.2855 4.5199L22.2946 4.51731C22.4489 4.47933 22.6107 4.48365 22.7628 4.52991C22.9182 4.57717 23.0576 4.66637 23.1656 4.78772C23.2736 4.90906 23.3461 5.05784 23.375 5.21769C23.404 5.37754 23.3883 5.54228 23.3296 5.69378L16.8296 22.4855C16.7772 22.6211 16.6921 22.7417 16.5819 22.8365C16.4717 22.9314 16.3398 22.9975 16.1979 23.0292C16.056 23.0608 15.9085 23.0569 15.7684 23.0178C15.6284 22.9788 15.5001 22.9058 15.3951 22.8053L11.7312 19.3007C11.6527 19.2255 11.5285 19.2269 11.4516 19.3037L10.1483 20.606C9.5852 21.1691 8.62208 20.7705 8.62208 19.9739V16.4119C8.62208 16.3573 8.59976 16.3051 8.56032 16.2673L2.93673 10.8886C2.82297 10.7797 2.74037 10.6425 2.69748 10.491C2.65458 10.3395 2.65296 10.1793 2.69277 10.027C2.73259 9.87462 2.8124 9.73569 2.92395 9.62457C3.03549 9.51344 3.1747 9.43414 3.32719 9.39489L22.2855 4.5199ZM19.9494 6.80578C20.0236 6.63781 19.6545 6.7261 19.6545 6.7261L5.65421 10.6195C5.58387 10.6376 5.52886 10.6924 5.5105 10.7626C5.49213 10.8329 5.51329 10.9076 5.56578 10.9578L9.56544 14.7819C9.63873 14.852 9.75286 14.8561 9.83103 14.7916L19.6756 7.07863C19.7327 7.04278 19.921 6.87001 19.9494 6.80578ZM20.7286 8.49644C20.7614 8.41159 21.0001 7.9565 20.9263 7.90328C20.8525 7.85005 20.5148 8.22556 20.4446 8.28351L11.1525 15.9933C11.1085 16.0297 11.0821 16.0832 11.08 16.1403C11.078 16.1973 11.1004 16.2526 11.1417 16.2921L15.3953 20.3545C15.4436 20.4007 15.5118 20.4197 15.5771 20.4052C15.6423 20.3907 15.696 20.3445 15.7201 20.2822L20.7286 8.49644Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-wrapper-7",
                children: "Send"
            })
        ]
    });
};
BtnMenuSend.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ]),
    mingcuteSendPlane: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"hj0f1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hj0f1":[function() {},{}],"2LALq":[function() {},{}],"7XzSY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Movements", ()=>(0, _movements.Movements));
var _movements = require("./Movements");

},{"./Movements":"4kd0M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4kd0M":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Movements", ()=>Movements);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _idDiamondDown = require("../IdDiamondDown");
var _styleCss = require("./style.css");
const Movements = ({ movement = "Movement info", className, override = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idDiamondDown.IdDiamondDown), {
    btnIconArrowColor: "#0066FF",
    className: "id-diamond-down-instance",
    rectangleClassName: "design-component-instance-node"
}), divClassName, frameClassName, dateClassName, amountClassName, text = "$600,50" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `movements ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "frame-3",
                children: [
                    override,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `movement-info ${divClassName}`,
                        children: movement
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `frame-4 ${frameClassName}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `date ${dateClassName}`,
                        children: "11/06/22"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `amount ${amountClassName}`,
                        children: text
                    })
                ]
            })
        ]
    });
};
Movements.propTypes = {
    movement: (0, _propTypesDefault.default).string,
    text: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../IdDiamondDown":"hJ445","./style.css":"hZybj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZybj":[function() {},{}],"1xiyT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrientationWrapper", ()=>(0, _orientationWrapper.OrientationWrapper));
var _orientationWrapper = require("./OrientationWrapper");

},{"./OrientationWrapper":"adJhM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"adJhM":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrientationWrapper", ()=>OrientationWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconAdd6 = require("../../icons/BtnIconAdd6");
var _btnDiamondIcon = require("../BtnDiamondIcon");
var _styleCss = require("./style.css");
const OrientationWrapper = ({ label = "Text", orientation, className, btnDiamondIconIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconAdd6.BtnIconAdd6), {
    className: "btn-icon-add-2",
    color: "white"
}), btnDiamondIconRectangleClassName, textClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `orientation-wrapper orientation-0-${orientation} ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnDiamondIcon.BtnDiamondIcon), {
                className: "instance-node",
                icon: btnDiamondIconIcon,
                rectangleClassName: btnDiamondIconRectangleClassName
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-3 ${textClassName}`,
                children: label
            })
        ]
    });
};
OrientationWrapper.propTypes = {
    label: (0, _propTypesDefault.default).string,
    orientation: (0, _propTypesDefault.default).oneOf([
        "vertical",
        "horizontal"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconAdd6":"87Gzw","../BtnDiamondIcon":"2YX4i","./style.css":"hcHKO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hcHKO":[function() {},{}],"2HPcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>(0, _section.Section));
var _section = require("./Section");

},{"./Section":"e1rJo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e1rJo":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconFilter = require("../../icons/BtnIconFilter");
var _btnIconSettings = require("../../icons/BtnIconSettings");
var _styleCss = require("./style.css");
const Section = ({ section = "section", className, icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconFilter.BtnIconFilter), {
    className: "icon-instance-node"
}), sectionClassName, override = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconSettings.BtnIconSettings), {
    className: "icon-instance-node"
}) })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `section ${className}`,
        children: [
            icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-wrapper-3 ${sectionClassName}`,
                children: section
            }),
            override
        ]
    });
};
Section.propTypes = {
    section: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconFilter":"9lZry","../../icons/BtnIconSettings":"fZiTP","./style.css":"7r2la","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fZiTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSettings", ()=>(0, _btnIconSettings.BtnIconSettings));
var _btnIconSettings = require("./BtnIconSettings");

},{"./BtnIconSettings":"jebhL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jebhL":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSettings", ()=>BtnIconSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconSettings = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-settings ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2627_1156)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M12 14.9948C13.654 14.9948 14.9948 13.654 14.9948 12C14.9948 10.346 13.654 9.00524 12 9.00524C10.346 9.00524 9.00524 10.346 9.00524 12C9.00524 13.654 10.346 14.9948 12 14.9948Z",
                        stroke: "var(--secundario)",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M19.3871 14.9948C19.2542 15.2959 19.2146 15.6299 19.2733 15.9537C19.332 16.2775 19.4864 16.5763 19.7165 16.8116L19.7764 16.8715C19.962 17.0569 20.1093 17.2771 20.2098 17.5195C20.3102 17.7619 20.3619 18.0217 20.3619 18.284C20.3619 18.5464 20.3102 18.8062 20.2098 19.0486C20.1093 19.2909 19.962 19.5111 19.7764 19.6966C19.591 19.8822 19.3708 20.0294 19.1284 20.1299C18.886 20.2304 18.6262 20.2821 18.3639 20.2821C18.1015 20.2821 17.8417 20.2304 17.5993 20.1299C17.357 20.0294 17.1368 19.8822 16.9513 19.6966L16.8914 19.6367C16.6562 19.4065 16.3574 19.2521 16.0335 19.1934C15.7097 19.1347 15.3757 19.1744 15.0746 19.3072C14.7794 19.4338 14.5276 19.6439 14.3502 19.9117C14.1728 20.1795 14.0776 20.4934 14.0764 20.8146V20.9843C14.0764 21.5138 13.866 22.0216 13.4916 22.396C13.1172 22.7705 12.6094 22.9808 12.0799 22.9808C11.5504 22.9808 11.0425 22.7705 10.6681 22.396C10.2937 22.0216 10.0834 21.5138 10.0834 20.9843V20.8945C10.0756 20.564 9.96867 20.2436 9.7764 19.9748C9.58413 19.7059 9.31543 19.5012 9.00524 19.3871C8.70415 19.2542 8.37016 19.2146 8.04633 19.2733C7.7225 19.332 7.42368 19.4864 7.18842 19.7165L7.12852 19.7764C6.9431 19.962 6.72291 20.1093 6.48054 20.2098C6.23816 20.3103 5.97836 20.362 5.71599 20.362C5.45362 20.362 5.19382 20.3103 4.95145 20.2098C4.70908 20.1093 4.48888 19.962 4.30346 19.7764C4.11783 19.591 3.97057 19.3708 3.8701 19.1284C3.76963 18.8861 3.71791 18.6263 3.71791 18.3639C3.71791 18.1015 3.76963 17.8417 3.8701 17.5993C3.97057 17.357 4.11783 17.1368 4.30346 16.9514L4.36336 16.8915C4.59349 16.6562 4.74787 16.3574 4.80659 16.0336C4.8653 15.7097 4.82566 15.3757 4.69278 15.0746C4.56624 14.7794 4.35613 14.5276 4.0883 14.3502C3.82048 14.1728 3.50664 14.0777 3.18542 14.0764H3.01572C2.48621 14.0764 1.97839 13.866 1.60397 13.4916C1.22955 13.1172 1.01921 12.6094 1.01921 12.0799C1.01921 11.5504 1.22955 11.0426 1.60397 10.6681C1.97839 10.2937 2.48621 10.0834 3.01572 10.0834H3.10556C3.43597 10.0756 3.75642 9.96869 4.02525 9.77642C4.29407 9.58415 4.49884 9.31545 4.61292 9.00526C4.7458 8.70417 4.78544 8.37017 4.72673 8.04635C4.66801 7.72252 4.51363 7.4237 4.2835 7.18844L4.2236 7.12854C4.03797 6.94312 3.89071 6.72293 3.79024 6.48055C3.68977 6.23818 3.63805 5.97838 3.63805 5.71601C3.63805 5.45364 3.68977 5.19384 3.79024 4.95147C3.89071 4.7091 4.03797 4.4889 4.2236 4.30348C4.40902 4.11785 4.62922 3.97059 4.87159 3.87012C5.11396 3.76965 5.37376 3.71793 5.63613 3.71793C5.8985 3.71793 6.1583 3.76965 6.40068 3.87012C6.64305 3.97059 6.86324 4.11785 7.04866 4.30348L7.10856 4.36338C7.34382 4.59351 7.64264 4.74789 7.96647 4.80661C8.2903 4.86532 8.62429 4.82568 8.92538 4.6928H9.00524C9.30049 4.56626 9.5523 4.35614 9.72966 4.08832C9.90703 3.8205 10.0022 3.50666 10.0035 3.18544V3.01573C10.0035 2.48623 10.2138 1.97841 10.5883 1.60399C10.9627 1.22957 11.4705 1.01923 12 1.01923C12.5295 1.01923 13.0373 1.22957 13.4117 1.60399C13.7862 1.97841 13.9965 2.48623 13.9965 3.01573V3.10558C13.9978 3.4268 14.093 3.74064 14.2703 4.00846C14.4477 4.27628 14.6995 4.4864 14.9948 4.61294C15.2959 4.74582 15.6298 4.78546 15.9537 4.72675C16.2775 4.66803 16.5763 4.51365 16.8116 4.28352L16.8715 4.22362C17.0569 4.03799 17.2771 3.89073 17.5195 3.79026C17.7618 3.68979 18.0216 3.63807 18.284 3.63807C18.5464 3.63807 18.8062 3.68979 19.0486 3.79026C19.2909 3.89073 19.5111 4.03799 19.6965 4.22362C19.8822 4.40904 20.0294 4.62923 20.1299 4.87161C20.2304 5.11398 20.2821 5.37378 20.2821 5.63615C20.2821 5.89852 20.2304 6.15832 20.1299 6.40069C20.0294 6.64307 19.8822 6.86326 19.6965 7.04868L19.6366 7.10857C19.4065 7.34384 19.2521 7.64266 19.1934 7.96649C19.1347 8.29031 19.1743 8.62431 19.3072 8.9254V9.00526C19.4338 9.30051 19.6439 9.55232 19.9117 9.72968C20.1795 9.90705 20.4934 10.0022 20.8146 10.0035H20.9843C21.5138 10.0035 22.0216 10.2139 22.396 10.5883C22.7704 10.9627 22.9808 11.4705 22.9808 12C22.9808 12.5295 22.7704 13.0373 22.396 13.4118C22.0216 13.7862 21.5138 13.9965 20.9843 13.9965H20.8944C20.5732 13.9978 20.2594 14.093 19.9916 14.2704C19.7237 14.4477 19.5136 14.6995 19.3871 14.9948Z",
                        stroke: "var(--secundario)",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2627_1156",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7r2la":[function() {},{}],"gA1Ca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusOnWrapper", ()=>(0, _statusOnWrapper.StatusOnWrapper));
var _statusOnWrapper = require("./StatusOnWrapper");

},{"./StatusOnWrapper":"jBwgv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBwgv":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusOnWrapper", ()=>StatusOnWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const StatusOnWrapper = ({ status, className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `status-on-wrapper status-${status} ${className}`
    });
};
StatusOnWrapper.propTypes = {
    status: (0, _propTypesDefault.default).oneOf([
        "off",
        "on"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"l10Gy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l10Gy":[function() {},{}],"9CEPp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subsection", ()=>(0, _subsection.Subsection));
var _subsection = require("./Subsection");

},{"./Subsection":"iEKcI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iEKcI":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subsection", ()=>Subsection);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconMore2 = require("../../icons/BtnIconMore2");
var _styleCss = require("./style.css");
const Subsection = ({ withTootilp = false, withIcon = true, subsection = "subsection", withTextLink = false, subsectionClassName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "subsection",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `text-wrapper-2 ${subsectionClassName}`,
                    children: subsection
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-2",
                children: withIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMore2.BtnIconMore2), {
                    className: "btn-icon-more"
                })
            })
        ]
    });
};
Subsection.propTypes = {
    withTootilp: (0, _propTypesDefault.default).bool,
    withIcon: (0, _propTypesDefault.default).bool,
    subsection: (0, _propTypesDefault.default).string,
    withTextLink: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/BtnIconMore2":"9NsUi","./style.css":"fpXcZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9NsUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMore2", ()=>(0, _btnIconMore2.BtnIconMore2));
var _btnIconMore2 = require("./BtnIconMore2");

},{"./BtnIconMore2":"01lqt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"01lqt":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMore2", ()=>BtnIconMore2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconMore2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-more-2 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M17 12C17 12.2652 16.8946 12.5196 16.7071 12.7071C16.5196 12.8946 16.2652 13 16 13H13V16C13 16.2652 12.8946 16.5196 12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16V13H8C7.73478 13 7.48043 12.8946 7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929C7.48043 11.1054 7.73478 11 8 11H11V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8V11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12Z",
                fill: "var(--secundario)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M11.811 2.10132C17.3339 2.10132 21.811 6.57847 21.811 12.1013C21.811 17.6242 17.3339 22.1013 11.811 22.1013C6.28819 22.1013 1.81104 17.6242 1.81104 12.1013C1.81104 6.57847 6.28819 2.10132 11.811 2.10132Z",
                stroke: "var(--secundario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fpXcZ":[function() {},{}],"kgF93":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconActivity1", ()=>(0, _btnIconActivity1.BtnIconActivity1));
var _btnIconActivity1 = require("./BtnIconActivity1");

},{"./BtnIconActivity1":"ef54k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ef54k":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconActivity1", ()=>BtnIconActivity1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconActivity1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-activity-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M12 6V12L16 14M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
            stroke: "var(--secundario)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1whhR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconClose1", ()=>(0, _btnIconClose1.BtnIconClose1));
var _btnIconClose1 = require("./BtnIconClose1");

},{"./BtnIconClose1":"dJi1Y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJi1Y":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconClose1", ()=>BtnIconClose1);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconClose1 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-close-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M17.5 6.5L6.5 17.5M6.5 6.5L17.5 17.5",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
BtnIconClose1.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7a5lB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconEyeOff1", ()=>(0, _btnIconEyeOff1.BtnIconEyeOff1));
var _btnIconEyeOff1 = require("./BtnIconEyeOff1");

},{"./BtnIconEyeOff1":"gcpEk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gcpEk":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconEyeOff1", ()=>BtnIconEyeOff1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconEyeOff1 = ({ className, color = "black" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-eye-off-1 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 25 25",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                className: "g",
                clipPath: "url(#clip0_2627_1332)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    className: "path",
                    d: "M14.62 14.9633C14.3454 15.258 14.0141 15.4944 13.6462 15.6584C13.2782 15.8224 12.8809 15.9105 12.4781 15.9176C12.0753 15.9247 11.6752 15.8506 11.3016 15.6998C10.9281 15.5489 10.5887 15.3243 10.3038 15.0394C10.019 14.7545 9.79439 14.4152 9.64351 14.0417C9.49262 13.6681 9.41853 13.268 9.42563 12.8652C9.43274 12.4624 9.52091 12.0651 9.68488 11.6971C9.84884 11.3291 10.0853 10.9979 10.38 10.7233M1.5 1.84326L23.5 23.8433M18.44 18.7833C16.7306 20.0863 14.6491 20.8081 12.5 20.8433C5.5 20.8433 1.5 12.8433 1.5 12.8433C2.74389 10.5252 4.46914 8.49987 6.56 6.90326L18.44 18.7833ZM10.4 5.08326C11.0883 4.92214 11.7931 4.8416 12.5 4.84326C19.5 4.84326 23.5 12.8433 23.5 12.8433C22.893 13.9789 22.1691 15.048 21.34 16.0333L10.4 5.08326Z",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2627_1332",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(0.5 0.843262)",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4QzDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMenu1", ()=>(0, _btnIconMenu1.BtnIconMenu1));
var _btnIconMenu1 = require("./BtnIconMenu1");

},{"./BtnIconMenu1":"3wLL6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3wLL6":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMenu1", ()=>BtnIconMenu1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconMenu1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-menu-1 ${className}`,
        fill: "none",
        height: "32",
        viewBox: "0 0 32 32",
        width: "32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M25.4866 14.9648H6.51283C6.03652 14.9648 5.65039 15.4282 5.65039 15.9998C5.65039 16.5714 6.03652 17.0347 6.51283 17.0347H25.4866C25.9629 17.0347 26.349 16.5714 26.349 15.9998C26.349 15.4282 25.9629 14.9648 25.4866 14.9648Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M25.4866 8.92822H6.51283C6.03652 8.92822 5.65039 9.39158 5.65039 9.96315C5.65039 10.5347 6.03652 10.9981 6.51283 10.9981H25.4866C25.9629 10.9981 26.349 10.5347 26.349 9.96315C26.349 9.39158 25.9629 8.92822 25.4866 8.92822Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M25.4866 21.002H6.51283C6.03652 21.002 5.65039 21.4653 5.65039 22.0369C5.65039 22.6085 6.03652 23.0718 6.51283 23.0718H25.4866C25.9629 23.0718 26.349 22.6085 26.349 22.0369C26.349 21.4653 25.9629 21.002 25.4866 21.002Z",
                fill: "white"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"abtTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSearch", ()=>(0, _btnIconSearch.BtnIconSearch));
var _btnIconSearch = require("./BtnIconSearch");

},{"./BtnIconSearch":"fEDKk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fEDKk":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSearch", ()=>BtnIconSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconSearch = ({ color = "var(--secundario)", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-search ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 25 25",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M21.3993 21.2295L17.0493 16.8795M19.3994 11.2295C19.3994 15.6478 15.8177 19.2295 11.3994 19.2295C6.98114 19.2295 3.39941 15.6478 3.39941 11.2295C3.39941 6.81121 6.98114 3.22949 11.3994 3.22949C15.8177 3.22949 19.3994 6.81121 19.3994 11.2295Z",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
BtnIconSearch.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7zjj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSettings2", ()=>(0, _btnIconSettings2.BtnIconSettings2));
var _btnIconSettings2 = require("./BtnIconSettings2");

},{"./BtnIconSettings2":"lm40d","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lm40d":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconSettings2", ()=>BtnIconSettings2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconSettings2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `btn-icon-settings-2 ${className}`,
        fill: "none",
        height: "25",
        viewBox: "0 0 25 25",
        width: "25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2633_365)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M12.5003 15.6811C14.1543 15.6811 15.4951 14.3403 15.4951 12.6863C15.4951 11.0324 14.1543 9.69158 12.5003 9.69158C10.8464 9.69158 9.50556 11.0324 9.50556 12.6863C9.50556 14.3403 10.8464 15.6811 12.5003 15.6811Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M19.8874 15.6811C19.7545 15.9822 19.7149 16.3162 19.7736 16.64C19.8323 16.9639 19.9867 17.2627 20.2168 17.4979L20.2767 17.5578C20.4624 17.7433 20.6096 17.9635 20.7101 18.2058C20.8106 18.4482 20.8623 18.708 20.8623 18.9704C20.8623 19.2327 20.8106 19.4925 20.7101 19.7349C20.6096 19.9773 20.4624 20.1975 20.2767 20.3829C20.0913 20.5685 19.8711 20.7158 19.6287 20.8163C19.3864 20.9167 19.1266 20.9684 18.8642 20.9684C18.6018 20.9684 18.342 20.9167 18.0996 20.8163C17.8573 20.7158 17.6371 20.5685 17.4517 20.3829L17.3918 20.323C17.1565 20.0929 16.8577 19.9385 16.5339 19.8798C16.21 19.8211 15.876 19.8607 15.5749 19.9936C15.2797 20.1201 15.0279 20.3302 14.8505 20.5981C14.6732 20.8659 14.578 21.1797 14.5767 21.5009V21.6706C14.5767 22.2002 14.3663 22.708 13.9919 23.0824C13.6175 23.4568 13.1097 23.6672 12.5802 23.6672C12.0507 23.6672 11.5429 23.4568 11.1684 23.0824C10.794 22.708 10.5837 22.2002 10.5837 21.6706V21.5808C10.5759 21.2504 10.469 20.9299 10.2767 20.6611C10.0845 20.3923 9.81575 20.1875 9.50556 20.0734C9.20447 19.9406 8.87048 19.9009 8.54665 19.9596C8.22282 20.0183 7.92401 20.1727 7.68874 20.4029L7.62884 20.4628C7.44342 20.6484 7.22323 20.7956 6.98086 20.8961C6.73849 20.9966 6.47869 21.0483 6.21632 21.0483C5.95394 21.0483 5.69414 20.9966 5.45177 20.8961C5.2094 20.7956 4.98921 20.6484 4.80379 20.4628C4.61816 20.2773 4.4709 20.0571 4.37042 19.8148C4.26995 19.5724 4.21824 19.3126 4.21824 19.0502C4.21824 18.7879 4.26995 18.5281 4.37042 18.2857C4.4709 18.0433 4.61816 17.8231 4.80379 17.6377L4.86368 17.5778C5.09382 17.3425 5.24819 17.0437 5.30691 16.7199C5.36563 16.3961 5.32599 16.0621 5.19311 15.761C5.06656 15.4657 4.85645 15.2139 4.58863 15.0366C4.32081 14.8592 4.00697 14.764 3.68574 14.7627H3.51604C2.98653 14.7627 2.47871 14.5524 2.10429 14.178C1.72988 13.8035 1.51953 13.2957 1.51953 12.7662C1.51953 12.2367 1.72988 11.7289 2.10429 11.3545C2.47871 10.9801 2.98653 10.7697 3.51604 10.7697H3.60588C3.9363 10.762 4.25675 10.655 4.52557 10.4628C4.7944 10.2705 4.99916 10.0018 5.11325 9.6916C5.24613 9.39051 5.28577 9.05652 5.22705 8.73269C5.16833 8.40886 5.01396 8.11004 4.78382 7.87478L4.72393 7.81488C4.5383 7.62946 4.39104 7.40927 4.29056 7.16689C4.19009 6.92452 4.13838 6.66472 4.13838 6.40235C4.13838 6.13998 4.19009 5.88018 4.29056 5.63781C4.39104 5.39544 4.5383 5.17524 4.72393 4.98982C4.90935 4.80419 5.12954 4.65693 5.37191 4.55646C5.61428 4.45599 5.87408 4.40427 6.13646 4.40427C6.39883 4.40427 6.65863 4.45599 6.901 4.55646C7.14337 4.65693 7.36356 4.80419 7.54898 4.98982L7.60888 5.04972C7.84415 5.27985 8.14296 5.43423 8.46679 5.49295C8.79062 5.55166 9.12461 5.51202 9.4257 5.37914H9.50556C9.80082 5.2526 10.0526 5.04248 10.23 4.77466C10.4074 4.50684 10.5025 4.193 10.5038 3.87178V3.70207C10.5038 3.17257 10.7142 2.66475 11.0886 2.29033C11.463 1.91591 11.9708 1.70557 12.5003 1.70557C13.0298 1.70557 13.5376 1.91591 13.9121 2.29033C14.2865 2.66475 14.4968 3.17257 14.4968 3.70207V3.79192C14.4981 4.11314 14.5933 4.42698 14.7707 4.6948C14.948 4.96262 15.1998 5.17274 15.4951 5.29928C15.7962 5.43216 16.1302 5.4718 16.454 5.41309C16.7778 5.35437 17.0766 5.19999 17.3119 4.96986L17.3718 4.90996C17.5572 4.72433 17.7774 4.57707 18.0198 4.4766C18.2622 4.37613 18.522 4.32441 18.7843 4.32441C19.0467 4.32441 19.3065 4.37613 19.5489 4.4766C19.7912 4.57707 20.0114 4.72433 20.1969 4.90996C20.3825 5.09538 20.5297 5.31558 20.6302 5.55795C20.7307 5.80032 20.7824 6.06012 20.7824 6.32249C20.7824 6.58486 20.7307 6.84466 20.6302 7.08703C20.5297 7.32941 20.3825 7.5496 20.1969 7.73502L20.137 7.79492C19.9068 8.03018 19.7525 8.329 19.6937 8.65283C19.635 8.97665 19.6747 9.31065 19.8075 9.61174V9.6916C19.9341 9.98685 20.1442 10.2387 20.412 10.416C20.6798 10.5934 20.9937 10.6886 21.3149 10.6899H21.4846C22.0141 10.6899 22.5219 10.9002 22.8964 11.2746C23.2708 11.649 23.4811 12.1569 23.4811 12.6864C23.4811 13.2159 23.2708 13.7237 22.8964 14.0981C22.5219 14.4725 22.0141 14.6829 21.4846 14.6829H21.3948C21.0735 14.6841 20.7597 14.7793 20.4919 14.9567C20.2241 15.1341 20.0139 15.3859 19.8874 15.6811Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2633_365",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(0.5 0.686523)",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1b9fi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondCar1", ()=>(0, _idDiamondCar1.IdDiamondCar1));
var _idDiamondCar1 = require("./IdDiamondCar1");

},{"./IdDiamondCar1":"gQChk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gQChk":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondCar1", ()=>IdDiamondCar1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IdDiamondCar1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `id-diamond-car-1 ${className}`,
        fill: "none",
        height: "45",
        viewBox: "0 0 45 45",
        width: "45",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#F2F3F7",
                height: "36.7695",
                rx: "18.3848",
                transform: "rotate(45 22.5 -3.31348)",
                width: "36.7695",
                x: "22.5",
                y: "-3.31348"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2633_291)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M19.667 34.0688C20.2193 34.0688 20.667 33.6211 20.667 33.0688C20.667 32.5166 20.2193 32.0688 19.667 32.0688C19.1147 32.0688 18.667 32.5166 18.667 33.0688C18.667 33.6211 19.1147 34.0688 19.667 34.0688Z",
                        stroke: "#2222E3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M30.667 34.0688C31.2193 34.0688 31.667 33.6211 31.667 33.0688C31.667 32.5166 31.2193 32.0688 30.667 32.0688C30.1147 32.0688 29.667 32.5166 29.667 33.0688C29.667 33.6211 30.1147 34.0688 30.667 34.0688Z",
                        stroke: "#2222E3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M11.667 13.0688H15.667L18.347 26.4588C18.4384 26.9192 18.6889 27.3328 19.0545 27.6271C19.4202 27.9215 19.8777 28.0778 20.347 28.0688H30.067C30.5363 28.0778 30.9938 27.9215 31.3594 27.6271C31.7251 27.3328 31.9755 26.9192 32.067 26.4588L33.667 18.0688H16.667",
                        stroke: "#2222E3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2633_291",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(10.667 12.0688)",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"81oQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondCard1", ()=>(0, _idDiamondCard1.IdDiamondCard1));
var _idDiamondCard1 = require("./IdDiamondCard1");

},{"./IdDiamondCard1":"bLkNi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bLkNi":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdDiamondCard1", ()=>IdDiamondCard1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IdDiamondCard1 = ({ className, color = "black" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `id-diamond-card-1 ${className}`,
        fill: "none",
        height: "45",
        viewBox: "0 0 45 45",
        width: "45",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#F2F3F7",
                height: "36.7695",
                rx: "18.3848",
                transform: "rotate(45 22.5 -3.31348)",
                width: "36.7695",
                x: "22.5",
                y: "-3.31348"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                clipPath: "url(#clip0_2633_323)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M31.5 15.0688H13.5C12.3954 15.0688 11.5 15.9643 11.5 17.0688V29.0688C11.5 30.1734 12.3954 31.0688 13.5 31.0688H31.5C32.6046 31.0688 33.5 30.1734 33.5 29.0688V17.0688C33.5 15.9643 32.6046 15.0688 31.5 15.0688Z",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        d: "M11.5 21.0688H33.5",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                className: "defs",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    className: "clip-path",
                    id: "clip0_2633_323",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        className: "rect",
                        fill: "white",
                        height: "24",
                        transform: "translate(10.5 11.0688)",
                        width: "24"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koQK1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieCardDetails", ()=>(0, _pixieCardDetails.PixieCardDetails));
var _pixieCardDetails = require("./PixieCardDetails");

},{"./PixieCardDetails":"j39NB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j39NB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieCardDetails", ()=>PixieCardDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconArrowBack = require("../../../../../icons/IconArrowBack");
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _regularCopyAlt = require("../../../../../icons/RegularCopyAlt");
var _styleCss = require("./style.css");
const PixieCardDetails = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const scrollRef = (0, _react.useRef)(null);
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pixie-card-details",
        ref: scrollRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper-2",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-6",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-28",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "subtitle",
                                    children: "Card details"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    onClick: handleButtonBack,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack.IconArrowBack), {
                                        className: "icon-arrow-back",
                                        color: "white"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-29",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-30",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-5",
                                        style: {
                                            borderRadius: 8,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            backgroundSize: "contain",
                                            backgroundImage: colors.url_card ? `url(${colors.url_card})` : "none",
                                            backgroundColor: colors.url_card ? "transparent" : "rgb(255, 255, 25, 0.1)"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-8",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "overlap-group-12"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-31",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-32",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-32",
                                                                    children: "Pay date"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-33",
                                                                    children: "10 ABR"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-32",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-32",
                                                                    children: "Due date"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-33",
                                                                    children: "11/30"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-33",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-34",
                                                            children: "7531 4532 6643 5849"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regularCopyAlt.RegularCopyAlt), {
                                                            className: "regular-copy-alt"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "bottom",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "fecha-pago",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-35",
                                                        children: "Available (USD)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-34",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-36",
                                                            children: "13,000"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "cupo-dispo",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-37",
                                                        children: "Assigned (USD)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-38",
                                                        children: "23,000"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-35",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "diamond-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 86,
                                                height: 86,
                                                viewBox: "0 0 86 86",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M8.66443 50.619C4.30097 46.2556 4.30096 39.181 8.66443 34.8175L43.2022 0.279733L77.74 34.8175C82.1034 39.181 82.1034 46.2556 77.74 50.619L43.2022 85.1568L8.66443 50.619Z",
                                                        fill: colors.cuaternario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M49.483 47.9705C49.483 55.6891 43.3335 61.9411 35.7415 61.9411C28.1495 61.9411 22 55.6891 22 47.9705C22 40.252 28.1495 34 35.7415 34C43.3335 34 49.483 40.252 49.483 47.9705Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M49.3338 34.5002L54.3338 39.5002L60.1671 33.6668L55.1671 28.6668L49.3338 34.5002Z",
                                                        fill: colors.septimo
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M58.5005 25.3335L55.1671 28.6668M55.1671 28.6668L60.1671 33.6668L54.3338 39.5002L49.3338 34.5002M55.1671 28.6668L49.3338 34.5002M42.4838 41.3502C43.3444 42.1993 44.0285 43.2102 44.4967 44.3248C44.965 45.4394 45.2081 46.6356 45.2122 47.8445C45.2162 49.0535 44.9811 50.2513 44.5203 51.369C44.0595 52.4867 43.3822 53.5022 42.5274 54.3571C41.6725 55.2119 40.657 55.8892 39.5393 56.35C38.4216 56.8108 37.2238 57.0459 36.0148 57.0419C34.8059 57.0378 33.6097 56.7947 32.4951 56.3264C31.3805 55.8582 30.3696 55.1741 29.5205 54.3135C27.8507 52.5846 26.9267 50.2691 26.9476 47.8656C26.9685 45.4622 27.9325 43.1631 29.6321 41.4635C31.3317 39.7639 33.6308 38.7999 36.0343 38.779C38.4377 38.7581 40.7533 39.682 42.4821 41.3518L42.4838 41.3502ZM42.4838 41.3502L49.3338 34.5002",
                                                        stroke: "#2222E3",
                                                        strokeWidth: 3.63636,
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-40",
                                                children: "CVV"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "diamond-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "btn-diamond-img-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "pin-code-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "pin-code",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-group-13",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                        width: 39,
                                                                        height: 39,
                                                                        viewBox: "0 0 39 39",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                d: "M38.6946 29.5462C38.6946 34.262 34.8748 38.0817 30.159 38.0817C25.4433 38.0817 21.6235 34.262 21.6235 29.5462C21.6235 24.8304 25.4433 21.0106 30.159 21.0106C34.8748 21.0106 38.6946 24.8304 38.6946 29.5462Z",
                                                                                fill: colors.septimo
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                cx: 10.8775,
                                                                                cy: 23.6807,
                                                                                r: 1.96974,
                                                                                fill: colors.terciario
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                                                                cx: 17.5964,
                                                                                cy: 23.6807,
                                                                                rx: 2.0354,
                                                                                ry: 1.96974,
                                                                                fill: colors.terciario
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                cx: 24.3155,
                                                                                cy: 23.6807,
                                                                                r: 1.96974,
                                                                                fill: colors.terciario
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                d: "M30.4874 12.7213H27.7735V9.27592C27.7735 4.16118 23.5125 0 18.275 0C13.0375 0 8.77643 4.16118 8.77643 9.27592V12.7213H6.06256C3.81792 12.7213 1.99176 14.5046 1.99176 16.6967V29.948C1.99176 32.14 3.81792 33.9234 6.06256 33.9234H30.4874C32.732 33.9234 34.5582 32.14 34.5582 29.948V16.6967C34.5582 14.5046 32.732 12.7213 30.4874 12.7213ZM11.4903 9.27592C11.4903 5.62253 14.5339 2.65026 18.275 2.65026C22.016 2.65026 25.0596 5.62253 25.0596 9.27592V12.7213H11.4903V9.27592ZM31.8443 29.948C31.8443 30.6786 31.2356 31.2731 30.4874 31.2731H6.06256C5.31435 31.2731 4.70563 30.6786 4.70563 29.948V16.6967C4.70563 15.966 5.31435 15.3715 6.06256 15.3715H30.4874C31.2356 15.3715 31.8443 15.966 31.8443 16.6967V29.948Z",
                                                                                fill: "#2222E3"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                d: "M11.4903 9.27592C11.4903 5.62253 14.5339 2.65026 18.275 2.65026C22.016 2.65026 25.0596 5.62253 25.0596 9.27592V12.7213H11.4903V9.27592Z",
                                                                                fill: colors.primario
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-36"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-40",
                                                children: "Missing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "diamond-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 86,
                                                height: 86,
                                                viewBox: "0 0 86 86",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M8.69568 51.0013C4.33222 46.6379 4.33221 39.5633 8.69568 35.1998L43.4014 0.494093L78.1071 35.1998C82.4706 39.5633 82.4706 46.6379 78.1072 51.0013L43.4014 85.7071L8.69568 51.0013Z",
                                                        fill: colors.cuaternario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M57.442 43.5337L48.2352 34.3269C47.3656 33.4574 47.3656 32.0635 48.2352 31.2068L57.442 22L66.6488 31.2068C67.5183 32.0763 67.5183 33.4701 66.6488 34.3269L57.442 43.5337Z",
                                                        fill: colors.septimo
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M43.3173 45.3687C42.6963 45.4233 41.8625 45.2412 41.5419 44.8434C40.9909 44.1593 39.9898 44.0515 39.3057 44.6025C38.6216 45.1535 38.5138 46.1546 39.0647 46.8387C39.6727 47.5936 40.5102 48.0559 41.3658 48.3083C41.571 48.9491 42.1717 49.4131 42.8807 49.4131C43.5505 49.4131 44.1236 48.999 44.3579 48.4129C45.9591 48.0224 47.07 46.8767 47.2644 45.3463C47.5006 43.4859 46.3109 41.7076 44.3713 41.022C43.1576 40.5929 42.5428 40.3413 42.3707 40.2601C42.1336 40.1483 42.1398 40.0652 42.1442 40.0046C42.1564 39.8404 42.2782 39.6876 42.3544 39.6647C43.2395 39.398 43.7093 39.6733 43.781 39.7579C44.2862 40.4746 45.2764 40.6472 45.9944 40.1434C46.7134 39.6389 46.8872 38.647 46.3826 37.9281C45.9703 37.3404 45.2875 36.8309 44.412 36.5655C44.2242 35.8964 43.6097 35.4058 42.8806 35.4058C42.1196 35.4058 41.4834 35.9403 41.327 36.6544C40.0189 37.0989 39.0783 38.3362 38.972 39.7695C38.8658 41.2026 39.6482 42.4931 41.0138 43.1371C41.4003 43.3194 42.2377 43.6417 43.311 44.021C43.9491 44.2466 44.1391 44.7079 44.1088 44.9457C44.0679 45.2686 43.5417 45.349 43.3173 45.3687Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M61.7694 41.9748C62.6478 41.9748 63.3598 41.2627 63.3598 40.3844V33.8948C63.3598 30.387 60.506 27.5332 56.9982 27.5332H29.0071C25.4993 27.5332 22.6455 30.387 22.6455 33.8948V50.9244C22.6455 54.4321 25.4993 57.286 29.0071 57.286H56.9982C60.506 57.286 63.3598 54.4321 63.3598 50.9244V48.3905C63.3598 47.7517 62.9775 47.1747 62.389 46.9258L62.2543 46.8688C62.1734 46.8346 62.0897 46.8071 62.0042 46.7867C61.4295 46.6493 60.8365 46.5797 60.2417 46.5797C56.0848 46.5797 52.7008 49.9525 52.6822 54.1052H33.3231C33.3048 49.9734 29.9546 46.6137 25.8263 46.58V38.3917C29.9659 38.358 33.3231 34.9799 33.3231 30.8326C33.3231 30.7931 33.3228 30.7535 33.3222 30.714H52.6831C52.6825 30.7535 52.6822 30.7931 52.6822 30.8326C52.6822 34.9799 56.0394 38.358 60.179 38.3917V40.3844C60.179 41.2627 60.891 41.9748 61.7694 41.9748ZM60.179 49.761V50.9244C60.179 52.6782 58.7521 54.1052 56.9982 54.1052H55.8631C55.8813 51.7273 57.8047 49.7945 60.179 49.761ZM30.1422 54.1052H29.0071C27.2532 54.1052 25.8263 52.6782 25.8263 50.9244V49.761C28.2006 49.7945 30.124 51.7273 30.1422 54.1052ZM30.1423 30.8326C30.1423 33.226 28.212 35.1772 25.8263 35.2108V33.8948C25.8263 32.1409 27.2532 30.714 29.0071 30.714H30.1408C30.1418 30.7534 30.1423 30.7931 30.1423 30.8326ZM55.863 30.8326C55.863 30.793 55.8635 30.7534 55.8645 30.714H56.9982C58.7521 30.714 60.179 32.1409 60.179 33.8948V35.2108C57.7934 35.1772 55.863 33.226 55.863 30.8326Z",
                                                        fill: colors.terciario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M30.1423 30.8326C30.1423 33.226 28.212 35.1772 25.8263 35.2108V33.8948C25.8263 32.1409 27.2532 30.714 29.0071 30.714H30.1408C30.1418 30.7534 30.1423 30.7931 30.1423 30.8326Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M30.1422 54.1052H29.0071C27.2532 54.1052 25.8263 52.6782 25.8263 50.9244V49.761C28.2006 49.7945 30.124 51.7273 30.1422 54.1052Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M60.179 49.761V50.9244C60.179 52.6782 58.7521 54.1052 56.9982 54.1052H55.8631C55.8813 51.7273 57.8047 49.7945 60.179 49.761Z",
                                                        fill: colors.primario
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-40",
                                                children: "Pay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "diamond-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 86,
                                                height: 86,
                                                viewBox: "0 0 86 86",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M8.1576 51.0013C3.79413 46.6379 3.79413 39.5633 8.15759 35.1998L42.8633 0.494093L77.5691 35.1998C81.9325 39.5633 81.9325 46.6379 77.5691 51.0013L42.8633 85.7071L8.1576 51.0013Z",
                                                        fill: colors.cuaternario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M26.5505 45.8667C28.1706 45.8667 29.4839 44.5534 29.4839 42.9333C29.4839 41.3133 28.1706 40 26.5505 40C24.9305 40 23.6172 41.3133 23.6172 42.9333C23.6172 44.5534 24.9305 45.8667 26.5505 45.8667Z",
                                                        fill: "#2222E3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M42.6833 45.8667C44.3034 45.8667 45.6167 44.5534 45.6167 42.9333C45.6167 41.3133 44.3034 40 42.6833 40C41.0633 40 39.75 41.3133 39.75 42.9333C39.75 44.5534 41.0633 45.8667 42.6833 45.8667Z",
                                                        fill: "#2222E3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M58.8171 45.8667C60.4372 45.8667 61.7505 44.5534 61.7505 42.9333C61.7505 41.3133 60.4372 40 58.8171 40C57.1971 40 55.8838 41.3133 55.8838 42.9333C55.8838 44.5534 57.1971 45.8667 58.8171 45.8667Z",
                                                        fill: "#2222E3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-40",
                                                children: "More"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-37",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "div-8",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title-3",
                                                children: "Last Transactions"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-38",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "btn-text-link",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-41",
                                                            children: "See all"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: 24,
                                                            height: 25,
                                                            viewBox: "0 0 24 25",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M9.75 17.2905L14.25 12.7905L9.75 8.29053",
                                                                stroke: "#01087F",
                                                                strokeWidth: 2,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-39",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-40",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "overlap-group-wrapper-2",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-14",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-13"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "img-2",
                                                                            alt: "Dinner",
                                                                            src: "/img/dinner.svg"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-41",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-42",
                                                                        children: "Starbucks coffee time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "btn-icon-chevron",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-1.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-42",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-2",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-2",
                                                                children: "- $25.11"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-40",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "overlap-group-wrapper-2",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-14",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-13"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "img-2",
                                                                            alt: "Paw",
                                                                            src: "/img/paw.svg"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-34",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-42",
                                                                        children: "Bruno\u2019s tricks"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "btn-icon-chevron",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-1.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-42",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-2",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-2",
                                                                children: "- $12.42"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-40",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "overlap-group-wrapper-2",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-14",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-13"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "shopping-bag",
                                                                            alt: "Shopping bag",
                                                                            src: "/img/shopping-bag.svg"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-34",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-42",
                                                                        children: "New gymn shoes"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "btn-icon-chevron",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-1.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-42",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-2",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-2",
                                                                children: "- $158.68"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-2",
                                                style: {
                                                    border: "none"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-40",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "overlap-group-wrapper-2",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-14",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-14"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "credit-card",
                                                                            alt: "Credit card",
                                                                            src: "/img/credit-card.svg"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-43",
                                                                children: "Card payment"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-42",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-2",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-3",
                                                                children: "$950.23"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"i8a4h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack":"dgOyH","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../icons/RegularCopyAlt":"9klXy"}],"i8a4h":[function() {},{}],"39byp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingTutorialEasy", ()=>(0, _pixieOnboardingTutorialEasy.PixieOnboardingTutorialEasy));
var _pixieOnboardingTutorialEasy = require("./PixieOnboardingTutorialEasy");

},{"./PixieOnboardingTutorialEasy":"8RaLS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8RaLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingTutorialEasy", ()=>PixieOnboardingTutorialEasy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sliderDots = require("../../../../../components/SliderDots");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboardingTutorialEasy = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-login-pixie-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_steppper-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen-totirial",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-3",
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 100,
                                height: 100,
                                viewBox: "0 0 151 150",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 104.5,
                                        cy: 103,
                                        r: 26,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M100.109 109.207C100.327 109.425 100.585 109.598 100.87 109.716C101.154 109.834 101.459 109.894 101.767 109.894C102.075 109.894 102.38 109.834 102.665 109.716C102.949 109.598 103.208 109.425 103.425 109.207L112.261 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.952 99.3114 113.025 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.868 97.7535C112.751 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.859 96.5636 111.565 96.4452C111.27 96.3268 110.955 96.2695 110.637 96.2767C110.32 96.284 110.007 96.3556 109.718 96.4874C109.429 96.6191 109.17 96.8081 108.957 97.043L101.773 104.227L98.2574 100.711C98.0438 100.476 97.7847 100.287 97.4959 100.155C97.207 100.024 96.8944 99.952 96.5769 99.9447C96.2595 99.9375 95.944 99.9948 95.6494 100.113C95.3548 100.232 95.0873 100.409 94.8632 100.633C94.6391 100.858 94.4631 101.126 94.3457 101.421C94.2283 101.716 94.1721 102.032 94.1805 102.35C94.1889 102.667 94.2616 102.979 94.3944 103.268C94.5271 103.556 94.7171 103.815 94.9527 104.027L100.109 109.207Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M42.0895 37.8866L50.8903 28.0194C51.095 27.7886 51.2522 27.5197 51.3529 27.2281C51.4537 26.9365 51.496 26.6279 51.4775 26.32C51.459 26.012 51.3801 25.7107 51.2451 25.4333C51.1102 25.1559 50.9219 24.9077 50.6911 24.703C50.4602 24.4984 50.1913 24.3412 49.8998 24.2404C49.6082 24.1396 49.2996 24.0973 48.9916 24.1158C48.6837 24.1343 48.3824 24.2133 48.1049 24.3482C47.8275 24.4832 47.5794 24.6714 47.3747 24.9023L38.5856 34.7694C38.1722 35.2356 37.961 35.847 37.9984 36.4689C38.0357 37.0909 38.3186 37.6725 38.7848 38.0859C39.251 38.4992 39.8623 38.7105 40.4843 38.6731C41.1062 38.6357 41.6879 38.3528 42.1012 37.8866H42.0895Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M25.4958 38.0741C25.9581 37.6603 26.2375 37.08 26.2726 36.4606C26.3078 35.8411 26.0958 35.2329 25.6833 34.7695L16.9059 24.9023C16.4926 24.4361 15.9109 24.1532 15.289 24.1158C14.667 24.0784 14.0557 24.2897 13.5895 24.703C13.1233 25.1164 12.8404 25.698 12.8031 26.32C12.7657 26.9419 12.9769 27.5532 13.3903 28.0194L22.1794 37.8866C22.3844 38.1173 22.633 38.3052 22.9109 38.4395C23.1888 38.5738 23.4905 38.6519 23.7986 38.6693C24.1068 38.6868 24.4153 38.6431 24.7066 38.541C24.9978 38.4389 25.266 38.2802 25.4958 38.0741Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Easy and Complete"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "all-you-need-in-your",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "id-diamond-down highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1233 6.67194L0.00488281 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-wrapper highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1235 6.67194L0.00512695 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "img-slider-dots",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "slider-dots-instance",
                            status: "off"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "design-component-instance-node",
                            status: "on"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-2"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"lsgCl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/SliderDots":"gfhZb","../../../../../hooks/useDynamicColors":"b2GRH"}],"lsgCl":[function() {},{}],"jTycc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingWelcome", ()=>(0, _pixieOnboardingWelcome.PixieOnboardingWelcome));
var _pixieOnboardingWelcome = require("./PixieOnboardingWelcome");

},{"./PixieOnboardingWelcome":"cJAuo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cJAuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingWelcome", ()=>PixieOnboardingWelcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboardingWelcome = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 129,
                                height: 130,
                                viewBox: "0 0 129 130",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 28.5,
                                        cy: 108,
                                        r: 22,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M109.38 84.5799C109.415 83.6859 109.267 82.7942 108.943 81.9599C108.62 81.1257 108.129 80.3667 107.5 79.7299C105.43 77.7299 101.84 76.8699 95.5002 76.9899C88.9738 77.2737 82.4885 78.171 76.1302 79.6699C72.1334 80.5412 68.1929 81.6533 64.3302 82.9999C61.3302 83.9999 59.2602 84.7099 56.8502 84.7099H56.7602C55.988 84.7516 55.2175 84.5997 54.5189 84.2679C53.8204 83.936 53.2158 83.4349 52.7602 82.8099C52.3251 82.1192 52.0657 81.3325 52.0047 80.5184C51.9437 79.7044 52.0829 78.8877 52.4102 78.1399C54.0075 73.7814 54.6188 69.123 54.2002 64.4999C53.5402 58.0499 50.3302 54.3399 45.3802 54.2999C44.6068 54.2524 43.8321 54.3686 43.1067 54.6409C42.3813 54.9131 41.7214 55.3353 41.1702 55.8799C39.3602 57.7599 39.3302 60.6199 39.4602 63.6299C39.5702 66.3699 36.5902 69.1599 34.8102 70.8299C30.8102 74.6099 27.7302 80.1299 27.0602 84.8899C26.9602 85.5999 26.8902 86.2499 26.8202 86.8899C26.8063 87.9491 26.5855 88.9954 26.1702 89.9699C24.1746 91.7691 22.0742 93.4487 19.8802 94.9999C19.6679 95.1569 19.4888 95.3544 19.3532 95.5809C19.2176 95.8075 19.1283 96.0586 19.0902 96.3199C19.0902 96.5699 18.2802 102.46 24.2402 110.03C28.5102 115.46 34.6102 117.91 38.5402 117.91H38.6802C39.269 117.965 39.8625 117.879 40.4118 117.66C40.9611 117.441 41.4506 117.095 41.8402 116.65C42.8402 115.26 46.7102 111.06 48.2402 110.24C52.1102 108.15 56.0102 106.24 59.5202 104.69C67.8202 104.53 89.0102 104.39 93.8102 105.58C94.6146 105.782 95.4409 105.882 96.2702 105.88C99.8802 105.88 103.64 104.07 104.8 100.39C105.198 99.3389 105.369 98.2161 105.304 97.0944C105.238 95.9728 104.937 94.8775 104.42 93.8799C104.039 93.2041 103.553 92.5931 102.98 92.0699C108.13 90.3499 109.36 87.1699 109.38 84.5799ZM100.99 99.1899C100.29 101.4 97.1502 102.29 94.7802 101.7C90.8402 100.7 78.6502 100.56 69.5802 100.59L70.5202 100.24C79.0683 96.9923 87.9385 94.6658 96.9802 93.2999C98.9802 93.8799 100.32 94.7399 100.91 95.8099C101.154 96.338 101.286 96.9103 101.3 97.4916C101.314 98.0729 101.208 98.6509 100.99 99.1899ZM98.8302 88.9999C82.7602 91.4599 74.2302 94.6399 69.1302 96.5399L67.6202 96.9999C60.3156 99.7404 53.2059 102.975 46.3402 106.68C44.0102 107.93 40.1402 112.35 38.9102 113.87C37.2802 114.1 31.5202 112.79 27.3802 107.52C23.6702 102.81 23.1002 99.1199 23.0402 97.6099C24.9202 96.1999 28.4802 93.4699 29.3502 92.3499C30.3502 90.9999 30.5802 89.3499 30.8202 87.2699C30.8802 86.7099 30.9502 86.0999 31.0402 85.4299C31.5902 81.5699 34.2102 76.8699 37.5702 73.7299C39.7002 71.7299 43.6702 68.0099 43.4702 63.4399C43.4102 62.0399 43.3002 59.4399 44.0702 58.6399C44.1602 58.5499 44.4202 58.2799 45.3402 58.2799C48.1302 58.2799 49.7702 60.5199 50.2102 64.8899C50.5909 68.903 50.0751 72.9505 48.7002 76.7399C48.1404 78.091 47.9206 79.5588 48.0601 81.0145C48.1996 82.4703 48.6941 83.8697 49.5002 85.0899C50.3193 86.2452 51.4099 87.1814 52.6759 87.8161C53.9419 88.4508 55.3445 88.7646 56.7602 88.7299C59.8802 88.7299 62.2902 87.9399 65.6302 86.8199C69.38 85.5055 73.2073 84.4234 77.0902 83.5799C83.1849 82.1356 89.4027 81.2718 95.6602 80.9999C100.52 80.9099 103.56 81.4399 104.72 82.5899C104.971 82.854 105.16 83.1703 105.274 83.516C105.388 83.8618 105.424 84.2285 105.38 84.5899C105.37 85.3899 105.35 87.9999 98.8302 88.9999Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M38.2202 44C38.3702 44 53.6402 46.28 59.9402 52.58C66.2402 58.88 68.5002 74.13 68.5002 74.28C68.5002 74.8104 68.7109 75.3191 69.086 75.6942C69.4611 76.0693 69.9698 76.28 70.5002 76.28C71.0306 76.28 71.5394 76.0693 71.9144 75.6942C72.2895 75.3191 72.5002 74.8104 72.5002 74.28C72.5002 74.13 74.7802 58.86 81.0802 52.56C87.3802 46.26 102.63 44 102.78 44C103.311 44 103.819 43.7893 104.194 43.4142C104.57 43.0391 104.78 42.5304 104.78 42C104.78 41.4695 104.57 40.9608 104.194 40.5858C103.819 40.2107 103.311 40 102.78 40C102.63 40 87.3602 37.72 81.0602 31.42C74.7602 25.12 72.5002 9.86997 72.5002 9.71997C72.5002 9.18954 72.2895 8.68083 71.9144 8.30576C71.5394 7.93068 71.0306 7.71997 70.5002 7.71997C69.9698 7.71997 69.4611 7.93068 69.086 8.30576C68.7109 8.68083 68.5002 9.18954 68.5002 9.71997C68.5002 9.86997 66.2202 25.14 59.9202 31.44C53.6202 37.74 38.3702 40 38.2202 40C37.6898 40 37.1811 40.2107 36.806 40.5858C36.4309 40.9608 36.2202 41.4695 36.2202 42C36.2202 42.5304 36.4309 43.0391 36.806 43.4142C37.1811 43.7893 37.6898 44 38.2202 44ZM62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M88.4999 26C89.0295 25.9978 89.5366 25.7856 89.9099 25.41L93.9099 21.41C94.2376 21.0274 94.4088 20.5353 94.3893 20.0319C94.3699 19.5286 94.1612 19.0511 93.805 18.6949C93.4488 18.3387 92.9714 18.1301 92.468 18.1106C91.9647 18.0912 91.4725 18.2624 91.0899 18.59L87.0899 22.59C86.8119 22.8697 86.6228 23.2253 86.5463 23.6122C86.4698 23.999 86.5094 24.3999 86.6601 24.7643C86.8108 25.1287 87.0658 25.4404 87.3932 25.6603C87.7205 25.8802 88.1056 25.9984 88.4999 26Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M87.0899 58.5899C86.7174 58.9646 86.5083 59.4715 86.5083 59.9999C86.5083 60.5283 86.7174 61.0352 87.0899 61.4099L91.0899 65.4099C91.4725 65.7375 91.9646 65.9087 92.468 65.8893C92.9713 65.8699 93.4488 65.6612 93.805 65.305C94.1612 64.9488 94.3699 64.4713 94.3893 63.968C94.4087 63.4646 94.2375 62.9725 93.9099 62.5899L89.9099 58.5899C89.5352 58.2174 89.0283 58.0083 88.4999 58.0083C87.9715 58.0083 87.4646 58.2174 87.0899 58.5899Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M51.0898 25.41C51.4724 25.7377 51.9646 25.9089 52.4679 25.8895C52.9713 25.87 53.4487 25.6614 53.8049 25.3052C54.1611 24.949 54.3698 24.4715 54.3892 23.9682C54.4087 23.4648 54.2375 22.9726 53.9098 22.59L49.9098 18.59C49.5272 18.2624 49.035 18.0912 48.5317 18.1106C48.0283 18.1301 47.5509 18.3387 47.1947 18.6949C46.8385 19.0511 46.6298 19.5286 46.6104 20.0319C46.5909 20.5353 46.7621 21.0274 47.0898 21.41L51.0898 25.41Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Your account has been opened"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "all-you-need-in-your",
                    children: "Enjoy all the benefits of our App"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2",
                    onClick: handleButtonClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "highlighted-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                            className: "test-button-4 highlighted-button",
                            disabled: "off",
                            endIcon: false,
                            label: "Let\u2019s start!",
                            onColor: "off",
                            size: "large",
                            startIcon: false,
                            textClassName: "test-button-5",
                            type: "primary"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"bhmC6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../hooks/useDynamicColors":"b2GRH"}],"bhmC6":[function() {},{}],"XmR4d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingStepper", ()=>(0, _pixieOnboardingStepper.PixieOnboardingStepper));
var _pixieOnboardingStepper = require("./PixieOnboardingStepper");

},{"./PixieOnboardingStepper":"fqQCO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fqQCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingStepper", ()=>PixieOnboardingStepper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboardingStepper = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_card_id-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "div-wrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Open account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "battery",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "capacity-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "capacity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "cap",
                                                alt: "Cap",
                                                src: "/img/cap-2.svg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "wifi",
                                        alt: "Wifi",
                                        src: "/img/wifi.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "cellular-connection",
                                        alt: "Cellular connection",
                                        src: "/img/cellular-connection.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "navs-statusbar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7",
                                        children: "9:50"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons",
                                        alt: "Icons",
                                        src: "/img/icons-6.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                            className: "header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "overlap-7",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "subtitle-4",
                                    children: "Terms and Conditions"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 72,
                            height: 72,
                            viewBox: "0 0 72 72",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.5 72L38.893 59.6009C37.7023 58.4299 37.7023 56.5528 38.893 55.399L51.5 43L64.107 55.399C65.2977 56.5701 65.2977 58.4471 64.107 59.6009L51.5 72Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.75 66.9375H20.25C18.609 66.9375 17.0352 66.2856 15.8748 65.1252C14.7144 63.9648 14.0625 62.391 14.0625 60.75V18C14.0625 16.359 14.7144 14.7852 15.8748 13.6248C17.0352 12.4644 18.609 11.8125 20.25 11.8125H23.0625V11.25C23.0625 9.60897 23.7144 8.03516 24.8748 6.87478C26.0352 5.7144 27.609 5.0625 29.25 5.0625C30.8874 5.07428 32.4544 5.72996 33.6122 6.8878C34.77 8.04563 35.4257 9.61261 35.4375 11.25V11.8125H43.1325C43.948 11.811 44.7557 11.9713 45.5089 12.2841C46.262 12.597 46.9456 13.0561 47.52 13.635L56.115 22.23C56.6939 22.8044 57.153 23.488 57.4659 24.2411C57.7787 24.9943 57.939 25.802 57.9375 26.6175V60.75C57.9375 62.391 57.2856 63.9648 56.1252 65.1252C54.9648 66.2856 53.391 66.9375 51.75 66.9375ZM20.25 15.1875C19.5041 15.1875 18.7887 15.4838 18.2613 16.0113C17.7338 16.5387 17.4375 17.2541 17.4375 18V60.75C17.4375 61.4959 17.7338 62.2113 18.2613 62.7387C18.7887 63.2662 19.5041 63.5625 20.25 63.5625H51.75C52.4959 63.5625 53.2113 63.2662 53.7387 62.7387C54.2662 62.2113 54.5625 61.4959 54.5625 60.75V28.6875H45C43.9575 28.6816 42.9594 28.2649 42.2223 27.5277C41.4851 26.7906 41.0684 25.7925 41.0625 24.75V15.1875H35.4375V20.25C35.4375 21.891 34.7856 23.4648 33.6252 24.6252C32.4648 25.7856 30.891 26.4375 29.25 26.4375C27.609 26.4375 26.0352 25.7856 24.8748 24.6252C23.7144 23.4648 23.0625 21.891 23.0625 20.25C23.0625 19.8024 23.2403 19.3732 23.5568 19.0568C23.8732 18.7403 24.3024 18.5625 24.75 18.5625C25.1976 18.5625 25.6268 18.7403 25.9432 19.0568C26.2597 19.3732 26.4375 19.8024 26.4375 20.25C26.4375 20.9959 26.7338 21.7113 27.2613 22.2387C27.7887 22.7662 28.5041 23.0625 29.25 23.0625C29.9959 23.0625 30.7113 22.7662 31.2387 22.2387C31.7662 21.7113 32.0625 20.9959 32.0625 20.25V15.1875H20.25ZM44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025ZM26.4375 11.8125H32.0625V11.25C32.0651 10.8861 31.9948 10.5254 31.8557 10.1892C31.7166 9.85301 31.5115 9.5481 31.2525 9.2925C30.8663 8.88491 30.3661 8.60333 29.8173 8.48457C29.2685 8.36582 28.6967 8.41541 28.1765 8.62688C27.6563 8.83834 27.2121 9.20184 26.9018 9.66983C26.5916 10.1378 26.4297 10.6886 26.4375 11.25V11.8125ZM47.25 55.6875H24.75C24.3024 55.6875 23.8732 55.5097 23.5568 55.1932C23.2403 54.8768 23.0625 54.4476 23.0625 54C23.0625 53.5524 23.2403 53.1232 23.5568 52.8068C23.8732 52.4903 24.3024 52.3125 24.75 52.3125H47.25C47.6976 52.3125 48.1268 52.4903 48.4432 52.8068C48.7597 53.1232 48.9375 53.5524 48.9375 54C48.9375 54.4476 48.7597 54.8768 48.4432 55.1932C48.1268 55.5097 47.6976 55.6875 47.25 55.6875ZM47.25 46.6875H24.75C24.3024 46.6875 23.8732 46.5097 23.5568 46.1932C23.2403 45.8768 23.0625 45.4476 23.0625 45C23.0625 44.5524 23.2403 44.1232 23.5568 43.8068C23.8732 43.4903 24.3024 43.3125 24.75 43.3125H47.25C47.6976 43.3125 48.1268 43.4903 48.4432 43.8068C48.7597 44.1232 48.9375 44.5524 48.9375 45C48.9375 45.4476 48.7597 45.8768 48.4432 46.1932C48.1268 46.5097 47.6976 46.6875 47.25 46.6875ZM33.75 37.6875H24.75C24.3024 37.6875 23.8732 37.5097 23.5568 37.1932C23.2403 36.8768 23.0625 36.4476 23.0625 36C23.0625 35.5524 23.2403 35.1232 23.5568 34.8068C23.8732 34.4903 24.3024 34.3125 24.75 34.3125H33.75C34.1976 34.3125 34.6268 34.4903 34.9432 34.8068C35.2597 35.1232 35.4375 35.5524 35.4375 36C35.4375 36.4476 35.2597 36.8768 34.9432 37.1932C34.6268 37.5097 34.1976 37.6875 33.75 37.6875Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subtitle-5",
                            children: "Welcome!"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "subtitle-6",
                            children: "Let\u2019s open your online account"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Accept Terms and Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Register your Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-7",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Scan your ID card"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: " Validate your identity"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Register your Mobile number"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Generate your credentials"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"dRurE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"dRurE":[function() {},{}],"a2vcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingCardId", ()=>(0, _pixieOnboardingCardId.PixieOnboardingCardId));
var _pixieOnboardingCardId = require("./PixieOnboardingCardId");

},{"./PixieOnboardingCardId":"ikJac","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ikJac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingCardId", ()=>PixieOnboardingCardId);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _iconChevronDown1 = require("../../../../../icons/IconChevronDown1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboardingCardId = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pixie-onboarding-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-13",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line-3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-14",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-4"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-7",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-3",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 98,
                            height: 73,
                            viewBox: "0 0 98 73",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-13",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-14",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-15",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "subtitle-11",
                                            children: "Now, get your ID card"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "subtitle-12",
                                        children: [
                                            "We will take a photo of the front & back.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Photos will be captured automatically."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "e-mail",
                                    children: "Country"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-16",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-17",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-15",
                                                children: "Select your country"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconChevronDown1.IconChevronDown1), {
                                                className: "icon-chevron-down",
                                                color: "#5C5C5C"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-3 highlighted-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-4",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-wrapper-16",
                            children: "I\xb4ve got my ID card!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overlap-9",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-18",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-arrow-back-1-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                        className: "icon-arrow-back-1-instance"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "subtitle-13",
                                    children: "Scan ID Card"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"ljBxe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../icons/IconChevronDown1":"ccPWd","../../../../../hooks/useDynamicColors":"b2GRH"}],"ljBxe":[function() {},{}],"f1DVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingPhone", ()=>(0, _pixieOnboardingPhone.PixieOnboardingPhone));
var _pixieOnboardingPhone = require("./PixieOnboardingPhone");

},{"./PixieOnboardingPhone":"bHMom","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bHMom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixieOnboardingPhone", ()=>PixieOnboardingPhone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _componenteToken = require("../../../../../components/ComponenteToken");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const PixieOnboardingPhone = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_welcome-pixie-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-pixie-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-8",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-10",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-2"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "atomo-step-final-no",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-2",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 65,
                            height: 87,
                            viewBox: "0 0 65 87",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z",
                                    fill: colors.sexto
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "subtitle-9",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "span",
                                            children: [
                                                "A validation code has been sent to\xa0\xa0",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-11",
                                            children: "+54 9 1122 6476"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteToken.ComponenteToken), {
                            active: false,
                            atomoTimeRectangleClassName: "componente-token-5",
                            atomoTimeSubtitleCopyClassName: "componente-token-3",
                            atomoTimeSubtitleCopyClassNameOverride: "componente-token-3",
                            atomoTimeTimelineClassName: "componente-token-4",
                            buttonActive: true,
                            buttonInactive: false,
                            buttonSmallEstado: "inactivo",
                            buttonSmallTextClassName: "componente-token-6",
                            buttonSmallTexto: "Resend code",
                            className: "componente-token-input",
                            default1: true,
                            error: false,
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName1: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName2: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenText: "8",
                            moleculaTokenNumbsAtomoNumbTokenText1: "4",
                            moleculaTokenNumbsAtomoNumbTokenText2: "9",
                            moleculaTokenNumbsAtomoNumbTokenText3: "6",
                            moleculaTokenNumbsDefaultFalseActiveClassName: "componente-token-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-3 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-12",
                            children: "Validate"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-10",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "overlap-group-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-10",
                                        children: "Register Mobile number"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"d1D9S","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteToken":"1K7Wn","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../hooks/useDynamicColors":"b2GRH"}],"d1D9S":[function() {},{}],"2oBV1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboarding", ()=>(0, _adultosOnboarding.AdultosOnboarding));
var _adultosOnboarding = require("./AdultosOnboarding");

},{"./AdultosOnboarding":"3eXMq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eXMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboarding", ()=>AdultosOnboarding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _btnPrimary = require("../../../../../components/BtnPrimary");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboarding = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
    };
    const handleButtonClickOnboarding = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_tutorial_easy-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-onboarding",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-7",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 490,
                            height: 239,
                            viewBox: "0 0 375 239",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M87.2391 280.362L278.969 66.1216L292.29 51.9809L292.38 52.0768L86.9893 281.59C87.0661 281.181 87.1559 280.778 87.2391 280.368",
                                    fill: "url(#paint0_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M87.9307 297.29L299.799 59.6228L300.427 60.256L88.2254 298.301C88.1229 297.962 88.0268 297.629 87.9307 297.29Z",
                                    fill: "url(#paint1_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M93.1402 309.277L308.308 68.2897L309.115 69.1148L93.7617 310.3C93.5439 309.961 93.3388 309.622 93.1338 309.277",
                                    fill: "url(#paint2_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M100.47 318.876L316.823 76.9556L317.816 77.9661L101.45 319.899C101.117 319.56 100.796 319.215 100.47 318.876Z",
                                    fill: "url(#paint3_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M108.838 327.311L325.338 85.6275L326.511 86.8235L110.023 328.501L108.838 327.311Z",
                                    fill: "url(#paint4_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M117.225 335.729L333.847 94.2946L335.205 95.6824L118.596 337.098L117.225 335.729Z",
                                    fill: "url(#paint5_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M125.612 344.139L342.363 102.966L343.9 104.533L127.169 345.699L125.612 344.139Z",
                                    fill: "url(#paint6_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M133.999 352.549L350.871 111.633L352.601 113.391L135.735 354.295L133.999 352.549Z",
                                    fill: "url(#paint7_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M142.386 360.959L359.386 120.299L361.295 122.243L144.314 362.891L142.386 360.959Z",
                                    fill: "url(#paint8_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M150.767 369.369L367.895 128.965L369.99 131.101L152.881 371.486L150.767 369.369Z",
                                    fill: "url(#paint9_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M159.154 377.773L376.411 137.631L378.685 139.952L161.448 380.082L159.154 377.773Z",
                                    fill: "url(#paint10_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M167.541 386.184L384.919 146.297L387.38 148.811L170.021 388.672L167.541 386.184Z",
                                    fill: "url(#paint11_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M175.922 394.594L393.428 154.97L396.074 157.662L178.587 397.268L175.922 394.594Z",
                                    fill: "url(#paint12_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M184.303 402.997L401.937 163.628L404.769 166.512L187.154 405.855L184.303 402.997Z",
                                    fill: "url(#paint13_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M192.683 411.401L410.445 172.295L413.463 175.364L195.72 414.445L192.683 411.401Z",
                                    fill: "url(#paint14_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M201.063 419.805L418.954 180.961L422.152 184.216L204.286 423.041L201.063 419.805Z",
                                    fill: "url(#paint15_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M209.444 428.21L427.463 189.628L430.846 193.075L212.853 431.625L209.444 428.21Z",
                                    fill: "url(#paint16_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M217.818 436.612L435.972 198.292L439.541 201.919L221.413 440.213L217.818 436.612Z",
                                    fill: "url(#paint17_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M226.199 445.017L444.481 206.959L448.236 210.777L229.973 448.803L226.199 445.017Z",
                                    fill: "url(#paint18_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M234.58 453.415L452.99 215.619L456.924 219.629L238.54 457.393L234.58 453.415Z",
                                    fill: "url(#paint19_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M242.954 461.817L461.499 224.284L465.612 228.473L247.1 465.975L242.954 461.817Z",
                                    fill: "url(#paint20_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M251.328 470.216L470.007 232.945L474.306 237.326L255.659 474.559L251.328 470.216Z",
                                    fill: "url(#paint21_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-184.915 280.471C-184.966 279.313 -184.986 278.162 -185.018 277.011L-3.34044 69.5178C-0.662216 69.2236 2.02881 68.9741 4.73907 68.7887L-184.659 285.095C-184.761 283.553 -184.851 282.012 -184.915 280.464",
                                    fill: "url(#paint22_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-183.974 293.095L12.9271 68.4109C15.3683 68.3405 17.803 68.3022 20.225 68.315L-183.096 300.322C-183.435 297.924 -183.724 295.513 -183.974 293.089",
                                    fill: "url(#paint23_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-181.872 307.953L28.1315 68.5201C30.3484 68.616 32.5589 68.7503 34.763 68.9166L-180.597 314.457C-181.058 312.302 -181.481 310.134 -181.872 307.953Z",
                                    fill: "url(#paint24_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-178.893 321.8L42.4518 69.6589C44.4765 69.8892 46.5011 70.1578 48.5066 70.452L-177.304 327.684C-177.861 325.733 -178.393 323.776 -178.893 321.8Z",
                                    fill: "url(#paint25_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-175.15 334.764L56.0034 71.6799C57.8615 72.0253 59.7196 72.3898 61.5585 72.78L-173.331 340.123C-173.965 338.351 -174.567 336.561 -175.15 334.764Z",
                                    fill: "url(#paint26_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-170.749 346.959L68.8687 74.4931C70.5795 74.9216 72.2774 75.3757 73.9689 75.849L-168.737 351.826C-169.429 350.214 -170.095 348.596 -170.749 346.959Z",
                                    fill: "url(#paint27_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-165.758 358.478L81.145 77.9983C82.7148 78.5036 84.2781 79.0216 85.8287 79.5589L-163.599 362.91C-164.335 361.439 -165.059 359.962 -165.758 358.478Z",
                                    fill: "url(#paint28_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-160.209 369.351L92.8512 82.1555C94.2928 82.7183 95.728 83.2939 97.1568 83.8887L-157.934 373.393C-158.71 372.056 -159.466 370.706 -160.209 369.351Z",
                                    fill: "url(#paint29_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-154.173 379.655L104.052 86.8953C105.378 87.5028 106.691 88.1296 108.005 88.7692L-151.809 383.332C-152.609 382.117 -153.398 380.889 -154.173 379.655Z",
                                    fill: "url(#paint30_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-147.657 389.413L114.752 92.2216C115.969 92.8675 117.18 93.5262 118.378 94.1978L-145.241 392.758C-146.061 391.651 -146.862 390.532 -147.663 389.413",
                                    fill: "url(#paint31_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-140.692 398.642L124.996 98.0612C126.105 98.7391 127.207 99.4363 128.309 100.133L-138.226 401.674C-139.052 400.67 -139.879 399.666 -140.692 398.642Z",
                                    fill: "url(#paint32_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-133.298 407.393L134.787 104.432C135.806 105.129 136.818 105.833 137.824 106.556L-130.806 410.117C-131.645 409.215 -132.478 408.307 -133.305 407.393",
                                    fill: "url(#paint33_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-125.481 415.649L144.135 111.301C145.058 112.024 145.974 112.746 146.884 113.482L-122.983 418.111C-123.822 417.299 -124.655 416.474 -125.481 415.649Z",
                                    fill: "url(#paint34_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-117.248 423.425L153.067 118.648C153.906 119.377 154.726 120.126 155.546 120.868L-114.749 425.625C-115.589 424.896 -116.422 424.16 -117.248 423.419",
                                    fill: "url(#paint35_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-108.611 430.743L161.543 126.51C162.299 127.245 163.055 127.981 163.799 128.729L-106.119 432.693C-106.952 432.047 -107.785 431.401 -108.605 430.743",
                                    fill: "url(#paint36_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-99.5512 437.578L169.61 134.842C170.283 135.578 170.949 136.326 171.616 137.074L-97.0972 439.299C-97.9174 438.73 -98.7375 438.16 -99.5576 437.578",
                                    fill: "url(#paint37_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-90.0752 443.935L177.222 143.68C177.818 144.416 178.407 145.158 178.997 145.906L-87.6597 445.451C-88.4734 444.952 -89.2679 444.441 -90.0752 443.935Z",
                                    fill: "url(#paint38_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-80.8809 449.418L183.905 152.374C184.43 153.096 184.962 153.825 185.481 154.555L-78.5166 450.723C-79.3111 450.294 -80.0928 449.859 -80.8744 449.418",
                                    fill: "url(#paint39_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-70.0146 455.091L190.965 162.716C191.426 163.439 191.868 164.161 192.323 164.89L-67.6952 456.191C-68.4705 455.827 -69.2458 455.462 -70.0082 455.091",
                                    fill: "url(#paint40_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-58.7954 460.097L197.379 173.51C197.77 174.22 198.16 174.917 198.545 175.633L-56.5528 461.012C-57.3089 460.711 -58.0521 460.404 -58.8018 460.097",
                                    fill: "url(#paint41_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-47.1274 464.492L203.21 184.838C203.536 185.528 203.85 186.232 204.171 186.929L-44.9489 465.215C-45.6794 464.978 -46.4098 464.735 -47.1338 464.492",
                                    fill: "url(#paint42_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-33.2754 468.68L209.04 198.401C209.303 199.079 209.546 199.764 209.802 200.448L-31.161 469.211C-31.8658 469.032 -32.577 468.859 -33.2754 468.68Z",
                                    fill: "url(#paint43_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-20.6846 471.559L213.391 210.873C213.59 211.526 213.807 212.172 214.006 212.824L-18.6727 471.955C-19.3455 471.827 -20.0118 471.686 -20.6846 471.559Z",
                                    fill: "url(#paint44_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-7.43457 473.709L217.056 224.107C217.21 224.734 217.357 225.354 217.498 225.987L-5.5124 473.945C-6.15312 473.869 -6.79385 473.792 -7.43457 473.709Z",
                                    fill: "url(#paint45_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M7.16699 475.057L220.022 238.784C220.124 239.385 220.214 239.98 220.304 240.581L8.98664 475.141C8.37796 475.115 7.76927 475.089 7.16699 475.057Z",
                                    fill: "url(#paint46_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint0_linear_2630_5042",
                                            x1: 94.238,
                                            y1: 145.72,
                                            x2: 299.628,
                                            y2: 145.72,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint1_linear_2630_5042",
                                            x1: 95.4302,
                                            y1: 157.065,
                                            x2: 307.926,
                                            y2: 157.065,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint2_linear_2630_5042",
                                            x1: 100.756,
                                            y1: 167.092,
                                            x2: 316.738,
                                            y2: 167.092,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint3_linear_2630_5042",
                                            x1: 108.14,
                                            y1: 176.139,
                                            x2: 325.487,
                                            y2: 176.139,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint4_linear_2630_5042",
                                            x1: 116.52,
                                            y1: 184.782,
                                            x2: 334.193,
                                            y2: 184.782,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint5_linear_2630_5042",
                                            x1: 124.918,
                                            y1: 193.421,
                                            x2: 342.898,
                                            y2: 193.421,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint6_linear_2630_5042",
                                            x1: 133.316,
                                            y1: 202.064,
                                            x2: 351.604,
                                            y2: 202.064,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint7_linear_2630_5042",
                                            x1: 141.714,
                                            y1: 210.701,
                                            x2: 360.316,
                                            y2: 210.701,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint8_linear_2630_5042",
                                            x1: 150.112,
                                            y1: 219.338,
                                            x2: 369.021,
                                            y2: 219.338,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint9_linear_2630_5042",
                                            x1: 158.504,
                                            y1: 227.976,
                                            x2: 377.727,
                                            y2: 227.976,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint10_linear_2630_5042",
                                            x1: 166.902,
                                            y1: 236.613,
                                            x2: 386.433,
                                            y2: 236.613,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint11_linear_2630_5042",
                                            x1: 175.3,
                                            y1: 245.248,
                                            x2: 395.138,
                                            y2: 245.248,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint12_linear_2630_5042",
                                            x1: 183.692,
                                            y1: 253.89,
                                            x2: 403.844,
                                            y2: 253.89,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint13_linear_2630_5042",
                                            x1: 192.084,
                                            y1: 262.519,
                                            x2: 412.55,
                                            y2: 262.519,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint14_linear_2630_5042",
                                            x1: 200.475,
                                            y1: 271.154,
                                            x2: 421.255,
                                            y2: 271.154,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint15_linear_2630_5042",
                                            x1: 208.866,
                                            y1: 279.792,
                                            x2: 429.954,
                                            y2: 279.792,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint16_linear_2630_5042",
                                            x1: 217.258,
                                            y1: 288.425,
                                            x2: 438.66,
                                            y2: 288.425,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint17_linear_2630_5042",
                                            x1: 225.644,
                                            y1: 297.058,
                                            x2: 447.366,
                                            y2: 297.058,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint18_linear_2630_5042",
                                            x1: 234.035,
                                            y1: 305.693,
                                            x2: 456.072,
                                            y2: 305.693,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint19_linear_2630_5042",
                                            x1: 242.427,
                                            y1: 314.325,
                                            x2: 464.771,
                                            y2: 314.325,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint20_linear_2630_5042",
                                            x1: 250.812,
                                            y1: 322.956,
                                            x2: 473.47,
                                            y2: 322.956,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint21_linear_2630_5042",
                                            x1: 259.198,
                                            y1: 331.585,
                                            x2: 482.176,
                                            y2: 331.585,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint22_linear_2630_5042",
                                            x1: -182.222,
                                            y1: 165.89,
                                            x2: 7.53462,
                                            y2: 165.89,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint23_linear_2630_5042",
                                            x1: -180.965,
                                            y1: 172.463,
                                            x2: 23.2333,
                                            y2: 172.463,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint24_linear_2630_5042",
                                            x1: -178.681,
                                            y1: 178.923,
                                            x2: 37.9545,
                                            y2: 178.923,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint25_linear_2630_5042",
                                            x1: -175.542,
                                            y1: 185.488,
                                            x2: 51.8567,
                                            y2: 185.488,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint26_linear_2630_5042",
                                            x1: -171.663,
                                            y1: 192.186,
                                            x2: 65.0457,
                                            y2: 192.186,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint27_linear_2630_5042",
                                            x1: -167.144,
                                            y1: 198.99,
                                            x2: 77.5742,
                                            y2: 198.99,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint28_linear_2630_5042",
                                            x1: -162.051,
                                            y1: 205.897,
                                            x2: 89.5351,
                                            y2: 205.897,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint29_linear_2630_5042",
                                            x1: -156.417,
                                            y1: 212.894,
                                            x2: 100.948,
                                            y2: 212.894,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint30_linear_2630_5042",
                                            x1: -150.31,
                                            y1: 219.968,
                                            x2: 111.867,
                                            y2: 219.968,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint31_linear_2630_5042",
                                            x1: -143.744,
                                            y1: 227.134,
                                            x2: 122.298,
                                            y2: 227.134,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint32_linear_2630_5042",
                                            x1: -136.729,
                                            y1: 234.355,
                                            x2: 132.272,
                                            y2: 234.355,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint33_linear_2630_5042",
                                            x1: -129.31,
                                            y1: 241.656,
                                            x2: 141.818,
                                            y2: 241.656,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint34_linear_2630_5042",
                                            x1: -121.469,
                                            y1: 249.03,
                                            x2: 150.896,
                                            y2: 249.03,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint35_linear_2630_5042",
                                            x1: -113.229,
                                            y1: 256.452,
                                            x2: 159.565,
                                            y2: 256.452,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint36_linear_2630_5042",
                                            x1: -104.598,
                                            y1: 263.958,
                                            x2: 167.812,
                                            y2: 263.958,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint37_linear_2630_5042",
                                            x1: -95.5626,
                                            y1: 271.515,
                                            x2: 175.611,
                                            y2: 271.515,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint38_linear_2630_5042",
                                            x1: -86.1112,
                                            y1: 279.147,
                                            x2: 182.961,
                                            y2: 279.147,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint39_linear_2630_5042",
                                            x1: -76.9567,
                                            y1: 286.304,
                                            x2: 189.405,
                                            y2: 286.304,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint40_linear_2630_5042",
                                            x1: -66.1498,
                                            y1: 294.459,
                                            x2: 196.188,
                                            y2: 294.459,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint41_linear_2630_5042",
                                            x1: -55.0105,
                                            y1: 302.571,
                                            x2: 202.336,
                                            y2: 302.571,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint42_linear_2630_5042",
                                            x1: -43.4315,
                                            y1: 310.701,
                                            x2: 207.873,
                                            y2: 310.701,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint43_linear_2630_5042",
                                            x1: -29.6943,
                                            y1: 319.97,
                                            x2: 213.383,
                                            y2: 319.97,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint44_linear_2630_5042",
                                            x1: -17.227,
                                            y1: 328.075,
                                            x2: 217.464,
                                            y2: 328.075,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint45_linear_2630_5042",
                                            x1: -4.1208,
                                            y1: 336.261,
                                            x2: 220.812,
                                            y2: 336.261,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint46_linear_2630_5042",
                                            x1: 10.307,
                                            y1: 344.886,
                                            x2: 223.444,
                                            y2: 344.886,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "capa-2",
                            alt: "Capa",
                            src: "/img/capa-1-1.svg"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "rectangle-9",
                        alt: "Rectangle",
                        src: "/img/rectangle.png"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "buttons-2",
                    children: [
                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            width: 100,
                            height: "auto",
                            src: colors.url_logo
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper-30",
                                    children: "Welcome"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper-30",
                                    children: "It\u2019s nice to see u!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClick,
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnPrimary.BtnPrimary), {
                                className: "btn-primary-5 highlighted-button",
                                divClassName: "btn-primary-6",
                                text: "Login by Password",
                                center: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "highlighted-button",
                            style: {
                                width: "100%"
                            },
                            onClick: handleButtonClickOnboarding,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnPrimary.BtnPrimary), {
                                className: "btn-primary-7",
                                divClassName: "btn-primary-8",
                                text: "Sign in"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"aQV1J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/BtnPrimary":"lD5WC","../../../../../hooks/useDynamicColors":"b2GRH"}],"aQV1J":[function() {},{}],"lD5WC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnPrimary", ()=>(0, _btnPrimary.BtnPrimary));
var _btnPrimary = require("./BtnPrimary");

},{"./BtnPrimary":"hJ6cd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJ6cd":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnPrimary", ()=>BtnPrimary);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const BtnPrimary = ({ withIcon = false, text = "Button", off = false, className, divClassName, center = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: `btn-primary off-${off} ${className}`,
        children: !center ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `text-wrapper ${divClassName}`,
            children: text
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `${divClassName}`,
            style: {
                textAlign: "center"
            },
            children: text
        })
    });
};
BtnPrimary.propTypes = {
    withIcon: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).string,
    off: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"a2Dbt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a2Dbt":[function() {},{}],"kF3OL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosLanding", ()=>(0, _adultosLanding.AdultosLanding));
var _adultosLanding = require("./AdultosLanding");

},{"./AdultosLanding":"khaEE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"khaEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosLanding", ()=>AdultosLanding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _btnIconMoneyWrapper = require("../../../../../components/BtnIconMoneyWrapper");
var _award1 = require("../../../../../icons/Award1");
var _btnIconMore2 = require("../../../../../icons/BtnIconMore2");
var _exchangeAlt1 = require("../../../../../icons/ExchangeAlt1");
var _icons19 = require("../../../../../icons/Icons19");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosLanding = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const scrollRef = (0, _react.useRef)(null);
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-card_details-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-landing",
        ref: scrollRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-108",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-109",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-21",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-19",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "btn-icon-money-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMoneyWrapper.BtnIconMoneyWrapper), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-22",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-22",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-80",
                                                        children: "3"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "hello-mary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "text-wrapper-81",
                                            children: [
                                                "Hello,",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-82",
                                            children: "Mary"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-110",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-23",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-83",
                                            children: "2,015 pts"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "award-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _award1.Award1), {
                                                className: "award"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "iconly-light-outline-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "more-square-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "more-square",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "overlap-group-23",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 25,
                                                    height: 24,
                                                    viewBox: "0 0 25 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M21 7.665C21 5.135 19.267 3.5 16.584 3.5L8.416 3.5C5.733 3.5 4 5.135 4 7.665L4 16.333C4 18.864 5.733 20.5 8.416 20.5L16.584 20.5C19.267 20.5 21 18.864 21 16.334L21 7.665ZM2.5 16.333L2.5 7.665C2.5 4.276 4.878 2 8.416 2L16.584 2C20.122 2 22.5 4.276 22.5 7.665L22.5 16.334C22.5 19.723 20.122 22 16.584 22L8.416 22C4.878 22 2.5 19.723 2.5 16.333Z",
                                                            fill: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21 7.665L21.5 7.665L21 7.665ZM4 7.665L4.5 7.665L4 7.665ZM4 16.333L3.5 16.333L4 16.333ZM21 16.334L20.5 16.334L21 16.334ZM2.5 7.665L3 7.665L2.5 7.665ZM22.5 7.665L23 7.665L22.5 7.665ZM22.5 16.334L22 16.334L22.5 16.334ZM21.5 7.665C21.5 6.28138 21.023 5.10182 20.1412 4.27003C19.2623 3.44103 18.0268 3 16.584 3L16.584 4C17.8242 4 18.7967 4.37647 19.455 4.99747C20.1105 5.61568 20.5 6.51862 20.5 7.665L21.5 7.665ZM16.584 3L8.416 3L8.416 4L16.584 4L16.584 3ZM8.416 3C6.97316 3 5.73767 3.44103 4.8588 4.27002C3.97695 5.10182 3.5 6.28138 3.5 7.665L4.5 7.665C4.5 6.51862 4.88955 5.61568 5.54496 4.99747C6.20333 4.37647 7.17584 4 8.416 4L8.416 3ZM3.5 7.665L3.5 16.333L4.5 16.333L4.5 7.665L3.5 7.665ZM3.5 16.333C3.5 17.717 3.9769 18.8971 4.8587 19.7293C5.73756 20.5587 6.97308 21 8.416 21L8.416 20C7.17592 20 6.20344 19.6233 5.54505 19.002C4.8896 18.3834 4.5 17.4799 4.5 16.333L3.5 16.333ZM8.416 21L16.584 21L16.584 20L8.416 20L8.416 21ZM16.584 21C18.0269 21 19.2624 20.5587 20.1413 19.7294C21.0231 18.8974 21.5 17.7176 21.5 16.334L20.5 16.334C20.5 17.4804 20.1104 18.3836 19.455 19.0021C18.7966 19.6233 17.8241 20 16.584 20L16.584 21ZM21.5 16.334L21.5 7.665L20.5 7.665L20.5 16.334L21.5 16.334ZM3 16.333L3 7.665L2 7.665L2 16.333L3 16.333ZM3 7.665C3 6.09184 3.54915 4.81117 4.47703 3.92278C5.40682 3.03257 6.75523 2.5 8.416 2.5L8.416 1.5C6.53878 1.5 4.92918 2.10543 3.78547 3.20047C2.63985 4.29733 2 5.84916 2 7.665L3 7.665ZM8.416 2.5L16.584 2.5L16.584 1.5L8.416 1.5L8.416 2.5ZM16.584 2.5C18.2448 2.5 19.5932 3.03257 20.523 3.92278C21.4508 4.81117 22 6.09184 22 7.665L23 7.665C23 5.84916 22.3602 4.29733 21.2145 3.20047C20.0708 2.10543 18.4612 1.5 16.584 1.5L16.584 2.5ZM22 7.665L22 16.334L23 16.334L23 7.665L22 7.665ZM22 16.334C22 17.9072 21.4508 19.1881 20.5229 20.0768C19.5931 20.9672 18.2447 21.5 16.584 21.5L16.584 22.5C18.4613 22.5 20.0709 21.8943 21.2146 20.799C22.3602 19.7019 23 18.1498 23 16.334L22 16.334ZM16.584 21.5L8.416 21.5L8.416 22.5L16.584 22.5L16.584 21.5ZM8.416 21.5C6.75529 21.5 5.4069 20.9672 4.4771 20.0767C3.54919 19.1879 3 17.9067 3 16.333L2 16.333C2 18.1493 2.63981 19.7016 3.7854 20.7988C4.9291 21.8943 6.53871 22.5 8.416 22.5L8.416 21.5Z",
                                                            fill: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M11.4863 15.9484C11.4863 15.3954 11.9333 14.9434 12.4863 14.9434C13.0393 14.9434 13.4863 15.3864 13.4863 15.9384L13.4863 15.9484C13.4863 16.5014 13.0393 16.9484 12.4863 16.9484C11.9333 16.9484 11.4863 16.5014 11.4863 15.9484Z",
                                                            fill: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M11.4863 15.9484C11.4863 15.3954 11.9333 14.9434 12.4863 14.9434C13.0393 14.9434 13.4863 15.3864 13.4863 15.9384L13.4863 15.9484C13.4863 16.5014 13.0393 16.9484 12.4863 16.9484C11.9333 16.9484 11.4863 16.5014 11.4863 15.9484",
                                                            stroke: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M11.4863 11.9386C11.4863 11.3856 11.9333 10.9346 12.4863 10.9346C13.0393 10.9346 13.4863 11.3766 13.4863 11.9296L13.4863 11.9386C13.4863 12.4916 13.0393 12.9386 12.4863 12.9386C11.9333 12.9386 11.4863 12.4916 11.4863 11.9386Z",
                                                            fill: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M11.4863 11.9386C11.4863 11.3856 11.9333 10.9346 12.4863 10.9346C13.0393 10.9346 13.4863 11.3766 13.4863 11.9296L13.4863 11.9386C13.4863 12.4916 13.0393 12.9386 12.4863 12.9386C11.9333 12.9386 11.4863 12.4916 11.4863 11.9386",
                                                            stroke: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M11.4863 7.9298C11.4863 7.3768 11.9333 6.9248 12.4863 6.9248C13.0393 6.9248 13.4863 7.3678 13.4863 7.9208L13.4863 7.9298C13.4863 8.4828 13.0393 8.9298 12.4863 8.9298C11.9333 8.9298 11.4863 8.4828 11.4863 7.9298Z",
                                                            fill: colors.primario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M11.4863 7.9298C11.4863 7.3768 11.9333 6.9248 12.4863 6.9248C13.0393 6.9248 13.4863 7.3678 13.4863 7.9208L13.4863 7.9298C13.4863 8.4828 13.0393 8.9298 12.4863 8.9298C11.9333 8.9298 11.4863 8.4828 11.4863 7.9298",
                                                            stroke: colors.primario
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-111",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "btn-switch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "selected",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-84",
                                        children: "Wealth"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-85",
                                        children: "Transactions"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-85",
                                        children: "Rewards"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "element-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "div-12",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-86",
                                            children: "My Products"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-112",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                    className: "icons-5",
                                                    color: "var(--secundario)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "menu-copy-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "oval-7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "oval-8"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "oval-9"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "accounts-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "overlap-20",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "debit-3 highlighted-button",
                                            onClick: handleButtonClick,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-22",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-121",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-122",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-107",
                                                                        children: "Balance"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-123",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-108",
                                                                                children: "$"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-124",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-109",
                                                                                        children: "13,000"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-110",
                                                                                        children: ".23"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-111",
                                                                                children: "USD"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-112",
                                                                children: "Digital Account"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-125",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-113",
                                                                children: "Debit Card ****2357"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                className: "trailing-icon-4",
                                                                color: "white"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "element-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "div-13",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "group-28",
                                            alt: "Group",
                                            src: "/img/group-638.svg"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-126",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-127",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-17"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            className: "div-14",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "text-wrapper-114",
                                                                    children: [
                                                                        "T. Balance",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-115",
                                                                    children: "$13,000"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-127",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            className: "div-14",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "text-wrapper-114",
                                                                    children: [
                                                                        "Debts",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-115",
                                                                    children: "$8,000"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-128",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-116",
                                                    children: "Total balance | Debts"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                    className: "trailing-icon-4",
                                                    color: colors.primario
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "div-13",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-129",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-130",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-116",
                                                        children: "Expenses & Incomes"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                        className: "trailing-icon-4",
                                                        color: colors.primario
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "chart-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-131",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "rectangle-24"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "rectangle-25"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-131",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "rectangle-26"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "rectangle-27"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-132",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-117",
                                                        children: "September"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-133",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-134",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "div-15",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "text-wrapper-114",
                                                                            children: [
                                                                                "Expenses",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "text-wrapper-118",
                                                                            children: "$2,000"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-135",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "div-15",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "text-wrapper-114",
                                                                            children: [
                                                                                "Incomes",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "text-wrapper-118",
                                                                            children: "$3,200"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "element-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "subsection-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "subsection-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-136",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "subsection-5",
                                                    children: "My Goals"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-137",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "btn-text-link-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-link-2",
                                                            children: "Manage"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMore2.BtnIconMore2), {
                                                        className: "icons-5"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "goals",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "goal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-138",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-119",
                                                            children: "Europe travel"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-120",
                                                            children: "$8,700"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "image-9",
                                                    alt: "Image",
                                                    src: "/img/image-217.png"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-29",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-28"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-121",
                                                    children: "15%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "goal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-138",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-119",
                                                            children: "New iPhone"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-120",
                                                            children: "$700.54"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-29",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-29"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-121",
                                                    children: "85%"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "image-10",
                                                    alt: "Image",
                                                    src: "/img/image-61980-1.png"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "goal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-138",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-119",
                                                            children: "Xmas gifts"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-120",
                                                            children: "$3,980"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "image-11",
                                                    alt: "Image",
                                                    src: "/img/image-61589.png"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-29",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-121",
                                                    children: "90%"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "menu-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "icon-and-text-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: 25,
                                    height: 24,
                                    viewBox: "0 0 25 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M19.918 12C19.918 12.2652 19.8126 12.5196 19.6251 12.7071C19.4375 12.8946 19.1832 13 18.918 13C18.6528 13 18.3984 12.8946 18.2109 12.7071C18.0233 12.5196 17.918 12.2652 17.918 12C17.918 11.7348 18.0233 11.4804 18.2109 11.2929C18.3984 11.1054 18.6528 11 18.918 11C19.1832 11 19.4375 11.1054 19.6251 11.2929C19.8126 11.4804 19.918 11.7348 19.918 12Z",
                                            fill: colors.primario
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M10.862 3.25H13.974C15.812 3.25 17.268 3.25 18.407 3.403C19.579 3.561 20.528 3.893 21.277 4.641C22.201 5.566 22.496 6.804 22.603 8.411C23.18 8.664 23.616 9.201 23.663 9.881C23.668 9.942 23.668 10.007 23.668 10.067V13.933C23.668 13.993 23.668 14.058 23.664 14.118C23.616 14.798 23.18 15.336 22.603 15.59C22.496 17.196 22.201 18.434 21.277 19.359C20.528 20.107 19.579 20.439 18.407 20.597C17.267 20.75 15.812 20.75 13.974 20.75H10.862C9.02397 20.75 7.56797 20.75 6.42897 20.597C5.25697 20.439 4.30797 20.107 3.55897 19.359C2.81097 18.61 2.47897 17.661 2.32097 16.489C2.16797 15.349 2.16797 13.894 2.16797 12.056V11.944C2.16797 10.106 2.16797 8.65 2.32097 7.511C2.47897 6.339 2.81097 5.39 3.55897 4.641C4.30797 3.893 5.25697 3.561 6.42897 3.403C7.56897 3.25 9.02397 3.25 10.862 3.25ZM21.086 15.75H19.148C17.003 15.75 15.167 14.122 15.167 12C15.167 9.878 17.003 8.25 19.147 8.25H21.085C20.971 6.909 20.714 6.2 20.215 5.702C19.792 5.279 19.212 5.025 18.206 4.89C17.179 4.752 15.824 4.75 13.917 4.75H10.917C9.00997 4.75 7.65597 4.752 6.62697 4.89C5.62197 5.025 5.04197 5.279 4.61897 5.702C4.19597 6.125 3.94197 6.705 3.80697 7.711C3.66897 8.739 3.66697 10.093 3.66697 12C3.66697 13.907 3.66897 15.262 3.80697 16.29C3.94197 17.295 4.19597 17.875 4.61897 18.298C5.04197 18.721 5.62197 18.975 6.62797 19.11C7.65597 19.248 9.00997 19.25 10.917 19.25H13.917C15.824 19.25 17.179 19.248 18.207 19.11C19.212 18.975 19.792 18.721 20.215 18.298C20.714 17.8 20.972 17.092 21.086 15.75ZM6.16797 8C6.16797 7.80109 6.24699 7.61032 6.38764 7.46967C6.52829 7.32902 6.71906 7.25 6.91797 7.25H10.918C11.1169 7.25 11.3076 7.32902 11.4483 7.46967C11.589 7.61032 11.668 7.80109 11.668 8C11.668 8.19891 11.589 8.38968 11.4483 8.53033C11.3076 8.67098 11.1169 8.75 10.918 8.75H6.91797C6.71906 8.75 6.52829 8.67098 6.38764 8.53033C6.24699 8.38968 6.16797 8.19891 6.16797 8ZM21.842 9.75H19.148C17.724 9.75 16.667 10.809 16.667 12C16.667 13.191 17.724 14.25 19.147 14.25H21.865C22.071 14.237 22.16 14.098 22.167 14.014V9.986C22.16 9.902 22.071 9.763 21.865 9.751H21.841L21.842 9.75Z",
                                            fill: colors.primario
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-5",
                                    children: "Accounts"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "icon-and-text-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exchangeAlt1.ExchangeAlt1), {
                                    className: "exchange-alt",
                                    color: colors.primario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-5",
                                    children: "Transfers"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "icon-and-text-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: 21,
                                    height: 20,
                                    viewBox: "0 0 21 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M8.81465 5.7C8.26365 6.113 8.01465 6.608 8.01465 7.07C8.01465 7.533 8.26365 8.028 8.81465 8.442C9.36665 8.856 10.1746 9.142 11.1096 9.142C11.3749 9.142 11.6292 9.24736 11.8168 9.43489C12.0043 9.62243 12.1096 9.87678 12.1096 10.142C12.1096 10.4072 12.0043 10.6616 11.8168 10.8491C11.6292 11.0366 11.3749 11.142 11.1096 11.142C9.78365 11.142 8.54465 10.74 7.61465 10.042C6.68465 9.344 6.01465 8.304 6.01465 7.071C6.01465 5.837 6.68465 4.797 7.61465 4.099C8.54465 3.402 9.78465 3 11.1096 3C13.1626 3 15.1036 3.983 15.8756 5.62C15.9317 5.73885 15.9637 5.86756 15.97 5.99879C15.9762 6.13003 15.9566 6.26121 15.9122 6.38485C15.8677 6.50849 15.7994 6.62217 15.711 6.7194C15.6226 6.81662 15.516 6.89549 15.3971 6.9515C15.2783 7.00751 15.1496 7.03956 15.0184 7.04583C14.8871 7.05209 14.7559 7.03245 14.6323 6.98801C14.5087 6.94358 14.395 6.87523 14.2978 6.78686C14.2005 6.6985 14.1217 6.59185 14.0656 6.473C13.7156 5.726 12.6236 5 11.1106 5C10.1756 5 9.36665 5.286 8.81465 5.7Z",
                                            fill: colors.primario
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M13.0745 14.583C13.6255 14.17 13.8735 13.675 13.8735 13.213C13.8735 12.75 13.6255 12.254 13.0735 11.841C12.5225 11.427 11.7135 11.141 10.7795 11.141C10.5143 11.141 10.2599 11.0356 10.0724 10.8481C9.88484 10.6606 9.77948 10.4062 9.77948 10.141C9.77948 9.87578 9.88484 9.62143 10.0724 9.43389C10.2599 9.24636 10.5143 9.141 10.7795 9.141C12.1055 9.141 13.3445 9.543 14.2745 10.241C15.2045 10.939 15.8735 11.979 15.8735 13.212C15.8735 14.445 15.2045 15.486 14.2735 16.183C13.3435 16.881 12.1055 17.283 10.7795 17.283C8.72648 17.283 6.78448 16.3 6.01348 14.662C5.90037 14.4221 5.88718 14.1471 5.97682 13.8975C6.06646 13.6479 6.25159 13.4441 6.49148 13.331C6.73137 13.2179 7.00637 13.2047 7.25598 13.2943C7.50559 13.384 7.70937 13.5691 7.82248 13.809C8.17448 14.557 9.26648 15.283 10.7795 15.283C11.7145 15.283 12.5225 14.997 13.0745 14.583ZM10.9175 1C11.1827 1 11.4371 1.10536 11.6246 1.29289C11.8121 1.48043 11.9175 1.73478 11.9175 2V3C11.9175 3.26522 11.8121 3.51957 11.6246 3.70711C11.4371 3.89464 11.1827 4 10.9175 4C10.6523 4 10.3979 3.89464 10.2104 3.70711C10.0228 3.51957 9.91748 3.26522 9.91748 3V2C9.91748 1.73478 10.0228 1.48043 10.2104 1.29289C10.3979 1.10536 10.6523 1 10.9175 1Z",
                                            fill: colors.primario
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M10.918 16C11.1832 16 11.4375 16.1054 11.6251 16.2929C11.8126 16.4804 11.918 16.7348 11.918 17V18C11.918 18.2652 11.8126 18.5196 11.6251 18.7071C11.4375 18.8946 11.1832 19 10.918 19C10.6528 19 10.3984 18.8946 10.2109 18.7071C10.0233 18.5196 9.91797 18.2652 9.91797 18V17C9.91797 16.7348 10.0233 16.4804 10.2109 16.2929C10.3984 16.1054 10.6528 16 10.918 16Z",
                                            fill: colors.primario
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-6",
                                    children: "Bills | TopUps"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "icon-and-text-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: 25,
                                    height: 24,
                                    viewBox: "0 0 25 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M10.918 17.5C10.918 15.567 9.35097 14 7.41797 14C5.48497 14 3.91797 15.567 3.91797 17.5C3.91797 19.433 5.48497 21 7.41797 21C9.35096 21 10.918 19.433 10.918 17.5Z",
                                            stroke: colors.primario,
                                            strokeWidth: 1.99832,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M10.918 6.5C10.918 4.567 9.35097 3 7.41797 3C5.48497 3 3.91797 4.567 3.91797 6.5C3.91797 8.433 5.48497 10 7.41797 10C9.35096 10 10.918 8.433 10.918 6.5Z",
                                            stroke: colors.primario,
                                            strokeWidth: 1.99832,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M21.918 6.5C21.918 4.567 20.351 3 18.418 3C16.485 3 14.918 4.567 14.918 6.5C14.918 8.433 16.485 10 18.418 10C20.351 10 21.918 8.433 21.918 6.5Z",
                                            stroke: colors.primario,
                                            strokeWidth: 1.99832,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M18.418 14V21",
                                            stroke: colors.primario,
                                            strokeWidth: 2,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M14.918 17.5156H21.918",
                                            stroke: colors.primario,
                                            strokeWidth: 2,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-5",
                                    children: "Hub"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"nQhFG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/BtnIconMoneyWrapper":"cnl9M","../../../../../icons/Award1":"kTiek","../../../../../icons/BtnIconMore2":"9NsUi","../../../../../icons/ExchangeAlt1":"6VbN1","../../../../../icons/Icons19":"2OHy7","../../../../../icons/TrailingIcon14":"1nwir","../../../../../hooks/useDynamicColors":"b2GRH"}],"nQhFG":[function() {},{}],"cnl9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMoneyWrapper", ()=>(0, _btnIconMoneyWrapper.BtnIconMoneyWrapper));
var _btnIconMoneyWrapper = require("./BtnIconMoneyWrapper");

},{"./BtnIconMoneyWrapper":"7o8Sz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7o8Sz":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMoneyWrapper", ()=>BtnIconMoneyWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _btnIconMoney = require("../../icons/BtnIconMoney");
var _styleCss = require("./style.css");
const BtnIconMoneyWrapper = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMoney.BtnIconMoney), {
        className: "btn-icon-money"
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../icons/BtnIconMoney":"8sDkW","./style.css":"68ims","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8sDkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMoney", ()=>(0, _btnIconMoney.BtnIconMoney));
var _btnIconMoney = require("./BtnIconMoney");

},{"./BtnIconMoney":"8TJ5w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8TJ5w":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BtnIconMoney", ()=>BtnIconMoney);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const BtnIconMoney = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `btn-icon-money ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"68ims":[function() {},{}],"kTiek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Award1", ()=>(0, _award1.Award1));
var _award1 = require("./Award1");

},{"./Award1":"hKpTn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hKpTn":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Award1", ()=>Award1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Award1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `award-1 ${className}`,
        fill: "none",
        height: "26",
        viewBox: "0 0 24 26",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16Z",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2.3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M8.21 14.8899L7 23.9999L12 20.9999L17 23.9999L15.79 14.8799",
                stroke: "var(--primario)",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2.3"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6VbN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExchangeAlt1", ()=>(0, _exchangeAlt1.ExchangeAlt1));
var _exchangeAlt1 = require("./ExchangeAlt1");

},{"./ExchangeAlt1":"dH7ll","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dH7ll":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExchangeAlt1", ()=>ExchangeAlt1);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ExchangeAlt1 = ({ color = "#0066FF", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `exchange-alt-1 ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M21.7101 9.28691L17.7101 5.28973C17.6169 5.19656 17.5062 5.12265 17.3844 5.07223C17.2626 5.0218 17.132 4.99585 17.0001 4.99585C16.7338 4.99585 16.4784 5.10156 16.2901 5.28973C16.1018 5.4779 15.996 5.73312 15.996 5.99923C15.996 6.26535 16.1018 6.52056 16.2901 6.70873L18.5901 8.99711H7.00014C6.73492 8.99711 6.48057 9.1024 6.29303 9.2898C6.1055 9.47721 6.00014 9.73138 6.00014 9.99641C6.00014 10.2614 6.1055 10.5156 6.29303 10.703C6.48057 10.8904 6.73492 10.9957 7.00014 10.9957H21.0001C21.1976 10.9947 21.3903 10.9354 21.554 10.8251C21.7177 10.7148 21.8451 10.5586 21.9201 10.3761C21.9967 10.1942 22.0176 9.99359 21.9803 9.79973C21.9429 9.60588 21.8489 9.42743 21.7101 9.28691ZM17.0001 12.9943H3.00014C2.80271 12.9953 2.61 13.0546 2.44628 13.1649C2.28256 13.2751 2.15516 13.4314 2.08014 13.6139C2.00356 13.7958 1.98264 13.9964 2.02001 14.1903C2.05739 14.3841 2.15138 14.5626 2.29014 14.7031L6.29014 18.7003C6.3831 18.7939 6.4937 18.8683 6.61556 18.919C6.73742 18.9697 6.86813 18.9958 7.00014 18.9958C7.13215 18.9958 7.26286 18.9697 7.38472 18.919C7.50658 18.8683 7.61718 18.7939 7.71014 18.7003C7.80387 18.6074 7.87826 18.4968 7.92903 18.3751C7.9798 18.2533 8.00594 18.1227 8.00594 17.9908C8.00594 17.8588 7.9798 17.7282 7.92903 17.6065C7.87826 17.4847 7.80387 17.3742 7.71014 17.2813L5.41014 14.9929H17.0001C17.2654 14.9929 17.5197 14.8876 17.7072 14.7002C17.8948 14.5128 18.0001 14.2586 18.0001 13.9936C18.0001 13.7286 17.8948 13.4744 17.7072 13.287C17.5197 13.0996 17.2654 12.9943 17.0001 12.9943Z",
            fill: color
        })
    });
};
ExchangeAlt1.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAFX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosCardDetails", ()=>(0, _adultosCardDetails.AdultosCardDetails));
var _adultosCardDetails = require("./AdultosCardDetails");

},{"./AdultosCardDetails":"eMkZo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eMkZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosCardDetails", ()=>AdultosCardDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _icons19 = require("../../../../../icons/Icons19");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosCardDetails = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-card-details",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-9",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-61",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "panel-panel-primary",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "title-5",
                                children: "Card details"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "highlighted-button",
                                style: {
                                    marginLeft: 12,
                                    marginTop: 15,
                                    position: "absolute"
                                },
                                onClick: handleButtonBack,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: 24,
                                    height: 25,
                                    viewBox: "0 0 24 25",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M19.9998 11.2998H7.82979L13.4198 5.7098L11.9998 4.2998L3.99979 12.2998L11.9998 20.2998L13.4098 18.8898L7.82979 13.2998H19.9998V11.2998Z",
                                        fill: colors.primario
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-62",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "debit",
                                style: {
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    backgroundSize: "contain",
                                    backgroundImage: colors.url_card ? `url(${colors.url_card})` : "none",
                                    backgroundColor: colors.url_card ? "transparent" : "#9ca3af"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-18",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-63",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-64",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-57",
                                                            children: "Available"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-65",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-66",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "frame-67",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-58",
                                                                                    children: "13,000"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "text-wrapper-59",
                                                                                    children: ".23"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-60",
                                                                            children: "USD"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                                    className: "img-4",
                                                                    color: "white"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-68",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-57",
                                                            children: "Assigned"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-69",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-67",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-61",
                                                                    children: "USD 23,000.00"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-70",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-62",
                                                    children: "7531 4532 6643 5849"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "img-4",
                                                    alt: "Copy",
                                                    src: "/img/copy.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-71",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-72",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 64,
                                                height: 64,
                                                viewBox: "0 0 64 64",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 64,
                                                        height: 64,
                                                        rx: 21.3405,
                                                        fill: "url(#paint0_linear_2627_751)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M40.25 43.2485H23.75C21.6823 43.2485 20 41.5662 20 39.4985C20 38.8568 20.1651 38.2233 20.4776 37.6662L28.7255 22.6698C28.727 22.6672 28.7285 22.6646 28.7299 22.662C30.1625 20.1151 33.8369 20.1142 35.2701 22.662C35.2716 22.6645 35.273 22.6672 35.2745 22.6698L43.5225 37.6662C43.8349 38.2233 44 38.8568 44 39.4985C44 41.5662 42.3177 43.2485 40.25 43.2485ZM30.3661 23.5777L22.1185 38.5734C22.117 38.576 22.1156 38.5786 22.1141 38.5812C21.9577 38.8593 21.875 39.1765 21.875 39.4985C21.875 40.5324 22.7161 41.3735 23.75 41.3735H40.25C41.2839 41.3735 42.125 40.5324 42.125 39.4985C42.125 39.1764 42.0423 38.8593 41.8859 38.5812C41.8844 38.5786 41.883 38.576 41.8815 38.5734L33.634 23.5779C32.9164 22.3081 31.0846 22.3067 30.3661 23.5777Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M32 34.811C31.4822 34.811 31.0625 34.3913 31.0625 33.8735V28.2485C31.0625 27.7308 31.4822 27.311 32 27.311C32.5178 27.311 32.9375 27.7308 32.9375 28.2485V33.8735C32.9375 34.3913 32.5178 34.811 32 34.811Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M32 38.561C32.5178 38.561 32.9375 38.1413 32.9375 37.6235C32.9375 37.1058 32.5178 36.686 32 36.686C31.4822 36.686 31.0625 37.1058 31.0625 37.6235C31.0625 38.1413 31.4822 38.561 32 38.561Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                            id: "paint0_linear_2627_751",
                                                            x1: 32,
                                                            y1: 23.9852,
                                                            x2: 32,
                                                            y2: 64,
                                                            gradientUnits: "userSpaceOnUse",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                    stopColor: "#efefef"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                    offset: 1,
                                                                    stopColor: "#efefef",
                                                                    stopOpacity: 0
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-63",
                                                children: "Missing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-72",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 64,
                                                height: 64,
                                                viewBox: "0 0 64 64",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 64,
                                                        height: 64,
                                                        rx: 21.3405,
                                                        fill: "url(#paint0_linear_2627_759)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M31.7039 34.7592C31.3117 34.7937 30.7851 34.6787 30.5827 34.4274C30.2347 33.9953 29.6024 33.9273 29.1703 34.2753C28.7383 34.6233 28.6702 35.2556 29.0181 35.6876C29.4021 36.1644 29.9311 36.4564 30.4714 36.6158C30.601 37.0205 30.9804 37.3135 31.4282 37.3135C31.8512 37.3135 32.2132 37.052 32.3612 36.6818C33.3725 36.4352 34.0741 35.7116 34.1968 34.745C34.346 33.57 33.5947 32.4469 32.3696 32.0139C31.6031 31.7429 31.2148 31.584 31.1061 31.5327C30.9563 31.4621 30.9602 31.4096 30.9631 31.3713C30.9707 31.2676 31.0477 31.1711 31.0958 31.1567C31.6548 30.9882 31.9515 31.1621 31.9968 31.2155C32.3159 31.6682 32.9412 31.7772 33.3948 31.459C33.8489 31.1403 33.9586 30.5139 33.64 30.0598C33.3795 29.6887 32.9483 29.3669 32.3953 29.1993C32.2767 28.7767 31.8886 28.4668 31.4281 28.4668C30.9475 28.4668 30.5457 28.8044 30.4469 29.2554C29.6207 29.5361 29.0267 30.3176 28.9596 31.2228C28.8925 32.128 29.3866 32.943 30.2491 33.3497C30.4932 33.4649 31.0221 33.6684 31.7 33.908C32.103 34.0505 32.223 34.3419 32.2039 34.492C32.178 34.6959 31.8457 34.7468 31.7039 34.7592Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M43.3583 32.6156C43.913 32.6156 44.3627 32.1659 44.3627 31.6112V27.5125C44.3627 25.297 42.5603 23.4946 40.3449 23.4946H22.6663C20.4508 23.4946 18.6484 25.297 18.6484 27.5125V38.268C18.6484 40.4834 20.4508 42.2858 22.6663 42.2858H40.3449C42.5603 42.2858 44.3627 40.4834 44.3627 38.268V36.6677C44.3627 36.2642 44.1213 35.8998 43.7496 35.7426L43.6645 35.7066C43.6134 35.685 43.5606 35.6676 43.5066 35.6547C43.1436 35.5679 42.7691 35.524 42.3934 35.524C39.768 35.524 37.6307 37.6542 37.619 40.2769H25.3922C25.3806 37.6674 23.2647 35.5455 20.6574 35.5242V30.3527C23.2718 30.3313 25.3922 28.1978 25.3922 25.5784C25.3922 25.5535 25.392 25.5285 25.3916 25.5036H37.6196C37.6192 25.5285 37.619 25.5535 37.619 25.5784C37.619 28.1978 39.7393 30.3313 42.3538 30.3527V31.6112C42.3538 32.1659 42.8035 32.6156 43.3583 32.6156ZM42.3538 37.5332V38.268C42.3538 39.3757 41.4526 40.2769 40.3449 40.2769H39.628C39.6395 38.7751 40.8542 37.5544 42.3538 37.5332ZM23.3832 40.2769H22.6663C21.5586 40.2769 20.6574 39.3757 20.6574 38.268V37.5332C22.1569 37.5544 23.3717 38.7751 23.3832 40.2769ZM23.3833 25.5784C23.3833 27.0901 22.1641 28.3224 20.6574 28.3436V27.5125C20.6574 26.4048 21.5586 25.5036 22.6663 25.5036H23.3823C23.3829 25.5285 23.3833 25.5535 23.3833 25.5784ZM39.6279 25.5784C39.6279 25.5534 39.6282 25.5285 39.6289 25.5036H40.3449C41.4526 25.5036 42.3538 26.4048 42.3538 27.5125V28.3436C40.8471 28.3224 39.6279 27.0901 39.6279 25.5784Z",
                                                        fill: colors.primario
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                            id: "paint0_linear_2627_759",
                                                            x1: 32,
                                                            y1: 23.9852,
                                                            x2: 32,
                                                            y2: 64,
                                                            gradientUnits: "userSpaceOnUse",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                    stopColor: "#efefef"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                    offset: 1,
                                                                    stopColor: "#efefef",
                                                                    stopOpacity: 0
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-63",
                                                children: "Pay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-72",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 64,
                                                height: 64,
                                                viewBox: "0 0 64 64",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 64,
                                                        height: 64,
                                                        rx: 21.3405,
                                                        fill: "url(#paint0_linear_2627_766)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                        clipPath: "url(#clip0_2627_766)",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M39.2254 34.8996C38.8593 34.5335 38.2657 34.5335 37.8996 34.8996L37.625 35.1742L37.3504 34.8996C36.9843 34.5335 36.3907 34.5335 36.0246 34.8996C35.6585 35.2657 35.6585 35.8593 36.0246 36.2254L36.2992 36.5L36.0246 36.7746C35.6585 37.1407 35.6585 37.7343 36.0246 38.1004C36.3907 38.4666 36.9843 38.4666 37.3504 38.1004L37.625 37.8258L37.8996 38.1004C38.2657 38.4666 38.8593 38.4666 39.2254 38.1004C39.5916 37.7343 39.5916 37.1407 39.2254 36.7746L38.9508 36.5L39.2254 36.2254C39.5916 35.8593 39.5916 35.2657 39.2254 34.8996Z",
                                                                fill: colors.primario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M33.6004 34.8996C33.2343 34.5335 32.6407 34.5335 32.2746 34.8996L32 35.1742L31.7254 34.8996C31.3593 34.5335 30.7657 34.5335 30.3996 34.8996C30.0335 35.2657 30.0335 35.8593 30.3996 36.2254L30.6742 36.5L30.3996 36.7746C30.0335 37.1407 30.0335 37.7343 30.3996 38.1004C30.7657 38.4666 31.3593 38.4666 31.7254 38.1004L32 37.8258L32.2746 38.1004C32.6407 38.4666 33.2343 38.4666 33.6004 38.1004C33.9666 37.7343 33.9666 37.1407 33.6004 36.7746L33.3258 36.5L33.6004 36.2254C33.9666 35.8593 33.9666 35.2657 33.6004 34.8996Z",
                                                                fill: colors.primario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M27.9754 34.8996C27.6093 34.5335 27.0157 34.5335 26.6496 34.8996L26.375 35.1742L26.1004 34.8996C25.7343 34.5335 25.1407 34.5335 24.7746 34.8996C24.4085 35.2657 24.4085 35.8593 24.7746 36.2254L25.0492 36.5L24.7746 36.7746C24.4085 37.1407 24.4085 37.7343 24.7746 38.1004C25.1407 38.4666 25.7343 38.4666 26.1004 38.1004L26.375 37.8258L26.6496 38.1004C27.0157 38.4666 27.6093 38.4666 27.9754 38.1004C28.3416 37.7343 28.3416 37.1407 27.9754 36.7746L27.7008 36.5L27.9754 36.2254C28.3416 35.8593 28.3416 35.2657 27.9754 34.8996Z",
                                                                fill: colors.primario
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M40.4375 29H38.5625V26.5625C38.5625 22.9439 35.6186 20 32 20C28.3814 20 25.4375 22.9439 25.4375 26.5625V29H23.5625C22.0117 29 20.75 30.2617 20.75 31.8125V41.1875C20.75 42.7383 22.0117 44 23.5625 44H40.4375C41.9883 44 43.25 42.7383 43.25 41.1875V31.8125C43.25 30.2617 41.9883 29 40.4375 29ZM27.3125 26.5625C27.3125 23.9778 29.4153 21.875 32 21.875C34.5847 21.875 36.6875 23.9778 36.6875 26.5625V29H27.3125V26.5625ZM41.375 41.1875C41.375 41.7044 40.9544 42.125 40.4375 42.125H23.5625C23.0456 42.125 22.625 41.7044 22.625 41.1875V31.8125C22.625 31.2956 23.0456 30.875 23.5625 30.875H40.4375C40.9544 30.875 41.375 31.2956 41.375 31.8125V41.1875Z",
                                                                fill: colors.primario
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                                id: "paint0_linear_2627_766",
                                                                x1: 32,
                                                                y1: 23.9852,
                                                                x2: 32,
                                                                y2: 64,
                                                                gradientUnits: "userSpaceOnUse",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                        stopColor: "#efefef"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                        offset: 1,
                                                                        stopColor: "#efefef",
                                                                        stopOpacity: 0
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                id: "clip0_2627_766",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                    width: 24,
                                                                    height: 24,
                                                                    fill: "white",
                                                                    transform: "translate(20 20)"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-63",
                                                children: "PIN"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-72",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 65,
                                                height: 65,
                                                viewBox: "0 0 65 65",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 64.0214,
                                                        height: 64.0214,
                                                        rx: 21.3405,
                                                        fill: "url(#paint0_linear_2627_775)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                        clipPath: "url(#clip0_2627_775)",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M32.9482 37.542C32.9482 38.0598 32.5285 38.4795 32.0107 38.4795H26.4795C25.9617 38.4795 25.542 38.0598 25.542 37.542C25.542 37.0242 25.9617 36.6045 26.4795 36.6045H32.0107C32.5285 36.6045 32.9482 37.0242 32.9482 37.542ZM44.0107 25.6428V36.6201C44.0107 38.0595 43.4502 39.4127 42.4324 40.4305L40.4305 42.4324C39.4127 43.4502 38.0595 44.0107 36.6201 44.0107H25.6428C22.5298 44.0107 20.0107 41.4914 20.0107 38.3787V25.6428C20.0107 22.5298 22.53 20.0107 25.6428 20.0107H38.3787C41.4917 20.0107 44.0107 22.53 44.0107 25.6428ZM42.01 37.5576H39.4326C38.3987 37.5576 37.5576 38.3987 37.5576 39.4326V42.01C38.1371 41.8506 38.6682 41.5431 39.1047 41.1066L41.1066 39.1047C41.5431 38.6682 41.8506 38.1371 42.01 37.5576ZM42.1357 25.6428C42.1357 23.5662 40.4552 21.8857 38.3787 21.8857H25.6428C23.5662 21.8857 21.8857 23.5663 21.8857 25.6428V38.3787C21.8857 40.4553 23.5663 42.1357 25.6428 42.1357H35.6826V39.4326C35.6826 37.3649 37.3649 35.6826 39.4326 35.6826H42.1357V25.6428ZM37.542 31.0732H26.4795C25.9617 31.0732 25.542 31.493 25.542 32.0107C25.542 32.5285 25.9617 32.9482 26.4795 32.9482H37.542C38.0598 32.9482 38.4795 32.5285 38.4795 32.0107C38.4795 31.493 38.0598 31.0732 37.542 31.0732ZM37.542 25.542H26.4795C25.9617 25.542 25.542 25.9617 25.542 26.4795C25.542 26.9973 25.9617 27.417 26.4795 27.417H37.542C38.0598 27.417 38.4795 26.9973 38.4795 26.4795C38.4795 25.9617 38.0598 25.542 37.542 25.542Z",
                                                            fill: colors.primario
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                                id: "paint0_linear_2627_775",
                                                                x1: 32.0107,
                                                                y1: 23.9932,
                                                                x2: 32.0107,
                                                                y2: 64.0215,
                                                                gradientUnits: "userSpaceOnUse",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                        stopColor: "#efefef"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                        offset: 1,
                                                                        stopColor: "#efefef",
                                                                        stopOpacity: 0
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                id: "clip0_2627_775",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                    width: 24,
                                                                    height: 24,
                                                                    fill: "white",
                                                                    transform: "translate(20.0107 20.0107)"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-63",
                                                children: "Statements"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "element",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "subsection-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-75",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-64",
                                                    children: "Last card activity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-76",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "btn-text-link-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-link",
                                                            children: "See all"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                        className: "trailing-icon-14",
                                                        color: "var(--secundario)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-77",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "feed-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "data",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                width: 48,
                                                                height: 49,
                                                                viewBox: "0 0 48 49",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                        y: 0.0214844,
                                                                        width: 48,
                                                                        height: 48,
                                                                        rx: 18,
                                                                        fill: "#efefef"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                                        clipPath: "url(#clip0_2627_824)",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            d: "M32.0155 21.5156C29.8186 21.5156 28.0312 19.7093 28.0312 17.489C28.0312 15.7876 28.259 12.9799 28.2687 12.8612C28.3108 12.3452 28.764 11.9613 29.2794 12.0032C29.7954 12.0453 30.1796 12.4979 30.1375 13.0139C30.1352 13.0422 29.9062 15.8645 29.9062 17.489C29.9062 18.6754 30.8524 19.6406 32.0155 19.6406C33.1787 19.6406 34.1249 18.6754 34.1249 17.489C34.1249 15.8633 33.896 13.0422 33.8936 13.0139C33.8515 12.4979 34.2356 12.0453 34.7517 12.0032C35.2672 11.9608 35.7203 12.3451 35.7624 12.8612C35.7721 12.9799 35.9999 15.7876 35.9999 17.489C35.9999 19.7093 34.2125 21.5156 32.0155 21.5156ZM32.953 16.5469V12.9375C32.953 12.4198 32.5333 12.0001 32.0155 12.0001C31.4978 12.0001 31.0781 12.4198 31.0781 12.9375V16.5469C31.0781 17.0647 31.4978 17.4844 32.0155 17.4844C32.5333 17.4844 32.953 17.0647 32.953 16.5469ZM28.9812 34.9317C29.4527 34.7177 29.6614 34.162 29.4473 33.6905C29.2333 33.2191 28.6776 33.0104 28.2061 33.2245C26.9085 33.8136 25.4541 34.125 24 34.125C18.417 34.125 13.875 29.583 13.875 24.0001C13.875 18.4171 18.417 13.8751 24 13.8751C24.4598 13.8751 24.9221 13.9062 25.374 13.9674C25.8868 14.0369 26.3594 13.6775 26.429 13.1644C26.4986 12.6514 26.139 12.179 25.6259 12.1095C25.0909 12.0369 24.5438 12.0001 24 12.0001C20.7947 12.0001 17.7812 13.2483 15.5147 15.5148C13.2482 17.7813 12 20.7948 12 24.0001C12 27.2054 13.2482 30.2188 15.5147 32.4853C17.7812 34.7518 20.7947 36 24 36C25.7195 36 27.4421 35.6306 28.9812 34.9317ZM24.2003 31.4509C24.718 31.4387 25.1276 31.0091 25.1154 30.4915C25.1032 29.9739 24.6749 29.5648 24.1559 29.5765C24.1113 29.5775 24.0668 29.578 24.0223 29.578C21.0197 29.578 18.5418 27.1723 18.4703 24.1549C18.4351 22.6716 18.9798 21.2633 20.0038 20.1896C21.0279 19.1158 22.409 18.5051 23.8925 18.4699C24.3423 18.4594 24.8395 18.5149 25.3313 18.6311C25.8356 18.7502 26.3402 18.4381 26.4592 17.9342C26.5783 17.4303 26.2663 16.9253 25.7624 16.8063C25.1171 16.6539 24.455 16.5807 23.8481 16.5954C21.8639 16.6424 20.0168 17.4593 18.647 18.8954C17.2773 20.3316 16.5488 22.2152 16.5959 24.1993C16.6916 28.2354 20.0054 31.453 24.0217 31.453C24.0809 31.4531 24.1409 31.4524 24.2003 31.4509ZM32.953 35.0625V24.3281C32.953 23.8104 32.5333 23.3906 32.0155 23.3906C31.4978 23.3906 31.0781 23.8104 31.0781 24.3281V35.0625C31.0781 35.5802 31.4978 36 32.0155 36C32.5333 36 32.953 35.5802 32.953 35.0625Z",
                                                                            fill: colors.primario
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                            id: "clip0_2627_824",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                                width: 24,
                                                                                height: 24,
                                                                                fill: "white",
                                                                                transform: "translate(12 12)"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-13",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-19",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "name",
                                                                            children: "Starbucks coffee time"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "subject-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject",
                                                                                children: "6 h ago"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-79",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-6",
                                                                children: "- $25.11"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                class: "trailing-icon-14 trailing-icon-14",
                                                                fill: "none",
                                                                height: "19",
                                                                viewBox: "0 0 18 19",
                                                                width: "18",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    class: "path",
                                                                    d: "M6.75 14.1602L11.25 9.66016L6.75 5.16016",
                                                                    stroke: "var(--secundario)",
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    "stroke-width": "2"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "feed-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "data",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 48,
                                                            height: 49,
                                                            viewBox: "0 0 48 49",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                    y: 0.0214844,
                                                                    width: 48,
                                                                    height: 48,
                                                                    rx: 18,
                                                                    fill: "#efefef"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                                    clipPath: "url(#clip0_2627_824)",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M32.0155 21.5156C29.8186 21.5156 28.0312 19.7093 28.0312 17.489C28.0312 15.7876 28.259 12.9799 28.2687 12.8612C28.3108 12.3452 28.764 11.9613 29.2794 12.0032C29.7954 12.0453 30.1796 12.4979 30.1375 13.0139C30.1352 13.0422 29.9062 15.8645 29.9062 17.489C29.9062 18.6754 30.8524 19.6406 32.0155 19.6406C33.1787 19.6406 34.1249 18.6754 34.1249 17.489C34.1249 15.8633 33.896 13.0422 33.8936 13.0139C33.8515 12.4979 34.2356 12.0453 34.7517 12.0032C35.2672 11.9608 35.7203 12.3451 35.7624 12.8612C35.7721 12.9799 35.9999 15.7876 35.9999 17.489C35.9999 19.7093 34.2125 21.5156 32.0155 21.5156ZM32.953 16.5469V12.9375C32.953 12.4198 32.5333 12.0001 32.0155 12.0001C31.4978 12.0001 31.0781 12.4198 31.0781 12.9375V16.5469C31.0781 17.0647 31.4978 17.4844 32.0155 17.4844C32.5333 17.4844 32.953 17.0647 32.953 16.5469ZM28.9812 34.9317C29.4527 34.7177 29.6614 34.162 29.4473 33.6905C29.2333 33.2191 28.6776 33.0104 28.2061 33.2245C26.9085 33.8136 25.4541 34.125 24 34.125C18.417 34.125 13.875 29.583 13.875 24.0001C13.875 18.4171 18.417 13.8751 24 13.8751C24.4598 13.8751 24.9221 13.9062 25.374 13.9674C25.8868 14.0369 26.3594 13.6775 26.429 13.1644C26.4986 12.6514 26.139 12.179 25.6259 12.1095C25.0909 12.0369 24.5438 12.0001 24 12.0001C20.7947 12.0001 17.7812 13.2483 15.5147 15.5148C13.2482 17.7813 12 20.7948 12 24.0001C12 27.2054 13.2482 30.2188 15.5147 32.4853C17.7812 34.7518 20.7947 36 24 36C25.7195 36 27.4421 35.6306 28.9812 34.9317ZM24.2003 31.4509C24.718 31.4387 25.1276 31.0091 25.1154 30.4915C25.1032 29.9739 24.6749 29.5648 24.1559 29.5765C24.1113 29.5775 24.0668 29.578 24.0223 29.578C21.0197 29.578 18.5418 27.1723 18.4703 24.1549C18.4351 22.6716 18.9798 21.2633 20.0038 20.1896C21.0279 19.1158 22.409 18.5051 23.8925 18.4699C24.3423 18.4594 24.8395 18.5149 25.3313 18.6311C25.8356 18.7502 26.3402 18.4381 26.4592 17.9342C26.5783 17.4303 26.2663 16.9253 25.7624 16.8063C25.1171 16.6539 24.455 16.5807 23.8481 16.5954C21.8639 16.6424 20.0168 17.4593 18.647 18.8954C17.2773 20.3316 16.5488 22.2152 16.5959 24.1993C16.6916 28.2354 20.0054 31.453 24.0217 31.453C24.0809 31.4531 24.1409 31.4524 24.2003 31.4509ZM32.953 35.0625V24.3281C32.953 23.8104 32.5333 23.3906 32.0155 23.3906C31.4978 23.3906 31.0781 23.8104 31.0781 24.3281V35.0625C31.0781 35.5802 31.4978 36 32.0155 36C32.5333 36 32.953 35.5802 32.953 35.0625Z",
                                                                        fill: colors.primario
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                        id: "clip0_2627_824",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                            width: 24,
                                                                            height: 24,
                                                                            fill: "white",
                                                                            transform: "translate(12 12)"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-13",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-group-19",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "name",
                                                                        children: "Bruno\u2019s tricks"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "subject-wrapper",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "subject",
                                                                            children: "11/06/24"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "feed-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "data",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                width: 48,
                                                                height: 49,
                                                                viewBox: "0 0 48 49",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                        y: 0.0214844,
                                                                        width: 48,
                                                                        height: 48,
                                                                        rx: 18,
                                                                        fill: "#efefef"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M33.0936 34.0811L31.7549 19.1725C31.7184 18.7653 31.3772 18.4535 30.9684 18.4535H28.2077V17.2084C28.2077 14.8879 26.32 13 23.9996 13C21.6793 13 19.7917 14.8879 19.7917 17.2084V18.4535H17.0291C16.6204 18.4535 16.2792 18.7653 16.2426 19.1725L14.8987 34.1397C14.8789 34.3606 14.9528 34.5795 15.1024 34.7431C15.252 34.9067 15.4635 34.9999 15.6852 34.9999H32.3125C32.3132 34.9999 32.314 34.9999 32.3146 34.9999C32.7508 34.9999 33.1043 34.6463 33.1043 34.2102C33.1042 34.1663 33.1006 34.1231 33.0936 34.0811ZM21.371 17.2084C21.371 15.7587 22.5502 14.5793 23.9997 14.5793C25.4493 14.5793 26.6286 15.7587 26.6286 17.2084V18.4535H21.371V17.2084ZM16.5489 33.4207L17.7511 20.0328H19.7917V21.4449C19.7917 21.881 20.1452 22.2345 20.5814 22.2345C21.0176 22.2345 21.371 21.881 21.371 21.4449V20.0328H26.6286V21.4449C26.6286 21.881 26.982 22.2345 27.4182 22.2345C27.8544 22.2345 28.2078 21.881 28.2078 21.4449V20.0328H30.2466L31.4488 33.4207H16.5489Z",
                                                                        fill: colors.primario
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-13",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-19",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "name",
                                                                            children: "New gymn shoes"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "subject-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject",
                                                                                children: "11/06/24"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-80",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-6",
                                                                children: "- $158.68"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                class: "trailing-icon-14 trailing-icon-14",
                                                                fill: "none",
                                                                height: "19",
                                                                viewBox: "0 0 18 19",
                                                                width: "18",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    class: "path",
                                                                    d: "M6.75 14.1602L11.25 9.66016L6.75 5.16016",
                                                                    stroke: "var(--secundario)",
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    "stroke-width": "2"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "feed-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "data",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "frame-78",
                                                                alt: "Frame",
                                                                src: "/img/frame-480954772-3.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-13",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-19",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "name",
                                                                            children: "Card payment"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "subject-wrapper",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject",
                                                                                children: "11/06/24"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "amount-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "amount-7",
                                                            children: "$950.23"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "intersect",
                    alt: "Intersect",
                    src: "/img/intersect.png"
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"a4ZlP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/Icons19":"2OHy7","../../../../../icons/TrailingIcon14":"1nwir","../../../../../hooks/useDynamicColors":"b2GRH"}],"a4ZlP":[function() {},{}],"3px1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingTutorialEasy", ()=>(0, _adultosOnboardingTutorialEasy.AdultosOnboardingTutorialEasy));
var _adultosOnboardingTutorialEasy = require("./AdultosOnboardingTutorialEasy");

},{"./AdultosOnboardingTutorialEasy":"b70cR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b70cR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingTutorialEasy", ()=>AdultosOnboardingTutorialEasy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboardingTutorialEasy = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_register-adultos-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_steppper-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-onboarding-screen-easy",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "young-onboarding-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "rectangle-2",
                            alt: "Rectangle",
                            src: "/img/rectangle.png"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "group",
                            alt: "Group",
                            src: "/img/easy-tutorial.png"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "pay-for-your-favorit",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "payment-worldwide",
                    children: "Easy and Complete"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-3 highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: "Frame",
                        width: 25,
                        style: {
                            marginTop: 15,
                            marginLeft: 10
                        },
                        src: "/img/flecha-adelante-azul.png"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-4 highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: "Frame",
                        width: 25,
                        style: {
                            marginTop: 15,
                            marginLeft: 10
                        },
                        src: "/img/flecha-atras-azul.png"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"t3POy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"t3POy":[function() {},{}],"8tHLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingWelcome", ()=>(0, _adultosOnboardingWelcome.AdultosOnboardingWelcome));
var _adultosOnboardingWelcome = require("./AdultosOnboardingWelcome");

},{"./AdultosOnboardingWelcome":"eX2tE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eX2tE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingWelcome", ()=>AdultosOnboardingWelcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboardingWelcome = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/young-onboarding-steppper${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-onboarding-screen-welcome",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "adultos-onboarding-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "rectangle-2",
                            alt: "Rectangle",
                            src: "/img/rectangle.png"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "group",
                            alt: "Group",
                            src: "/img/welcome-young-adultos.png",
                            style: {
                                width: 150,
                                height: 150,
                                objectFit: 'contain'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "pay-for-your-favorit",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "Your account has been opened"
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "Enjoy all the benefits of our App"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "payment-worldwide",
                    children: "Welcome Soan!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Let\u2019s start!"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"e8TsT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"e8TsT":[function() {},{}],"cLe84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingStepper", ()=>(0, _adultosOnboardingStepper.AdultosOnboardingStepper));
var _adultosOnboardingStepper = require("./AdultosOnboardingStepper");

},{"./AdultosOnboardingStepper":"77jOo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"77jOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingStepper", ()=>AdultosOnboardingStepper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboardingStepper = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_card_id-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-stepper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-group-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "image",
                                        alt: "Image",
                                        src: "/img/folder-young-adultos.png"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle",
                                        children: "Welcome!"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "subtitle-2",
                                        children: "Let\u2019s open your online account"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-6",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-7",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "subtitle-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-3",
                                                            children: "Accept Terms and Conditions"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Register your Email"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Scan your ID card"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: " Validate your identity"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "subtitle-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-3",
                                                            children: "Register your Mobile number"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Generate your credentials"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-9 highlighted-button",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7",
                                        onClick: handleButtonClick,
                                        children: "Open account"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "status-bar"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title",
                                        children: "Terms and Conditions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"7PjWg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"7PjWg":[function() {},{}],"dfkf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingCardId", ()=>(0, _adultosOnboardingCardId.AdultosOnboardingCardId));
var _adultosOnboardingCardId = require("./AdultosOnboardingCardId");

},{"./AdultosOnboardingCardId":"f1cWq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f1cWq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingCardId", ()=>AdultosOnboardingCardId);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _direcDown = require("../../../../../icons/DirecDown");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboardingCardId = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-group-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overlap-group-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "molecula-stepper",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "content-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "numb",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-9",
                                                        children: "1"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "line"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-10",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-2"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-11",
                                                            children: "3"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-3"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-11",
                                                            children: "4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-3"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-3",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-11",
                                                            children: "5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-3"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "atomo-step-final-no",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "content-5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "numb-3",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-11",
                                                        children: "6"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "element-2",
                                    alt: "Element",
                                    src: "/img/card-id.png"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-13",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "subtitle-5",
                                        children: "Now, get your ID card"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "element-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "subtitle-6",
                                            children: [
                                                "We will take a photo of the front & back.",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                "Photos will be captured automatically."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-14",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-12",
                                                    children: "Country"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "account-select",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-15",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-16",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-13",
                                                                    children: "USA"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _direcDown.DirecDown), {
                                                                className: "btn-icon-chevron",
                                                                color: colors.primario
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                marginTop: 150,
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-17 highlighted-button",
                                                style: {
                                                    borderRadius: 12,
                                                    width: "100%"
                                                },
                                                onClick: handleButtonClick,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-wrapper-14",
                                                    children: "I\xb4ve got my ID card!"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-18",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bars-status-default-wrapper"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title-2",
                                        children: "Scan ID Card"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back-2",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"1ZxF3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/DirecDown":"edyec","../../../../../hooks/useDynamicColors":"b2GRH"}],"1ZxF3":[function() {},{}],"edyec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirecDown", ()=>(0, _direcDown.DirecDown));
var _direcDown = require("./DirecDown");

},{"./DirecDown":"59IEG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"59IEG":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirecDown", ()=>DirecDown);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DirecDown = ({ color = "#01087F", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `direc-down ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M7.5 9.75L12 14.25L16.5 9.75",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
DirecDown.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60gqD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingPhone", ()=>(0, _adultosOnboardingPhone.AdultosOnboardingPhone));
var _adultosOnboardingPhone = require("./AdultosOnboardingPhone");

},{"./AdultosOnboardingPhone":"kr6Xf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kr6Xf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdultosOnboardingPhone", ()=>AdultosOnboardingPhone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _atomoTime = require("../../../../../components/AtomoTime");
var _buttonSmall = require("../../../../../components/ButtonSmall");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const AdultosOnboardingPhone = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_welcome-adultos-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-onboarding-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "young-onboarding-3",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overlap-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "molecula-stepper-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "content-6",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "numb-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-16",
                                                        children: "1"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "line-4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-17",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-4"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-17",
                                                            children: "3"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-4"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-6",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-18",
                                                            children: "4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-5"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "div-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-19",
                                                            children: "5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-6"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "atomo-step-final-no-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "content-7",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "numb-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-19",
                                                        children: "6"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "signature-cinemawide-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            alt: "Validate Phone",
                                            src: "/img/phone-adultos.png",
                                            style: {
                                                marginLeft: -10,
                                                marginTop: -20,
                                                width: 150,
                                                height: 150,
                                                objectFit: 'contain'
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "element-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "subtitle-8",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-wrapper-20",
                                                    children: "A validation code has been sent to"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-wrapper-21",
                                                    children: "+54 9 1122 6476"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "numbs",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-5",
                                                        children: "2"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-5",
                                                        children: "2"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-5",
                                                        children: "2"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-5",
                                                        children: "2"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTime.AtomoTime), {
                                            className: "atomo-time-instance",
                                            rectangleClassName: "atomo-time-3",
                                            subtitleCopyClassName: "atomo-time-4",
                                            subtitleCopyClassNameOverride: "atomo-time-4",
                                            timelineClassName: "atomo-time-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSmall.ButtonSmall), {
                                            className: "button-small-instance",
                                            estado: "inactivo",
                                            iconLeft: false,
                                            iconRigth: false,
                                            textClassName: "button-small-2",
                                            texto: "Resend code",
                                            tipo: "link"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "action-buttons-3",
                                            onClick: handleButtonClick,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-22 highlighted-button",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-22",
                                                    children: "Validate"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-23",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "status-bar-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title-3",
                                        children: "Register Mobile number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back-3",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"87PLN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/AtomoTime":"djEQ8","../../../../../components/ButtonSmall":"6rhhx","../../../../../hooks/useDynamicColors":"b2GRH"}],"87PLN":[function() {},{}],"bgMjd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboarding", ()=>(0, _youngOnboarding.YoungOnboarding));
var _youngOnboarding = require("./YoungOnboarding");

},{"./YoungOnboarding":"g3E1B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g3E1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboarding", ()=>YoungOnboarding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _btnPrimary = require("../../../../../components/BtnPrimary");
var _styleCss = require("./style.css");
const YoungOnboarding = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-young-mobile${currentParams}`);
    };
    const handleButtonClickOnboarding = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_tutorial_easy-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "adultos-onboarding",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-7",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 490,
                            height: 239,
                            viewBox: "0 0 375 239",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M87.2391 280.362L278.969 66.1216L292.29 51.9809L292.38 52.0768L86.9893 281.59C87.0661 281.181 87.1559 280.778 87.2391 280.368",
                                    fill: "url(#paint0_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M87.9307 297.29L299.799 59.6228L300.427 60.256L88.2254 298.301C88.1229 297.962 88.0268 297.629 87.9307 297.29Z",
                                    fill: "url(#paint1_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M93.1402 309.277L308.308 68.2897L309.115 69.1148L93.7617 310.3C93.5439 309.961 93.3388 309.622 93.1338 309.277",
                                    fill: "url(#paint2_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M100.47 318.876L316.823 76.9556L317.816 77.9661L101.45 319.899C101.117 319.56 100.796 319.215 100.47 318.876Z",
                                    fill: "url(#paint3_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M108.838 327.311L325.338 85.6275L326.511 86.8235L110.023 328.501L108.838 327.311Z",
                                    fill: "url(#paint4_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M117.225 335.729L333.847 94.2946L335.205 95.6824L118.596 337.098L117.225 335.729Z",
                                    fill: "url(#paint5_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M125.612 344.139L342.363 102.966L343.9 104.533L127.169 345.699L125.612 344.139Z",
                                    fill: "url(#paint6_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M133.999 352.549L350.871 111.633L352.601 113.391L135.735 354.295L133.999 352.549Z",
                                    fill: "url(#paint7_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M142.386 360.959L359.386 120.299L361.295 122.243L144.314 362.891L142.386 360.959Z",
                                    fill: "url(#paint8_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M150.767 369.369L367.895 128.965L369.99 131.101L152.881 371.486L150.767 369.369Z",
                                    fill: "url(#paint9_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M159.154 377.773L376.411 137.631L378.685 139.952L161.448 380.082L159.154 377.773Z",
                                    fill: "url(#paint10_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M167.541 386.184L384.919 146.297L387.38 148.811L170.021 388.672L167.541 386.184Z",
                                    fill: "url(#paint11_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M175.922 394.594L393.428 154.97L396.074 157.662L178.587 397.268L175.922 394.594Z",
                                    fill: "url(#paint12_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M184.303 402.997L401.937 163.628L404.769 166.512L187.154 405.855L184.303 402.997Z",
                                    fill: "url(#paint13_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M192.683 411.401L410.445 172.295L413.463 175.364L195.72 414.445L192.683 411.401Z",
                                    fill: "url(#paint14_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M201.063 419.805L418.954 180.961L422.152 184.216L204.286 423.041L201.063 419.805Z",
                                    fill: "url(#paint15_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M209.444 428.21L427.463 189.628L430.846 193.075L212.853 431.625L209.444 428.21Z",
                                    fill: "url(#paint16_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M217.818 436.612L435.972 198.292L439.541 201.919L221.413 440.213L217.818 436.612Z",
                                    fill: "url(#paint17_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M226.199 445.017L444.481 206.959L448.236 210.777L229.973 448.803L226.199 445.017Z",
                                    fill: "url(#paint18_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M234.58 453.415L452.99 215.619L456.924 219.629L238.54 457.393L234.58 453.415Z",
                                    fill: "url(#paint19_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M242.954 461.817L461.499 224.284L465.612 228.473L247.1 465.975L242.954 461.817Z",
                                    fill: "url(#paint20_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M251.328 470.216L470.007 232.945L474.306 237.326L255.659 474.559L251.328 470.216Z",
                                    fill: "url(#paint21_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-184.915 280.471C-184.966 279.313 -184.986 278.162 -185.018 277.011L-3.34044 69.5178C-0.662216 69.2236 2.02881 68.9741 4.73907 68.7887L-184.659 285.095C-184.761 283.553 -184.851 282.012 -184.915 280.464",
                                    fill: "url(#paint22_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-183.974 293.095L12.9271 68.4109C15.3683 68.3405 17.803 68.3022 20.225 68.315L-183.096 300.322C-183.435 297.924 -183.724 295.513 -183.974 293.089",
                                    fill: "url(#paint23_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-181.872 307.953L28.1315 68.5201C30.3484 68.616 32.5589 68.7503 34.763 68.9166L-180.597 314.457C-181.058 312.302 -181.481 310.134 -181.872 307.953Z",
                                    fill: "url(#paint24_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-178.893 321.8L42.4518 69.6589C44.4765 69.8892 46.5011 70.1578 48.5066 70.452L-177.304 327.684C-177.861 325.733 -178.393 323.776 -178.893 321.8Z",
                                    fill: "url(#paint25_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-175.15 334.764L56.0034 71.6799C57.8615 72.0253 59.7196 72.3898 61.5585 72.78L-173.331 340.123C-173.965 338.351 -174.567 336.561 -175.15 334.764Z",
                                    fill: "url(#paint26_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-170.749 346.959L68.8687 74.4931C70.5795 74.9216 72.2774 75.3757 73.9689 75.849L-168.737 351.826C-169.429 350.214 -170.095 348.596 -170.749 346.959Z",
                                    fill: "url(#paint27_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-165.758 358.478L81.145 77.9983C82.7148 78.5036 84.2781 79.0216 85.8287 79.5589L-163.599 362.91C-164.335 361.439 -165.059 359.962 -165.758 358.478Z",
                                    fill: "url(#paint28_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-160.209 369.351L92.8512 82.1555C94.2928 82.7183 95.728 83.2939 97.1568 83.8887L-157.934 373.393C-158.71 372.056 -159.466 370.706 -160.209 369.351Z",
                                    fill: "url(#paint29_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-154.173 379.655L104.052 86.8953C105.378 87.5028 106.691 88.1296 108.005 88.7692L-151.809 383.332C-152.609 382.117 -153.398 380.889 -154.173 379.655Z",
                                    fill: "url(#paint30_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-147.657 389.413L114.752 92.2216C115.969 92.8675 117.18 93.5262 118.378 94.1978L-145.241 392.758C-146.061 391.651 -146.862 390.532 -147.663 389.413",
                                    fill: "url(#paint31_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-140.692 398.642L124.996 98.0612C126.105 98.7391 127.207 99.4363 128.309 100.133L-138.226 401.674C-139.052 400.67 -139.879 399.666 -140.692 398.642Z",
                                    fill: "url(#paint32_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-133.298 407.393L134.787 104.432C135.806 105.129 136.818 105.833 137.824 106.556L-130.806 410.117C-131.645 409.215 -132.478 408.307 -133.305 407.393",
                                    fill: "url(#paint33_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-125.481 415.649L144.135 111.301C145.058 112.024 145.974 112.746 146.884 113.482L-122.983 418.111C-123.822 417.299 -124.655 416.474 -125.481 415.649Z",
                                    fill: "url(#paint34_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-117.248 423.425L153.067 118.648C153.906 119.377 154.726 120.126 155.546 120.868L-114.749 425.625C-115.589 424.896 -116.422 424.16 -117.248 423.419",
                                    fill: "url(#paint35_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-108.611 430.743L161.543 126.51C162.299 127.245 163.055 127.981 163.799 128.729L-106.119 432.693C-106.952 432.047 -107.785 431.401 -108.605 430.743",
                                    fill: "url(#paint36_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-99.5512 437.578L169.61 134.842C170.283 135.578 170.949 136.326 171.616 137.074L-97.0972 439.299C-97.9174 438.73 -98.7375 438.16 -99.5576 437.578",
                                    fill: "url(#paint37_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-90.0752 443.935L177.222 143.68C177.818 144.416 178.407 145.158 178.997 145.906L-87.6597 445.451C-88.4734 444.952 -89.2679 444.441 -90.0752 443.935Z",
                                    fill: "url(#paint38_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-80.8809 449.418L183.905 152.374C184.43 153.096 184.962 153.825 185.481 154.555L-78.5166 450.723C-79.3111 450.294 -80.0928 449.859 -80.8744 449.418",
                                    fill: "url(#paint39_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-70.0146 455.091L190.965 162.716C191.426 163.439 191.868 164.161 192.323 164.89L-67.6952 456.191C-68.4705 455.827 -69.2458 455.462 -70.0082 455.091",
                                    fill: "url(#paint40_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-58.7954 460.097L197.379 173.51C197.77 174.22 198.16 174.917 198.545 175.633L-56.5528 461.012C-57.3089 460.711 -58.0521 460.404 -58.8018 460.097",
                                    fill: "url(#paint41_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-47.1274 464.492L203.21 184.838C203.536 185.528 203.85 186.232 204.171 186.929L-44.9489 465.215C-45.6794 464.978 -46.4098 464.735 -47.1338 464.492",
                                    fill: "url(#paint42_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-33.2754 468.68L209.04 198.401C209.303 199.079 209.546 199.764 209.802 200.448L-31.161 469.211C-31.8658 469.032 -32.577 468.859 -33.2754 468.68Z",
                                    fill: "url(#paint43_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-20.6846 471.559L213.391 210.873C213.59 211.526 213.807 212.172 214.006 212.824L-18.6727 471.955C-19.3455 471.827 -20.0118 471.686 -20.6846 471.559Z",
                                    fill: "url(#paint44_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M-7.43457 473.709L217.056 224.107C217.21 224.734 217.357 225.354 217.498 225.987L-5.5124 473.945C-6.15312 473.869 -6.79385 473.792 -7.43457 473.709Z",
                                    fill: "url(#paint45_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M7.16699 475.057L220.022 238.784C220.124 239.385 220.214 239.98 220.304 240.581L8.98664 475.141C8.37796 475.115 7.76927 475.089 7.16699 475.057Z",
                                    fill: "url(#paint46_linear_2630_5042)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint0_linear_2630_5042",
                                            x1: 94.238,
                                            y1: 145.72,
                                            x2: 299.628,
                                            y2: 145.72,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint1_linear_2630_5042",
                                            x1: 95.4302,
                                            y1: 157.065,
                                            x2: 307.926,
                                            y2: 157.065,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint2_linear_2630_5042",
                                            x1: 100.756,
                                            y1: 167.092,
                                            x2: 316.738,
                                            y2: 167.092,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint3_linear_2630_5042",
                                            x1: 108.14,
                                            y1: 176.139,
                                            x2: 325.487,
                                            y2: 176.139,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint4_linear_2630_5042",
                                            x1: 116.52,
                                            y1: 184.782,
                                            x2: 334.193,
                                            y2: 184.782,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint5_linear_2630_5042",
                                            x1: 124.918,
                                            y1: 193.421,
                                            x2: 342.898,
                                            y2: 193.421,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint6_linear_2630_5042",
                                            x1: 133.316,
                                            y1: 202.064,
                                            x2: 351.604,
                                            y2: 202.064,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint7_linear_2630_5042",
                                            x1: 141.714,
                                            y1: 210.701,
                                            x2: 360.316,
                                            y2: 210.701,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint8_linear_2630_5042",
                                            x1: 150.112,
                                            y1: 219.338,
                                            x2: 369.021,
                                            y2: 219.338,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint9_linear_2630_5042",
                                            x1: 158.504,
                                            y1: 227.976,
                                            x2: 377.727,
                                            y2: 227.976,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint10_linear_2630_5042",
                                            x1: 166.902,
                                            y1: 236.613,
                                            x2: 386.433,
                                            y2: 236.613,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint11_linear_2630_5042",
                                            x1: 175.3,
                                            y1: 245.248,
                                            x2: 395.138,
                                            y2: 245.248,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint12_linear_2630_5042",
                                            x1: 183.692,
                                            y1: 253.89,
                                            x2: 403.844,
                                            y2: 253.89,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint13_linear_2630_5042",
                                            x1: 192.084,
                                            y1: 262.519,
                                            x2: 412.55,
                                            y2: 262.519,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint14_linear_2630_5042",
                                            x1: 200.475,
                                            y1: 271.154,
                                            x2: 421.255,
                                            y2: 271.154,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint15_linear_2630_5042",
                                            x1: 208.866,
                                            y1: 279.792,
                                            x2: 429.954,
                                            y2: 279.792,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint16_linear_2630_5042",
                                            x1: 217.258,
                                            y1: 288.425,
                                            x2: 438.66,
                                            y2: 288.425,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint17_linear_2630_5042",
                                            x1: 225.644,
                                            y1: 297.058,
                                            x2: 447.366,
                                            y2: 297.058,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint18_linear_2630_5042",
                                            x1: 234.035,
                                            y1: 305.693,
                                            x2: 456.072,
                                            y2: 305.693,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint19_linear_2630_5042",
                                            x1: 242.427,
                                            y1: 314.325,
                                            x2: 464.771,
                                            y2: 314.325,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint20_linear_2630_5042",
                                            x1: 250.812,
                                            y1: 322.956,
                                            x2: 473.47,
                                            y2: 322.956,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint21_linear_2630_5042",
                                            x1: 259.198,
                                            y1: 331.585,
                                            x2: 482.176,
                                            y2: 331.585,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.septimo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint22_linear_2630_5042",
                                            x1: -182.222,
                                            y1: 165.89,
                                            x2: 7.53462,
                                            y2: 165.89,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint23_linear_2630_5042",
                                            x1: -180.965,
                                            y1: 172.463,
                                            x2: 23.2333,
                                            y2: 172.463,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint24_linear_2630_5042",
                                            x1: -178.681,
                                            y1: 178.923,
                                            x2: 37.9545,
                                            y2: 178.923,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint25_linear_2630_5042",
                                            x1: -175.542,
                                            y1: 185.488,
                                            x2: 51.8567,
                                            y2: 185.488,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint26_linear_2630_5042",
                                            x1: -171.663,
                                            y1: 192.186,
                                            x2: 65.0457,
                                            y2: 192.186,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint27_linear_2630_5042",
                                            x1: -167.144,
                                            y1: 198.99,
                                            x2: 77.5742,
                                            y2: 198.99,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint28_linear_2630_5042",
                                            x1: -162.051,
                                            y1: 205.897,
                                            x2: 89.5351,
                                            y2: 205.897,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint29_linear_2630_5042",
                                            x1: -156.417,
                                            y1: 212.894,
                                            x2: 100.948,
                                            y2: 212.894,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint30_linear_2630_5042",
                                            x1: -150.31,
                                            y1: 219.968,
                                            x2: 111.867,
                                            y2: 219.968,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint31_linear_2630_5042",
                                            x1: -143.744,
                                            y1: 227.134,
                                            x2: 122.298,
                                            y2: 227.134,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint32_linear_2630_5042",
                                            x1: -136.729,
                                            y1: 234.355,
                                            x2: 132.272,
                                            y2: 234.355,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint33_linear_2630_5042",
                                            x1: -129.31,
                                            y1: 241.656,
                                            x2: 141.818,
                                            y2: 241.656,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint34_linear_2630_5042",
                                            x1: -121.469,
                                            y1: 249.03,
                                            x2: 150.896,
                                            y2: 249.03,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint35_linear_2630_5042",
                                            x1: -113.229,
                                            y1: 256.452,
                                            x2: 159.565,
                                            y2: 256.452,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint36_linear_2630_5042",
                                            x1: -104.598,
                                            y1: 263.958,
                                            x2: 167.812,
                                            y2: 263.958,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint37_linear_2630_5042",
                                            x1: -95.5626,
                                            y1: 271.515,
                                            x2: 175.611,
                                            y2: 271.515,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint38_linear_2630_5042",
                                            x1: -86.1112,
                                            y1: 279.147,
                                            x2: 182.961,
                                            y2: 279.147,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint39_linear_2630_5042",
                                            x1: -76.9567,
                                            y1: 286.304,
                                            x2: 189.405,
                                            y2: 286.304,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint40_linear_2630_5042",
                                            x1: -66.1498,
                                            y1: 294.459,
                                            x2: 196.188,
                                            y2: 294.459,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint41_linear_2630_5042",
                                            x1: -55.0105,
                                            y1: 302.571,
                                            x2: 202.336,
                                            y2: 302.571,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint42_linear_2630_5042",
                                            x1: -43.4315,
                                            y1: 310.701,
                                            x2: 207.873,
                                            y2: 310.701,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint43_linear_2630_5042",
                                            x1: -29.6943,
                                            y1: 319.97,
                                            x2: 213.383,
                                            y2: 319.97,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint44_linear_2630_5042",
                                            x1: -17.227,
                                            y1: 328.075,
                                            x2: 217.464,
                                            y2: 328.075,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint45_linear_2630_5042",
                                            x1: -4.1208,
                                            y1: 336.261,
                                            x2: 220.812,
                                            y2: 336.261,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                            id: "paint46_linear_2630_5042",
                                            x1: 10.307,
                                            y1: 344.886,
                                            x2: 223.444,
                                            y2: 344.886,
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.26,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.36,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.49,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.63,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.79,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 0.85,
                                                    stopColor: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                    offset: 1,
                                                    stopColor: colors.secundario
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "capa-2",
                            alt: "Capa",
                            src: "/img/capa-1-1.svg"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "rectangle-9",
                        alt: "Rectangle",
                        src: "/img/rectangle.png"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "buttons-2",
                    children: [
                        colors.url_logo !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            width: 100,
                            height: "auto",
                            src: colors.url_logo
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper-30",
                                    children: "Welcome"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-wrapper-30",
                                    children: "It\u2019s nice to see u!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            onClick: handleButtonClick,
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnPrimary.BtnPrimary), {
                                className: "btn-primary-5 highlighted-button",
                                divClassName: "btn-primary-6",
                                text: "Login by Password",
                                center: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "highlighted-button",
                            onClick: handleButtonClickOnboarding,
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnPrimary.BtnPrimary), {
                                className: "btn-primary-7",
                                divClassName: "btn-primary-8",
                                text: "Sign In"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"crfO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/BtnPrimary":"lD5WC"}],"crfO3":[function() {},{}],"9YXCR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasyTelco", ()=>(0, _corporativoOnboardingTutorialEasyTelco.CorporativoOnboardingTutorialEasyTelco));
var _corporativoOnboardingTutorialEasyTelco = require("./CorporativoOnboardingTutorialEasyTelco");

},{"./CorporativoOnboardingTutorialEasyTelco":"1c15J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1c15J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasyTelco", ()=>CorporativoOnboardingTutorialEasyTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sliderDots = require("../../../../../components/SliderDots");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingTutorialEasyTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_register-corporativo-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_steppper-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen-totirial",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-3",
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 100,
                                height: 100,
                                viewBox: "0 0 151 150",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 104.5,
                                        cy: 103,
                                        r: 26,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M100.109 109.207C100.327 109.425 100.585 109.598 100.87 109.716C101.154 109.834 101.459 109.894 101.767 109.894C102.075 109.894 102.38 109.834 102.665 109.716C102.949 109.598 103.208 109.425 103.425 109.207L112.261 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.952 99.3114 113.025 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.868 97.7535C112.751 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.859 96.5636 111.565 96.4452C111.27 96.3268 110.955 96.2695 110.637 96.2767C110.32 96.284 110.007 96.3556 109.718 96.4874C109.429 96.6191 109.17 96.8081 108.957 97.043L101.773 104.227L98.2574 100.711C98.0438 100.476 97.7847 100.287 97.4959 100.155C97.207 100.024 96.8944 99.952 96.5769 99.9447C96.2595 99.9375 95.944 99.9948 95.6494 100.113C95.3548 100.232 95.0873 100.409 94.8632 100.633C94.6391 100.858 94.4631 101.126 94.3457 101.421C94.2283 101.716 94.1721 102.032 94.1805 102.35C94.1889 102.667 94.2616 102.979 94.3944 103.268C94.5271 103.556 94.7171 103.815 94.9527 104.027L100.109 109.207Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M42.0895 37.8866L50.8903 28.0194C51.095 27.7886 51.2522 27.5197 51.3529 27.2281C51.4537 26.9365 51.496 26.6279 51.4775 26.32C51.459 26.012 51.3801 25.7107 51.2451 25.4333C51.1102 25.1559 50.9219 24.9077 50.6911 24.703C50.4602 24.4984 50.1913 24.3412 49.8998 24.2404C49.6082 24.1396 49.2996 24.0973 48.9916 24.1158C48.6837 24.1343 48.3824 24.2133 48.1049 24.3482C47.8275 24.4832 47.5794 24.6714 47.3747 24.9023L38.5856 34.7694C38.1722 35.2356 37.961 35.847 37.9984 36.4689C38.0357 37.0909 38.3186 37.6725 38.7848 38.0859C39.251 38.4992 39.8623 38.7105 40.4843 38.6731C41.1062 38.6357 41.6879 38.3528 42.1012 37.8866H42.0895Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M25.4958 38.0741C25.9581 37.6603 26.2375 37.08 26.2726 36.4606C26.3078 35.8411 26.0958 35.2329 25.6833 34.7695L16.9059 24.9023C16.4926 24.4361 15.9109 24.1532 15.289 24.1158C14.667 24.0784 14.0557 24.2897 13.5895 24.703C13.1233 25.1164 12.8404 25.698 12.8031 26.32C12.7657 26.9419 12.9769 27.5532 13.3903 28.0194L22.1794 37.8866C22.3844 38.1173 22.633 38.3052 22.9109 38.4395C23.1888 38.5738 23.4905 38.6519 23.7986 38.6693C24.1068 38.6868 24.4153 38.6431 24.7066 38.541C24.9978 38.4389 25.266 38.2802 25.4958 38.0741Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Easy and Complete"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "all-you-need-in-your",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "id-diamond-down highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1233 6.67194L0.00488281 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-wrapper highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1235 6.67194L0.00512695 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "img-slider-dots",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "slider-dots-instance",
                            status: "off"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "design-component-instance-node",
                            status: "on"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-2"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"j3bkG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/SliderDots":"gfhZb","../../../../../hooks/useDynamicColors":"b2GRH"}],"j3bkG":[function() {},{}],"gcyDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcomeTelco", ()=>(0, _corporativoOnboardingWelcomeTelco.CorporativoOnboardingWelcomeTelco));
var _corporativoOnboardingWelcomeTelco = require("./CorporativoOnboardingWelcomeTelco");

},{"./CorporativoOnboardingWelcomeTelco":"kh1aq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kh1aq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcomeTelco", ()=>CorporativoOnboardingWelcomeTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingWelcomeTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/telco-landing-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 129,
                                height: 130,
                                viewBox: "0 0 129 130",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 28.5,
                                        cy: 108,
                                        r: 22,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M109.38 84.5799C109.415 83.6859 109.267 82.7942 108.943 81.9599C108.62 81.1257 108.129 80.3667 107.5 79.7299C105.43 77.7299 101.84 76.8699 95.5002 76.9899C88.9738 77.2737 82.4885 78.171 76.1302 79.6699C72.1334 80.5412 68.1929 81.6533 64.3302 82.9999C61.3302 83.9999 59.2602 84.7099 56.8502 84.7099H56.7602C55.988 84.7516 55.2175 84.5997 54.5189 84.2679C53.8204 83.936 53.2158 83.4349 52.7602 82.8099C52.3251 82.1192 52.0657 81.3325 52.0047 80.5184C51.9437 79.7044 52.0829 78.8877 52.4102 78.1399C54.0075 73.7814 54.6188 69.123 54.2002 64.4999C53.5402 58.0499 50.3302 54.3399 45.3802 54.2999C44.6068 54.2524 43.8321 54.3686 43.1067 54.6409C42.3813 54.9131 41.7214 55.3353 41.1702 55.8799C39.3602 57.7599 39.3302 60.6199 39.4602 63.6299C39.5702 66.3699 36.5902 69.1599 34.8102 70.8299C30.8102 74.6099 27.7302 80.1299 27.0602 84.8899C26.9602 85.5999 26.8902 86.2499 26.8202 86.8899C26.8063 87.9491 26.5855 88.9954 26.1702 89.9699C24.1746 91.7691 22.0742 93.4487 19.8802 94.9999C19.6679 95.1569 19.4888 95.3544 19.3532 95.5809C19.2176 95.8075 19.1283 96.0586 19.0902 96.3199C19.0902 96.5699 18.2802 102.46 24.2402 110.03C28.5102 115.46 34.6102 117.91 38.5402 117.91H38.6802C39.269 117.965 39.8625 117.879 40.4118 117.66C40.9611 117.441 41.4506 117.095 41.8402 116.65C42.8402 115.26 46.7102 111.06 48.2402 110.24C52.1102 108.15 56.0102 106.24 59.5202 104.69C67.8202 104.53 89.0102 104.39 93.8102 105.58C94.6146 105.782 95.4409 105.882 96.2702 105.88C99.8802 105.88 103.64 104.07 104.8 100.39C105.198 99.3389 105.369 98.2161 105.304 97.0944C105.238 95.9728 104.937 94.8775 104.42 93.8799C104.039 93.2041 103.553 92.5931 102.98 92.0699C108.13 90.3499 109.36 87.1699 109.38 84.5799ZM100.99 99.1899C100.29 101.4 97.1502 102.29 94.7802 101.7C90.8402 100.7 78.6502 100.56 69.5802 100.59L70.5202 100.24C79.0683 96.9923 87.9385 94.6658 96.9802 93.2999C98.9802 93.8799 100.32 94.7399 100.91 95.8099C101.154 96.338 101.286 96.9103 101.3 97.4916C101.314 98.0729 101.208 98.6509 100.99 99.1899ZM98.8302 88.9999C82.7602 91.4599 74.2302 94.6399 69.1302 96.5399L67.6202 96.9999C60.3156 99.7404 53.2059 102.975 46.3402 106.68C44.0102 107.93 40.1402 112.35 38.9102 113.87C37.2802 114.1 31.5202 112.79 27.3802 107.52C23.6702 102.81 23.1002 99.1199 23.0402 97.6099C24.9202 96.1999 28.4802 93.4699 29.3502 92.3499C30.3502 90.9999 30.5802 89.3499 30.8202 87.2699C30.8802 86.7099 30.9502 86.0999 31.0402 85.4299C31.5902 81.5699 34.2102 76.8699 37.5702 73.7299C39.7002 71.7299 43.6702 68.0099 43.4702 63.4399C43.4102 62.0399 43.3002 59.4399 44.0702 58.6399C44.1602 58.5499 44.4202 58.2799 45.3402 58.2799C48.1302 58.2799 49.7702 60.5199 50.2102 64.8899C50.5909 68.903 50.0751 72.9505 48.7002 76.7399C48.1404 78.091 47.9206 79.5588 48.0601 81.0145C48.1996 82.4703 48.6941 83.8697 49.5002 85.0899C50.3193 86.2452 51.4099 87.1814 52.6759 87.8161C53.9419 88.4508 55.3445 88.7646 56.7602 88.7299C59.8802 88.7299 62.2902 87.9399 65.6302 86.8199C69.38 85.5055 73.2073 84.4234 77.0902 83.5799C83.1849 82.1356 89.4027 81.2718 95.6602 80.9999C100.52 80.9099 103.56 81.4399 104.72 82.5899C104.971 82.854 105.16 83.1703 105.274 83.516C105.388 83.8618 105.424 84.2285 105.38 84.5899C105.37 85.3899 105.35 87.9999 98.8302 88.9999Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M38.2202 44C38.3702 44 53.6402 46.28 59.9402 52.58C66.2402 58.88 68.5002 74.13 68.5002 74.28C68.5002 74.8104 68.7109 75.3191 69.086 75.6942C69.4611 76.0693 69.9698 76.28 70.5002 76.28C71.0306 76.28 71.5394 76.0693 71.9144 75.6942C72.2895 75.3191 72.5002 74.8104 72.5002 74.28C72.5002 74.13 74.7802 58.86 81.0802 52.56C87.3802 46.26 102.63 44 102.78 44C103.311 44 103.819 43.7893 104.194 43.4142C104.57 43.0391 104.78 42.5304 104.78 42C104.78 41.4695 104.57 40.9608 104.194 40.5858C103.819 40.2107 103.311 40 102.78 40C102.63 40 87.3602 37.72 81.0602 31.42C74.7602 25.12 72.5002 9.86997 72.5002 9.71997C72.5002 9.18954 72.2895 8.68083 71.9144 8.30576C71.5394 7.93068 71.0306 7.71997 70.5002 7.71997C69.9698 7.71997 69.4611 7.93068 69.086 8.30576C68.7109 8.68083 68.5002 9.18954 68.5002 9.71997C68.5002 9.86997 66.2202 25.14 59.9202 31.44C53.6202 37.74 38.3702 40 38.2202 40C37.6898 40 37.1811 40.2107 36.806 40.5858C36.4309 40.9608 36.2202 41.4695 36.2202 42C36.2202 42.5304 36.4309 43.0391 36.806 43.4142C37.1811 43.7893 37.6898 44 38.2202 44ZM62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M88.4999 26C89.0295 25.9978 89.5366 25.7856 89.9099 25.41L93.9099 21.41C94.2376 21.0274 94.4088 20.5353 94.3893 20.0319C94.3699 19.5286 94.1612 19.0511 93.805 18.6949C93.4488 18.3387 92.9714 18.1301 92.468 18.1106C91.9647 18.0912 91.4725 18.2624 91.0899 18.59L87.0899 22.59C86.8119 22.8697 86.6228 23.2253 86.5463 23.6122C86.4698 23.999 86.5094 24.3999 86.6601 24.7643C86.8108 25.1287 87.0658 25.4404 87.3932 25.6603C87.7205 25.8802 88.1056 25.9984 88.4999 26Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M87.0899 58.5899C86.7174 58.9646 86.5083 59.4715 86.5083 59.9999C86.5083 60.5283 86.7174 61.0352 87.0899 61.4099L91.0899 65.4099C91.4725 65.7375 91.9646 65.9087 92.468 65.8893C92.9713 65.8699 93.4488 65.6612 93.805 65.305C94.1612 64.9488 94.3699 64.4713 94.3893 63.968C94.4087 63.4646 94.2375 62.9725 93.9099 62.5899L89.9099 58.5899C89.5352 58.2174 89.0283 58.0083 88.4999 58.0083C87.9715 58.0083 87.4646 58.2174 87.0899 58.5899Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M51.0898 25.41C51.4724 25.7377 51.9646 25.9089 52.4679 25.8895C52.9713 25.87 53.4487 25.6614 53.8049 25.3052C54.1611 24.949 54.3698 24.4715 54.3892 23.9682C54.4087 23.4648 54.2375 22.9726 53.9098 22.59L49.9098 18.59C49.5272 18.2624 49.035 18.0912 48.5317 18.1106C48.0283 18.1301 47.5509 18.3387 47.1947 18.6949C46.8385 19.0511 46.6298 19.5286 46.6104 20.0319C46.5909 20.5353 46.7621 21.0274 47.0898 21.41L51.0898 25.41Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Your account has been opened"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "all-you-need-in-your",
                    children: "Enjoy all the benefits of our App"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2",
                    onClick: handleButtonClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "highlighted-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                            className: "test-button-4 highlighted-button",
                            disabled: "off",
                            endIcon: false,
                            label: "Let\u2019s start!",
                            onColor: "off",
                            size: "large",
                            startIcon: false,
                            textClassName: "test-button-5",
                            type: "primary"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"hjV91","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../hooks/useDynamicColors":"b2GRH"}],"hjV91":[function() {},{}],"6ACwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepperTelco", ()=>(0, _corporativoOnboardingStepperTelco.CorporativoOnboardingStepperTelco));
var _corporativoOnboardingStepperTelco = require("./CorporativoOnboardingStepperTelco");

},{"./CorporativoOnboardingStepperTelco":"2EV0x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2EV0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepperTelco", ()=>CorporativoOnboardingStepperTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingStepperTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_card_id-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-stepper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Open account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "battery",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "capacity-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "capacity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "cap",
                                                alt: "Cap",
                                                src: "/img/cap-2.svg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "wifi",
                                        alt: "Wifi",
                                        src: "/img/wifi.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "cellular-connection",
                                        alt: "Cellular connection",
                                        src: "/img/cellular-connection.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "navs-statusbar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7",
                                        children: "9:50"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons",
                                        alt: "Icons",
                                        src: "/img/icons-6.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                            className: "header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-4",
                                        children: "Terms and Conditions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-4"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 180,
                                                            height: 170,
                                                            viewBox: "0 0 200 190",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.75
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 72,
                            height: 72,
                            viewBox: "0 0 72 72",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.5 72L38.893 59.6009C37.7023 58.4299 37.7023 56.5528 38.893 55.399L51.5 43L64.107 55.399C65.2977 56.5701 65.2977 58.4471 64.107 59.6009L51.5 72Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.75 66.9375H20.25C18.609 66.9375 17.0352 66.2856 15.8748 65.1252C14.7144 63.9648 14.0625 62.391 14.0625 60.75V18C14.0625 16.359 14.7144 14.7852 15.8748 13.6248C17.0352 12.4644 18.609 11.8125 20.25 11.8125H23.0625V11.25C23.0625 9.60897 23.7144 8.03516 24.8748 6.87478C26.0352 5.7144 27.609 5.0625 29.25 5.0625C30.8874 5.07428 32.4544 5.72996 33.6122 6.8878C34.77 8.04563 35.4257 9.61261 35.4375 11.25V11.8125H43.1325C43.948 11.811 44.7557 11.9713 45.5089 12.2841C46.262 12.597 46.9456 13.0561 47.52 13.635L56.115 22.23C56.6939 22.8044 57.153 23.488 57.4659 24.2411C57.7787 24.9943 57.939 25.802 57.9375 26.6175V60.75C57.9375 62.391 57.2856 63.9648 56.1252 65.1252C54.9648 66.2856 53.391 66.9375 51.75 66.9375ZM20.25 15.1875C19.5041 15.1875 18.7887 15.4838 18.2613 16.0113C17.7338 16.5387 17.4375 17.2541 17.4375 18V60.75C17.4375 61.4959 17.7338 62.2113 18.2613 62.7387C18.7887 63.2662 19.5041 63.5625 20.25 63.5625H51.75C52.4959 63.5625 53.2113 63.2662 53.7387 62.7387C54.2662 62.2113 54.5625 61.4959 54.5625 60.75V28.6875H45C43.9575 28.6816 42.9594 28.2649 42.2223 27.5277C41.4851 26.7906 41.0684 25.7925 41.0625 24.75V15.1875H35.4375V20.25C35.4375 21.891 34.7856 23.4648 33.6252 24.6252C32.4648 25.7856 30.891 26.4375 29.25 26.4375C27.609 26.4375 26.0352 25.7856 24.8748 24.6252C23.7144 23.4648 23.0625 21.891 23.0625 20.25C23.0625 19.8024 23.2403 19.3732 23.5568 19.0568C23.8732 18.7403 24.3024 18.5625 24.75 18.5625C25.1976 18.5625 25.6268 18.7403 25.9432 19.0568C26.2597 19.3732 26.4375 19.8024 26.4375 20.25C26.4375 20.9959 26.7338 21.7113 27.2613 22.2387C27.7887 22.7662 28.5041 23.0625 29.25 23.0625C29.9959 23.0625 30.7113 22.7662 31.2387 22.2387C31.7662 21.7113 32.0625 20.9959 32.0625 20.25V15.1875H20.25ZM44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025ZM26.4375 11.8125H32.0625V11.25C32.0651 10.8861 31.9948 10.5254 31.8557 10.1892C31.7166 9.85301 31.5115 9.5481 31.2525 9.2925C30.8663 8.88491 30.3661 8.60333 29.8173 8.48457C29.2685 8.36582 28.6967 8.41541 28.1765 8.62688C27.6563 8.83834 27.2121 9.20184 26.9018 9.66983C26.5916 10.1378 26.4297 10.6886 26.4375 11.25V11.8125ZM47.25 55.6875H24.75C24.3024 55.6875 23.8732 55.5097 23.5568 55.1932C23.2403 54.8768 23.0625 54.4476 23.0625 54C23.0625 53.5524 23.2403 53.1232 23.5568 52.8068C23.8732 52.4903 24.3024 52.3125 24.75 52.3125H47.25C47.6976 52.3125 48.1268 52.4903 48.4432 52.8068C48.7597 53.1232 48.9375 53.5524 48.9375 54C48.9375 54.4476 48.7597 54.8768 48.4432 55.1932C48.1268 55.5097 47.6976 55.6875 47.25 55.6875ZM47.25 46.6875H24.75C24.3024 46.6875 23.8732 46.5097 23.5568 46.1932C23.2403 45.8768 23.0625 45.4476 23.0625 45C23.0625 44.5524 23.2403 44.1232 23.5568 43.8068C23.8732 43.4903 24.3024 43.3125 24.75 43.3125H47.25C47.6976 43.3125 48.1268 43.4903 48.4432 43.8068C48.7597 44.1232 48.9375 44.5524 48.9375 45C48.9375 45.4476 48.7597 45.8768 48.4432 46.1932C48.1268 46.5097 47.6976 46.6875 47.25 46.6875ZM33.75 37.6875H24.75C24.3024 37.6875 23.8732 37.5097 23.5568 37.1932C23.2403 36.8768 23.0625 36.4476 23.0625 36C23.0625 35.5524 23.2403 35.1232 23.5568 34.8068C23.8732 34.4903 24.3024 34.3125 24.75 34.3125H33.75C34.1976 34.3125 34.6268 34.4903 34.9432 34.8068C35.2597 35.1232 35.4375 35.5524 35.4375 36C35.4375 36.4476 35.2597 36.8768 34.9432 37.1932C34.6268 37.5097 34.1976 37.6875 33.75 37.6875Z",
                                    fill: colors.primario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025Z",
                                    fill: colors.sexto
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subtitle-5",
                            children: "Welcome!"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "subtitle-6",
                            children: "Let\u2019s open your online account"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Accept Terms and Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Register your Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-7",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Scan your ID card"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: " Validate your identity"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Register your Mobile number"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Generate your credentials"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"dpbo7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"dpbo7":[function() {},{}],"9cdlb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardIdTelco", ()=>(0, _corporativoOnboardingCardIdTelco.CorporativoOnboardingCardIdTelco));
var _corporativoOnboardingCardIdTelco = require("./CorporativoOnboardingCardIdTelco");

},{"./CorporativoOnboardingCardIdTelco":"gE2u8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gE2u8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardIdTelco", ()=>CorporativoOnboardingCardIdTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _iconChevronDown1 = require("../../../../../icons/IconChevronDown1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingCardIdTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_phone-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-13",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line-3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-14",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-4"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-7",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-3",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 98,
                            height: 73,
                            viewBox: "0 0 98 73",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-13",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-14",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-15",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "subtitle-11",
                                            children: "Now, get your ID card"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "subtitle-12",
                                        children: [
                                            "We will take a photo of the front & back.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Photos will be captured automatically."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "e-mail",
                                    children: "Country"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-16",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-17",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-15",
                                                children: "Select your country"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconChevronDown1.IconChevronDown1), {
                                                className: "icon-chevron-down",
                                                color: "#5C5C5C"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-4 highlighted-button",
                        onClick: handleButtonClickLogin,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-wrapper-16",
                            children: "I\xb4ve got my ID card!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-9",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-18",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-1-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1-instance"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-13",
                                        children: "Scan ID Card"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-13",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-14",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-5",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-6"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-19",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"l7gqt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../icons/IconChevronDown1":"ccPWd","../../../../../hooks/useDynamicColors":"b2GRH"}],"l7gqt":[function() {},{}],"f7o6c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhoneTelco", ()=>(0, _corporativoOnboardingPhoneTelco.CorporativoOnboardingPhoneTelco));
var _corporativoOnboardingPhoneTelco = require("./CorporativoOnboardingPhoneTelco");

},{"./CorporativoOnboardingPhoneTelco":"eePwG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eePwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhoneTelco", ()=>CorporativoOnboardingPhoneTelco);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _componenteToken = require("../../../../../components/ComponenteToken");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingPhoneTelco = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/telco-onboarding_welcome-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-8",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-10",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-2"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "atomo-step-final-no",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-2",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 65,
                            height: 87,
                            viewBox: "0 0 65 87",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z",
                                    fill: colors.sexto
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "subtitle-9",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "span",
                                            children: [
                                                "A validation code has been sent to\xa0\xa0",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-11",
                                            children: "+54 9 1122 6476"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteToken.ComponenteToken), {
                            active: false,
                            atomoTimeRectangleClassName: "componente-token-5",
                            atomoTimeSubtitleCopyClassName: "componente-token-3",
                            atomoTimeSubtitleCopyClassNameOverride: "componente-token-3",
                            atomoTimeTimelineClassName: "componente-token-4",
                            buttonActive: true,
                            buttonInactive: false,
                            buttonSmallEstado: "inactivo",
                            buttonSmallTextClassName: "componente-token-6",
                            buttonSmallTexto: "Resend code",
                            className: "componente-token-input",
                            default1: true,
                            error: false,
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName1: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName2: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenText: "8",
                            moleculaTokenNumbsAtomoNumbTokenText1: "4",
                            moleculaTokenNumbsAtomoNumbTokenText2: "9",
                            moleculaTokenNumbsAtomoNumbTokenText3: "6",
                            moleculaTokenNumbsDefaultFalseActiveClassName: "componente-token-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2 highlighted-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-3 ",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-12",
                            children: "Validate"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-10",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-5"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-10",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-10",
                                        children: "Register Mobile number"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"1AMYE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteToken":"1K7Wn","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../hooks/useDynamicColors":"b2GRH"}],"1AMYE":[function() {},{}],"4l8UB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLandingRegional", ()=>(0, _corporativoLandingRegional.CorporativoLandingRegional));
var _corporativoLandingRegional = require("./CorporativoLandingRegional");

},{"./CorporativoLandingRegional":"89gPR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89gPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLandingRegional", ()=>CorporativoLandingRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("../../../../../components/Button");
var _icons1 = require("../../../../../icons/Icons1");
var _icons19 = require("../../../../../icons/Icons19");
var _nameMenuDarkTrue = require("../../../../../icons/NameMenuDarkTrue");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _trailingIcon19 = require("../../../../../icons/TrailingIcon19");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _frameCorp = require("../../../../../components/FrameCorp");
var _styleCss = require("./style.css");
const CorporativoLandingRegional = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const scrollRef = (0, _react.useRef)(null);
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_card_id-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "contenedor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "corporativo-landing",
            ref: scrollRef,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "div-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                            className: "header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rectangle-4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frameCorp.FrameCorp), {
                                            color: colors.septimo
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-7",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-11",
                                                children: "Good morning, Mary"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons1.Icons1), {
                                                        className: "icon-instance-node-2",
                                                        color: "white"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nameMenuDarkTrue.NameMenuDarkTrue), {
                                                        className: "icon-instance-node-2",
                                                        color: "white"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "vector-2",
                            alt: "Vector",
                            src: "/img/vector-101.svg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "accounts",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "tarjtetas",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "title",
                                                    children: "Accounts"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                            className: "icon-instance-node-2",
                                                            color: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "menu-copy",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval-2"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval-3"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "account highlighted-button",
                                            onClick: handleButtonClick,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-11",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-12",
                                                            children: "Balance"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            className: "element-USD",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "span",
                                                                    children: "$13,000"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-13",
                                                                    children: ".23"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-14",
                                                                    children: "\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-15",
                                                                    children: "USD"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-12",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                            className: "main-account",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "span",
                                                                    children: "Main account "
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "text-wrapper-16",
                                                                    children: "| ****2357"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            className: "button-instance",
                                                            divClassName: "button-4",
                                                            leadingIcon: false,
                                                            size: "small",
                                                            text: "Transactions",
                                                            trailingIcon: true,
                                                            trailingIcon14StyleOverrideClassName: "button-5",
                                                            trailingIcon14Color: colors.secundario,
                                                            type: "text"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "button-6",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-17",
                                                    children: "More"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon19.TrailingIcon19), {
                                                    className: "trailing-icon"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "botonera",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-14",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "overlap-group-8",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "border-vector-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                alt: "Vector",
                                                                src: "/img/iconZellePng.png"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "texto-iconos",
                                                    children: "Zelle"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "btn-icon-contacts",
                                                    alt: "Btn icon contacts",
                                                    src: "/img/btn-icon-contacts-2.svg"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "texto-iconos",
                                                    children: "Wired Transfers"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "invoice",
                                                    alt: "Invoice",
                                                    src: "/img/invoice.svg"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "texto-iconos",
                                                    children: "Pay Bills"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-15",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "plus",
                                                    alt: "Plus",
                                                    src: "/img/plus.svg"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "texto-iconos",
                                                    children: "CNEx"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "cards",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "div-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "title-2",
                                                    children: "Cards"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-16",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                            className: "icon-instance-node-2",
                                                            color: colors.secundario
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "menu-copy",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval-4"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval-5"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "oval-6"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "cardss",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "gold",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-21",
                                                            children: "Credit GOLD ****5849"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon19.TrailingIcon19), {
                                                            className: "trailing-icon"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "balances",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "div-5",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "group-2",
                                                    alt: "Group",
                                                    src: "/img/group-637-2.svg"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-18",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-19",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-4"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "div-6",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "span",
                                                                            children: [
                                                                                "T. Balance",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "text-wrapper-22",
                                                                            children: "$13,000"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-19",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-5"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "div-6",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "span",
                                                                            children: [
                                                                                "Debts",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "text-wrapper-22",
                                                                            children: "$8,000"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-20",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-23",
                                                            children: "Total balance | Debts"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                            className: "trailing-icon",
                                                            style: {
                                                                color: colors.primario
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "div-5",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-21",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-22",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-23",
                                                                children: "Expenses & Incomes"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                className: "trailing-icon",
                                                                style: {
                                                                    color: colors.primario
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "chart",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-23",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "rectangle-5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "rectangle-6"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-23",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "rectangle-7"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "rectangle-8"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-24",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-24",
                                                                children: "September"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-25",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "expenses-wrapper",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "text-wrapper-24",
                                                                            children: [
                                                                                "Expenses",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                "$2,000"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "incomes-wrapper",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "text-wrapper-24",
                                                                            children: [
                                                                                "Incomes",
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                                "$3,200"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "banners",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "image-2",
                                                        alt: "Image",
                                                        src: "/img/image-62026.png"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-26",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "image-3",
                                                                alt: "Image",
                                                                src: "/img/image-62032.png"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "group-3",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-10",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                            className: "in-all-TACOS",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "text-wrapper-25",
                                                                                    children: [
                                                                                        "in all",
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "text-wrapper-26",
                                                                                    children: "TACOS"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                            className: "element-OFF",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "text-wrapper-27",
                                                                                    children: "40"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "text-wrapper-28",
                                                                                    children: "%OFF"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "image-4",
                                            alt: "Image",
                                            src: "/img/image-62014.png"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "image-5",
                                            alt: "Image",
                                            src: "/img/image-62011.png"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "image-4",
                                            alt: "Image",
                                            src: "/img/image-62017.png"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"8apol","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/Button":"jfuTO","../../../../../icons/Icons1":"gEDpR","../../../../../icons/Icons19":"2OHy7","../../../../../icons/NameMenuDarkTrue":"8A1Jb","../../../../../icons/TrailingIcon14":"1nwir","../../../../../icons/TrailingIcon19":"bdQbQ","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/FrameCorp":"aBd21"}],"8apol":[function() {},{}],"6yyDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoCardRegional", ()=>(0, _corporativoCardRegional.CorporativoCardRegional));
var _corporativoCardRegional = require("./CorporativoCardRegional");

},{"./CorporativoCardRegional":"fccci","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fccci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoCardRegional", ()=>CorporativoCardRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack = require("../../../../../icons/IconArrowBack");
var _regularCopyAlt = require("../../../../../icons/RegularCopyAlt");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _frameCorp = require("../../../../../components/FrameCorp");
var _styleCss = require("./style.css");
const CorporativoCardRegional = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/corporativo-landing${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-card",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper-3",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-9",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                        className: "header-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-15"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-43",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frameCorp.FrameCorp), {
                                        color: colors.septimo
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-44",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-arrow-back-wrapper highlighted-button",
                                            onClick: handleButtonBack,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack.IconArrowBack), {
                                                className: "icon-arrow-back-1",
                                                color: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-2",
                                            children: "Card details"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-45",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-46",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-10",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            style: {
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center",
                                                backgroundSize: "contain",
                                                backgroundImage: colors.url_card ? `url(${colors.url_card})` : "none",
                                                backgroundColor: colors.url_card ? "transparent" : "#e8eaed"
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-11",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-9",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group-16"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-47",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-48",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-45",
                                                                        children: "Pay date"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-46",
                                                                        children: "10 ABR"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-48",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-45",
                                                                        children: "Due date"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-46",
                                                                        children: "11/30"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-49",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-47",
                                                                children: "7531 4532 6643 5849"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regularCopyAlt.RegularCopyAlt), {
                                                                className: "regular-copy-alt-2"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "bottom-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "fecha-pago-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-48",
                                                            children: "Available (USD)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-49",
                                                                children: "13,000"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "fecha-pago-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-48",
                                                            children: "Assigned (USD)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-50",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-49",
                                                                children: "23,000"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "botonera-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "key",
                                                alt: "Key",
                                                src: "/img/key.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "CVV"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "group-10",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "overlap-group-17",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-7",
                                                                alt: "Vector",
                                                                src: "/img/vector-5.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-52",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-9"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-10"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "ellipse-9"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-8",
                                                                alt: "Vector",
                                                                src: "/img/vector-6.svg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "PIN"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-51",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "frame-53",
                                                alt: "Frame",
                                                src: "/img/frame-1171274973.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "Pay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-54",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "group-wrapper",
                                                alt: "Regular menu dots",
                                                src: "/img/regular-menu-dots.svg"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-53-quinto",
                                                children: "More"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-55",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "tarjtetas-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title-4",
                                                children: "Last Transactions"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-56",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "btn-text-link-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-54",
                                                            children: "See all"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-3",
                                                            alt: "Btn icon chevron",
                                                            src: "/img/btn-icon-chevron-4.svg"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-57",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Dinner",
                                                                src: "/img/dinner-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Starbucks coffee time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $25.11"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Paw",
                                                                src: "/img/paw-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Bruno\u2019s tricks"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $12.42"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "shopping-bag-2",
                                                                alt: "Shopping bag",
                                                                src: "/img/shopping-bag-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "New gymn shoes"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $158.68"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Dinner",
                                                                src: "/img/dinner-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Starbucks coffee time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $25.11"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "shopping-bag-2",
                                                                alt: "Shopping bag",
                                                                src: "/img/shopping-bag-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-50",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "New gymn shoes"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-4",
                                                                children: "- $158.68"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "movements-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-58",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-3",
                                                                alt: "Credit card",
                                                                src: "/img/credit-card-1.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-55",
                                                                        children: "Card payment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "img-3",
                                                                        alt: "Btn icon chevron",
                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-59",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "date-3",
                                                                children: "11/06/22"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "amount-5",
                                                                children: "$950.23"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"8dRLj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack":"dgOyH","../../../../../icons/RegularCopyAlt":"9klXy","../../../../../hooks/useDynamicColors":"b2GRH","../../../../../components/FrameCorp":"aBd21"}],"8dRLj":[function() {},{}],"jkHvY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasyRegional", ()=>(0, _corporativoOnboardingTutorialEasyRegional.CorporativoOnboardingTutorialEasyRegional));
var _corporativoOnboardingTutorialEasyRegional = require("./CorporativoOnboardingTutorialEasyRegional");

},{"./CorporativoOnboardingTutorialEasyRegional":"1dCl1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1dCl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingTutorialEasyRegional", ()=>CorporativoOnboardingTutorialEasyRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sliderDots = require("../../../../../components/SliderDots");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingTutorialEasyRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_register-corporativo-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_steppper-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen-totirial",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-3",
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 100,
                                height: 100,
                                viewBox: "0 0 151 150",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 104.5,
                                        cy: 103,
                                        r: 26,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M85.2617 103.125C85.2617 106.833 86.3614 110.459 88.4217 113.542C90.4819 116.625 93.4103 119.029 96.8364 120.448C100.263 121.867 104.033 122.238 107.67 121.515C111.307 120.791 114.648 119.005 117.27 116.383C119.892 113.761 121.678 110.42 122.401 106.783C123.125 103.146 122.754 99.3758 121.334 95.9497C119.915 92.5236 117.512 89.5952 114.429 87.5349C111.345 85.4747 107.72 84.375 104.012 84.375C99.0389 84.375 94.2698 86.3504 90.7535 89.8668C87.2372 93.3831 85.2617 98.1522 85.2617 103.125ZM104.012 89.0625C106.793 89.0625 109.512 89.8872 111.824 91.4325C114.137 92.9777 115.939 95.1739 117.004 97.7435C118.068 100.313 118.347 103.141 117.804 105.868C117.261 108.596 115.922 111.102 113.955 113.069C111.989 115.035 109.483 116.375 106.755 116.917C104.027 117.46 101.2 117.181 98.6302 116.117C96.0606 115.053 93.8644 113.25 92.3192 110.938C90.774 108.625 89.9492 105.906 89.9492 103.125C89.9492 99.3954 91.4308 95.8185 94.068 93.1813C96.7053 90.5441 100.282 89.0625 104.012 89.0625Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M100.109 109.207C100.327 109.425 100.585 109.598 100.87 109.716C101.154 109.834 101.459 109.894 101.767 109.894C102.075 109.894 102.38 109.834 102.665 109.716C102.949 109.598 103.208 109.425 103.425 109.207L112.261 100.359C112.497 100.147 112.687 99.8882 112.82 99.5998C112.952 99.3114 113.025 98.9991 113.034 98.6817C113.042 98.3643 112.986 98.0485 112.868 97.7535C112.751 97.4585 112.575 97.1904 112.351 96.9655C112.127 96.7406 111.859 96.5636 111.565 96.4452C111.27 96.3268 110.955 96.2695 110.637 96.2767C110.32 96.284 110.007 96.3556 109.718 96.4874C109.429 96.6191 109.17 96.8081 108.957 97.043L101.773 104.227L98.2574 100.711C98.0438 100.476 97.7847 100.287 97.4959 100.155C97.207 100.024 96.8944 99.952 96.5769 99.9447C96.2595 99.9375 95.944 99.9948 95.6494 100.113C95.3548 100.232 95.0873 100.409 94.8632 100.633C94.6391 100.858 94.4631 101.126 94.3457 101.421C94.2283 101.716 94.1721 102.032 94.1805 102.35C94.1889 102.667 94.2616 102.979 94.3944 103.268C94.5271 103.556 94.7171 103.815 94.9527 104.027L100.109 109.207Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M101.781 46.0312H106.469C107.09 46.0312 107.686 46.2782 108.126 46.7177C108.566 47.1573 108.812 47.7534 108.812 48.375H113.5C113.5 46.5102 112.759 44.7218 111.441 43.4032C110.122 42.0845 108.334 41.3438 106.469 41.3438V39H101.781V41.3438C99.9164 41.3438 98.128 42.0845 96.8094 43.4032C95.4908 44.7218 94.75 46.5102 94.75 48.375C94.75 50.2398 95.4908 52.0282 96.8094 53.3468C98.128 54.6655 99.9164 55.4062 101.781 55.4062H106.469C107.09 55.4062 107.686 55.6532 108.126 56.0927C108.566 56.5323 108.812 57.1284 108.812 57.75C108.812 58.3716 108.566 58.9677 108.126 59.4073C107.686 59.8468 107.09 60.0938 106.469 60.0938H101.781C101.16 60.0938 100.564 59.8468 100.124 59.4073C99.6844 58.9677 99.4375 58.3716 99.4375 57.75H94.75C94.75 59.6148 95.4908 61.4032 96.8094 62.7218C98.128 64.0405 99.9164 64.7812 101.781 64.7812V67.125H106.469V64.7812C108.334 64.7812 110.122 64.0405 111.441 62.7218C112.759 61.4032 113.5 59.6148 113.5 57.75C113.5 55.8852 112.759 54.0968 111.441 52.7782C110.122 51.4595 108.334 50.7188 106.469 50.7188H101.781C101.16 50.7188 100.564 50.4718 100.124 50.0323C99.6844 49.5927 99.4375 48.9966 99.4375 48.375C99.4375 47.7534 99.6844 47.1573 100.124 46.7177C100.564 46.2782 101.16 46.0312 101.781 46.0312Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M129.406 14.0625H77.8438C75.9789 14.0625 74.1905 14.8033 72.8719 16.1219C71.5533 17.4405 70.8125 19.2289 70.8125 21.0938V71.4844C70.8125 72.106 71.0594 72.7021 71.499 73.1417C71.9385 73.5812 72.5346 73.8281 73.1562 73.8281C73.7779 73.8281 74.374 73.5812 74.8135 73.1417C75.2531 72.7021 75.5 72.106 75.5 71.4844V21.0938C75.5 20.4721 75.7469 19.876 76.1865 19.4365C76.626 18.9969 77.2221 18.75 77.8438 18.75H88.3906V21.0938C88.3906 22.9586 89.1314 24.747 90.45 26.0656C91.7686 27.3842 93.5571 28.125 95.4219 28.125H111.828C113.693 28.125 115.481 27.3842 116.8 26.0656C118.119 24.747 118.859 22.9586 118.859 21.0938V18.75H129.406C130.028 18.75 130.624 18.9969 131.064 19.4365C131.503 19.876 131.75 20.4721 131.75 21.0938V128.906C131.75 129.528 131.503 130.124 131.064 130.564C130.624 131.003 130.028 131.25 129.406 131.25H77.8438C77.2221 131.25 76.626 131.003 76.1865 130.564C75.7469 130.124 75.5 129.528 75.5 128.906V120.703C75.5 120.082 75.2531 119.485 74.8135 119.046C74.374 118.606 73.7779 118.359 73.1562 118.359C72.5346 118.359 71.9385 118.606 71.499 119.046C71.0594 119.485 70.8125 120.082 70.8125 120.703V128.906C70.8125 130.771 71.5533 132.559 72.8719 133.878C74.1905 135.197 75.9789 135.938 77.8438 135.938H129.406C131.271 135.938 133.059 135.197 134.378 133.878C135.697 132.559 136.438 130.771 136.438 128.906V21.0938C136.438 19.2289 135.697 17.4405 134.378 16.1219C133.059 14.8033 131.271 14.0625 129.406 14.0625ZM114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M114.172 21.0938C114.172 21.7154 113.925 22.3115 113.485 22.751C113.046 23.1906 112.45 23.4375 111.828 23.4375H95.4219C94.8003 23.4375 94.2041 23.1906 93.7646 22.751C93.3251 22.3115 93.0781 21.7154 93.0781 21.0938V18.75H114.172V21.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M33 54L18.5253 39.4632C17.1582 38.0903 17.1582 35.8895 18.5253 34.5368L33 20L47.4747 34.5368C48.8418 35.9097 48.8418 38.1104 47.4747 39.4632L33 54Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M75.1952 104.566C76.616 101.634 77.8223 98.6027 78.8046 95.496C79.2688 94.2563 79.4446 92.9272 79.3187 91.6095C79.1928 90.2917 78.7685 89.0199 78.078 87.8906C76.5143 85.3469 74.1161 83.425 71.2929 82.4531C71.2929 77.9062 67.203 74.8476 63.0897 72.9609C62.6754 71.2893 61.8802 69.7362 60.7662 68.4229C59.6521 67.1097 58.2495 66.0718 56.6679 65.3906C59.6561 58.2304 63.1952 49.3359 64.2499 45.5741C66.0077 39.3046 67.9764 32.9882 61.2733 30.4921C55.0155 28.1484 51.2186 35.6132 49.3788 39.1757C40.4608 56.5781 35.3163 64.7226 35.3163 64.8398C33.2304 68.2148 32.7499 68.8593 32.0585 69.0116C30.6305 66.9536 29.4097 64.7593 28.4139 62.4609C24.6874 54.8085 20.2108 51.914 15.1014 53.8124C8.97254 56.121 7.53113 62.2968 10.4257 68.4609C14.4804 77.1679 14.0116 88.6171 13.0155 98.0859C12.4061 104.086 13.8944 108.797 17.4686 112.148C17.2487 113.265 16.9271 114.36 16.5077 115.418C16.362 115.794 16.3157 116.201 16.3734 116.6C16.4312 116.999 16.5909 117.377 16.8371 117.696C17.0834 118.015 17.4079 118.266 17.7792 118.423C18.1506 118.58 18.5562 118.639 18.9569 118.594C24.1344 118.222 29.3311 118.974 34.1913 120.797C40.1103 123.25 45.5283 126.769 50.1757 131.18C50.4142 131.413 50.6999 131.593 51.0136 131.707C51.3273 131.822 51.6617 131.867 51.9946 131.842C52.3274 131.816 52.651 131.72 52.9436 131.559C53.2362 131.399 53.4911 131.177 53.6913 130.91C57.91 125.051 55.9179 127.066 58.871 124.512C66.1014 118.254 70.953 113.226 75.1366 104.59L75.1952 104.566ZM74.0233 90.2929C74.3695 90.8462 74.5779 91.4744 74.6309 92.1249C74.6839 92.7754 74.5801 93.4292 74.328 94.0312C73.417 96.9027 72.3048 99.7065 70.9999 102.422C70.5899 103.01 69.9863 103.436 69.2944 103.624C68.6026 103.813 67.8665 103.752 67.2147 103.453C66.5652 103.098 66.0089 102.595 65.5913 101.984C65.1738 101.373 64.9068 100.671 64.8124 99.9374C65.7474 98.9128 66.4792 97.7197 66.9686 96.4218C68.328 92.7656 69.5116 90.2812 70.4257 87.2812C71.9007 87.9 73.1546 88.9497 74.0233 90.2929ZM66.4296 81.457C67.0155 82.6288 66.16 85.289 65.5741 87.082C65.1522 88.3827 63.7811 91.4882 62.6093 94.7109C61.953 96.4804 60.5936 98.0976 58.7186 97.8749C57.9519 97.7407 57.2341 97.4068 56.6375 96.9069C56.0409 96.407 55.5865 95.7587 55.3202 95.0273C56.2584 94.1776 56.9814 93.1173 57.4296 91.9335C62.8436 78.3046 62.6093 78.7734 62.8436 78.164C64.3354 78.8872 65.5822 80.0321 66.4296 81.457ZM58.0155 72.7968C59.7968 76.1718 57.3358 78.4452 53.0585 90.2343C52.3554 91.9921 51.2069 92.3788 49.7772 91.6874C48.9803 91.1879 48.3647 90.4459 48.0209 89.5705C47.677 88.6951 47.6231 87.7325 47.8671 86.8241C49.0389 82.8398 53.8436 72.0351 54.7929 69.7968C56.1697 70.4123 57.3032 71.4675 58.0155 72.7968ZM55.8475 120.914C52.6132 123.715 53.5741 122.93 51.4647 125.965C46.8392 121.93 41.5764 118.691 35.8905 116.379C31.4283 114.691 26.7038 113.803 21.9335 113.754C22.7069 110.355 21.6639 109.5 21.1014 109.066C18.3124 106.723 17.1991 103.348 17.6796 98.5898C18.746 88.3945 19.2499 76.1718 14.6796 66.4921C13.0975 63.0937 13.0975 59.5781 16.6483 58.289C17.6561 57.9023 20.3632 56.8945 24.1132 64.5937C25.9647 68.4257 26.0819 68.1093 30.7811 78.996C31.045 79.5379 31.5074 79.9573 32.0724 80.1671C32.6375 80.3769 33.2616 80.361 33.8151 80.1227C34.3687 79.8844 34.8092 79.442 35.0451 78.8873C35.281 78.3327 35.2942 77.7085 35.0819 77.1445C35.0233 76.9921 34.3554 75.457 33.4999 73.5116C35.8436 72.7968 37.0155 70.8632 39.2069 67.3827C39.2772 67.2656 44.5624 58.8398 53.5038 41.4023C56.1639 36.2226 57.9218 34.371 59.5975 34.9687C62.41 36.0234 61.203 38.9882 59.6913 44.3437C58.3202 49.2187 52.203 64.0077 49.3788 70.4648C47.7499 74.2148 44.3983 82.1835 43.3905 85.3945C42.8008 87.3744 42.9112 89.497 43.7031 91.4052C44.4949 93.3133 45.9199 94.8904 47.7382 95.871C48.7243 96.3422 49.7981 96.6017 50.8905 96.6327C51.4565 98.1807 52.4346 99.5447 53.7192 100.577C55.0038 101.61 56.5461 102.272 58.1796 102.492C58.9939 102.593 59.8197 102.545 60.6171 102.351C61.0027 103.508 61.6162 104.576 62.4213 105.492C63.2263 106.408 64.2067 107.153 65.3046 107.684C66.0485 108.014 66.8391 108.228 67.6483 108.316C64.3203 113.044 60.3483 117.285 55.8475 120.914Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M34.4844 33.0938V19.5586C34.4844 18.937 34.2374 18.3409 33.7979 17.9013C33.3584 17.4618 32.7622 17.2148 32.1406 17.2148C31.519 17.2148 30.9229 17.4618 30.4833 17.9013C30.0438 18.3409 29.7969 18.937 29.7969 19.5586V33.0938C29.7969 33.7154 30.0438 34.3115 30.4833 34.751C30.9229 35.1906 31.519 35.4375 32.1406 35.4375C32.7622 35.4375 33.3584 35.1906 33.7979 34.751C34.2374 34.3115 34.4844 33.7154 34.4844 33.0938Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M42.0895 37.8866L50.8903 28.0194C51.095 27.7886 51.2522 27.5197 51.3529 27.2281C51.4537 26.9365 51.496 26.6279 51.4775 26.32C51.459 26.012 51.3801 25.7107 51.2451 25.4333C51.1102 25.1559 50.9219 24.9077 50.6911 24.703C50.4602 24.4984 50.1913 24.3412 49.8998 24.2404C49.6082 24.1396 49.2996 24.0973 48.9916 24.1158C48.6837 24.1343 48.3824 24.2133 48.1049 24.3482C47.8275 24.4832 47.5794 24.6714 47.3747 24.9023L38.5856 34.7694C38.1722 35.2356 37.961 35.847 37.9984 36.4689C38.0357 37.0909 38.3186 37.6725 38.7848 38.0859C39.251 38.4992 39.8623 38.7105 40.4843 38.6731C41.1062 38.6357 41.6879 38.3528 42.1012 37.8866H42.0895Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M25.4958 38.0741C25.9581 37.6603 26.2375 37.08 26.2726 36.4606C26.3078 35.8411 26.0958 35.2329 25.6833 34.7695L16.9059 24.9023C16.4926 24.4361 15.9109 24.1532 15.289 24.1158C14.667 24.0784 14.0557 24.2897 13.5895 24.703C13.1233 25.1164 12.8404 25.698 12.8031 26.32C12.7657 26.9419 12.9769 27.5532 13.3903 28.0194L22.1794 37.8866C22.3844 38.1173 22.633 38.3052 22.9109 38.4395C23.1888 38.5738 23.4905 38.6519 23.7986 38.6693C24.1068 38.6868 24.4153 38.6431 24.7066 38.541C24.9978 38.4389 25.266 38.2802 25.4958 38.0741Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Easy and Complete"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-4",
                            children: "\uEA08"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "all-you-need-in-your",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "id-diamond-down highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1233 6.67194L0.00488281 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-wrapper highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-wrapper-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                paddingTop: 15,
                                marginLeft: 12
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 21,
                                height: 13,
                                viewBox: "0 0 21 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M13.8545 12L19.1834 6.67105L13.8545 1.34211",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1184 6.67047L0 6.67047",
                                        stroke: "#353FDF",
                                        strokeWidth: 1.77632
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18.1235 6.67194L0.00512695 6.67194",
                                        stroke: "white",
                                        strokeWidth: 1.77632
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "img-slider-dots",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "slider-dots-instance",
                            status: "off"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDots.SliderDots), {
                            className: "design-component-instance-node",
                            status: "on"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-2"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"1NcYL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/SliderDots":"gfhZb","../../../../../hooks/useDynamicColors":"b2GRH"}],"1NcYL":[function() {},{}],"6Ddn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcomeRegional", ()=>(0, _corporativoOnboardingWelcomeRegional.CorporativoOnboardingWelcomeRegional));
var _corporativoOnboardingWelcomeRegional = require("./CorporativoOnboardingWelcomeRegional");

},{"./CorporativoOnboardingWelcomeRegional":"ifc9f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ifc9f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingWelcomeRegional", ()=>CorporativoOnboardingWelcomeRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _testButton = require("../../../../../components/TestButton");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingWelcomeRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-landing-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-screen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: 344,
                                height: 854,
                                viewBox: "0 0 344 854",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M174.109 -227.127L-198.021 -66.7389C-255.171 -42.1073 -281.532 24.1897 -256.901 81.3396L-96.5124 453.47L275.618 293.082C332.768 268.45 359.129 202.153 334.498 145.003L174.109 -227.127Z",
                                    fill: colors.cuaternario
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-1",
                            style: {
                                marginTop: -40
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: 129,
                                height: 130,
                                viewBox: "0 0 129 130",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 28.5,
                                        cy: 108,
                                        r: 22,
                                        fill: colors.sexto
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M109.38 84.5799C109.415 83.6859 109.267 82.7942 108.943 81.9599C108.62 81.1257 108.129 80.3667 107.5 79.7299C105.43 77.7299 101.84 76.8699 95.5002 76.9899C88.9738 77.2737 82.4885 78.171 76.1302 79.6699C72.1334 80.5412 68.1929 81.6533 64.3302 82.9999C61.3302 83.9999 59.2602 84.7099 56.8502 84.7099H56.7602C55.988 84.7516 55.2175 84.5997 54.5189 84.2679C53.8204 83.936 53.2158 83.4349 52.7602 82.8099C52.3251 82.1192 52.0657 81.3325 52.0047 80.5184C51.9437 79.7044 52.0829 78.8877 52.4102 78.1399C54.0075 73.7814 54.6188 69.123 54.2002 64.4999C53.5402 58.0499 50.3302 54.3399 45.3802 54.2999C44.6068 54.2524 43.8321 54.3686 43.1067 54.6409C42.3813 54.9131 41.7214 55.3353 41.1702 55.8799C39.3602 57.7599 39.3302 60.6199 39.4602 63.6299C39.5702 66.3699 36.5902 69.1599 34.8102 70.8299C30.8102 74.6099 27.7302 80.1299 27.0602 84.8899C26.9602 85.5999 26.8902 86.2499 26.8202 86.8899C26.8063 87.9491 26.5855 88.9954 26.1702 89.9699C24.1746 91.7691 22.0742 93.4487 19.8802 94.9999C19.6679 95.1569 19.4888 95.3544 19.3532 95.5809C19.2176 95.8075 19.1283 96.0586 19.0902 96.3199C19.0902 96.5699 18.2802 102.46 24.2402 110.03C28.5102 115.46 34.6102 117.91 38.5402 117.91H38.6802C39.269 117.965 39.8625 117.879 40.4118 117.66C40.9611 117.441 41.4506 117.095 41.8402 116.65C42.8402 115.26 46.7102 111.06 48.2402 110.24C52.1102 108.15 56.0102 106.24 59.5202 104.69C67.8202 104.53 89.0102 104.39 93.8102 105.58C94.6146 105.782 95.4409 105.882 96.2702 105.88C99.8802 105.88 103.64 104.07 104.8 100.39C105.198 99.3389 105.369 98.2161 105.304 97.0944C105.238 95.9728 104.937 94.8775 104.42 93.8799C104.039 93.2041 103.553 92.5931 102.98 92.0699C108.13 90.3499 109.36 87.1699 109.38 84.5799ZM100.99 99.1899C100.29 101.4 97.1502 102.29 94.7802 101.7C90.8402 100.7 78.6502 100.56 69.5802 100.59L70.5202 100.24C79.0683 96.9923 87.9385 94.6658 96.9802 93.2999C98.9802 93.8799 100.32 94.7399 100.91 95.8099C101.154 96.338 101.286 96.9103 101.3 97.4916C101.314 98.0729 101.208 98.6509 100.99 99.1899ZM98.8302 88.9999C82.7602 91.4599 74.2302 94.6399 69.1302 96.5399L67.6202 96.9999C60.3156 99.7404 53.2059 102.975 46.3402 106.68C44.0102 107.93 40.1402 112.35 38.9102 113.87C37.2802 114.1 31.5202 112.79 27.3802 107.52C23.6702 102.81 23.1002 99.1199 23.0402 97.6099C24.9202 96.1999 28.4802 93.4699 29.3502 92.3499C30.3502 90.9999 30.5802 89.3499 30.8202 87.2699C30.8802 86.7099 30.9502 86.0999 31.0402 85.4299C31.5902 81.5699 34.2102 76.8699 37.5702 73.7299C39.7002 71.7299 43.6702 68.0099 43.4702 63.4399C43.4102 62.0399 43.3002 59.4399 44.0702 58.6399C44.1602 58.5499 44.4202 58.2799 45.3402 58.2799C48.1302 58.2799 49.7702 60.5199 50.2102 64.8899C50.5909 68.903 50.0751 72.9505 48.7002 76.7399C48.1404 78.091 47.9206 79.5588 48.0601 81.0145C48.1996 82.4703 48.6941 83.8697 49.5002 85.0899C50.3193 86.2452 51.4099 87.1814 52.6759 87.8161C53.9419 88.4508 55.3445 88.7646 56.7602 88.7299C59.8802 88.7299 62.2902 87.9399 65.6302 86.8199C69.38 85.5055 73.2073 84.4234 77.0902 83.5799C83.1849 82.1356 89.4027 81.2718 95.6602 80.9999C100.52 80.9099 103.56 81.4399 104.72 82.5899C104.971 82.854 105.16 83.1703 105.274 83.516C105.388 83.8618 105.424 84.2285 105.38 84.5899C105.37 85.3899 105.35 87.9999 98.8302 88.9999Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M38.2202 44C38.3702 44 53.6402 46.28 59.9402 52.58C66.2402 58.88 68.5002 74.13 68.5002 74.28C68.5002 74.8104 68.7109 75.3191 69.086 75.6942C69.4611 76.0693 69.9698 76.28 70.5002 76.28C71.0306 76.28 71.5394 76.0693 71.9144 75.6942C72.2895 75.3191 72.5002 74.8104 72.5002 74.28C72.5002 74.13 74.7802 58.86 81.0802 52.56C87.3802 46.26 102.63 44 102.78 44C103.311 44 103.819 43.7893 104.194 43.4142C104.57 43.0391 104.78 42.5304 104.78 42C104.78 41.4695 104.57 40.9608 104.194 40.5858C103.819 40.2107 103.311 40 102.78 40C102.63 40 87.3602 37.72 81.0602 31.42C74.7602 25.12 72.5002 9.86997 72.5002 9.71997C72.5002 9.18954 72.2895 8.68083 71.9144 8.30576C71.5394 7.93068 71.0306 7.71997 70.5002 7.71997C69.9698 7.71997 69.4611 7.93068 69.086 8.30576C68.7109 8.68083 68.5002 9.18954 68.5002 9.71997C68.5002 9.86997 66.2202 25.14 59.9202 31.44C53.6202 37.74 38.3702 40 38.2202 40C37.6898 40 37.1811 40.2107 36.806 40.5858C36.4309 40.9608 36.2202 41.4695 36.2202 42C36.2202 42.5304 36.4309 43.0391 36.806 43.4142C37.1811 43.7893 37.6898 44 38.2202 44ZM62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M62.7702 34.29C66.5502 30.51 69.0102 24.29 70.5002 19.18C71.9902 24.32 74.5002 30.51 78.2302 34.29C81.9602 38.07 88.2302 40.53 93.3402 42.02C88.1902 43.51 82.0102 46.02 78.2302 49.75C74.4502 53.48 71.9902 59.7 70.5002 64.84C69.0102 59.7 66.5002 53.51 62.7702 49.73C59.0402 45.95 52.7702 43.49 47.6602 42C52.8102 40.51 58.9902 38.05 62.7702 34.27V34.29Z",
                                        fill: colors.septimo
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M88.4999 26C89.0295 25.9978 89.5366 25.7856 89.9099 25.41L93.9099 21.41C94.2376 21.0274 94.4088 20.5353 94.3893 20.0319C94.3699 19.5286 94.1612 19.0511 93.805 18.6949C93.4488 18.3387 92.9714 18.1301 92.468 18.1106C91.9647 18.0912 91.4725 18.2624 91.0899 18.59L87.0899 22.59C86.8119 22.8697 86.6228 23.2253 86.5463 23.6122C86.4698 23.999 86.5094 24.3999 86.6601 24.7643C86.8108 25.1287 87.0658 25.4404 87.3932 25.6603C87.7205 25.8802 88.1056 25.9984 88.4999 26Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M87.0899 58.5899C86.7174 58.9646 86.5083 59.4715 86.5083 59.9999C86.5083 60.5283 86.7174 61.0352 87.0899 61.4099L91.0899 65.4099C91.4725 65.7375 91.9646 65.9087 92.468 65.8893C92.9713 65.8699 93.4488 65.6612 93.805 65.305C94.1612 64.9488 94.3699 64.4713 94.3893 63.968C94.4087 63.4646 94.2375 62.9725 93.9099 62.5899L89.9099 58.5899C89.5352 58.2174 89.0283 58.0083 88.4999 58.0083C87.9715 58.0083 87.4646 58.2174 87.0899 58.5899Z",
                                        fill: colors.primario
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M51.0898 25.41C51.4724 25.7377 51.9646 25.9089 52.4679 25.8895C52.9713 25.87 53.4487 25.6614 53.8049 25.3052C54.1611 24.949 54.3698 24.4715 54.3892 23.9682C54.4087 23.4648 54.2375 22.9726 53.9098 22.59L49.9098 18.59C49.5272 18.2624 49.035 18.0912 48.5317 18.1106C48.0283 18.1301 47.5509 18.3387 47.1947 18.6949C46.8385 19.0511 46.6298 19.5286 46.6104 20.0319C46.5909 20.5353 46.7621 21.0274 47.0898 21.41L51.0898 25.41Z",
                                        fill: colors.primario
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "easy-accesible-2",
                            children: " Your account has been opened"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "all-you-need-in-your",
                    children: "Enjoy all the benefits of our App"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2",
                    onClick: handleButtonClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "highlighted-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testButton.TestButton), {
                            className: "test-button-4 highlighted-button",
                            disabled: "off",
                            endIcon: false,
                            label: "Let\u2019s start!",
                            onColor: "off",
                            size: "large",
                            startIcon: false,
                            textClassName: "test-button-5",
                            type: "primary"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"kWyRx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/TestButton":"7GP6t","../../../../../hooks/useDynamicColors":"b2GRH"}],"kWyRx":[function() {},{}],"9QovJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepperRegional", ()=>(0, _corporativoOnboardingStepperRegional.CorporativoOnboardingStepperRegional));
var _corporativoOnboardingStepperRegional = require("./CorporativoOnboardingStepperRegional");

},{"./CorporativoOnboardingStepperRegional":"hCNKw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hCNKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingStepperRegional", ()=>CorporativoOnboardingStepperRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingStepperRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_card_id-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "corporativo-stepper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Open account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "battery",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "capacity-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "capacity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "cap",
                                                alt: "Cap",
                                                src: "/img/cap-2.svg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "wifi",
                                        alt: "Wifi",
                                        src: "/img/wifi.svg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "cellular-connection",
                                        alt: "Cellular connection",
                                        src: "/img/cellular-connection.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "navs-statusbar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7",
                                        children: "9:50"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons",
                                        alt: "Icons",
                                        src: "/img/icons-6.svg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                            className: "header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-4",
                                        children: "Terms and Conditions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "rectangle-4"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 180,
                                                            height: 170,
                                                            viewBox: "0 0 200 190",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.1
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.05
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.2
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.15
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.25
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.3
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.55
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.75
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.35
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.65
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.6
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.45
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.5
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.7
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.8
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                                    fill: "#F2F3F7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                                    fill: "#F2F3F7",
                                                                    fillOpacity: 0.9
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 72,
                            height: 72,
                            viewBox: "0 0 72 72",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.5 72L38.893 59.6009C37.7023 58.4299 37.7023 56.5528 38.893 55.399L51.5 43L64.107 55.399C65.2977 56.5701 65.2977 58.4471 64.107 59.6009L51.5 72Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M51.75 66.9375H20.25C18.609 66.9375 17.0352 66.2856 15.8748 65.1252C14.7144 63.9648 14.0625 62.391 14.0625 60.75V18C14.0625 16.359 14.7144 14.7852 15.8748 13.6248C17.0352 12.4644 18.609 11.8125 20.25 11.8125H23.0625V11.25C23.0625 9.60897 23.7144 8.03516 24.8748 6.87478C26.0352 5.7144 27.609 5.0625 29.25 5.0625C30.8874 5.07428 32.4544 5.72996 33.6122 6.8878C34.77 8.04563 35.4257 9.61261 35.4375 11.25V11.8125H43.1325C43.948 11.811 44.7557 11.9713 45.5089 12.2841C46.262 12.597 46.9456 13.0561 47.52 13.635L56.115 22.23C56.6939 22.8044 57.153 23.488 57.4659 24.2411C57.7787 24.9943 57.939 25.802 57.9375 26.6175V60.75C57.9375 62.391 57.2856 63.9648 56.1252 65.1252C54.9648 66.2856 53.391 66.9375 51.75 66.9375ZM20.25 15.1875C19.5041 15.1875 18.7887 15.4838 18.2613 16.0113C17.7338 16.5387 17.4375 17.2541 17.4375 18V60.75C17.4375 61.4959 17.7338 62.2113 18.2613 62.7387C18.7887 63.2662 19.5041 63.5625 20.25 63.5625H51.75C52.4959 63.5625 53.2113 63.2662 53.7387 62.7387C54.2662 62.2113 54.5625 61.4959 54.5625 60.75V28.6875H45C43.9575 28.6816 42.9594 28.2649 42.2223 27.5277C41.4851 26.7906 41.0684 25.7925 41.0625 24.75V15.1875H35.4375V20.25C35.4375 21.891 34.7856 23.4648 33.6252 24.6252C32.4648 25.7856 30.891 26.4375 29.25 26.4375C27.609 26.4375 26.0352 25.7856 24.8748 24.6252C23.7144 23.4648 23.0625 21.891 23.0625 20.25C23.0625 19.8024 23.2403 19.3732 23.5568 19.0568C23.8732 18.7403 24.3024 18.5625 24.75 18.5625C25.1976 18.5625 25.6268 18.7403 25.9432 19.0568C26.2597 19.3732 26.4375 19.8024 26.4375 20.25C26.4375 20.9959 26.7338 21.7113 27.2613 22.2387C27.7887 22.7662 28.5041 23.0625 29.25 23.0625C29.9959 23.0625 30.7113 22.7662 31.2387 22.2387C31.7662 21.7113 32.0625 20.9959 32.0625 20.25V15.1875H20.25ZM44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025ZM26.4375 11.8125H32.0625V11.25C32.0651 10.8861 31.9948 10.5254 31.8557 10.1892C31.7166 9.85301 31.5115 9.5481 31.2525 9.2925C30.8663 8.88491 30.3661 8.60333 29.8173 8.48457C29.2685 8.36582 28.6967 8.41541 28.1765 8.62688C27.6563 8.83834 27.2121 9.20184 26.9018 9.66983C26.5916 10.1378 26.4297 10.6886 26.4375 11.25V11.8125ZM47.25 55.6875H24.75C24.3024 55.6875 23.8732 55.5097 23.5568 55.1932C23.2403 54.8768 23.0625 54.4476 23.0625 54C23.0625 53.5524 23.2403 53.1232 23.5568 52.8068C23.8732 52.4903 24.3024 52.3125 24.75 52.3125H47.25C47.6976 52.3125 48.1268 52.4903 48.4432 52.8068C48.7597 53.1232 48.9375 53.5524 48.9375 54C48.9375 54.4476 48.7597 54.8768 48.4432 55.1932C48.1268 55.5097 47.6976 55.6875 47.25 55.6875ZM47.25 46.6875H24.75C24.3024 46.6875 23.8732 46.5097 23.5568 46.1932C23.2403 45.8768 23.0625 45.4476 23.0625 45C23.0625 44.5524 23.2403 44.1232 23.5568 43.8068C23.8732 43.4903 24.3024 43.3125 24.75 43.3125H47.25C47.6976 43.3125 48.1268 43.4903 48.4432 43.8068C48.7597 44.1232 48.9375 44.5524 48.9375 45C48.9375 45.4476 48.7597 45.8768 48.4432 46.1932C48.1268 46.5097 47.6976 46.6875 47.25 46.6875ZM33.75 37.6875H24.75C24.3024 37.6875 23.8732 37.5097 23.5568 37.1932C23.2403 36.8768 23.0625 36.4476 23.0625 36C23.0625 35.5524 23.2403 35.1232 23.5568 34.8068C23.8732 34.4903 24.3024 34.3125 24.75 34.3125H33.75C34.1976 34.3125 34.6268 34.4903 34.9432 34.8068C35.2597 35.1232 35.4375 35.5524 35.4375 36C35.4375 36.4476 35.2597 36.8768 34.9432 37.1932C34.6268 37.5097 34.1976 37.6875 33.75 37.6875Z",
                                    fill: colors.primario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M44.4375 15.5025V24.75C44.4375 24.8992 44.4968 25.0423 44.6023 25.1477C44.7077 25.2532 44.8508 25.3125 45 25.3125H54.2475C54.1027 25.0607 53.929 24.8266 53.73 24.615L45.135 16.02C44.9277 15.8159 44.6929 15.6417 44.4375 15.5025Z",
                                    fill: colors.sexto
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subtitle-5",
                            children: "Welcome!"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "subtitle-6",
                            children: "Let\u2019s open your online account"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Accept Terms and Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Register your Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-7",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Scan your ID card"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: " Validate your identity"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "subtitle-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-7",
                                                children: "Register your Mobile number"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-9",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "subtitle-8",
                                                children: "Generate your credentials"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"fjHX2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"fjHX2":[function() {},{}],"khQcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardIdRegional", ()=>(0, _corporativoOnboardingCardIdRegional.CorporativoOnboardingCardIdRegional));
var _corporativoOnboardingCardIdRegional = require("./CorporativoOnboardingCardIdRegional");

},{"./CorporativoOnboardingCardIdRegional":"gvY8v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvY8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingCardIdRegional", ()=>CorporativoOnboardingCardIdRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _iconChevronDown1 = require("../../../../../icons/IconChevronDown1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingCardIdRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickLogin = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_phone-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-4",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-13",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line-3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-14",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-4"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "element-3",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-7",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb-6",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-3",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 98,
                            height: 73,
                            viewBox: "0 0 98 73",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-13",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-14",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-15",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "subtitle-11",
                                            children: "Now, get your ID card"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "subtitle-12",
                                        children: [
                                            "We will take a photo of the front & back.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Photos will be captured automatically."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "e-mail",
                                    children: "Country"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-16",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-17",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-wrapper-15",
                                                children: "Select your country"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconChevronDown1.IconChevronDown1), {
                                                className: "icon-chevron-down",
                                                color: "#5C5C5C"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-4 highlighted-button",
                        onClick: handleButtonClickLogin,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-wrapper-16",
                            children: "I\xb4ve got my ID card!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-9",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-18",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-1-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1-instance"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-13",
                                        children: "Scan ID Card"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-13",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-14",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-5",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-6"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-19",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"4hxV3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../icons/IconChevronDown1":"ccPWd","../../../../../hooks/useDynamicColors":"b2GRH"}],"4hxV3":[function() {},{}],"N32jz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhoneRegional", ()=>(0, _corporativoOnboardingPhoneRegional.CorporativoOnboardingPhoneRegional));
var _corporativoOnboardingPhoneRegional = require("./CorporativoOnboardingPhoneRegional");

},{"./CorporativoOnboardingPhoneRegional":"ivCBt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ivCBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoOnboardingPhoneRegional", ()=>CorporativoOnboardingPhoneRegional);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _componenteToken = require("../../../../../components/ComponenteToken");
var _iconArrowBack1 = require("../../../../../icons/IconArrowBack1");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoOnboardingPhoneRegional = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/regional_retail-onboarding_welcome-corporativo-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "screen-coporativo-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "corporativo-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "molecula-stepper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "numb",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-8",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-9",
                                            children: "4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "div-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "div-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "numb-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-wrapper-10",
                                            children: "5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "line-2"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "atomo-step-final-no",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content-5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "element-2",
                                        children: "6"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: 65,
                            height: 87,
                            viewBox: "0 0 65 87",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z",
                                    fill: colors.septimo
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z",
                                    fill: colors.sexto
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z",
                                    fill: colors.secundario
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z",
                                    fill: colors.secundario
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "subtitle-9",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "span",
                                            children: [
                                                "A validation code has been sent to\xa0\xa0",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-wrapper-11",
                                            children: "+54 9 1122 6476"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componenteToken.ComponenteToken), {
                            active: false,
                            atomoTimeRectangleClassName: "componente-token-5",
                            atomoTimeSubtitleCopyClassName: "componente-token-3",
                            atomoTimeSubtitleCopyClassNameOverride: "componente-token-3",
                            atomoTimeTimelineClassName: "componente-token-4",
                            buttonActive: true,
                            buttonInactive: false,
                            buttonSmallEstado: "inactivo",
                            buttonSmallTextClassName: "componente-token-6",
                            buttonSmallTexto: "Resend code",
                            className: "componente-token-input",
                            default1: true,
                            error: false,
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName1: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassName2: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride: "componente-token-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride: "componente-token-input-instance",
                            moleculaTokenNumbsAtomoNumbTokenText: "8",
                            moleculaTokenNumbsAtomoNumbTokenText1: "4",
                            moleculaTokenNumbsAtomoNumbTokenText2: "9",
                            moleculaTokenNumbsAtomoNumbTokenText3: "6",
                            moleculaTokenNumbsDefaultFalseActiveClassName: "componente-token-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "action-buttons-2 highlighted-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-3 ",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-12",
                            children: "Validate"
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                    className: "header-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-10",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "rectangle-5"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-10",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: 180,
                                                    height: 170,
                                                    viewBox: "0 0 200 190",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.05
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.2
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.15
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.25
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.55
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.75
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.35
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.65
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.45
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z",
                                                            fill: "#F2F3F7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z",
                                                            fill: "#F2F3F7",
                                                            fillOpacity: 0.9
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-arrow-back-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconArrowBack1.IconArrowBack1), {
                                            className: "icon-arrow-back-1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle-10",
                                        children: "Register Mobile number"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"1Fv75","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../components/ComponenteToken":"1K7Wn","../../../../../icons/IconArrowBack1":"cdwRy","../../../../../hooks/useDynamicColors":"b2GRH"}],"1Fv75":[function() {},{}],"iXtDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CorporativoLoginDashboard", ()=>CorporativoLoginDashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const CorporativoLoginDashboard = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const [username, setUsername] = (0, _react.useState)("");
    const [password, setPassword] = (0, _react.useState)("");
    const [rememberMe, setRememberMe] = (0, _react.useState)(false);
    const [showPassword, setShowPassword] = (0, _react.useState)(false);
    const styles = {
        laptop: {
            marginTop: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#333",
            borderRadius: "15px 15px 5px 5px",
            padding: "10px",
            width: "960px",
            position: "relative",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
        },
        screen: {
            backgroundColor: "white",
            borderRadius: "5px",
            overflow: "hidden",
            width: "100%",
            height: "500px"
        },
        container: {
            display: "flex",
            height: "100%"
        },
        leftContainer: {
            flex: 1,
            background: `linear-gradient(to right,${colors.primario}, ${colors.secundario})`,
            color: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        title: {
            fontSize: "1rem",
            fontFamily: "Inter",
            fontWeight: "600",
            textAlign: "center",
            marginBottom: "20px"
        },
        rightContainer: {
            flex: 1,
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px"
        },
        subtitle: {
            fontSize: "0.9rem",
            color: `${colors.primario}`,
            fontFamily: "Inter",
            fontWeight: "600",
            marginBottom: "20px"
        },
        inputGroup: {
            marginBottom: "20px",
            width: "80%"
        },
        label: {
            fontSize: "0.8rem",
            color: `${colors.primario}`,
            fontFamily: "Inter",
            fontWeight: "600",
            marginBottom: "8px"
        },
        input: {
            width: "100%",
            padding: "8px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "0.9rem"
        },
        passwordContainer: {
            display: "flex",
            position: "relative",
            alignItems: "center"
        },
        eyeButton: {
            background: "none",
            border: "none",
            position: "absolute",
            right: "20px",
            fontSize: "1.2rem",
            cursor: "pointer"
        },
        rememberMeContainer: {
            display: "flex",
            alignItems: "center",
            marginBottom: "20px"
        },
        rememberMeLabel: {
            fontSize: "1rem",
            color: "gray",
            marginRight: "10px"
        },
        loginButton: {
            backgroundColor: colors.secundario,
            color: "white",
            padding: "10px 60px",
            border: "none",
            borderRadius: "4px",
            fontFamily: "Inter",
            cursor: "pointer",
            fontSize: "1rem"
        },
        base: {
            position: "absolute",
            width: "1100px",
            height: "20px",
            backgroundColor: "rgb(170, 170, 170)",
            borderRadius: "0px 0px 10px 10px",
            bottom: 0
        }
    };
    const handleLogin = ()=>{
        const currentParams = location.search;
        navigate(`/backoffice-users-corporativo-web${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: styles.laptop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: styles.screen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.container,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                position: "absolute",
                                right: 20,
                                top: 20,
                                display: "flex",
                                gap: "8px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: "https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us",
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: "/img/espana.png",
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: "/img/portugal.png",
                                    height: 20,
                                    width: 20
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.leftContainer,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    style: styles.title,
                                    children: "Welcome to VXApp Dashboard!"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: colors.url_logo ?? "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png",
                                    alt: "Logo",
                                    style: {
                                        width: 120,
                                        height: "auto",
                                        borderRadius: 8,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        backgroundSize: "contain",
                                        backgroundColor: "transparent"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.rightContainer,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    style: styles.subtitle,
                                    children: "Please, enter your personal information to begin"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.inputGroup,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: styles.label,
                                            children: "Username"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: username,
                                            onChange: (e)=>setUsername(e.target.value),
                                            style: styles.input
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.inputGroup,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: styles.label,
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: styles.passwordContainer,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: showPassword ? "text" : "password",
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    style: styles.input
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        ...styles.eyeButton,
                                                        background: "transparent"
                                                    },
                                                    onClick: ()=>setShowPassword(!showPassword),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        width: 25,
                                                        height: 25,
                                                        viewBox: "0 0 25 25",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                                clipPath: "url(#clip0_4801_27552)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M2.12598 12.6537C2.12598 12.6537 6.12598 4.65369 13.126 4.65369C20.126 4.65369 24.126 12.6537 24.126 12.6537C24.126 12.6537 20.126 20.6537 13.126 20.6537C6.12598 20.6537 2.12598 12.6537 2.12598 12.6537Z",
                                                                        stroke: colors.secundario,
                                                                        strokeWidth: 2,
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M13.126 15.6537C14.7828 15.6537 16.126 14.3105 16.126 12.6537C16.126 10.9968 14.7828 9.65369 13.126 9.65369C11.4691 9.65369 10.126 10.9968 10.126 12.6537C10.126 14.3105 11.4691 15.6537 13.126 15.6537Z",
                                                                        stroke: colors.secundario,
                                                                        strokeWidth: 2,
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                                                                    id: "clip0_4801_27552",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                        width: 24,
                                                                        height: 24,
                                                                        fill: "white",
                                                                        transform: "translate(0.938721 0.557495)"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.rememberMeContainer,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            style: styles.rememberMeLabel,
                                            children: "Remember me"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: rememberMe,
                                            onChange: ()=>setRememberMe(!rememberMe)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: handleLogin,
                                    style: styles.loginButton,
                                    className: "highlighted-button ",
                                    children: "Log In"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: styles.base
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./style.css":"j00JZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb","../../../../../hooks/useDynamicColors":"b2GRH"}],"j00JZ":[function() {},{}],"j4NfX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkanId1VisaMobile", ()=>SkanId1VisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const SkanId1VisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [selectedCountry, setSelectedCountry] = (0, _react.useState)("United States");
    const countries = [
        "United States",
        "Canada",
        "Mexico",
        "Argentina",
        "Brazil",
        "Chile",
        "Colombia",
        "Peru",
        "United Kingdom",
        "Germany",
        "France",
        "Italy",
        "Spain",
        "Portugal",
        "Netherlands",
        "Australia",
        "New Zealand",
        "India",
        "China",
        "Japan",
        "South Korea",
        "South Africa",
        "Egypt",
        "Nigeria",
        "Russia",
        "Ukraine",
        "Poland",
        "Sweden",
        "Norway",
        "Denmark",
        "Finland",
        "Turkey",
        "Saudi Arabia",
        "United Arab Emirates",
        "Pakistan",
        "Bangladesh",
        "Vietnam",
        "Thailand",
        "Philippines",
        "Indonesia",
        "Malaysia",
        "Singapore",
        "Israel",
        "Switzerland",
        "Austria",
        "Belgium",
        "Ireland",
        "Czech Republic",
        "Greece",
        "Hungary",
        "Romania",
        "Slovakia",
        "Croatia",
        "Morocco",
        "Algeria",
        "Kenya",
        "Ethiopia"
    ];
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_skan_id_02-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #333333",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        containerPhone: {
            width: "100%",
            margin: "0 auto",
            fontFamily: "sans-serif",
            padding: "20px"
        },
        description: {
            fontSize: "15px",
            color: "#333",
            marginBottom: "20px",
            lineHeight: "1.5"
        },
        label: {
            display: "block",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "12px",
            color: "#111"
        },
        select: {
            width: "100%",
            padding: "12px",
            fontSize: "16px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            backgroundColor: "#fff"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        containerStep: {
            display: "flex",
            alignItems: "baseline",
            fontFamily: "sans-serif"
        },
        current: {
            color: colors.primario,
            fontSize: "40px",
            fontWeight: "bold"
        },
        separator: {
            margin: "0 2px",
            color: "#959699",
            fontSize: "18px"
        },
        total: {
            color: "#959699",
            fontSize: "18px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        container: {
            display: "flex",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box",
            alignItems: "center",
            margin: "16px 0 8px 0"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            height: "160px",
            width: "90%",
            borderBottom: "1px solid #E7E7E7"
        },
        title: {
            fontSize: "18px",
            marginBottom: "20px",
            color: "#333"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            width: "90%",
            marginBottom: "40px"
        },
        checkbox: {
            marginTop: "4px",
            transform: "scale(1.2)",
            accentColor: "#0052cc"
        },
        button: {
            width: "90%",
            padding: "12px",
            height: "54px",
            backgroundColor: colors.primario,
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "absolute",
            bottom: 16
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 12
                            },
                            children: colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 70,
                                    maxWidth: 120,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerStep,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.current,
                                    children: "04"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.separator,
                                    children: " / "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.total,
                                    children: "06"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.container,
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "initial",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerPhone,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: "64",
                                    height: "64",
                                    viewBox: "0 0 64 64",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "2",
                                            y: "2",
                                            width: "60",
                                            height: "60",
                                            rx: "12",
                                            fill: "white"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                            cx: "32",
                                            cy: "20",
                                            r: "6",
                                            stroke: "#333333",
                                            strokeWidth: "2",
                                            fill: colors.primario
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M24 32C24 28 28 26 32 26C36 26 40 28 40 32",
                                            stroke: "#333333",
                                            strokeWidth: "2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M20 44C20 38 26 36 32 36C38 36 44 38 44 44V48H20V44Z",
                                            stroke: "#333333",
                                            strokeWidth: "2",
                                            fill: colors.secundario
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "10",
                                            y: "10",
                                            width: "8",
                                            height: "8",
                                            stroke: "#333333",
                                            "stroke-width": "2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "46",
                                            y: "10",
                                            width: "8",
                                            height: "8",
                                            stroke: "#333333",
                                            "stroke-width": "2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "10",
                                            y: "46",
                                            width: "8",
                                            height: "8",
                                            stroke: "#333333",
                                            "stroke-width": "2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "46",
                                            y: "46",
                                            width: "8",
                                            height: "8",
                                            stroke: "#333333",
                                            "stroke-width": "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: styles.description,
                                    children: "Scan your ID Card to continue. We\u2019ll use it to verify your identity. You\u2019ll be able to use your DNI to resume your application if needed."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    style: styles.label,
                                    children: "Choose your country"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                    value: selectedCountry,
                                    onChange: (e)=>setSelectedCountry(e.target.value),
                                    style: styles.select,
                                    children: countries.map((country)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            value: country,
                                            children: country
                                        }, country))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClick,
                            style: styles.button,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Jump":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkanId2VisaMobile", ()=>SkanId2VisaMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
const SkanId2VisaMobile = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_success-visa-mobile${currentParams}`);
    };
    const styles = {
        telefono: {
            fontFamily: "Open Sans, sans-serif",
            marginTop: "30px",
            backgroundColor: "#f1f1f1",
            display: "flex",
            borderRadius: "50px",
            border: "15px solid #000000",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%"
        },
        container: {
            display: "flex",
            alignItems: "center",
            margin: "16px 0 8px 0",
            padding: "16px",
            height: "100%",
            boxSizing: "border-box"
        },
        arrow: {
            fontSize: "26px",
            marginLeft: "8px"
        },
        containerPhone: {
            width: "100%",
            background: "#263238",
            margin: "0 auto",
            fontFamily: "sans-serif",
            padding: "20px"
        },
        description: {
            fontSize: "15px",
            color: "#333",
            marginBottom: "20px",
            lineHeight: "1.5"
        },
        label: {
            display: "block",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "12px",
            color: "#111"
        },
        topSection: {
            backgroundColor: "#263238",
            height: "400px",
            position: "relative",
            padding: "20px",
            display: "flex",
            justifyContent: "center"
        },
        closeBtn: {
            position: "absolute",
            top: -10,
            right: -15,
            background: "none",
            color: "#fff",
            border: "none",
            fontSize: "20px",
            cursor: "pointer"
        },
        imageWrapper: {
            borderRadius: "8px",
            padding: "4px"
        },
        image: {
            width: "260px",
            borderRadius: "4px"
        },
        bottomSection: {
            marginTop: "40px",
            textAlign: "center",
            padding: "16px"
        },
        stepper: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        stepActive: {
            backgroundColor: colors.primario,
            color: "#fff",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            lineHeight: "28px",
            fontWeight: "bold"
        },
        stepInactive: {
            backgroundColor: "#e5e7eb",
            color: "#6b7280",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            lineHeight: "28px",
            fontWeight: "bold"
        },
        line: {
            height: "2px",
            width: "40px",
            backgroundColor: "#d1d5db",
            margin: "0 8px"
        },
        labels: {
            display: "flex",
            justifyContent: "center",
            gap: "50px",
            marginTop: "8px"
        },
        labelActive: {
            fontSize: "14px",
            color: "#111827",
            fontWeight: "bold"
        },
        labelInactive: {
            fontSize: "14px",
            color: "#9ca3af"
        },
        lines: {
            display: "flex",
            flexDirection: "column",
            marginRight: "8px"
        },
        lineBlue: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.primario,
            marginBottom: "4px"
        },
        lineYellow: {
            width: "30px",
            height: "6px",
            backgroundColor: colors.secundario
        },
        containerStep: {
            display: "flex",
            alignItems: "baseline",
            fontFamily: "sans-serif"
        },
        current: {
            color: colors.primario,
            fontSize: "40px",
            fontWeight: "bold"
        },
        separator: {
            margin: "0 2px",
            color: "#959699",
            fontSize: "18px"
        },
        total: {
            color: "#959699",
            fontSize: "18px"
        },
        page: {
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "30px",
            position: "relative",
            backgroundColor: "#ffffff",
            width: "375px",
            height: "812px",
            overflow: "hidden",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            height: "160px",
            width: "90%",
            borderBottom: "1px solid #E7E7E7"
        },
        title: {
            fontSize: "18px",
            marginBottom: "20px",
            color: "#333"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            width: "90%",
            marginBottom: "40px"
        },
        checkbox: {
            marginTop: "4px",
            transform: "scale(1.2)",
            accentColor: "#0052cc"
        },
        button: {
            width: "90%",
            padding: "12px",
            height: "54px",
            backgroundColor: colors.primario,
            color: "#fff",
            fontSize: "16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "absolute",
            bottom: 16
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.telefono,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 12
                            },
                            children: colors.url_logo !== "" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "inicio-de-sesion-de-2",
                                src: colors.url_logo,
                                style: {
                                    height: 70,
                                    maxWidth: 120,
                                    objectFit: 'contain'
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.containerStep,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.current,
                                    children: "04"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.separator,
                                    children: " / "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: styles.total,
                                    children: "06"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        ...styles.container,
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "initial",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: styles.containerPhone,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: styles.topSection,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        style: styles.closeBtn,
                                        children: "\u2715"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: styles.imageWrapper,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: "/img/skanid.png",
                                            alt: "Document preview",
                                            style: styles.image
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: styles.bottomSection,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.stepper,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: styles.stepActive,
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: styles.line
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: styles.stepInactive,
                                            children: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: styles.labels,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: styles.labelActive,
                                            children: "Front"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: styles.labelInactive,
                                            children: "Back"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleButtonClick,
                            style: styles.button,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84Bgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const NotFound = ()=>{
    const styles = {
        container404: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            color: "#333",
            fontFamily: "Arial, sans-serif"
        },
        pantalla: {
            padding: "2rem"
        },
        code: {
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "#3F6A88"
        },
        message: {
            fontSize: "1.5rem",
            marginBottom: "1rem",
            color: "#333333"
        },
        contact: {
            fontSize: "1rem",
            color: "#1d3557"
        },
        negrita: {
            fontWeight: "bold"
        }
    };
    (0, _react.useEffect)(()=>{
        const originalBackground = document.body.style.backgroundColor;
        document.body.style.backgroundColor = "rgb(249, 249, 249)";
        return ()=>{
            document.body.style.backgroundColor = originalBackground;
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.container404,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.pantalla,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    alt: "Veritran",
                    width: 300,
                    src: "/img/veritran_logo.svg"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: styles.code,
                    children: "This view does not exist"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: styles.contact,
                    children: [
                        "Please contact",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: styles.negrita,
                            children: "presales@veritran.com"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0KVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungLanding", ()=>(0, _youngLanding.YoungLanding));
var _youngLanding = require("./YoungLanding");

},{"./YoungLanding":"btS78","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"btS78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungLanding", ()=>YoungLanding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _avataaarDefault = require("../../../../../components/AvataaarDefault");
var _btnIconMoneyWrapper = require("../../../../../components/BtnIconMoneyWrapper");
var _clothingGraphic = require("../../../../../components/ClothingGraphic");
var _clothingShirtScoop = require("../../../../../components/ClothingShirtScoop");
var _eyebrowOutline = require("../../../../../components/EyebrowOutline");
var _eyesDefault = require("../../../../../components/EyesDefault");
var _noseDefault = require("../../../../../components/NoseDefault");
var _text = require("../../../../../components/Text");
var _eyebrow4 = require("../../../../../icons/Eyebrow4");
var _eyes = require("../../../../../icons/Eyes");
var _eyes1 = require("../../../../../icons/Eyes1");
var _eyesWink = require("../../../../../icons/EyesWink");
var _iconSmall2 = require("../../../../../icons/IconSmall2");
var _iconlyLightOutlineArrowDown21 = require("../../../../../icons/IconlyLightOutlineArrowDown21");
var _icons19 = require("../../../../../icons/Icons19");
var _mouth = require("../../../../../icons/Mouth");
var _mouth2 = require("../../../../../icons/Mouth2");
var _nose4 = require("../../../../../icons/Nose4");
var _trailingIcon14 = require("../../../../../icons/TrailingIcon14");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungLanding = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const scrollRef = (0, _react.useRef)(null);
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-card_details-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-landing",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "div-18",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-27",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-35"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "element-11",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-28",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                                        className: "header-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-164",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "img-wrapper",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "iconly-light-outline-5",
                                                        alt: "Iconly light outline",
                                                        src: "/img/iconly-light-outline-more-square-1.svg"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-165",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-166",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "group-41",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-29",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "iconly-light-outline-6"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "group-42",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group-32",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-147",
                                                                                children: "3"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-148",
                                                        children: "Mary"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "gg-crown-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gg-crown",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "overlap-30",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "crown",
                                                                alt: "Crown",
                                                                src: "/img/crown.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-167",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-33",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "vector-12",
                                                                            alt: "Vector",
                                                                            src: "/img/vector-12.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "ellipse-24",
                                                                            alt: "Ellipse",
                                                                            src: "/img/ellipse-18.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "ellipse-25",
                                                                            alt: "Ellipse",
                                                                            src: "/img/ellipse-20.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "ellipse-26",
                                                                            alt: "Ellipse",
                                                                            src: "/img/ellipse-19.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "t-tulo-cuenta",
                                                                            children: "2"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "a",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-168",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-149",
                                                    children: "Total Balance | ****2357"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-169",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                        className: "icons-19",
                                                        color: "white"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "group-43",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-150",
                                                                children: "$"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-group-34",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-151",
                                                                        children: "13,000"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-152",
                                                                        children: ".23"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-153",
                                                                children: "USD"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "menu-copy-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-10"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-11"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "oval-12"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "b",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-170",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "button-medium",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "icon-nombre",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-31",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "icon-transactions",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group-35",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "icon-enviar"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                                    width: 13,
                                                                                    height: 18,
                                                                                    viewBox: "0 0 13 18",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M12.3388 5.19514L7.50746 0.340803C7.27664 0.121914 6.97139 0 6.65415 0C6.33691 0 6.03166 0.121914 5.80084 0.340803L0.969543 5.19514C0.765757 5.4271 0.657587 5.7285 0.66708 6.0379C0.676572 6.3473 0.803013 6.64141 1.02063 6.86029C1.23825 7.07917 1.53067 7.20635 1.83828 7.2159C2.14589 7.22544 2.44555 7.11664 2.67617 6.91168L5.44757 4.12919V12.5417C5.43697 12.7076 5.46031 12.874 5.51615 13.0305C5.57199 13.187 5.65915 13.3303 5.77223 13.4516C5.88531 13.5728 6.02191 13.6695 6.1736 13.7356C6.32529 13.8017 6.48884 13.8358 6.65415 13.8358C6.81946 13.8358 6.98301 13.8017 7.1347 13.7356C7.28638 13.6695 7.42299 13.5728 7.53607 13.4516C7.64915 13.3303 7.7363 13.187 7.79214 13.0305C7.84798 12.874 7.87133 12.7076 7.86073 12.5417V4.12919L10.6272 6.91168C10.8557 7.12884 11.1594 7.24791 11.4737 7.24365C11.7881 7.23938 12.0885 7.11211 12.3111 6.88882C12.5338 6.66554 12.6612 6.36381 12.6663 6.04762C12.6715 5.73143 12.554 5.42565 12.3388 5.19514Z",
                                                                                            fill: colors.secundario
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                            d: "M7.76647 16.2208C7.73493 16.1499 7.69835 16.0813 7.65701 16.0156C7.61385 15.9474 7.562 15.8852 7.50276 15.8305C7.44905 15.7721 7.38896 15.7201 7.32364 15.6753C7.25608 15.6347 7.18632 15.598 7.11467 15.5652C7.04085 15.5344 6.96419 15.5109 6.88579 15.4952C6.72964 15.4652 6.56926 15.4652 6.41311 15.4952C6.33651 15.5116 6.26157 15.5351 6.18921 15.5652C6.11656 15.5959 6.04665 15.6327 5.98023 15.6753C5.91332 15.72 5.85158 15.772 5.79614 15.8305C5.73987 15.8866 5.68982 15.9487 5.64687 16.0156C5.60364 16.0802 5.56697 16.1489 5.53741 16.2208C5.50671 16.2951 5.48338 16.3722 5.46775 16.451C5.45217 16.5268 5.44383 16.6039 5.44287 16.6812C5.4434 16.8411 5.47553 16.9993 5.53741 17.1466C5.56589 17.2206 5.60261 17.2912 5.64687 17.3568C5.73354 17.4908 5.84709 17.605 5.98023 17.6921C6.04554 17.7367 6.11564 17.7736 6.18921 17.8022C6.33566 17.8645 6.49295 17.8968 6.65194 17.8973C6.7297 17.905 6.80802 17.905 6.88579 17.8973C6.96419 17.8816 7.04085 17.8581 7.11467 17.8273C7.18616 17.7975 7.25451 17.7606 7.31867 17.7172C7.38525 17.674 7.44698 17.6236 7.50276 17.567C7.56086 17.5113 7.6126 17.4492 7.65701 17.3819C7.69938 17.3151 7.736 17.2447 7.76647 17.1717C7.82972 17.025 7.86029 16.8661 7.85603 16.7063C7.86362 16.628 7.86362 16.5493 7.85603 16.471C7.83532 16.3846 7.80529 16.3007 7.76647 16.2208Z",
                                                                                            fill: colors.secundario
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-154",
                                                                        children: "Send"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "icon-nombre-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "icon-nombre-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "overlap-group-36",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "icon-transactions-2",
                                                                        style: {
                                                                            top: 7
                                                                        },
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                            width: 13,
                                                                            height: 18,
                                                                            viewBox: "0 0 13 18",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                    d: "M0.994256 12.8049L5.82555 17.6592C6.05637 17.8781 6.36162 18 6.67886 18C6.9961 18 7.30135 17.8781 7.53217 17.6592L12.3635 12.8049C12.5673 12.5729 12.6754 12.2715 12.6659 11.9621C12.6564 11.6527 12.53 11.3586 12.3124 11.1397C12.0948 10.9208 11.8023 10.7937 11.4947 10.7841C11.1871 10.7746 10.8875 10.8834 10.6568 11.0883L7.88544 13.8708L7.88544 5.45829C7.89604 5.29237 7.8727 5.12602 7.81686 4.96953C7.76102 4.81303 7.67386 4.66972 7.56078 4.54844C7.4477 4.42716 7.3111 4.33049 7.15941 4.26441C7.00772 4.19833 6.84417 4.16423 6.67886 4.16423C6.51355 4.16423 6.35 4.19833 6.19831 4.26441C6.04662 4.33049 5.91002 4.42716 5.79694 4.54844C5.68386 4.66972 5.59671 4.81303 5.54087 4.96953C5.48502 5.12602 5.46168 5.29237 5.47228 5.45829L5.47228 13.8708L2.70586 11.0883C2.47731 10.8712 2.17364 10.7521 1.85926 10.7564C1.54488 10.7606 1.24452 10.8879 1.02188 11.1112C0.799235 11.3345 0.671823 11.6362 0.666667 11.9524C0.66151 12.2686 0.779013 12.5743 0.994256 12.8049Z",
                                                                                    fill: colors.secundario
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                                    d: "M5.56654 1.77918C5.59808 1.85013 5.63466 1.91871 5.676 1.98436C5.71916 2.0526 5.77101 2.11485 5.83025 2.16953C5.88396 2.22786 5.94404 2.2799 6.00937 2.32467C6.07692 2.36527 6.14669 2.40203 6.21834 2.43477C6.29215 2.46564 6.36882 2.48911 6.44722 2.50483C6.60336 2.53485 6.76375 2.53485 6.9199 2.50483C6.99649 2.48837 7.07144 2.46492 7.1438 2.43477C7.21645 2.40412 7.28636 2.36729 7.35277 2.32467C7.41968 2.28 7.48143 2.22797 7.53687 2.16953C7.59314 2.11342 7.64319 2.05134 7.68614 1.98436C7.72937 1.91983 7.76604 1.85109 7.7956 1.77918C7.8263 1.70494 7.84963 1.62783 7.86526 1.54897C7.88084 1.47321 7.88917 1.39613 7.89014 1.31877C7.88961 1.15886 7.85748 1.00065 7.7956 0.853353C7.76712 0.779358 7.7304 0.708848 7.68614 0.643166C7.59947 0.509246 7.48592 0.395034 7.35277 0.307865C7.28747 0.263348 7.21737 0.226413 7.1438 0.197766C6.99735 0.13553 6.84005 0.103209 6.68107 0.102681C6.6033 0.0950497 6.52498 0.0950497 6.44722 0.102681C6.36882 0.118399 6.29215 0.141867 6.21834 0.172744C6.14684 0.202474 6.0785 0.23936 6.01434 0.282843C5.94775 0.326038 5.88603 0.376378 5.83025 0.432977C5.77214 0.488737 5.72041 0.550842 5.676 0.618142C5.63363 0.684941 5.59701 0.75526 5.56654 0.828331C5.50329 0.97504 5.47272 1.13389 5.47698 1.29375C5.46939 1.37196 5.46939 1.45074 5.47698 1.52896C5.49769 1.61539 5.52772 1.6993 5.56654 1.77918Z",
                                                                                    fill: colors.secundario
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-155",
                                                                        children: "Collect"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-171",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-6",
                                                                alt: "Solar bus outline",
                                                                src: "/img/solar-bus-outline.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-156",
                                                                children: "Top Ups"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-6",
                                                                alt: "File text",
                                                                src: "/img/file-text.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-156",
                                                                children: "Pay Bills"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "img-6",
                                                                alt: "Icons",
                                                                src: "/img/icons-21.svg"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-156",
                                                                children: "Hub"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-36"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "element-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "inside-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "switch",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "btn-switch-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-13",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-158",
                                                        children: "My Products"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "element-14",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-159",
                                                        children: "Winning"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "cardss-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "cardss-2 highlighted-button",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-19",
                                                    onClick: handleButtonClick,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "tarjeta-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-172",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-160",
                                                                            children: "Credit"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-161",
                                                                            children: "****5849"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "uim-master-card",
                                                                    alt: "Uim master card",
                                                                    src: "/img/uim-master-card.svg"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-173",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-162",
                                                                    children: "GOLD"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "txt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-163",
                                                                            children: "Available"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-164",
                                                                            children: "$ 1,250"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-174",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-165",
                                                                            children: "02/29"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-166",
                                                                            children: "Pay date"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-19",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "tarjeta-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-172",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-160",
                                                                            children: "Credit"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-161",
                                                                            children: "****2345"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "logo-visa-8",
                                                                    alt: "Logo visa",
                                                                    src: "/img/logo-visa-8.svg"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-173",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "text-wrapper-162",
                                                                    children: "SILVER"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "txt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-163",
                                                                            children: "Available"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-164",
                                                                            children: "$ 550.00"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-174",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-165",
                                                                            children: "09/22"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "text-wrapper-166",
                                                                            children: "Pay date"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "all",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "element-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "div-20",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "subsection-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-176",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-168",
                                                                children: "My Goals"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "iconly-light-outline-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-169",
                                                                children: "Manage"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-177",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-178",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-33",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "frame-179",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "frame-180",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "frame-181",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "text-wrapper-170",
                                                                                            children: "New iPhone"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trailingIcon14.TrailingIcon14), {
                                                                                            className: "icon-instance-node-6",
                                                                                            color: "#0066FF"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                                    className: "due-date-days",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "text-wrapper-171",
                                                                                            children: "Due date: "
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "text-wrapper-172",
                                                                                            children: "90 days"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "frame-182",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                                    className: "element-16",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "text-wrapper-172",
                                                                                            children: "$700.54"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                            className: "text-wrapper-173",
                                                                                            children: [
                                                                                                " ",
                                                                                                "/ $950,000"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "group-46",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "overlap-group-37",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                                                                                className: "text-instance",
                                                                                                color: "primary",
                                                                                                size: "caption"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                                                                                className: "text-11",
                                                                                                color: "primary",
                                                                                                size: "caption"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "image-13",
                                                                    alt: "Image",
                                                                    src: "/img/image-61980-1.png"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "vector-13",
                                            alt: "Vector",
                                            src: "/img/vector-271.svg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "element-17",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "div-20",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "subsection-9",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-176",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-168",
                                                            children: "Last activity"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "iconly-light-outline-8",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-169",
                                                                children: "See all"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconlyLightOutlineArrowDown21.IconlyLightOutlineArrowDown21), {
                                                                className: "icon-instance-node-6",
                                                                color: "white"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-186",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-187",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-39",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "vector-14",
                                                                    alt: "Vector",
                                                                    src: "/img/vector-270-1.svg"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-27"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-28"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-29"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-188",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "feed-row-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "data-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "btn-icon-money-instance-wrapper",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _btnIconMoneyWrapper.BtnIconMoneyWrapper), {})
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-189",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "name-3",
                                                                                        children: "Sent - Pamela F."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "subject-3",
                                                                                        children: "11/06/24"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-190",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                                className: "amount-10",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "text-wrapper-174",
                                                                                        children: "-$1.609"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "text-wrapper-175",
                                                                                        children: ",23"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-191",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "subject-4",
                                                                                        children: "Regular transf?"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "x-smaall",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconSmall2.IconSmall2), {
                                                                                            className: "icon-small",
                                                                                            color: "#8E8E8E"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "feed-row-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "data-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "frame-192",
                                                                                alt: "Frame",
                                                                                src: "/img/frame-480954771-6.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "group-48",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "overlap-group-40",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "name-4",
                                                                                            children: "Refund Promo"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "frame-193",
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "subject-5",
                                                                                                children: "6 h ago"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-194",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                            className: "amount-11",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "text-wrapper-174",
                                                                                    children: "+$2.950,"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "text-wrapper-175",
                                                                                    children: "23"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "feed-row-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "data-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "frame-192",
                                                                                alt: "Frame",
                                                                                src: "/img/frame-480954772-5.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "group-48",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "overlap-group-40",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "name-4",
                                                                                            children: "Mission finished"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "frame-193",
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "subject-5",
                                                                                                children: "You earn a prize"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-195",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "amount-12",
                                                                            children: "+$950,23"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "pockets-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pockets",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "subsection-10",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-176",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-176",
                                                            children: "Favorite contacts transfers"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "iconly-light-outline-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-169",
                                                            children: "Manage"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-196",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-197",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-198",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "i-hope-your-day-wrapper",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avataaarDefault.AvataaarDefault), {
                                                                        body: "/img/body-1.png",
                                                                        bodyClassName: "i-hope-your-day-2",
                                                                        className: "i-hope-your-day",
                                                                        clothingShirtScoopClothingShirtScoop: "/img/clothes-3.svg",
                                                                        clothingShirtScoopClothingShirtScoopClassName: "design-component-instance-node-4",
                                                                        faceClassName: "i-hope-your-day-3",
                                                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mouth2.Mouth2), {
                                                                            className: "mouth-2"
                                                                        }),
                                                                        icon1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyebrow4.Eyebrow4), {
                                                                            className: "eyebrow-4"
                                                                        }),
                                                                        mouthStyleOverrideClassName: "avataaar-default-3",
                                                                        overlapClassName: "avataaar-default-instance",
                                                                        overlapGroupClassName: "avataaar-default-2",
                                                                        override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyes.Eyes), {
                                                                            className: "eyes-2"
                                                                        }),
                                                                        top: "/img/top-1.png",
                                                                        topClassName: "i-hope-your-day-4"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-177",
                                                                children: "Karol"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-197",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-200",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avataaarDefault.AvataaarDefault), {
                                                                    body: "/img/body-4.png",
                                                                    bodyClassName: "avataaar-6",
                                                                    className: "avataaar-5",
                                                                    faceClassName: "avataaar-4",
                                                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mouth.Mouth), {
                                                                        className: "nose",
                                                                        opacity: "0.7"
                                                                    }),
                                                                    icon1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyebrow4.Eyebrow4), {
                                                                        className: "eyebrow-2"
                                                                    }),
                                                                    mouthStyleOverrideClassName: "avataaar-7",
                                                                    overlapClassName: "avataaar-default-instance",
                                                                    overlapGroupClassName: "avataaar-default-2",
                                                                    override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyesWink.EyesWink), {
                                                                        className: "eyes-wink"
                                                                    }),
                                                                    override1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clothingGraphic.ClothingGraphic), {
                                                                        className: "clothing-graphic-shirt",
                                                                        clothingGraphic: "/img/clothing-graphic-shirt-1.svg"
                                                                    }),
                                                                    top: "/img/top-4.png",
                                                                    topClassName: "avataaar-8"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-177",
                                                                children: "Jean"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-197",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-200",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "avataaar-9",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "overlap-36",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "body-3",
                                                                                alt: "Body",
                                                                                src: "/img/body-5.png"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clothingShirtScoop.ClothingShirtScoop), {
                                                                                className: "clothes",
                                                                                clothingShirtScoop: "/img/clothes-1.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "face-2",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "overlap-37",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "mouth-eating",
                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                className: "overlap-group-41",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "om-nom-nom"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "redish"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "redish-2"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nose4.Nose4), {
                                                                                            className: "nose-4"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyesDefault.EyesDefault), {
                                                                                            className: "eyes-6",
                                                                                            eyeClassName: "eyes-7",
                                                                                            eyeClassNameOverride: "eyes-8"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyebrow4.Eyebrow4), {
                                                                                            className: "eyebrow-3"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "top-2",
                                                                                alt: "Top",
                                                                                src: "/img/top-5.png"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-177",
                                                                children: "Norma"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "frame-197",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-198",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "i-hope-your-day-wrapper",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avataaarDefault.AvataaarDefault), {
                                                                        body: "/img/body-1.png",
                                                                        bodyClassName: "i-hope-your-day-2",
                                                                        className: "i-hope-your-day",
                                                                        faceClassName: "i-hope-your-day-3",
                                                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyes1.Eyes1), {
                                                                            className: "mouth-2"
                                                                        }),
                                                                        icon1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyebrowOutline.EyebrowOutline), {
                                                                            className: "eyebrow-outline-default",
                                                                            eyebrowOutline: "/img/eyebrow-5.png"
                                                                        }),
                                                                        icon2: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noseDefault.NoseDefault), {
                                                                            className: "nose-default-instance",
                                                                            noseDefault: "/img/nose-5.png"
                                                                        }),
                                                                        overlapClassName: "avataaar-default-instance",
                                                                        overlapGroupClassName: "avataaar-default-2",
                                                                        override: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyes1.Eyes1), {
                                                                            className: "eyes-2"
                                                                        }),
                                                                        override1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clothingShirtScoop.ClothingShirtScoop), {
                                                                            className: "design-component-instance-node-4",
                                                                            clothingShirtScoop: "/img/clothes-2.svg"
                                                                        }),
                                                                        top: "/img/top-1.png",
                                                                        topClassName: "i-hope-your-day-4"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-177",
                                                                children: "Susan"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "menu-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon-and-text-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "icon-and-text-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-transactions-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 13,
                                            height: 18,
                                            viewBox: "0 0 13 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M12.3388 5.19514L7.50746 0.340803C7.27664 0.121914 6.97139 0 6.65415 0C6.33691 0 6.03166 0.121914 5.80084 0.340803L0.969543 5.19514C0.765757 5.4271 0.657587 5.7285 0.66708 6.0379C0.676572 6.3473 0.803013 6.64141 1.02063 6.86029C1.23825 7.07917 1.53067 7.20635 1.83828 7.2159C2.14589 7.22544 2.44555 7.11664 2.67617 6.91168L5.44757 4.12919V12.5417C5.43697 12.7076 5.46031 12.874 5.51615 13.0305C5.57199 13.187 5.65915 13.3303 5.77223 13.4516C5.88531 13.5728 6.02191 13.6695 6.1736 13.7356C6.32529 13.8017 6.48884 13.8358 6.65415 13.8358C6.81946 13.8358 6.98301 13.8017 7.1347 13.7356C7.28638 13.6695 7.42299 13.5728 7.53607 13.4516C7.64915 13.3303 7.7363 13.187 7.79214 13.0305C7.84798 12.874 7.87133 12.7076 7.86073 12.5417V4.12919L10.6272 6.91168C10.8557 7.12884 11.1594 7.24791 11.4737 7.24365C11.7881 7.23938 12.0885 7.11211 12.3111 6.88882C12.5338 6.66554 12.6612 6.36381 12.6663 6.04762C12.6715 5.73143 12.554 5.42565 12.3388 5.19514Z",
                                                    fill: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M7.76647 16.2208C7.73493 16.1499 7.69835 16.0813 7.65701 16.0156C7.61385 15.9474 7.562 15.8852 7.50276 15.8305C7.44905 15.7721 7.38896 15.7201 7.32364 15.6753C7.25608 15.6347 7.18632 15.598 7.11467 15.5652C7.04085 15.5344 6.96419 15.5109 6.88579 15.4952C6.72964 15.4652 6.56926 15.4652 6.41311 15.4952C6.33651 15.5116 6.26157 15.5351 6.18921 15.5652C6.11656 15.5959 6.04665 15.6327 5.98023 15.6753C5.91332 15.72 5.85158 15.772 5.79614 15.8305C5.73987 15.8866 5.68982 15.9487 5.64687 16.0156C5.60364 16.0802 5.56697 16.1489 5.53741 16.2208C5.50671 16.2951 5.48338 16.3722 5.46775 16.451C5.45217 16.5268 5.44383 16.6039 5.44287 16.6812C5.4434 16.8411 5.47553 16.9993 5.53741 17.1466C5.56589 17.2206 5.60261 17.2912 5.64687 17.3568C5.73354 17.4908 5.84709 17.605 5.98023 17.6921C6.04554 17.7367 6.11564 17.7736 6.18921 17.8022C6.33566 17.8645 6.49295 17.8968 6.65194 17.8973C6.7297 17.905 6.80802 17.905 6.88579 17.8973C6.96419 17.8816 7.04085 17.8581 7.11467 17.8273C7.18616 17.7975 7.25451 17.7606 7.31867 17.7172C7.38525 17.674 7.44698 17.6236 7.50276 17.567C7.56086 17.5113 7.6126 17.4492 7.65701 17.3819C7.69938 17.3151 7.736 17.2447 7.76647 17.1717C7.82972 17.025 7.86029 16.8661 7.85603 16.7063C7.86362 16.628 7.86362 16.5493 7.85603 16.471C7.83532 16.3846 7.80529 16.3007 7.76647 16.2208Z",
                                                    fill: colors.secundario
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-13",
                                        children: "Send"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon-and-text-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "icon-and-text-8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-transactions-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: 13,
                                            height: 18,
                                            viewBox: "0 0 13 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M0.994256 12.8049L5.82555 17.6592C6.05637 17.8781 6.36162 18 6.67886 18C6.9961 18 7.30135 17.8781 7.53217 17.6592L12.3635 12.8049C12.5673 12.5729 12.6754 12.2715 12.6659 11.9621C12.6564 11.6527 12.53 11.3586 12.3124 11.1397C12.0948 10.9208 11.8023 10.7937 11.4947 10.7841C11.1871 10.7746 10.8875 10.8834 10.6568 11.0883L7.88544 13.8708L7.88544 5.45829C7.89604 5.29237 7.8727 5.12602 7.81686 4.96953C7.76102 4.81303 7.67386 4.66972 7.56078 4.54844C7.4477 4.42716 7.3111 4.33049 7.15941 4.26441C7.00772 4.19833 6.84417 4.16423 6.67886 4.16423C6.51355 4.16423 6.35 4.19833 6.19831 4.26441C6.04662 4.33049 5.91002 4.42716 5.79694 4.54844C5.68386 4.66972 5.59671 4.81303 5.54087 4.96953C5.48502 5.12602 5.46168 5.29237 5.47228 5.45829L5.47228 13.8708L2.70586 11.0883C2.47731 10.8712 2.17364 10.7521 1.85926 10.7564C1.54488 10.7606 1.24452 10.8879 1.02188 11.1112C0.799235 11.3345 0.671823 11.6362 0.666667 11.9524C0.66151 12.2686 0.779013 12.5743 0.994256 12.8049Z",
                                                    fill: colors.secundario
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    d: "M5.56654 1.77918C5.59808 1.85013 5.63466 1.91871 5.676 1.98436C5.71916 2.0526 5.77101 2.11485 5.83025 2.16953C5.88396 2.22786 5.94404 2.2799 6.00937 2.32467C6.07692 2.36527 6.14669 2.40203 6.21834 2.43477C6.29215 2.46564 6.36882 2.48911 6.44722 2.50483C6.60336 2.53485 6.76375 2.53485 6.9199 2.50483C6.99649 2.48837 7.07144 2.46492 7.1438 2.43477C7.21645 2.40412 7.28636 2.36729 7.35277 2.32467C7.41968 2.28 7.48143 2.22797 7.53687 2.16953C7.59314 2.11342 7.64319 2.05134 7.68614 1.98436C7.72937 1.91983 7.76604 1.85109 7.7956 1.77918C7.8263 1.70494 7.84963 1.62783 7.86526 1.54897C7.88084 1.47321 7.88917 1.39613 7.89014 1.31877C7.88961 1.15886 7.85748 1.00065 7.7956 0.853353C7.76712 0.779358 7.7304 0.708848 7.68614 0.643166C7.59947 0.509246 7.48592 0.395034 7.35277 0.307865C7.28747 0.263348 7.21737 0.226413 7.1438 0.197766C6.99735 0.13553 6.84005 0.103209 6.68107 0.102681C6.6033 0.0950497 6.52498 0.0950497 6.44722 0.102681C6.36882 0.118399 6.29215 0.141867 6.21834 0.172744C6.14684 0.202474 6.0785 0.23936 6.01434 0.282843C5.94775 0.326038 5.88603 0.376378 5.83025 0.432977C5.77214 0.488737 5.72041 0.550842 5.676 0.618142C5.63363 0.684941 5.59701 0.75526 5.56654 0.828331C5.50329 0.97504 5.47272 1.13389 5.47698 1.29375C5.46939 1.37196 5.46939 1.45074 5.47698 1.52896C5.49769 1.61539 5.52772 1.6993 5.56654 1.77918Z",
                                                    fill: colors.secundario
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-13",
                                        children: "Receive"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon-and-text-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "icon-and-text-9",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: 20,
                                        height: 18,
                                        viewBox: "0 0 20 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M11.7019 8.21357H18.5351C18.7653 8.21357 18.986 8.128 19.1488 7.97568C19.3116 7.82337 19.403 7.61678 19.403 7.40138V1.0066C19.4037 0.899526 19.3817 0.793386 19.3384 0.694281C19.2951 0.595176 19.2313 0.505062 19.1506 0.429124C19.07 0.353186 18.9741 0.292923 18.8685 0.251801C18.7628 0.210679 18.6495 0.18951 18.5351 0.189512H11.7019C11.5864 0.188217 11.4717 0.208395 11.3646 0.248877C11.2575 0.289359 11.1599 0.34934 11.0778 0.425343C10.9956 0.501345 10.9303 0.591858 10.8858 0.691634C10.8413 0.791411 10.8184 0.898466 10.8184 1.0066V7.40138C10.8183 7.50928 10.8413 7.61611 10.8859 7.71562C10.9305 7.81513 10.9958 7.90532 11.0781 7.98094C11.1603 8.05655 11.2579 8.11607 11.365 8.15601C11.4721 8.19595 11.5866 8.21552 11.7019 8.21357ZM12.5698 1.81879H17.662V6.58429H12.5698V1.81879Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M8.28446 9.78517H1.45125C1.33684 9.78453 1.2234 9.80506 1.1175 9.84559C1.0116 9.88611 0.915316 9.94584 0.834172 10.0213C0.753028 10.0968 0.688631 10.1866 0.64469 10.2854C0.600748 10.3843 0.578123 10.4903 0.578125 10.5974V16.9921C0.579506 17.208 0.672115 17.4146 0.835704 17.5668C0.999293 17.7189 1.22059 17.8043 1.45125 17.8043H8.28446C8.51602 17.8043 8.73809 17.7183 8.90182 17.565C9.06556 17.4118 9.15755 17.204 9.15755 16.9873V10.5974C9.15755 10.4903 9.13493 10.3843 9.09099 10.2854C9.04705 10.1866 8.98265 10.0968 8.90151 10.0213C8.82036 9.94584 8.72407 9.88611 8.61818 9.84559C8.51228 9.80506 8.39887 9.78453 8.28446 9.78517ZM7.41133 16.18H2.32434V11.4144H7.41133V16.18Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M11.7019 14.6095H18.5351C18.7653 14.6095 18.986 14.5239 19.1488 14.3716C19.3116 14.2193 19.403 14.0127 19.403 13.7973V10.5975C19.386 10.3923 19.2869 10.2007 19.1255 10.061C18.9642 9.92121 18.7524 9.84358 18.5325 9.84358C18.3126 9.84358 18.1009 9.92121 17.9395 10.061C17.7781 10.2007 17.679 10.3923 17.662 10.5975V12.9802H15.989V10.5975C15.989 10.4904 15.9664 10.3844 15.9225 10.2855C15.8785 10.1867 15.8141 10.0969 15.733 10.0214C15.6518 9.94595 15.5555 9.88623 15.4496 9.8457C15.3437 9.80518 15.2303 9.78464 15.1159 9.78529H11.7019C11.5866 9.78334 11.4721 9.80291 11.365 9.84285C11.2579 9.88279 11.1603 9.94231 11.0781 10.0179C10.9958 10.0935 10.9305 10.1837 10.8859 10.2832C10.8413 10.3827 10.8183 10.4896 10.8184 10.5975V13.7973C10.8183 13.9052 10.8413 14.012 10.8859 14.1116C10.9305 14.2111 10.9958 14.3013 11.0781 14.3769C11.1603 14.4525 11.2579 14.512 11.365 14.5519C11.4721 14.5919 11.5866 14.6115 11.7019 14.6095ZM12.5698 11.4146H14.2428V12.9802H12.5698V11.4146Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M15.1163 16.1782H11.7023C11.5823 16.1695 11.4617 16.1841 11.3481 16.2211C11.2344 16.2581 11.1301 16.3167 11.0418 16.3932C10.9535 16.4697 10.883 16.5624 10.8348 16.6656C10.7866 16.7688 10.7617 16.8802 10.7617 16.9929C10.7617 17.1055 10.7866 17.2169 10.8348 17.3201C10.883 17.4233 10.9535 17.5161 11.0418 17.5926C11.1301 17.6691 11.2344 17.7276 11.3481 17.7646C11.4617 17.8016 11.5823 17.8162 11.7023 17.8075H15.1163C15.2363 17.8162 15.3569 17.8016 15.4706 17.7646C15.5843 17.7276 15.6885 17.6691 15.7768 17.5926C15.8652 17.5161 15.9356 17.4233 15.9838 17.3201C16.032 17.2169 16.0569 17.1055 16.0569 16.9929C16.0569 16.8802 16.032 16.7688 15.9838 16.6656C15.9356 16.5624 15.8652 16.4697 15.7768 16.3932C15.6885 16.3167 15.5843 16.2581 15.4706 16.2211C15.3569 16.1841 15.2363 16.1695 15.1163 16.1782Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M19.3845 16.825C19.3635 16.7204 19.3209 16.6207 19.2591 16.5314C19.2282 16.4864 19.1913 16.4453 19.1493 16.4091C18.9818 16.2629 18.7613 16.1816 18.5323 16.1816C18.3033 16.1816 18.0829 16.2629 17.9154 16.4091C17.8765 16.4467 17.8415 16.4876 17.8108 16.5314C17.7779 16.576 17.7499 16.6235 17.7272 16.6733C17.706 16.7222 17.6903 16.7731 17.6801 16.825C17.675 16.8787 17.675 16.9327 17.6801 16.9864C17.6795 17.0931 17.7019 17.1987 17.7459 17.2971C17.7899 17.3955 17.8547 17.4845 17.9363 17.5589C18.0149 17.6358 18.1091 17.6974 18.2134 17.7399C18.3201 17.7787 18.4336 17.7986 18.548 17.7986C18.6629 17.7999 18.7768 17.7793 18.8828 17.7381C18.9889 17.6969 19.0849 17.6359 19.165 17.5589C19.2487 17.4856 19.3131 17.3952 19.3532 17.2947C19.3967 17.197 19.4198 17.0923 19.4211 16.9864C19.4169 16.9313 19.4045 16.877 19.3845 16.825Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M8.28344 0.189819H4.86421C4.63768 0.196203 4.42283 0.285253 4.26554 0.437937C4.10825 0.59062 4.02101 0.794824 4.02248 1.0069V7.40169C4.02248 7.61709 4.11392 7.82368 4.27668 7.97599C4.43943 8.12831 4.66017 8.21388 4.89034 8.21388H8.30958C8.42956 8.22259 8.55017 8.20799 8.66385 8.171C8.77752 8.13401 8.88179 8.07542 8.97012 7.99893C9.05845 7.92243 9.12892 7.82967 9.17712 7.72647C9.22532 7.62327 9.25019 7.51186 9.25019 7.39924C9.25019 7.28661 9.22532 7.17521 9.17712 7.07201C9.12892 6.96881 9.05845 6.87605 8.97012 6.79955C8.88179 6.72305 8.77752 6.66447 8.66385 6.62748C8.55017 6.59049 8.42956 6.57589 8.30958 6.5846H5.76347V5.01893H8.30958C8.54114 5.01893 8.76321 4.93285 8.92694 4.77961C9.09068 4.62638 9.18267 4.41855 9.18267 4.20185V1.0069C9.18272 0.897512 9.15931 0.789225 9.11381 0.688463C9.06831 0.587701 9.00165 0.496516 8.91779 0.420314C8.83392 0.344112 8.73455 0.284445 8.62558 0.244852C8.51662 0.205258 8.40028 0.186544 8.28344 0.189819ZM7.41032 3.38966H5.73733V1.81909H7.41032V3.38966Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M1.45125 5.01857C1.68281 5.01857 1.90488 4.93248 2.06861 4.77925C2.23235 4.62601 2.32434 4.41819 2.32434 4.20148V1.00654C2.32434 0.789833 2.23235 0.582004 2.06861 0.428771C1.90488 0.275538 1.68281 0.189453 1.45125 0.189453C1.21969 0.189453 0.997591 0.275538 0.833853 0.428771C0.670114 0.582004 0.578125 0.789833 0.578125 1.00654V4.20148C0.578125 4.41819 0.670114 4.62601 0.833853 4.77925C0.997591 4.93248 1.21969 5.01857 1.45125 5.01857Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M1.11698 8.15462C1.22323 8.19539 1.33677 8.21697 1.45159 8.21822C1.68224 8.21693 1.90296 8.13027 2.06557 7.97718C2.22818 7.82409 2.31946 7.617 2.31945 7.40114C2.32462 7.34743 2.32462 7.29339 2.31945 7.23968C2.30923 7.18719 2.29166 7.13619 2.26718 7.088C2.24626 7.03989 2.21996 6.99397 2.18875 6.95101C2.15801 6.90445 2.12114 6.86171 2.07898 6.8238C2.03882 6.78738 1.99505 6.75462 1.94827 6.72594C1.90069 6.69513 1.84987 6.6689 1.79664 6.64766C1.74436 6.62784 1.69005 6.61309 1.63456 6.60362C1.49457 6.57754 1.34988 6.58397 1.21316 6.62235C1.07644 6.66073 0.951867 6.7299 0.85034 6.8238C0.808172 6.86171 0.771273 6.90445 0.740537 6.95101C0.709322 6.99397 0.683055 7.03989 0.662133 7.088C0.637655 7.13619 0.620057 7.18719 0.609833 7.23968C0.604665 7.29339 0.604665 7.34743 0.609833 7.40114C0.609666 7.50844 0.632235 7.6147 0.676206 7.7138C0.720177 7.81289 0.784704 7.90285 0.866039 7.97848C0.936258 8.05231 1.02158 8.11221 1.11698 8.15462Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M4.54648 14.5507C4.65233 14.5927 4.76612 14.6143 4.88109 14.6143C4.99605 14.6143 5.10985 14.5927 5.2157 14.5507C5.32167 14.5106 5.41774 14.4507 5.49801 14.3745C5.5777 14.2982 5.64152 14.2086 5.68621 14.1103C5.72811 14.0106 5.7494 13.9044 5.74895 13.7972C5.7501 13.5813 5.65988 13.3737 5.49801 13.2199C5.45678 13.1846 5.41312 13.1519 5.3673 13.122C5.31971 13.0912 5.26893 13.065 5.2157 13.0437C5.16318 13.0246 5.10891 13.0098 5.05359 12.9997C4.91279 12.974 4.76746 12.9807 4.62999 13.019C4.49251 13.0574 4.367 13.1263 4.26417 13.2199C4.10229 13.3737 4.01205 13.5813 4.01319 13.7972C4.01317 14.0129 4.10325 14.2201 4.26417 14.3745C4.34443 14.4507 4.4405 14.5106 4.54648 14.5507Z",
                                                fill: colors.secundario
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M14.9454 3.40478C14.8891 3.41362 14.8345 3.4301 14.7833 3.45371C14.7302 3.47324 14.6794 3.49784 14.6317 3.5271C14.5382 3.58848 14.4568 3.66464 14.3912 3.75217C14.3308 3.8427 14.2867 3.94186 14.2605 4.04573C14.2556 4.09782 14.2556 4.15021 14.2605 4.2023C14.2605 4.419 14.3525 4.62683 14.5162 4.78006C14.68 4.9333 14.9021 5.01938 15.1336 5.01938C15.247 5.02057 15.3594 4.99887 15.463 4.95578C15.5704 4.91825 15.667 4.85796 15.7453 4.77964C15.8276 4.70468 15.8928 4.61485 15.9368 4.5156C15.9808 4.41635 16.0028 4.30976 16.0015 4.2023C16.0009 4.0816 15.9718 3.96251 15.9162 3.85359C15.8607 3.74467 15.78 3.64864 15.68 3.57238C15.58 3.49613 15.4632 3.44155 15.338 3.41257C15.2128 3.38359 15.0823 3.38093 14.9558 3.40478H14.9454Z",
                                                fill: colors.secundario
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-13",
                                        children: "QR"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../components/AvataaarDefault":"4Nflu","../../../../../components/BtnIconMoneyWrapper":"cnl9M","../../../../../components/ClothingGraphic":"3LlJp","../../../../../components/ClothingShirtScoop":"jL6T4","../../../../../components/EyebrowOutline":"2dYAm","../../../../../components/EyesDefault":"fHyYv","../../../../../components/NoseDefault":"gblSy","../../../../../components/Text":"bpitb","../../../../../icons/Eyebrow4":"8BSXp","../../../../../icons/Eyes":"3yJYD","../../../../../icons/Eyes1":"bdpO0","../../../../../icons/EyesWink":"kp9Vu","../../../../../icons/IconSmall2":"9lwhH","../../../../../icons/IconlyLightOutlineArrowDown21":"faBA3","../../../../../icons/Icons19":"2OHy7","../../../../../icons/Mouth":"h88Fk","../../../../../icons/Mouth2":"bNCXf","../../../../../icons/Nose4":"5TVZy","../../../../../icons/TrailingIcon14":"1nwir","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"lvwB0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Nflu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvataaarDefault", ()=>(0, _avataaarDefault.AvataaarDefault));
var _avataaarDefault = require("./AvataaarDefault");

},{"./AvataaarDefault":"3fA4W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3fA4W":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvataaarDefault", ()=>AvataaarDefault);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _eyebrow = require("../../icons/Eyebrow");
var _mouth = require("../../icons/Mouth");
var _clothingShirtScoop = require("../ClothingShirtScoop");
var _eyesDefault = require("../EyesDefault");
var _styleCss = require("./style.css");
const AvataaarDefault = ({ className, overlapClassName, bodyClassName, body = "/img/body.png", clothingShirtScoopClothingShirtScoop = "/img/clothes.svg", clothingShirtScoopClothingShirtScoopClassName, faceClassName, overlapGroupClassName, icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mouth.Mouth), {
    className: "mouth-1",
    opacity: "0.7"
}), mouthStyleOverrideClassName, override = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyesDefault.EyesDefault), {
    className: "eyes-default-instance"
}), icon1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyebrow.Eyebrow), {
    className: "eyebrow-instance"
}), topClassName, top = "/img/top.png", override1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clothingShirtScoop.ClothingShirtScoop), {
    className: clothingShirtScoopClothingShirtScoopClassName,
    clothingShirtScoop: clothingShirtScoopClothingShirtScoop
}), icon2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mouth.Mouth), {
    className: mouthStyleOverrideClassName,
    opacity: "0.16"
}) })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `avataaar-default ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `overlap ${overlapClassName}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: `body-2 ${bodyClassName}`,
                    alt: "Body",
                    src: body
                }),
                override1,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `face ${faceClassName}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `overlap-group-4 ${overlapGroupClassName}`,
                        children: [
                            icon,
                            icon2,
                            override,
                            icon1
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: `top ${topClassName}`,
                    alt: "Top",
                    src: top
                })
            ]
        })
    });
};
AvataaarDefault.propTypes = {
    body: (0, _propTypesDefault.default).string,
    clothingShirtScoopClothingShirtScoop: (0, _propTypesDefault.default).string,
    top: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","../../icons/Eyebrow":"a82yr","../../icons/Mouth":"h88Fk","../ClothingShirtScoop":"jL6T4","../EyesDefault":"fHyYv","./style.css":"U6qee","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a82yr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyebrow", ()=>(0, _eyebrow.Eyebrow));
var _eyebrow = require("./Eyebrow");

},{"./Eyebrow":"7bsxT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7bsxT":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyebrow", ()=>Eyebrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Eyebrow = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `eyebrow ${className}`,
        fill: "none",
        height: "24",
        viewBox: "0 0 112 24",
        width: "112",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M15.6302 17.1586C19.5452 11.6499 30.2779 8.56084 39.523 10.8312C40.5957 11.0946 41.6789 10.4386 41.9423 9.36586C42.2057 8.29317 41.5497 7.21003 40.477 6.9466C29.7404 4.30998 17.3121 7.887 12.3698 14.8414C11.7299 15.7418 11.9411 16.9904 12.8414 17.6302C13.7418 18.2701 14.9904 18.0589 15.6302 17.1586Z",
                fill: "black",
                fillOpacity: "0.6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M96.3701 17.1586C92.4551 11.6499 81.7224 8.56084 72.4773 10.8312C71.4046 11.0946 70.3214 10.4386 70.058 9.36586C69.7946 8.29317 70.4506 7.21003 71.5233 6.9466C82.2599 4.30998 94.6882 7.887 99.6305 14.8414C100.27 15.7418 100.059 16.9904 99.1589 17.6302C98.2585 18.2701 97.0099 18.0589 96.3701 17.1586Z",
                fill: "black",
                fillOpacity: "0.6"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h88Fk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mouth", ()=>(0, _mouth.Mouth));
var _mouth = require("./Mouth");

},{"./Mouth":"5IJps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5IJps":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mouth", ()=>Mouth);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Mouth = ({ opacity = "0.7", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `mouth ${className}`,
        fill: "none",
        height: "7",
        viewBox: "0 0 17 7",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            clipRule: "evenodd",
            d: "M5.30371 2.45312C5.30371 3.66815 6.80966 4.65312 8.66735 4.65312C10.525 4.65312 12.031 3.66815 12.031 2.45312",
            fill: "black",
            fillOpacity: opacity,
            fillRule: "evenodd"
        })
    });
};
Mouth.propTypes = {
    opacity: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jL6T4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClothingShirtScoop", ()=>(0, _clothingShirtScoop.ClothingShirtScoop));
var _clothingShirtScoop = require("./ClothingShirtScoop");

},{"./ClothingShirtScoop":"jiNe1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jiNe1":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClothingShirtScoop", ()=>ClothingShirtScoop);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const ClothingShirtScoop = ({ className, clothingShirtScoop = "/img/clothing-shirt-scoop-neck.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `clothing-shirt-scoop ${className}`,
        alt: "Clothing shirt scoop",
        src: clothingShirtScoop
    });
};
ClothingShirtScoop.propTypes = {
    clothingShirtScoop: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"cNCD4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cNCD4":[function() {},{}],"fHyYv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyesDefault", ()=>(0, _eyesDefault.EyesDefault));
var _eyesDefault = require("./EyesDefault");

},{"./EyesDefault":"hIJtP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hIJtP":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyesDefault", ()=>EyesDefault);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const EyesDefault = ({ className, eyeClassName, eyeClassNameOverride })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `eyes-default ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `eye ${eyeClassName}`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `eye-2 ${eyeClassNameOverride}`
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./style.css":"9z0Vg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9z0Vg":[function() {},{}],"U6qee":[function() {},{}],"3LlJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClothingGraphic", ()=>(0, _clothingGraphic.ClothingGraphic));
var _clothingGraphic = require("./ClothingGraphic");

},{"./ClothingGraphic":"7EVlc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7EVlc":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClothingGraphic", ()=>ClothingGraphic);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const ClothingGraphic = ({ className, clothingGraphic = "/img/clothing-graphic-shirt.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `clothing-graphic ${className}`,
        alt: "Clothing graphic",
        src: clothingGraphic
    });
};
ClothingGraphic.propTypes = {
    clothingGraphic: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"fzCTB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fzCTB":[function() {},{}],"2dYAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyebrowOutline", ()=>(0, _eyebrowOutline.EyebrowOutline));
var _eyebrowOutline = require("./EyebrowOutline");

},{"./EyebrowOutline":"bAdj9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bAdj9":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyebrowOutline", ()=>EyebrowOutline);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const EyebrowOutline = ({ className, eyebrowOutline = "/img/eyebrow-outline-default.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `eyebrow-outline ${className}`,
        alt: "Eyebrow outline",
        src: eyebrowOutline
    });
};
EyebrowOutline.propTypes = {
    eyebrowOutline: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"1Qh5G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Qh5G":[function() {},{}],"gblSy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoseDefault", ()=>(0, _noseDefault.NoseDefault));
var _noseDefault = require("./NoseDefault");

},{"./NoseDefault":"8qLk3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8qLk3":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoseDefault", ()=>NoseDefault);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const NoseDefault = ({ className, noseDefault = "/img/nose-default.svg" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: `nose-default ${className}`,
        alt: "Nose default",
        src: noseDefault
    });
};
NoseDefault.propTypes = {
    noseDefault: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"j1apR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j1apR":[function() {},{}],"bpitb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
var _text = require("./Text");

},{"./Text":"j7F7F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7F7F":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styleCss = require("./style.css");
const Text = ({ size, color, className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `text ${size} color-${color} ${className}`
    });
};
Text.propTypes = {
    size: (0, _propTypesDefault.default).oneOf([
        "headline",
        "caption",
        "body"
    ]),
    color: (0, _propTypesDefault.default).oneOf([
        "primary",
        "secondary"
    ])
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","./style.css":"cM0ZM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cM0ZM":[function() {},{}],"8BSXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyebrow4", ()=>(0, _eyebrow4.Eyebrow4));
var _eyebrow4 = require("./Eyebrow4");

},{"./Eyebrow4":"jl0Wg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jl0Wg":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyebrow4", ()=>Eyebrow4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Eyebrow4 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `eyebrow-4 ${className}`,
        fill: "none",
        height: "7",
        viewBox: "0 0 34 7",
        width: "34",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M5.33133 4.80979C6.47318 3.29489 9.60357 2.44541 12.3001 3.06975C12.6129 3.1422 12.9288 2.96178 13.0057 2.66679C13.0825 2.3718 12.8912 2.07394 12.5783 2.00149C9.44678 1.27643 5.82187 2.2601 4.38035 4.17257C4.19373 4.42017 4.25532 4.76354 4.51792 4.9395C4.78053 5.11546 5.1447 5.05739 5.33133 4.80979Z",
                fill: "black",
                fillOpacity: "0.6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                d: "M28.8806 4.80979C27.7387 3.29489 24.6083 2.44541 21.9119 3.06975C21.599 3.1422 21.2831 2.96178 21.2062 2.66679C21.1294 2.3718 21.3208 2.07394 21.6336 2.00149C24.7651 1.27643 28.39 2.2601 29.8316 4.17257C30.0182 4.42017 29.9566 4.76354 29.694 4.9395C29.4314 5.11546 29.0672 5.05739 28.8806 4.80979Z",
                fill: "black",
                fillOpacity: "0.6"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3yJYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyes", ()=>(0, _eyes.Eyes));
var _eyes = require("./Eyes");

},{"./Eyes":"cSKF9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cSKF9":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyes", ()=>Eyes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Eyes = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `eyes ${className}`,
        fill: "none",
        height: "13",
        viewBox: "0 0 34 13",
        width: "34",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#EDB98A",
                height: "12.1",
                transform: "translate(0.772461 0.291016)",
                width: "32.6667"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                className: "ellipse-33",
                cx: "9.52246",
                cy: "6.34141",
                fill: "black",
                fillOpacity: "0.6",
                rx: "1.75",
                ry: "1.65"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M21.3672 7.15331C21.8272 6.07577 22.983 5.26944 24.3893 5.17673C25.7905 5.08434 27.0502 5.72626 27.6671 6.72688C27.8504 7.02412 27.6408 7.29108 27.3966 7.1196C26.6406 6.58854 25.6011 6.29429 24.4776 6.36836C23.3894 6.44011 22.4301 6.8438 21.7618 7.43725C21.5174 7.65423 21.2327 7.46848 21.3672 7.15331Z",
                fill: "black",
                fillOpacity: "0.6",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bdpO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyes1", ()=>(0, _eyes1.Eyes1));
var _eyes1 = require("./Eyes1");

},{"./Eyes1":"dlsHk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlsHk":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Eyes1", ()=>Eyes1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Eyes1 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `eyes-1 ${className}`,
        fill: "none",
        height: "13",
        viewBox: "0 0 3 13",
        width: "3",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
            className: "rect",
            fill: "#EDB98A",
            height: "12.1",
            transform: "translate(0.355469 0.390625)",
            width: "31.5"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kp9Vu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyesWink", ()=>(0, _eyesWink.EyesWink));
var _eyesWink = require("./EyesWink");

},{"./EyesWink":"1Bnox","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Bnox":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EyesWink", ()=>EyesWink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const EyesWink = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `eyes-wink ${className}`,
        fill: "none",
        height: "13",
        viewBox: "0 0 32 13",
        width: "32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#FFDBB4",
                height: "12.1",
                transform: "translate(0.606445 0.375)",
                width: "30.8226"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                className: "ellipse-33",
                cx: "8.86215",
                cy: "6.42441",
                fill: "black",
                fillOpacity: "0.6",
                rx: "1.65121",
                ry: "1.65"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M20.0379 7.23828C20.4719 6.16073 21.5624 5.3544 22.8893 5.26169C24.2115 5.1693 25.4 5.81122 25.9821 6.81184C26.155 7.10908 25.9572 7.37604 25.7269 7.20456C25.0135 6.6735 24.0327 6.37925 22.9727 6.45332C21.9458 6.52507 21.0407 6.92877 20.4101 7.52221C20.1796 7.73919 19.9109 7.55344 20.0379 7.23828Z",
                fill: "black",
                fillOpacity: "0.6",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9lwhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconSmall2", ()=>(0, _iconSmall2.IconSmall2));
var _iconSmall2 = require("./IconSmall2");

},{"./IconSmall2":"6NcU6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6NcU6":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconSmall2", ()=>IconSmall2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconSmall2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `icon-small-2 ${className}`,
        fill: "none",
        height: "20",
        viewBox: "0 0 20 20",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M15.9205 5.06089C15.5784 4.72456 15.1722 4.45775 14.7252 4.27572C14.2782 4.09369 13.799 4 13.3151 4C12.8312 4 12.3521 4.09369 11.905 4.27572C11.458 4.45775 11.0518 4.72456 10.7098 5.06089L9.99982 5.75857L9.28988 5.06089C8.5989 4.38184 7.66172 4.00035 6.68453 4.00035C5.70733 4.00035 4.77016 4.38184 4.07917 5.06089C3.38819 5.73994 3 6.66092 3 7.62125C3 8.58157 3.38819 9.50255 4.07917 10.1816L4.78911 10.8793L9.2989 15.3112C9.68797 15.6935 10.3117 15.6935 10.7007 15.3112L15.2105 10.8793L15.9205 10.1816C16.2627 9.84543 16.5342 9.44628 16.7194 9.00697C16.9047 8.56765 17 8.09678 17 7.62125C17 7.14571 16.9047 6.67484 16.7194 6.23552C16.5342 5.79621 16.2627 5.39706 15.9205 5.06089Z",
            fill: "#FD0658"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"faBA3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconlyLightOutlineArrowDown21", ()=>(0, _iconlyLightOutlineArrowDown21.IconlyLightOutlineArrowDown21));
var _iconlyLightOutlineArrowDown21 = require("./IconlyLightOutlineArrowDown21");

},{"./IconlyLightOutlineArrowDown21":"fx95Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fx95Q":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconlyLightOutlineArrowDown21", ()=>IconlyLightOutlineArrowDown21);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const IconlyLightOutlineArrowDown21 = ({ color = "white", className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `iconly-light-outline-arrow-down-2-1 ${className}`,
        fill: "none",
        height: "19",
        viewBox: "0 0 18 19",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            d: "M5.97725 15.3509C5.77755 15.1512 5.7594 14.8387 5.92279 14.6185L5.97725 14.5554L10.8293 9.70312L5.97725 4.85087C5.77755 4.65117 5.7594 4.33867 5.92279 4.11847L5.97725 4.05538C6.17695 3.85568 6.48945 3.83752 6.70966 4.00091L6.77275 4.05538L12.0227 9.30538C12.2224 9.50508 12.2406 9.81758 12.0772 10.0378L12.0227 10.1009L6.77275 15.3509C6.55308 15.5705 6.19692 15.5705 5.97725 15.3509Z",
            fill: color,
            stroke: color
        })
    });
};
IconlyLightOutlineArrowDown21.propTypes = {
    color: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"gonF6","prop-types":"gLXGb","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bNCXf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mouth2", ()=>(0, _mouth2.Mouth2));
var _mouth2 = require("./Mouth2");

},{"./Mouth2":"aHdk3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aHdk3":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mouth2", ()=>Mouth2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Mouth2 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: `mouth-2 ${className}`,
        fill: "none",
        height: "13",
        viewBox: "0 0 32 13",
        width: "32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                className: "rect",
                fill: "#EDB98A",
                height: "12.1",
                transform: "translate(0.355469 0.390625)",
                width: "31.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: "path",
                clipRule: "evenodd",
                d: "M10.598 4.55104C10.9065 7.16127 13.2545 9.19082 16.1053 9.19082C18.9648 9.19082 21.3185 7.14871 21.6154 4.52684C21.6392 4.31583 21.3893 3.96582 21.0761 3.96582C16.732 3.96582 13.4038 3.96582 11.1722 3.96582C10.8572 3.96582 10.5671 4.28989 10.598 4.55104Z",
                fill: "black",
                fillOpacity: "0.7",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                className: "mask",
                height: "7",
                id: "mask0_2633_240",
                maskUnits: "userSpaceOnUse",
                width: "12",
                x: "10",
                y: "3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    className: "path",
                    clipRule: "evenodd",
                    d: "M10.598 4.55104C10.9065 7.16127 13.2545 9.19082 16.1053 9.19082C18.9648 9.19082 21.3185 7.14871 21.6154 4.52684C21.6392 4.31583 21.3893 3.96582 21.0761 3.96582C16.732 3.96582 13.4038 3.96582 11.1722 3.96582C10.8572 3.96582 10.5671 4.28989 10.598 4.55104Z",
                    fill: "white",
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                className: "g",
                mask: "url(#mask0_2633_240)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "path",
                        clipRule: "evenodd",
                        d: "M11.7305 3.14043C11.7305 1.9254 12.7154 0.94043 13.9305 0.94043H18.5721C19.7872 0.94043 20.7721 1.9254 20.7721 3.14043C20.7721 4.35546 19.7872 5.34043 18.5721 5.34043H13.9305C12.7154 5.34043 11.7305 4.35546 11.7305 3.14043Z",
                        fill: "white",
                        fillRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        className: "ellipse-33",
                        cx: "14.6468",
                        cy: "10.0152",
                        fill: "#FF4F6D",
                        rx: "3.20833",
                        ry: "3.025"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        className: "ellipse-33",
                        cx: "17.5638",
                        cy: "10.0152",
                        fill: "#FF4F6D",
                        rx: "3.20833",
                        ry: "3.025"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5TVZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nose4", ()=>(0, _nose4.Nose4));
var _nose4 = require("./Nose4");

},{"./Nose4":"imYgw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"imYgw":[function(require,module,exports,__globalThis) {
/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nose4", ()=>Nose4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Nose4 = ({ className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `nose-4 ${className}`,
        fill: "none",
        height: "8",
        viewBox: "0 0 15 8",
        width: "15",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            className: "path",
            clipRule: "evenodd",
            d: "M4.36328 2.89355C4.36328 4.04546 5.76748 4.97927 7.49964 4.97927C9.23181 4.97927 10.636 4.04546 10.636 2.89355",
            fill: "black",
            fillOpacity: "0.16",
            fillRule: "evenodd"
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lvwB0":[function() {},{}],"6FYQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungCardDetails", ()=>(0, _youngCardDetails.YoungCardDetails));
var _youngCardDetails = require("./YoungCardDetails");

},{"./YoungCardDetails":"l9xkK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9xkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungCardDetails", ()=>YoungCardDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconlyLightOutlineArrowDown21 = require("../../../../../icons/IconlyLightOutlineArrowDown21");
var _icons19 = require("../../../../../icons/Icons19");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungCardDetails = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonBack = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-card-details",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper-4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-13",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-19"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-20"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "element-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-14",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-82",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-15",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "overlap-15",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "debit-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "overlap-16",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    position: "block"
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "frame-83",
                                                                style: {
                                                                    backgroundRepeat: "no-repeat",
                                                                    backgroundPosition: "center",
                                                                    backgroundSize: "contain",
                                                                    backgroundImage: colors.url_card ? `url(${colors.url_card})` : "none",
                                                                    backgroundColor: colors.url_card ? "transparent" : "rgb(255,255,255, 0.3)"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-90",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-70",
                                                                                children: "7531 4532 6643 5849"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                className: "img-5",
                                                                                alt: "Copy",
                                                                                src: "/img/copy.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-84",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-65",
                                                                                children: "Available"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-85",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "frame-86",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                className: "frame-87",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "text-wrapper-66",
                                                                                                        children: "13,000"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                        className: "text-wrapper-67",
                                                                                                        children: ".23"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                className: "text-wrapper-68",
                                                                                                children: "USD"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons19.Icons19), {
                                                                                        className: "img-5",
                                                                                        color: "white"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-88",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "text-wrapper-65",
                                                                                children: "Assigned"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "frame-89",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "frame-87",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "text-wrapper-69",
                                                                                        children: "USD 23,000.00"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-91",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-92",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "frame-93",
                                                            alt: "Frame",
                                                            src: "/img/frame-1171274973-1.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-71",
                                                            children: "Pay"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-92",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-5",
                                                            alt: "Pin code",
                                                            src: "/img/pin-code.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-71",
                                                            children: "PIN"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-92",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-5",
                                                            alt: "File",
                                                            src: "/img/file.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-71",
                                                            children: "Statement"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-92",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-5",
                                                            alt: "Calendar",
                                                            src: "/img/calendar.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-71",
                                                            children: "Installments"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-92",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "img-5",
                                                            alt: "Warning",
                                                            src: "/img/warning.png"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-71",
                                                            children: "Missing"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-94",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "panel-panel-primary-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title-6",
                                                children: "Card details"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: handleButtonBack,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "icons-arrow-back-2",
                                                    alt: "Icons arrow back",
                                                    src: "/img/icons-arrow-back-1.png"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "inside-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "inside",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-95",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "subsection-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-96",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-wrapper-73",
                                                    children: "Last activity"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "iconly-light-outline-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-74",
                                                        children: "See all"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconlyLightOutlineArrowDown21.IconlyLightOutlineArrowDown21), {
                                                        className: "iconly-light-outline-arrow-down-2-1",
                                                        color: "white"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-97",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-98",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "vector-9",
                                                            alt: "Vector",
                                                            src: "/img/vector-270.svg"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-15"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-16"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-99",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feed-row-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "data-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "frame-100",
                                                                        alt: "Frame",
                                                                        src: "/img/frame-480954771-1.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-101",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-102",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "name-2",
                                                                                        children: "Starbucks coffee time"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                        className: "img-5",
                                                                                        alt: "Btn icon chevron",
                                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject-2",
                                                                                children: "11/06/24"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "amount-8",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-75",
                                                                        children: "- $25"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-76",
                                                                        children: ".11"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feed-row-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "data-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "frame-100",
                                                                        alt: "Frame",
                                                                        src: "/img/frame-480954771-4.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-103",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-102",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "name-2",
                                                                                        children: "Bruno\u2019s tricks"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                        className: "img-5",
                                                                                        alt: "Btn icon chevron",
                                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject-2",
                                                                                children: "11/06/24"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "amount-8",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-75",
                                                                        children: "- $12"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-76",
                                                                        children: ".42"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feed-row-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "data-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "frame-100",
                                                                        alt: "Frame",
                                                                        src: "/img/frame-480954771-2.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-103",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-102",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "name-2",
                                                                                        children: "New gymn shoes"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                        className: "img-5",
                                                                                        alt: "Btn icon chevron",
                                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject-2",
                                                                                children: "11/06/24"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "amount-8",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-75",
                                                                        children: "- $158"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-wrapper-76",
                                                                        children: ".68"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feed-row-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "data-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        className: "frame-100",
                                                                        alt: "Frame",
                                                                        src: "/img/frame-480954771-3.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "frame-103",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "frame-102",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "name-2",
                                                                                        children: "Card payment"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                        className: "img-5",
                                                                                        alt: "Btn icon chevron",
                                                                                        src: "/img/btn-icon-chevron-5.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "subject-2",
                                                                                children: "11/06/24"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-104",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "amount-9",
                                                                    children: "$950.23"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../icons/IconlyLightOutlineArrowDown21":"faBA3","../../../../../icons/Icons19":"2OHy7","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"1FpyB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1FpyB":[function() {},{}],"e96qW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingTutorialEasy", ()=>(0, _youngOnboardingTutorialEasy.YoungOnboardingTutorialEasy));
var _youngOnboardingTutorialEasy = require("./YoungOnboardingTutorialEasy");

},{"./YoungOnboardingTutorialEasy":"1KluX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1KluX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingTutorialEasy", ()=>YoungOnboardingTutorialEasy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungOnboardingTutorialEasy = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClickAtras = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-login-young-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_steppper-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-onboarding-screen-easy",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "young-onboarding-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "rectangle-2",
                            alt: "Rectangle",
                            src: "/img/rectangle.png"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "group",
                            alt: "Group",
                            src: "/img/easy-tutorial.png"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "pay-for-your-favorit",
                    children: [
                        "All you need in your phone. ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "We offer the best user experience to make your tasks easier."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "payment-worldwide",
                    children: "Easy and Complete"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-3 highlighted-button",
                    onClick: handleButtonAdelante,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: "Frame",
                        width: 25,
                        style: {
                            marginTop: 15,
                            marginLeft: 10
                        },
                        src: "/img/flecha-adelante-azul.png"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-4 highlighted-button",
                    onClick: handleButtonClickAtras,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: "Frame",
                        width: 25,
                        style: {
                            marginTop: 15,
                            marginLeft: 10
                        },
                        src: "/img/flecha-atras-azul.png"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"7szj0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7szj0":[function() {},{}],"lKPyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingWelcome", ()=>(0, _youngOnboardingWelcome.YoungOnboardingWelcome));
var _youngOnboardingWelcome = require("./YoungOnboardingWelcome");

},{"./YoungOnboardingWelcome":"jEmOW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEmOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingWelcome", ()=>YoungOnboardingWelcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungOnboardingWelcome = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-landing-young-mobile${currentParams}`);
    };
    const handleButtonAdelante = ()=>{
        const currentParams = location.search;
        navigate(`/young-onboarding-steppper${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-onboarding-screen-welcome",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "young-onboarding-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "rectangle-2",
                            alt: "Rectangle",
                            src: "/img/rectangle.png"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "group",
                            alt: "Group",
                            src: "/img/welcome-young-adultos.png",
                            style: {
                                width: 150,
                                objectFit: 'contain',
                                maxHeight: 200
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "pay-for-your-favorit",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: "Your account has been opened"
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "Enjoy all the benefits of our App"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "payment-worldwide",
                    children: "Welcome Soan!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "test-button-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "test-button-2 highlighted-button",
                        onClick: handleButtonClick,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-wrapper-5",
                            children: "Let\u2019s start!"
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"7vBUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7vBUX":[function() {},{}],"S1Fva":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingStepper", ()=>(0, _youngOnboardingStepper.YoungOnboardingStepper));
var _youngOnboardingStepper = require("./YoungOnboardingStepper");

},{"./YoungOnboardingStepper":"bYc7x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bYc7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingStepper", ()=>YoungOnboardingStepper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungOnboardingStepper = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const colors = (0, _useDynamicColorsDefault.default)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_card_id-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-stepper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-group-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ellipse-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-2"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "image",
                                        alt: "Image",
                                        src: "/img/folder-young-adultos.png"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "subtitle",
                                        children: "Welcome!"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "subtitle-2",
                                        children: "Let\u2019s open your online account"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "frame-6",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-7",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "ellipse-3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "subtitle-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-3",
                                                            children: "Accept Terms and Conditions"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Register your Email"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Scan your ID card"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: " Validate your identity"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "subtitle-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-3",
                                                            children: "Register your Mobile number"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "group-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "subtitle-4",
                                                            children: "Generate your credentials"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-9",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-wrapper-7 highlighted-button",
                                        onClick: handleButtonClick,
                                        children: "Open account"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "status-bar"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title",
                                        children: "Terms and Conditions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"20Qrj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20Qrj":[function() {},{}],"kypKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingCardId", ()=>(0, _youngOnboardingCardId.YoungOnboardingCardId));
var _youngOnboardingCardId = require("./YoungOnboardingCardId");

},{"./YoungOnboardingCardId":"fKIT5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fKIT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingCardId", ()=>YoungOnboardingCardId);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _direcDown = require("../../../../../icons/DirecDown");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungOnboardingCardId = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_phone-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-card-id",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "overlap-group-wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-group-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-11",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-4"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "molecula-stepper",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "content-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-9",
                                                            children: "1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-10",
                                                                children: "2"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-2"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-11",
                                                                children: "3"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-3"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-11",
                                                                children: "4"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-3"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-11",
                                                                children: "5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-3"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "atomo-step-final-no",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "content-5",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-11",
                                                            children: "6"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "element-2",
                                        alt: "Element",
                                        src: "/img/card-id.png"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-13",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "subtitle-5",
                                            children: "Now, get your ID card"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "element-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "subtitle-6",
                                                children: [
                                                    "We will take a photo of the front & back.",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    "Center your document in the frame and please make sure it doesn\xb4t show any glare or shadows.",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    "Photos will be captured automatically."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "frame-14",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-12",
                                                        children: "Country"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "account-select",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "frame-15",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "frame-16",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-wrapper-13",
                                                                        children: "USA"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _direcDown.DirecDown), {
                                                                    className: "btn-icon-chevron",
                                                                    color: colors.primario
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    marginTop: 150,
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-17 highlighted-button",
                                                    style: {
                                                        borderRadius: 30,
                                                        width: "100%"
                                                    },
                                                    onClick: handleButtonClick,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-wrapper-14",
                                                        children: "I\xb4ve got my ID card!"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-18",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bars-status-default-wrapper"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title-2",
                                        children: "Scan ID Card"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back-2",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../icons/DirecDown":"edyec","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"lALdC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lALdC":[function() {},{}],"289aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingPhone", ()=>(0, _youngOnboardingPhone.YoungOnboardingPhone));
var _youngOnboardingPhone = require("./YoungOnboardingPhone");

},{"./YoungOnboardingPhone":"gnE6c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gnE6c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoungOnboardingPhone", ()=>YoungOnboardingPhone);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _atomoTime = require("../../../../../components/AtomoTime");
var _buttonSmall = require("../../../../../components/ButtonSmall");
var _useDynamicColors = require("../../../../../hooks/useDynamicColors");
var _useDynamicColorsDefault = parcelHelpers.interopDefault(_useDynamicColors);
var _styleCss = require("./style.css");
const YoungOnboardingPhone = ()=>{
    const colors = (0, _useDynamicColorsDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleButtonClick = ()=>{
        const currentParams = location.search;
        navigate(`/vxlab-onboarding_welcome-young-mobile${currentParams}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "young-onboarding-phone",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "young-onboarding-3",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-19",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-5"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-20",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "molecula-stepper-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "content-6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-16",
                                                            children: "1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "line-4"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-17",
                                                                children: "2"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-4"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-17",
                                                                children: "3"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-4"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-6",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-18",
                                                                children: "4"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "div-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "div-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "numb-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "text-wrapper-19",
                                                                children: "5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "line-6"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "atomo-step-final-no-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "content-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "numb-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "text-wrapper-19",
                                                            children: "6"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "group-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "signature-cinemawide-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: "Validate Phone",
                                                src: "/img/phone-adultos.png",
                                                style: {
                                                    marginLeft: -10,
                                                    marginTop: -20,
                                                    objectFit: 'contain',
                                                    width: 150
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "element-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "subtitle-8",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-20",
                                                        children: "A validation code has been sent to"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-wrapper-21",
                                                        children: "+54 9 1122 6476"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "numbs",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "element-5",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "element-5",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "element-5",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "element-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "element-5",
                                                            children: "2"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _atomoTime.AtomoTime), {
                                                className: "atomo-time-instance",
                                                rectangleClassName: "atomo-time-3",
                                                subtitleCopyClassName: "atomo-time-4",
                                                subtitleCopyClassNameOverride: "atomo-time-4",
                                                timelineClassName: "atomo-time-2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSmall.ButtonSmall), {
                                                className: "button-small-instance",
                                                estado: "inactivo",
                                                iconLeft: false,
                                                iconRigth: false,
                                                textClassName: "button-small-2",
                                                texto: "Resend code",
                                                tipo: "link"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "action-buttons-3",
                                                onClick: handleButtonClick,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-22 highlighted-button",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-wrapper-22",
                                                        children: "Validate"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-23",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "status-bar-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "panel-panel-primary-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "title-3",
                                        children: "Register Mobile number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "icons-arrow-back-3",
                                        alt: "Icons arrow back",
                                        src: "/img/icons-arrow-back-1.png"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","../../../../../components/AtomoTime":"djEQ8","../../../../../components/ButtonSmall":"6rhhx","../../../../../hooks/useDynamicColors":"b2GRH","./style.css":"7LeKy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7LeKy":[function() {},{}]},["jTTlG"], "jTTlG", "parcelRequireb8e7", {})

//# sourceMappingURL=vxapp-previews-prod.wfsystems.com.ar.bbd73688.js.map
